// ==========================================
// RECIPES & MOTIVATIONAL CONSTANTS
// ==========================================

const MOTIVATIONAL_QUOTES = [
  "La tua salute è un investimento, non una spesa.",
  "Ogni giorno è una nuova opportunità per migliorare.",
  "Non arrenderti, l'inizio è sempre la parte più difficile.",
  "Piccoli passi quotidiani portano a grandi risultati.",
  "Il successo è la somma di piccoli sforzi ripetuti giorno dopo giorno."
];

const RECIPES = [
  {
    "title": "Shake Formula 1 Delizia al Cacao + PDM",
    "title_en": "Formula 1 Cocoa Delight & PDM Shake",
    "title_ro": "Shake Formula 1 Deliciu de Cacao & PDM",
    "title_es": "Batido Fórmula 1 Delicia de Cacao y PDM",
    "category": "frullati",
    "emoji": "🍫",
    "gradient": "linear-gradient(135deg, #6b4c41 0%, #3e2723 100%)",
    "prepTime": "2 min",
    "calories": "220 kcal",
    "difficulty": "Facile",
    "description": "La formula standard Herbalife: Formula 1 e PDM shakerati in 250ml di acqua fresca per 22g di proteine pure, massima cremosità e zero zuccheri del latte.",
    "description_en": "The standard Herbalife formula: Formula 1 and PDM shaken with 250ml cold water for 22g clean protein, ultimate creaminess, and zero milk sugars.",
    "description_ro": "Formula standard Herbalife: Formula 1 și PDM amestecate în 250ml apă rece pentru 22g proteine pure, textură cremoasă și zero zahăr din lapte.",
    "description_es": "La fórmula estándar Herbalife: Fórmula 1 y PDM mezclados con 250ml de agua fría para 22g de proteína pura, máxima cremosidad y sin azúcares de la leche.",
    "ingredients": "2 misurini di F1 Cacao (26g), 1 misurino di PDM (Protein Drink Mix - 14g), 250-300ml di acqua fresca, 3 cubetti di ghiaccio.",
    "ingredients_en": "2 scoops F1 Cocoa (26g), 1 scoop PDM (Protein Drink Mix - 14g), 250-300ml cold water, 3 ice cubes.",
    "ingredients_ro": "2 măsuri F1 Cacao (26g), 1 măsură PDM (Protein Drink Mix - 14g), 250-300ml apă rece, 3 cuburi de gheață.",
    "ingredients_es": "2 cucharadas de F1 Cacao (26g), 1 cucharada de PDM (Protein Drink Mix - 14g), 250-300ml de agua fría, 3 cubitos de hielo.",
    "protein": "22g",
    "carbs": "22g",
    "fats": "4g",
    "tip": "Aggiungi un pizzico di cannella per accelerare il metabolismo!",
    "tip_en": "Add a pinch of cinnamon to speed up your metabolism!",
    "tip_ro": "Aggiungi un pizzico di cannella per accelerare il metabolismo!",
    "tip_es": "Aggiungi un pizzico di cannella per accelerare il metabolismo!",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1572490122747-3968b75cc699?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1572490122747-3968b75cc699?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Shake F1 Vaniglia & Frutti di Bosco + PDM",
    "title_en": "F1 Vanilla & Wild Berries Shake + PDM",
    "title_ro": "Shake F1 Vanilie & Fructe de Pădure + PDM",
    "title_es": "Batido F1 Vainilla y Frutos Rojos + PDM",
    "category": "frullati",
    "emoji": "🍓",
    "gradient": "linear-gradient(135deg, #fce4ec 0%, #d81b60 100%)",
    "prepTime": "3 min",
    "calories": "225 kcal",
    "difficulty": "Facile",
    "description": "Una combinazione fresca, proteica e antiossidante: F1 Vaniglia + PDM shakerati in acqua con 40g di frutti di bosco.",
    "description_en": "A fresh, protein-rich antioxidant combo: F1 Vanilla + PDM blended in pure water with 40g fresh berries.",
    "description_ro": "O combinație proaspătă și antioxidantă: F1 Vanilie + PDM preparate cu apă rece și 40g fructe de pădure.",
    "description_es": "Una combinación fresca y antioxidante: F1 Vainilla + PDM mezclados con agua y 40g de frutos rojos.",
    "ingredients": "2 misurini di F1 Vaniglia (26g), 1 misurino PDM (14g), 250ml acqua fresca, 40g frutti di bosco freschi, ghiaccio.",
    "ingredients_en": "2 scoops F1 Vanilla (26g), 1 scoop PDM (14g), 250ml cold water, 40g fresh berries, ice.",
    "ingredients_ro": "2 măsuri F1 Vanilie (26g), 1 măsură PDM (14g), 250ml apă rece, 40g fructe de pădure, gheață.",
    "ingredients_es": "2 cucharadas de F1 Vainilla (26g), 1 cucharada PDM (14g), 250ml agua fría, 40g frutos rojos, hielo.",
    "protein": "23g",
    "carbs": "24g",
    "fats": "4g",
    "tip": "Usa frutti di bosco congelati per una consistenza da frappé densissimo!",
    "tip_en": "Use frozen berries for a thick ice-cream smoothie consistency!",
    "tip_ro": "Usa frutti di bosco congelati per una consistenza da frappé densissimo!",
    "tip_es": "Usa frutti di bosco congelati per una consistenza da frappé densissimo!",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1553530666-ba11a7da3888?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1553530666-ba11a7da3888?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Green Power Shake (con Bevanda di Mandorla)",
    "title_en": "Green Power Shake (with Almond Beverage)",
    "title_ro": "Shake Green Power (cu Băutură de Migdale)",
    "title_es": "Batido Green Power (con Bebida de Almendras)",
    "category": "frullati",
    "emoji": "🥬",
    "gradient": "linear-gradient(135deg, #dcedc8 0%, #689f38 100%)",
    "prepTime": "4 min",
    "calories": "230 kcal",
    "difficulty": "Medio",
    "description": "La nostra variante speciale con bevanda di mandorle senza zuccheri: vitamine, minerali e clorofilla per una ricarica verde.",
    "description_en": "Our special plant-based recipe with unsweetened almond drink: chlorophyll and vitamins for natural vitality.",
    "description_ro": "Varianta noastră specială cu băutură de migdale fără zahăr: clorofilă și vitamine pentru revitalizare.",
    "description_es": "Nuestra variante especial con bebida de almendras sin azúcar: clorofila y vitaminas para recarga verde.",
    "ingredients": "2 misurini F1 Mela Speziata o Vaniglia (26g), 250ml bevanda vegetale di mandorla senza zuccheri, 1 manciata di spinaci baby freschi, ghiaccio.",
    "ingredients_en": "2 scoops F1 Spiced Apple or Vanilla (26g), 250ml unsweetened almond drink, 1 handful fresh spinach, ice.",
    "ingredients_ro": "2 măsuri F1 Măr Condimentat sau Vanilie (26g), 250ml băutură de migdale fără zahăr, 1 mână de spanac, gheață.",
    "ingredients_es": "2 cucharadas F1 Manzana o Vainilla (26g), 250ml bebida vegetal de almendras sin azúcar, 1 puñado de espinacas, hielo.",
    "protein": "16g",
    "carbs": "24g",
    "fats": "5g",
    "tip": "Puoi sostituire la bevanda di mandorla con 1 misurino di PDM in acqua per alzare la quota proteica a 22g!",
    "tip_en": "You can swap almond milk for 1 scoop of PDM in water to raise protein to 22g!",
    "tip_ro": "Puoi sostituire la bevanda di mandorla con 1 misurino di PDM in acqua per alzare la quota proteica a 22g!",
    "tip_es": "Puoi sostituire la bevanda di mandorla con 1 misurino di PDM in acqua per alzare la quota proteica a 22g!",
    "productKeys": [
      "formula1"
    ],
    "img": "https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Shake F1 Caffè Macchiato & PDM",
    "title_en": "F1 Cafe Latte & PDM Shake",
    "title_ro": "Shake F1 Caffe Latte & PDM",
    "title_es": "Batido F1 Café Latte y PDM",
    "category": "frullati",
    "emoji": "☕",
    "gradient": "linear-gradient(135deg, #d7ccc8 0%, #795548 100%)",
    "prepTime": "2 min",
    "calories": "210 kcal",
    "difficulty": "Facile",
    "description": "L'energia del caffè unita alla cremosità di Formula 1 + PDM in acqua per iniziare al massimo la giornata.",
    "description_en": "The rich aroma of coffee blended with Formula 1 + PDM in cold water for a powerful morning boost.",
    "description_ro": "Aroma de cafea combinată cu Formula 1 + PDM în apă rece pentru cel mai bun început de zi.",
    "description_es": "El aroma de café combinado con Fórmula 1 + PDM en agua fría para empezar el día con energía.",
    "ingredients": "2 misurini F1 Caffellatte (26g), 1 misurino PDM (14g), 250ml acqua fresca, 1 tazzina di caffè espresso, ghiaccio.",
    "ingredients_en": "2 scoops F1 Cafe Latte (26g), 1 scoop PDM (14g), 250ml cold water, 1 shot of espresso, ice.",
    "ingredients_ro": "2 măsuri F1 Caffe Latte (26g), 1 măsură PDM (14g), 250ml apă rece, 1 shot de espresso, gheață.",
    "ingredients_es": "2 cucharadas F1 Café Latte (26g), 1 cucharada PDM (14g), 250ml agua fría, 1 café expreso, hielo.",
    "protein": "22g",
    "carbs": "20g",
    "fats": "4g",
    "tip": "Aggiungi cubetti di ghiaccio prima di frullare per una crema fredda al caffè da bar!",
    "tip_en": "Add ice cubes before blending for a thick frosty iced latte texture!",
    "tip_ro": "Aggiungi cubetti di ghiaccio prima di frullare per una crema fredda al caffè da bar!",
    "tip_es": "Aggiungi cubetti di ghiaccio prima di frullare per una crema fredda al caffè da bar!",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1517701550927-30cf4ba1dba5?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1517701550927-30cf4ba1dba5?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Tropical Mango & Passion PDM",
    "title_en": "Tropical Mango & Passion PDM",
    "title_ro": "Mango Tropical & Passion PDM",
    "title_es": "Mango Tropical & Maracuyá PDM",
    "category": "frullati",
    "emoji": "🥭",
    "gradient": "linear-gradient(135deg, #ffe082 0%, #ff8f00 100%)",
    "prepTime": "3 min",
    "calories": "235 kcal",
    "difficulty": "Facile",
    "description": "Sapore esotico e freschezza, con Formula 1 Frutto della Passione + PDM in acqua e dadini di mango.",
    "description_en": "Exotic tropical freshness with Formula 1 Passion Fruit + PDM in cold water and mango cubes.",
    "description_ro": "Aromă exotică și prospețime cu Formula 1 Fructul Pasiunii + PDM în apă rece și cuburi de mango.",
    "description_es": "Sabor exótico y frescura con Fórmula 1 Maracuyá + PDM en agua fría y dados de mango.",
    "ingredients": "2 misurini F1 Frutto della Passione (26g), 1 misurino PDM (14g), 250ml acqua fresca, 30g mango a cubetti, ghiaccio.",
    "ingredients_en": "2 scoops F1 Passion Fruit (26g), 1 scoop PDM (14g), 250ml cold water, 30g diced mango, ice.",
    "ingredients_ro": "2 măsuri F1 Fructul Pasiunii (26g), 1 măsură PDM (14g), 250ml apă rece, 30g cuburi mango, gheață.",
    "ingredients_es": "2 cucharadas F1 Maracuyá (26g), 1 cucharada PDM (14g), 250ml agua fría, 30g dados de mango, hielo.",
    "protein": "23g",
    "carbs": "23g",
    "fats": "4g",
    "tip": "Aggiungi qualche fogliolina di menta per un tocco caraibico.",
    "tip_en": "Add some mint leaves for a Caribbean touch.",
    "tip_ro": "Aggiungi qualche fogliolina di menta per un tocco caraibico.",
    "tip_es": "Aggiungi qualche fogliolina di menta per un tocco caraibico.",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1546173159-315724a31696?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1546173159-315724a31696?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Cioco-Menta Proteico F1 + PDM",
    "title_en": "F1 + PDM Mint-Choco Protein Shake",
    "title_ro": "Shake F1 + PDM Mentă-Ciocolată",
    "title_es": "Batido F1 + PDM Menta-Chocolate",
    "category": "frullati",
    "emoji": "🍫",
    "gradient": "linear-gradient(135deg, #b2dfdb 0%, #00796b 100%)",
    "prepTime": "2 min",
    "calories": "220 kcal",
    "difficulty": "Facile",
    "description": "Il gusto rinfrescante della menta unito al cioccolato con Formula 1 e PDM in acqua fresca.",
    "description_en": "The refreshing taste of mint combined with chocolate: Formula 1 and PDM blended with cold water.",
    "description_ro": "Gustul răcoritor al mentei combinat cu ciocolata: Formula 1 și PDM cu apă rece.",
    "description_es": "El sabor refrescante de la menta combinado con chocolate: Fórmula 1 y PDM en agua fría.",
    "ingredients": "2 misurini F1 Cioccolato e Menta (26g), 1 misurino PDM (14g), 250ml acqua fresca, 3 foglioline di menta, ghiaccio.",
    "ingredients_en": "2 scoops F1 Mint Chocolate (26g), 1 scoop PDM (14g), 250ml cold water, 3 mint leaves, ice.",
    "ingredients_ro": "2 măsuri F1 Ciocolată și Mentă (26g), 1 măsură PDM (14g), 250ml apă rece, 3 frunze de mentă, gheață.",
    "ingredients_es": "2 cucharadas F1 Chocolate y Menta (26g), 1 cucharada PDM (14g), 250ml agua fría, 3 hojas de menta, hielo.",
    "protein": "22g",
    "carbs": "22g",
    "fats": "4g",
    "tip": "Aggiungi nibs di cacao crudo per una croccantezza extra.",
    "tip_en": "Add raw cacao nibs for an extra crunch.",
    "tip_ro": "Aggiungi nibs di cacao crudo per una croccantezza extra.",
    "tip_es": "Aggiungi nibs di cacao crudo per una croccantezza extra.",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1541658016709-82535e94bc69?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1577805947697-89e18249d767?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Shake F1 Cacao & PDM + Aloe",
    "title_en": "F1 Cocoa & PDM Shake + Aloe",
    "title_ro": "Shake F1 Cacao & PDM + Aloe",
    "title_es": "Batido F1 Cacao y PDM + Aloe",
    "category": "frullati",
    "emoji": "🍫",
    "gradient": "linear-gradient(135deg, #6b4c41 0%, #3e2723 100%)",
    "prepTime": "3 min",
    "calories": "220 kcal",
    "difficulty": "Facile",
    "description": "Shake Formula 1 Cacao + PDM in acqua fresca + Infuso caldo con Aloe Max + un frutto fresco 🍫",
    "description_en": "Formula 1 Cocoa Shake + PDM in cold water + Warm Herbal Tea with Aloe Max + fresh green apple 🍫",
    "description_ro": "Shake Formula 1 Cacao + PDM în apă rece + Ceai cald cu Aloe Max + un măr verde 🍫",
    "description_es": "Batido Fórmula 1 Chocolate + PDM en agua fría + Té caliente con Aloe Max + una manzana verde 🍫",
    "ingredients": "2 misurini F1 Cacao (26g), 1 misurino PDM (14g), 250ml acqua fresca, 1 tappo Aloe Max in acqua calda, Infuso Herbalife.",
    "ingredients_en": "2 scoops F1 Smooth Chocolate (26g), 1 scoop PDM (14g), 250ml cold water, 1 cap Aloe Max in warm water, Herbal Tea.",
    "ingredients_ro": "2 măsuri F1 Cacao (26g), 1 măsură PDM (14g), 250ml apă rece, 1 căpăcel Aloe Max în apă caldă, Ceai Herbalife.",
    "ingredients_es": "2 cucharadas F1 Chocolate (26g), 1 cucharada PDM (14g), 250ml agua fría, 1 tapón Aloe Max en agua tibia, Té Herbalife.",
    "protein": "22g",
    "carbs": "22g",
    "fats": "4g",
    "tip": "La combinazione di Aloe e Infuso di prima mattina riattiva idratazione e metabolismo.",
    "tip_en": "Morning Aloe & Herbal Tea instantly activates hydration and metabolism.",
    "tip_ro": "Combinația de Aloe și Ceai de dimineață reactivează hidratarea și metabolismul.",
    "tip_es": "El Aloe y Té por la mañana reactivan la hidratación y el metabolismo.",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1577805947697-89e18249d767?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1541658016709-82535e94bc69?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Shake F1 Vaniglia & Frutti Rossi + PDM",
    "title_en": "F1 Vanilla & Berry Shake + PDM",
    "title_ro": "Shake F1 Vanilie & Fructe de Pădure + PDM",
    "title_es": "Batido F1 Vainilla y Frutos Rojos + PDM",
    "category": "frullati",
    "emoji": "🍓",
    "gradient": "linear-gradient(135deg, #fce4ec 0%, #d81b60 100%)",
    "prepTime": "3 min",
    "calories": "225 kcal",
    "difficulty": "Facile",
    "description": "Shake F1 Vaniglia + PDM in acqua con frutti di bosco + Aloe e Infuso + una pera 🍓",
    "description_en": "F1 Vanilla Shake + PDM in cold water with berries + Aloe & Tea + ripe pear 🍓",
    "description_ro": "Shake F1 Vanilie + PDM în apă cu fructe de pădure + Aloe și Ceai + o pară 🍓",
    "description_es": "Batido F1 Vainilla + PDM en agua con frutos rojos + Aloe y Té + una pera 🍓",
    "ingredients": "2 misurini F1 Vaniglia (26g), 1 misurino PDM (14g), 250ml acqua fresca, 40g frutti rossi, Aloe e Infuso.",
    "ingredients_en": "2 scoops F1 French Vanilla (26g), 1 scoop PDM (14g), 250ml cold water, 40g fresh berries, Aloe and Tea.",
    "ingredients_ro": "2 măsuri F1 Vanilie (26g), 1 măsură PDM (14g), 250ml apă rece, 40g fructe de pădure, Aloe și Ceai.",
    "ingredients_es": "2 cucharadas F1 Vainilla (26g), 1 cucharada PDM (14g), 250ml agua fría, 40g frutos rojos, Aloe y Té.",
    "protein": "23g",
    "carbs": "24g",
    "fats": "3.5g",
    "tip": "I frutti di bosco sono ricchi di antiossidanti protettivi.",
    "tip_en": "Wild berries are packed with protective antioxidants and natural vitamins.",
    "tip_ro": "Fructele de pădure sunt bogate în antioxidanți protectori.",
    "tip_es": "Los frutos rojos son ricos en antioxidantes protectores.",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1623065422902-30a2d299bbe4?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1623065422902-30a2d299bbe4?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Shake F1 Banana Cream & PDM",
    "title_en": "F1 Banana Cream & PDM Shake",
    "title_ro": "Shake F1 Banană & PDM",
    "title_es": "Batido F1 Plátano y PDM",
    "category": "frullati",
    "emoji": "🍌",
    "gradient": "linear-gradient(135deg, #10b981 0%, #047857 100%)",
    "prepTime": "3 min",
    "calories": "220 kcal",
    "difficulty": "Facile",
    "description": "Shake F1 Banana Cream + PDM in acqua fresca + Aloe Max e Infuso + kiwi 🍌",
    "description_en": "F1 Banana Cream + PDM in cold water + Aloe Max and Tea + fresh kiwi 🍌",
    "description_ro": "Shake F1 Banană + PDM în apă rece + Aloe Max și Ceai + kiwi 🍌",
    "description_es": "Batido F1 Plátano + PDM en agua fría + Aloe Max y Té + kiwi 🍌",
    "ingredients": "2 misurini F1 Banana Cream (26g), 1 misurino PDM (14g), 250ml acqua fresca, Aloe Max e Infuso.",
    "ingredients_en": "2 scoops F1 Banana Cream (26g), 1 scoop PDM (14g), 250ml cold water, Aloe and Tea.",
    "ingredients_ro": "2 măsuri F1 Banană (26g), 1 măsură PDM (14g), 250ml apă rece, Aloe și Ceai.",
    "ingredients_es": "2 cucharadas F1 Plátano (26g), 1 cucharada PDM (14g), 250ml agua fría, Aloe y Té.",
    "protein": "22g",
    "carbs": "22g",
    "fats": "3.5g",
    "tip": "Il potassio della banana previene i crampi muscolari.",
    "tip_en": "Natural potassium in bananas helps prevent muscle cramps.",
    "tip_ro": "Potasiul din banană previne crampele musculare.",
    "tip_es": "El potasio del plátano previene la fatiga muscular.",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1603569283847-aa295f0d016a?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1603569283847-aa295f0d016a?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Shake F1 Caffellatte & PDM",
    "title_en": "F1 Cafe Latte & PDM Shake",
    "title_ro": "Shake F1 Caffe Latte & PDM",
    "title_es": "Batido F1 Café Latte y PDM",
    "category": "frullati",
    "emoji": "☕",
    "gradient": "linear-gradient(135deg, #d7ccc8 0%, #795548 100%)",
    "prepTime": "3 min",
    "calories": "220 kcal",
    "difficulty": "Facile",
    "description": "Shake F1 Caffellatte + PDM in acqua fresca + 1 espresso + Aloe e Infuso ☕",
    "description_en": "F1 Cafe Latte + PDM in cold water + 1 shot espresso + Aloe & Tea ☕",
    "description_ro": "Shake F1 Caffe Latte + PDM în apă rece + 1 shot espresso + Aloe și Ceai ☕",
    "description_es": "Batido F1 Café Latte + PDM en agua fría + 1 café expreso + Aloe y Té ☕",
    "ingredients": "2 misurini F1 Caffellatte (26g), 1 misurino PDM (14g), 250ml acqua fresca, 1 espresso, Aloe e Infuso.",
    "ingredients_en": "2 scoops F1 Cafe Latte (26g), 1 scoop PDM (14g), 250ml cold water, 1 shot espresso, Aloe and Tea.",
    "ingredients_ro": "2 măsuri F1 Caffe Latte (26g), 1 măsură PDM (14g), 250ml apă rece, 1 shot espresso, Aloe și Ceai.",
    "ingredients_es": "2 cucharadas F1 Café Latte (26g), 1 cucharada PDM (14g), 250ml agua fría, 1 café expreso, Aloe y Té.",
    "protein": "22g",
    "carbs": "21g",
    "fats": "4g",
    "tip": "Gusto avvolgente senza acidità per lo stomaco.",
    "tip_en": "Smooth coffee flavor that is gentle and non-acidic for the stomach.",
    "tip_ro": "Gust cremos de cafea fără aciditate pentru stomac.",
    "tip_es": "Sabor delicioso a café suave sin acidez estomacal.",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1461023058943-07fcbe16d735?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1461023058943-07fcbe16d735?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Shake F1 Vaniglia, Cannella & PDM",
    "title_en": "F1 Vanilla, Cinnamon & PDM Shake",
    "title_ro": "Shake F1 Vanilie, Scorțișoară & PDM",
    "title_es": "Batido F1 Vainilla, Canela y PDM",
    "category": "frullati",
    "emoji": "🥤",
    "gradient": "linear-gradient(135deg, #10b981 0%, #047857 100%)",
    "prepTime": "3 min",
    "calories": "225 kcal",
    "difficulty": "Facile",
    "description": "Shake F1 Vaniglia con spolverata di cannella + PDM in acqua + Aloe e Infuso + 1 kiwi 🥝",
    "description_en": "F1 Vanilla with ground cinnamon + PDM in cold water + Aloe and Tea + 1 kiwi 🥝",
    "description_ro": "Shake F1 Vanilie cu scorțișoară + PDM în apă + Aloe și Ceai + 1 kiwi 🥝",
    "description_es": "Batido F1 Vainilla con canela en polvo + PDM en agua + Aloe y Té + 1 kiwi 🥝",
    "ingredients": "2 misurini F1 Vaniglia (26g), 1 misurino PDM (14g), 250ml acqua fresca, cannella, Aloe e Infuso.",
    "ingredients_en": "2 scoops F1 Vanilla (26g), 1 scoop PDM (14g), 250ml cold water, cinnamon, Aloe and Tea.",
    "ingredients_ro": "2 măsuri F1 Vanilie (26g), 1 măsură PDM (14g), 250ml apă rece, scorțișoară, Aloe și Ceai.",
    "ingredients_es": "2 cucharadas F1 Vainilla (26g), 1 cucharada PDM (14g), 250ml agua fría, canela en polvo, Aloe y Té.",
    "protein": "22g",
    "carbs": "23g",
    "fats": "3.5g",
    "tip": "Il kiwi apporta vitamina C naturale e fibra digestiva.",
    "tip_en": "Kiwi delivers natural Vitamin C and prebiotic digestive enzymes.",
    "tip_ro": "Kiwi aduce vitamina C naturală și enzime digestive.",
    "tip_es": "El kiwi aporta vitamina C natural y enzimas digestivas.",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Shake F1 Fragola & Frutti Rossi + PDM",
    "title_en": "F1 Strawberry & Wild Berries + PDM",
    "title_ro": "Shake F1 Căpșuni & Fructe de Pădure + PDM",
    "title_es": "Batido F1 Fresa y Frutos Rojos + PDM",
    "category": "frullati",
    "emoji": "🍓",
    "gradient": "linear-gradient(135deg, #fce4ec 0%, #d81b60 100%)",
    "prepTime": "3 min",
    "calories": "225 kcal",
    "difficulty": "Facile",
    "description": "Shake F1 Fragola + PDM in acqua fresca con frutti di bosco + Aloe e Infuso + mandarino 🍓",
    "description_en": "F1 Strawberry + PDM in cold water with berries + Aloe and Tea + tangerine 🍓",
    "description_ro": "Shake F1 Căpșuni + PDM în apă rece cu fructe de pădure + Aloe și Ceai + mandarină 🍓",
    "description_es": "Batido F1 Fresa + PDM en agua fría con frutos rojos + Aloe y Té + mandarina 🍓",
    "ingredients": "2 misurini F1 Fragola (26g), 1 misurino PDM (14g), 250ml acqua fresca, 40g frutti rossi, Aloe e Infuso.",
    "ingredients_en": "2 scoops F1 Strawberry (26g), 1 scoop PDM (14g), 250ml cold water, 40g wild berries, Aloe and Tea.",
    "ingredients_ro": "2 măsuri F1 Căpșuni (26g), 1 măsură PDM (14g), 250ml apă rece, 40g fructe de pădure, Aloe și Ceai.",
    "ingredients_es": "2 cucharadas F1 Fresa (26g), 1 cucharada PDM (14g), 250ml agua fría, 40g frutos rojos, Aloe y Té.",
    "protein": "22g",
    "carbs": "23g",
    "fats": "3.5g",
    "tip": "Giorno 7: carica di energia positiva per completare la sfida!",
    "tip_en": "Day 7: stay energized and keep momentum strong for the final stretch!",
    "tip_ro": "Ziua 7: energie pozitivă pentru a finaliza cu succes provocarea!",
    "tip_es": "Día 7: ¡máxima energía positiva para completar el reto!",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1586985289688-ca3cf47d3e6e?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1586985289688-ca3cf47d3e6e?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Shake F1 Biscotto & Crema + PDM",
    "title_en": "F1 Cookie Crunch & PDM Shake",
    "title_ro": "Shake F1 Biscuit & PDM",
    "title_es": "Batido F1 Galleta y Crema + PDM",
    "category": "frullati",
    "emoji": "🍪",
    "gradient": "linear-gradient(135deg, #10b981 0%, #047857 100%)",
    "prepTime": "3 min",
    "calories": "220 kcal",
    "difficulty": "Facile",
    "description": "Shake F1 Cookies & Cream + PDM in acqua fresca + Aloe e Infuso + fetta di melone 🍪",
    "description_en": "F1 Cookie Crunch + PDM in cold water + Aloe and Tea + melon slice 🍪",
    "description_ro": "Shake F1 Biscuit + PDM în apă rece + Aloe și Ceai + felie de pepene 🍪",
    "description_es": "Batido F1 Cookies & Cream + PDM en agua fría + Aloe y Té + rodaja de melón 🍪",
    "ingredients": "2 misurini F1 Cookies & Cream (26g), 1 misurino PDM (14g), 250ml acqua fresca, Aloe e Infuso.",
    "ingredients_en": "2 scoops F1 Cookie Crunch (26g), 1 scoop PDM (14g), 250ml cold water, Aloe and Tea.",
    "ingredients_ro": "2 măsuri F1 Biscuit (26g), 1 măsură PDM (14g), 250ml apă rece, Aloe și Ceai.",
    "ingredients_es": "2 cucharadas F1 Galleta y Crema (26g), 1 cucharada PDM (14g), 250ml agua fría, Aloe y Té.",
    "protein": "22g",
    "carbs": "23g",
    "fats": "4g",
    "tip": "Dolcezza avvolgente senza zuccheri raffinati aggiunti.",
    "tip_en": "Decadent sweet taste with zero added refined sugars.",
    "tip_ro": "Dulceață desăvârșită fără zaharuri rafinate adăugate.",
    "tip_es": "Sabor delicioso sin azúcares refinados añadidos.",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1579954115545-a95591f28bfc?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1579954115545-a95591f28bfc?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Shake F1 Cioccolato, Menta & PDM",
    "title_en": "F1 Mint Chocolate & PDM Shake",
    "title_ro": "Shake F1 Ciocolată, Mentă & PDM",
    "title_es": "Batido F1 Chocolate, Menta y PDM",
    "category": "frullati",
    "emoji": "🍫",
    "gradient": "linear-gradient(135deg, #6b4c41 0%, #3e2723 100%)",
    "prepTime": "3 min",
    "calories": "220 kcal",
    "difficulty": "Facile",
    "description": "Shake F1 Cioccolato + PDM in acqua fresca con foglie di menta + Aloe e Infuso + mela 🍫",
    "description_en": "F1 Chocolate + PDM in cold water with fresh mint leaves + Aloe and Tea + apple 🍫",
    "description_ro": "Shake F1 Ciocolată + PDM în apă rece cu frunze de mentă + Aloe și Ceai + măr 🍫",
    "description_es": "Batido F1 Chocolate + PDM en agua fría con hojas de menta fresca + Aloe y Té + manzana 🍫",
    "ingredients": "2 misurini F1 Cioccolato (26g), 1 misurino PDM (14g), 250ml acqua fresca, 3 foglie menta fresca, ghiaccio, Aloe e Infuso.",
    "ingredients_en": "2 scoops F1 Chocolate (26g), 1 scoop PDM (14g), 250ml cold water, 3 mint leaves, ice, Aloe and Tea.",
    "ingredients_ro": "2 măsuri F1 Ciocolată (26g), 1 măsură PDM (14g), 250ml apă rece, 3 frunze mentă, gheață, Aloe și Ceai.",
    "ingredients_es": "2 cucharadas F1 Chocolate (26g), 1 cucharada PDM (14g), 250ml agua fría, 3 hojas menta fresca, hielo, Aloe y Té.",
    "protein": "22g",
    "carbs": "22g",
    "fats": "4g",
    "tip": "Gusto rinfrescante tipo After Eight energizzante.",
    "tip_en": "Refreshing after-dinner mint style flavor that boosts morning vitality.",
    "tip_ro": "Gust răcoritor și energizant stil After Eight.",
    "tip_es": "Sabor refrescante estilo After Eight para activarte.",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Shake F1 Celebrativo Day 10 + PDM 🏆",
    "title_en": "F1 Day 10 Celebration Shake + PDM 🏆",
    "title_ro": "Shake F1 Festiv Ziua 10 + PDM 🏆",
    "title_es": "Batido F1 Celebración Día 10 + PDM 🏆",
    "category": "frullati",
    "emoji": "🥤",
    "gradient": "linear-gradient(135deg, #10b981 0%, #047857 100%)",
    "prepTime": "3 min",
    "calories": "245 kcal",
    "difficulty": "Facile",
    "description": "Shake F1 Caffellatte o Vaniglia + PDM in acqua fresca con cannella + 3 noci + Aloe e Infuso 🌟",
    "description_en": "F1 Cafe Latte or Vanilla + PDM in cold water with cinnamon + 3 walnuts + Aloe & Tea 🌟",
    "description_ro": "Shake F1 Caffe Latte sau Vanilie + PDM în apă rece cu scorțișoară + 3 nuci + Aloe și Ceai 🌟",
    "description_es": "Batido F1 Café Latte o Vainilla + PDM en agua fría con canela + 3 nueces + Aloe y Té 🌟",
    "ingredients": "2 misurini F1 Caffellatte o Vaniglia (26g), 1 misurino PDM (14g), 250ml acqua fresca, cannella, 3 noci, Aloe e Infuso.",
    "ingredients_en": "2 scoops F1 Cafe Latte or Vanilla (26g), 1 scoop PDM (14g), 250ml cold water, cinnamon, 3 walnuts, Aloe & Tea.",
    "ingredients_ro": "2 măsuri F1 Caffe Latte sau Vanilie (26g), 1 măsură PDM (14g), 250ml apă rece, scorțișoară, 3 nuci, Aloe și Ceai.",
    "ingredients_es": "2 cucharadas F1 Café Latte o Vainilla (26g), 1 cucharada PDM (14g), 250ml agua fría, canela, 3 nueces, Aloe y Té.",
    "protein": "24g",
    "carbs": "22g",
    "fats": "7g",
    "tip": "Complimenti! Oggi completi i tuoi 10 Giorni di trasformazione!",
    "tip_en": "Congratulations! Today you complete your 10-Day Wellness Challenge!",
    "tip_ro": "Felicitări! Astăzi finalizezi cele 10 Zile de transformare!",
    "tip_es": "¡Felicidades! ¡Hoy completas tus 10 Días de transformación!",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1543339308-43e59d6b73a6?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1502741224143-90386d7f8c82?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Pancake Proteico F1 + PDM",
    "title_en": "F1 + PDM Protein Pancake",
    "title_ro": "Clătite Proteice F1 + PDM",
    "title_es": "Pancakes Proteicos F1 + PDM",
    "category": "snack",
    "emoji": "🥞",
    "gradient": "linear-gradient(135deg, #ffecb3 0%, #ffb300 100%)",
    "prepTime": "8 min",
    "calories": "245 kcal",
    "difficulty": "Medio",
    "description": "Pancake soffici e nutrienti con Formula 1 Biscotto e PDM in acqua, la colazione dei campioni.",
    "description_en": "Fluffy, nutritious pancakes with Formula 1 Cookie Crunch and PDM in water, breakfast of champions.",
    "description_ro": "Clătite pufoase și hrănitoare cu Formula 1 Biscuit și PDM în apă, micul dejun al campionilor.",
    "description_es": "Pancakes esponjosos y nutritivos con Fórmula 1 Galleta y PDM en agua, el desayuno de campeones.",
    "ingredients": "2 misurini F1 Biscotto e Crema (26g), 1 misurino PDM (14g), 1 albume (o uovo), 40ml acqua. Cuocere in padella antiaderente.",
    "ingredients_en": "2 scoops F1 Cookie Crunch (26g), 1 scoop PDM (14g), 1 egg white (or egg), 40ml water. Cook in non-stick pan.",
    "ingredients_ro": "2 măsuri F1 Biscuit (26g), 1 măsură PDM (14g), 1 albuș (sau ou), 40ml apă. Se gătesc în tigaie antiaderentă.",
    "ingredients_es": "2 cucharadas F1 Galleta (26g), 1 cucharada PDM (14g), 1 clara (o huevo), 40ml agua. Cocinar en sartén antiadherente.",
    "protein": "24g",
    "carbs": "22g",
    "fats": "5g",
    "tip": "Guarnisci con un filo di yogurt greco 0% o frutti di bosco freschi.",
    "tip_en": "Garnish with a spoon of 0% Greek yogurt or fresh berries.",
    "tip_ro": "Guarnisci con un filo di yogurt greco 0% o frutti di bosco freschi.",
    "tip_es": "Guarnisci con un filo di yogurt greco 0% o frutti di bosco freschi.",
    "productKeys": [
      "formula1",
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1528207776546-365bb710ee93?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1528207776546-365bb710ee93?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "High Protein Iced Coffee Frappé",
    "title_en": "High Protein Iced Coffee Frappé",
    "title_ro": "Cafea Proteică Rece Iced Coffee Frappé",
    "title_es": "Batido Café Proteico Iced Coffee Frappé",
    "category": "snack",
    "emoji": "☕",
    "gradient": "linear-gradient(135deg, #4e342e 0%, #271d19 100%)",
    "prepTime": "2 min",
    "calories": "80 kcal",
    "difficulty": "Facilissimo",
    "description": "La pausa caffè perfetta: 15g di proteine pure del siero del latte, vero caffè 100% Robusta e solo 80 kcal con zero zuccheri aggiunti.",
    "description_en": "The ultimate coffee break: 15g pure whey protein, 100% Robusta espresso beans, only 80 kcal and zero added sugar.",
    "description_ro": "Pauza de cafea ideală: 15g proteine din zer, cafea autentică 100% Robusta și doar 80 kcal fără adaos de zahăr.",
    "description_es": "La pausa de café perfecta: 15g de proteína de suero, auténtico café 100% Robusta y solo 80 kcal sin azúcar añadido.",
    "ingredients": "2 misurini High Protein Iced Coffee (gusto Caramello o Macchiato), 250ml acqua fredda, 4-5 cubetti di ghiaccio, spolverata di cannella o cacao.",
    "ingredients_en": "2 scoops High Protein Iced Coffee (Caramel or Latte Macchiato), 250ml cold water, 4-5 ice cubes, dusting of cinnamon or cocoa.",
    "ingredients_ro": "2 măsuri High Protein Iced Coffee (Caramel sau Latte Macchiato), 250ml apă rece, 4-5 cuburi de gheață, scorțișoară sau cacao.",
    "ingredients_es": "2 cucharadas High Protein Iced Coffee (Caramelo o Macchiato), 250ml agua fría, 4-5 cubitos de hielo, canela o cacao en polvo.",
    "protein": "15g",
    "carbs": "5g",
    "fats": "0.5g",
    "tip": "Frulla con il ghiaccio per ottenere una schiuma densa e cremosa proprio come al bar!",
    "tip_en": "Blend with ice to get a thick, frosty barista-style coffee crema!",
    "tip_ro": "Frulla con il ghiaccio per ottenere una schiuma densa e cremosa proprio come al bar!",
    "tip_es": "Frulla con il ghiaccio per ottenere una schiuma densa e cremosa proprio come al bar!",
    "productKeys": [
      "icedcoffee"
    ],
    "img": "https://images.unsplash.com/photo-1517256064527-09c73fc73e38?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1517256064527-09c73fc73e38?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Protein Mocha Power Shake",
    "title_en": "Protein Mocha Power Shake",
    "title_ro": "Shake Proteic Mocha Power",
    "title_es": "Batido Proteico Mocha Power",
    "category": "snack",
    "emoji": "🍫☕",
    "gradient": "linear-gradient(135deg, #5d4037 0%, #3e2723 100%)",
    "prepTime": "2 min",
    "calories": "160 kcal",
    "difficulty": "Facile",
    "description": "Fusione gourmet tra High Protein Iced Coffee e Formula 1 Cacao per 22g di proteine, carica termogenica e gusto moka irresistibile.",
    "description_en": "Gourmet fusion of High Protein Iced Coffee and F1 Cocoa: 22g protein, natural thermogenic boost, and rich mocha flavor.",
    "description_ro": "Fuziune între Iced Coffee și F1 Cacao: 22g proteine, stimulare termogenică și gust intens de cafea mocha.",
    "description_es": "Fusión gourmet entre Iced Coffee y F1 Chocolate: 22g de proteína, impulso termogénico y sabor a moca irresistible.",
    "ingredients": "1 misurino High Protein Iced Coffee, 1 misurino Formula 1 Cacao (o Cioccolato e Menta), 250ml acqua fresca, ghiaccio.",
    "ingredients_en": "1 scoop High Protein Iced Coffee, 1 scoop Formula 1 Cocoa, 250ml cold water, ice cubes.",
    "ingredients_ro": "1 măsură High Protein Iced Coffee, 1 măsură Formula 1 Cacao, 250ml apă rece, gheață.",
    "ingredients_es": "1 cucharada High Protein Iced Coffee, 1 cucharada Fórmula 1 Chocolate, 250ml agua fría, hielo.",
    "protein": "22g",
    "carbs": "15g",
    "fats": "2g",
    "tip": "Ideale a metà pomeriggio per sconfiggere il calo di concentrazione e riattivare il focus mentale!",
    "tip_en": "Perfect for mid-afternoon slumps to recharge mental focus and sustain fullness!",
    "tip_ro": "Ideale a metà pomeriggio per sconfiggere il calo di concentrazione e riattivare il focus mentale!",
    "tip_es": "Ideale a metà pomeriggio per sconfiggere il calo di concentrazione e riattivare il focus mentale!",
    "productKeys": [
      "icedcoffee",
      "formula1"
    ],
    "img": "https://images.unsplash.com/photo-1578314675249-a6910f80cc4e?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1578314675249-a6910f80cc4e?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Tri-Blend Green Vegan Power Shake",
    "title_en": "Tri-Blend Green Vegan Power Shake",
    "title_ro": "Shake Vegan Tri-Blend Green Power",
    "title_es": "Batido Vegano Tri-Blend Green Power",
    "category": "snack",
    "emoji": "🌱",
    "gradient": "linear-gradient(135deg, #33691e 0%, #1b5e20 100%)",
    "prepTime": "3 min",
    "calories": "160 kcal",
    "difficulty": "Facile",
    "description": "Proteine 100% vegetali biologiche (piselli, quinoa, lino) con Tri-Blend Select e spinaci baby per fibre, minerali e sazietà pulita.",
    "description_en": "100% organic plant protein (pea, quinoa, flaxseed) with Tri-Blend Select and baby spinach for fiber, minerals, and clean satiety.",
    "description_ro": "Proteine 100% vegetale organice (mazăre, quinoa, in) cu Tri-Blend Select și spanac pentru fibre, minerale și sațietate curată.",
    "description_es": "Proteínas 100% vegetales ecológicas (guisantes, quinoa, lino) con Tri-Blend Select y espinacas para fibra y saciedad limpia.",
    "ingredients": "2 misurini Tri Blend Select Banana o Coffee Caramel (26g), 250ml acqua fresca, 1 manciata di spinaci baby freschi, 3 cubetti di ghiaccio.",
    "ingredients_en": "2 scoops Tri Blend Select (26g), 250ml cold water, 1 handful fresh baby spinach, 3 ice cubes.",
    "ingredients_ro": "2 măsuri Tri Blend Select (26g), 250ml apă rece, 1 mână de spanac proaspăt, 3 cuburi de gheață.",
    "ingredients_es": "2 cucharadas Tri Blend Select (26g), 250ml agua fría, 1 puñado de espinacas frescas, 3 cubitos de hielo.",
    "protein": "20g",
    "carbs": "11g",
    "fats": "2.5g",
    "tip": "Tri-Blend è naturalmente senza glutine, privo di soia e certificato Vegan Society!",
    "tip_en": "Tri-Blend is naturally gluten-free, soy-free, and Vegan Society certified!",
    "tip_ro": "Tri-Blend è naturalmente senza glutine, privo di soia e certificato Vegan Society!",
    "tip_es": "Tri-Blend è naturalmente senza glutine, privo di soia e certificato Vegan Society!",
    "productKeys": [
      "triblend"
    ],
    "img": "https://images.unsplash.com/photo-1576045057995-568f588f82fb?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1576045057995-568f588f82fb?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Tri-Blend Protein Porridge & Bowl",
    "title_en": "Tri-Blend Protein Porridge & Bowl",
    "title_ro": "Bol / Porridge Proteic Tri-Blend",
    "title_es": "Porridge Proteico Vegano Tri-Blend",
    "category": "snack",
    "emoji": "🥣",
    "gradient": "linear-gradient(135deg, #a1887f 0%, #5d4037 100%)",
    "prepTime": "5 min",
    "calories": "210 kcal",
    "difficulty": "Medio",
    "description": "Una crema calda e nutriente all'avena arricchita con Tri-Blend Select per 22g di proteine biologiche a lento rilascio.",
    "description_en": "Warm, nourishing whole-grain oats enriched with Tri-Blend Select for 22g slow-release organic protein.",
    "description_ro": "Cremă caldă de ovăz îmbogățită cu Tri-Blend Select pentru 22g proteine vegetale cu eliberare lentă.",
    "description_es": "Crema caliente de avena enriquecida con Tri-Blend Select para 22g de proteína vegetal de lenta absorción.",
    "ingredients": "1 misurino Tri Blend Select (20g), 30g fiocchi d'avena integrale, 120ml acqua calda, 20g frutti di bosco o mirtilli freschi.",
    "ingredients_en": "1 scoop Tri Blend Select (20g), 30g rolled whole oats, 120ml warm water, 20g fresh berries.",
    "ingredients_ro": "1 măsură Tri Blend Select (20g), 30g fulgi de ovăz integral, 120ml apă caldă, 20g fructe de pădure.",
    "ingredients_es": "1 cucharada Tri Blend Select (20g), 30g copos de avena integral, 120ml agua caliente, 20g frutos rojos.",
    "protein": "22g",
    "carbs": "24g",
    "fats": "3.5g",
    "tip": "Mescola il Tri-Blend quando l'avena tiepida è pronta per preservare tutti i micronutrienti!",
    "tip_en": "Stir in Tri-Blend after oats are warmed to preserve raw vitamins and delicate enzymes!",
    "tip_ro": "Mescola il Tri-Blend quando l'avena tiepida è pronta per preservare tutti i micronutrienti!",
    "tip_es": "Mescola il Tri-Blend quando l'avena tiepida è pronta per preservare tutti i micronutrienti!",
    "productKeys": [
      "triblend"
    ],
    "img": "https://images.unsplash.com/photo-1584776296944-ab6fb57b0bdd?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1584776296944-ab6fb57b0bdd?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Muffin Proteico in Tazza",
    "title_en": "Protein Mug Cake",
    "title_ro": "Brioșă Proteică la Cană",
    "title_es": "Mug Cake Proteico",
    "category": "snack",
    "emoji": "🧁",
    "gradient": "linear-gradient(135deg, #d32f2f 0%, #7b1fa2 100%)",
    "prepTime": "5 min",
    "calories": "180 kcal",
    "difficulty": "Medio",
    "description": "Un delizioso snack cotto al microonde per soddisfare la voglia di dolce in modo sano.",
    "description_en": "A delicious microwaved snack to satisfy your sweet tooth the healthy way.",
    "description_ro": "Un snack delicios la cuptorul cu microunde pentru a-ți satisface pofta de dulce.",
    "description_es": "Un delicioso snack de microondas para satisfacer el antojo dulce de forma sana.",
    "ingredients": "1 misurino F1 Cacao, 1 uovo intero, 2 cucchiai d'acqua, 1/2 cucchiaino di lievito.",
    "ingredients_en": "1 scoop F1 Cocoa, 1 whole egg, 2 tbsp water, 1/2 tsp baking powder.",
    "ingredients_ro": "1 măsură F1 Cacao, 1 ou întreg, 2 linguri de apă, 1/2 linguriță praf de copt.",
    "ingredients_es": "1 cucharada F1 Cacao, 1 huevo entero, 2 cucharadas de agua, 1/2 cucharadita de levadura.",
    "protein": "14g",
    "carbs": "12g",
    "fats": "8g",
    "tip": "Fai attenzione a non cuocerlo troppo: 90 secondi nel microonde bastano!",
    "tip_en": "Be careful not to overcook: 90 seconds in the microwave is enough!",
    "tip_ro": "Fai attenzione a non cuocerlo troppo: 90 secondi nel microonde bastano!",
    "tip_es": "Fai attenzione a non cuocerlo troppo: 90 secondi nel microonde bastano!",
    "productKeys": [
      "formula1"
    ],
    "img": "https://images.unsplash.com/photo-1607958996333-41aef7caefaa?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1607958996333-41aef7caefaa?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Barretta Proteica Herbalife",
    "title_en": "Herbalife Protein Bar",
    "title_ro": "Baton Proteic Herbalife",
    "title_es": "Barrita Proteica Herbalife",
    "category": "snack",
    "emoji": "🍫",
    "gradient": "linear-gradient(135deg, #795548 0%, #3e2723 100%)",
    "prepTime": "1 min",
    "calories": "140 kcal",
    "difficulty": "Facile",
    "description": "Snack pronto, perfetto da portare sempre con sé per spezzare la fame tra i pasti.",
    "description_en": "Ready-to-eat snack, perfect to carry with you to curb hunger between meals.",
    "description_ro": "Snack gata de consumat, perfect de luat cu tine pentru a-ți stăvili foamea între mese.",
    "description_es": "Snack listo para comer, perfecto para llevar contigo y matar el hambre entre comidas.",
    "ingredients": "1 Barretta Proteica Herbalife (gusto a scelta).",
    "ingredients_en": "1 Herbalife Protein Bar (flavor of choice).",
    "ingredients_ro": "1 Baton Proteic Herbalife (aroma preferată).",
    "ingredients_es": "1 Barrita Proteica Herbalife (sabor a elegir).",
    "protein": "10g",
    "carbs": "15g",
    "fats": "4g",
    "tip": "Tienila in frigo nei mesi estivi per un effetto rinfrescante e croccante.",
    "tip_en": "Keep it in the fridge during summer months for a refreshing crispness.",
    "tip_ro": "Păstrează-l la frigider în lunile calde pentru o textură crocantă și răcoroasă.",
    "tip_es": "Guárdala en la nevera en verano para disfrutarla fresca y crujiente.",
    "productKeys": [
      "proteinbar"
    ],
    "img": "assets/snack_protein_bar.png",
    "image": "https://images.unsplash.com/photo-1606313564200-e75d5e30476c?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Protein Chips Herbalife",
    "title_en": "Herbalife Protein Chips",
    "title_ro": "Protein Chips Herbalife",
    "title_es": "Protein Chips Herbalife",
    "category": "snack",
    "emoji": "🥨",
    "gradient": "linear-gradient(135deg, #ea580c 0%, #c2410c 100%)",
    "prepTime": "1 min",
    "calories": "135 kcal",
    "difficulty": "Facile",
    "description": "Snack proteico salato irresistibile e croccante con piselli soffiati. 50% di grassi in meno rispetto alle patatine tradizionali fritte.",
    "description_en": "Irresistible savory crunchy protein snack made with popped pea protein. 50% less fat compared to traditional fried potato chips.",
    "description_ro": "Gustare sărată proteică crocantă și delicioasă din mazăre expandată. Cu 50% mai puține grăsimi decât chipsurile tradiționale prăjite.",
    "description_es": "Snack proteico salado crujiente e irresistible con proteína de guisante inflada. Con 50% menos grasa que las patatas fritas tradicionales.",
    "ingredients": "1 sacchetto Protein Chips Herbalife (gusto Barbecue o Cipolla).",
    "ingredients_en": "1 bag Herbalife Protein Chips (Barbecue or Onion flavor).",
    "ingredients_ro": "1 pungă Protein Chips Herbalife (aromă Barbecue sau Ceapă).",
    "ingredients_es": "1 bolsa Protein Chips Herbalife (sabor Barbacoa o Cebolla).",
    "protein": "11g",
    "carbs": "12g",
    "fats": "3.2g",
    "tip": "Ideale per spezzare la fame nel pomeriggio o come sfizio salato senza sensi di colpa.",
    "tip_en": "Perfect for an afternoon savory snack or satisfying crunch without guilty feelings.",
    "tip_ro": "Ideal pentru a potoli pofta de sărat după-amiaza fără regrete.",
    "tip_es": "Ideal para calmar el antojo salado de la tarde sin remordimientos.",
    "productKeys": [
      "proteinchips"
    ],
    "img": "https://images.unsplash.com/photo-1566478989037-eec170784d0b?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1566478989037-eec170784d0b?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Aperitivo Fit: Protein Chips & Salsa",
    "title_en": "Fit Appetizer: Protein Chips & Dip",
    "title_ro": "Aperitiv Fit: Protein Chips & Sos",
    "title_es": "Aperitivo Fit: Protein Chips & Salsa",
    "category": "snack",
    "emoji": "🥑",
    "gradient": "linear-gradient(135deg, #65a30d 0%, #3f6212 100%)",
    "prepTime": "3 min",
    "calories": "175 kcal",
    "difficulty": "Facile",
    "description": "Un aperitivo sano e sfizioso: Protein Chips Herbalife intinte in hummus di ceci o guacamole leggero.",
    "description_en": "A healthy, satisfying finger-food: Herbalife Protein Chips dipped in chickpea hummus or fresh light guacamole.",
    "description_ro": "Un aperitiv sănătos și gustos: Protein Chips Herbalife servite cu hummus de năut sau guacamole ușor.",
    "description_es": "Un aperitivo sano y sabroso: Protein Chips Herbalife acompañadas de hummus de garbanzo o guacamole ligero.",
    "ingredients": "1 sacchetto Protein Chips Herbalife, 40g hummus tradizionale o 30g guacamole fresco, succo di lime.",
    "ingredients_en": "1 bag Herbalife Protein Chips, 40g chickpea hummus or 30g fresh guacamole, squeeze of lime.",
    "ingredients_ro": "1 pungă Protein Chips Herbalife, 40g hummus tradițional sau 30g guacamole proaspăt, suc de lămâie verde.",
    "ingredients_es": "1 bolsa Protein Chips Herbalife, 40g hummus de garbanzo o 30g guacamole fresco, unas gotas de lima.",
    "protein": "14g",
    "carbs": "16g",
    "fats": "5.5g",
    "tip": "Uno snack conviviale completo di proteine vegetali, fibre e grassi buoni.",
    "tip_en": "A delicious social snack packed with clean plant protein, fiber and healthy fats.",
    "tip_ro": "O gustare plină de proteine vegetale curate, fibre și grăsimi sănătoase.",
    "tip_es": "Un snack perfecto con proteína vegetal limpia, fibra y grasas saludables.",
    "productKeys": [
      "proteinchips"
    ],
    "img": "https://images.unsplash.com/photo-1513456852971-30c0b8199d4d?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1513456852971-30c0b8199d4d?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Yogurt Greco & Cannella",
    "title_en": "Greek Yogurt & Cinnamon",
    "title_ro": "Iaurt Grecesc & Scorțișoară",
    "title_es": "Yogur Griego & Canela",
    "category": "snack",
    "emoji": "🧁",
    "gradient": "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    "prepTime": "2 min",
    "calories": "140 kcal",
    "difficulty": "Facile",
    "description": "Yogurt greco bianco 0% grassi con una spolverata di cannella e frutti freschi 🧁",
    "description_en": "Plain 0% fat Greek yogurt dusted with cinnamon and fresh blueberries 🧁",
    "description_ro": "Iaurt grecesc 0% grăsime cu scorțișoară și afine proaspete 🧁",
    "description_es": "Yogur griego 0% grasa con un toque de canela y arándanos frescos 🧁",
    "ingredients": "150g yogurt greco 0%, cannella in polvere, 30g mirtilli o fragole fresche.",
    "ingredients_en": "150g 0% Greek yogurt, ground cinnamon, 30g fresh blueberries or strawberries.",
    "ingredients_ro": "150g iaurt grecesc 0%, scorțișoară pudră, 30g afine proaspete.",
    "ingredients_es": "150g yogur griego 0%, canela en polvo, 30g arándanos o fresas.",
    "protein": "15g",
    "carbs": "10g",
    "fats": "0.5g",
    "tip": "La cannella aiuta a regolare la glicemia evitando picchi di fame.",
    "tip_en": "Cinnamon helps regulate blood sugar levels, preventing sudden cravings.",
    "tip_ro": "Scorțișoara ajută la reglarea glicemiei și previne poftele.",
    "tip_es": "La canela ayuda a regular los niveles de azúcar y previene la ansiedad.",
    "productKeys": [],
    "img": "assets/healthy_afternoon_snack.png",
    "image": "https://images.unsplash.com/photo-1488477181946-6428a0291777?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Protein Chips & Hummus Fit 🥨",
    "title_en": "Protein Chips & Fit Hummus 🥨",
    "title_ro": "Protein Chips & Hummus Fit 🥨",
    "title_es": "Protein Chips & Hummus Fit 🥨",
    "category": "snack",
    "emoji": "🥨",
    "gradient": "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
    "prepTime": "2 min",
    "calories": "175 kcal",
    "difficulty": "Facile",
    "description": "Snack salato croccante: 1 sacchetto di Protein Chips Herbalife con 2 cucchiai di hummus di ceci",
    "description_en": "Savory crunchy snack: 1 bag of Herbalife Protein Chips paired with 2 tbsp chickpea hummus",
    "description_ro": "Gustare sărată crocantă: 1 pungă Protein Chips Herbalife cu 2 linguri de hummus de năut",
    "description_es": "Snack salato crujiente: 1 bolsa de Protein Chips Herbalife con 2 cucharadas de hummus de garbanzo",
    "ingredients": "1 sacchetto Protein Chips Herbalife (30g), 40g hummus tradizionale.",
    "ingredients_en": "1 bag Herbalife Protein Chips (30g), 40g traditional hummus.",
    "ingredients_ro": "1 pungă Protein Chips Herbalife (30g), 40g hummus tradițional.",
    "ingredients_es": "1 bolsa Protein Chips Herbalife (30g), 40g hummus tradicional.",
    "protein": "14g",
    "carbs": "16g",
    "fats": "5.5g",
    "tip": "Chips di piselli soffiati non fritte con il 50% di grassi in meno rispetto alle patatine tradizionali!",
    "tip_en": "Popped pea protein chips with 50% less fat than standard fried potato chips!",
    "tip_ro": "Chipsuri din mazăre expandată, neprăjite, cu 50% mai puține grăsimi decât chipsurile clasice!",
    "tip_es": "¡Chips de proteína de guisante inflada no fritas con 50% menos de grasa que las patatas tradicionales!",
    "productKeys": [
      "proteinchips"
    ],
    "img": "assets/snack_hummus_veggies.png",
    "image": "https://images.unsplash.com/photo-1577906096429-f73c2c312435?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Caffè Proteico Iced Coffee Shakerato ☕",
    "title_en": "High Protein Iced Coffee Frappé ☕",
    "title_ro": "Cafea Proteică Rece Iced Coffee ☕",
    "title_es": "Café Proteico Iced Coffee Frappé ☕",
    "category": "snack",
    "emoji": "☕",
    "gradient": "linear-gradient(135deg, #78350f 0%, #451a03 100%)",
    "prepTime": "2 min",
    "calories": "80 kcal",
    "difficulty": "Facile",
    "description": "Spuntino rinfrescante con 2 misurini di High Protein Iced Coffee in acqua fredda con ghiaccio",
    "description_en": "Refreshing protein iced coffee made with 2 scoops of High Protein Iced Coffee and ice",
    "description_ro": "Gustare răcoritoare cu 2 măsuri de High Protein Iced Coffee în apă rece cu gheață",
    "description_es": "Snack refrescante con 2 cucharadas de High Protein Iced Coffee en agua fría con hielo",
    "ingredients": "2 misurini High Protein Iced Coffee, 250ml acqua fredda, cubetti di ghiaccio, spolverata di cannella.",
    "ingredients_en": "2 scoops High Protein Iced Coffee, 250ml cold water, ice cubes, cinnamon dusting.",
    "ingredients_ro": "2 măsuri High Protein Iced Coffee, 250ml apă rece, cuburi de gheață, scorțișoară.",
    "ingredients_es": "2 cucharadas High Protein Iced Coffee, 250ml agua fría, cubitos de hielo, canela.",
    "protein": "15g",
    "carbs": "5g",
    "fats": "0.5g",
    "tip": "15g di proteine e 80mg di caffeina con sole 80 kcal e zero zuccheri aggiunti.",
    "tip_en": "15g whey protein and 80mg caffeine with only 80 kcal and zero added sugar.",
    "tip_ro": "15g proteine și 80mg cafeină cu doar 80 kcal și zero adaos de zahăr.",
    "tip_es": "15g de proteína y 80mg de cafeína con solo 80 kcal y sin azúcar añadido.",
    "productKeys": [
      "highproteinicedcoffee"
    ],
    "img": "https://images.unsplash.com/photo-1541167760496-1628856ab772?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1550989460-0adf9ea622e2?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Shake Proteico Veloce PDM",
    "title_en": "Quick PDM Protein Boost",
    "title_ro": "Shake Rapid PDM",
    "title_es": "Batido Rápido de PDM",
    "category": "snack",
    "emoji": "🍫",
    "gradient": "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    "prepTime": "1 min",
    "calories": "110 kcal",
    "difficulty": "Facile",
    "description": "Shake rapido con 1 misurino di Protein Drink Mix (PDM) Herbalife ed acqua fresca 🥤",
    "description_en": "Speedy shake with 1 scoop Herbalife Protein Drink Mix (PDM) in chilled water 🥤",
    "description_ro": "Shake rapid cu 1 măsură de Protein Drink Mix (PDM) Herbalife în apă rece 🥤",
    "description_es": "Batido rápido con 1 cucharada de Protein Drink Mix (PDM) en agua fría 🥤",
    "ingredients": "1 misurino PDM Herbalife, 250ml acqua fredda, ghiaccio.",
    "ingredients_en": "1 scoop Herbalife PDM, 250ml cold water, ice cubes.",
    "ingredients_ro": "1 măsură PDM Herbalife, 250ml apă rece, gheață.",
    "ingredients_es": "1 cucharada PDM Herbalife, 250ml agua fría, hielo.",
    "protein": "15g",
    "carbs": "4g",
    "fats": "1.5g",
    "tip": "15g di proteine pure con sole 110 kcal.",
    "tip_en": "Delivers 15g of pure protein with only 110 kcal.",
    "tip_ro": "15g de proteine pure cu doar 110 kcal.",
    "tip_es": "15g de proteína pura con solo 110 kcal.",
    "productKeys": [
      "pdm"
    ],
    "img": "https://images.unsplash.com/photo-1594498653385-d5172c532c00?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1590080875515-8a3a8dc5735e?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Tri-Blend Select Vegan Protein Snack 🌱",
    "title_en": "Tri-Blend Select Vegan Protein Snack 🌱",
    "title_ro": "Tri-Blend Select Gustare Proteică Vegană 🌱",
    "title_es": "Tri-Blend Select Snack Proteico Vegano 🌱",
    "category": "snack",
    "emoji": "🌱",
    "gradient": "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    "prepTime": "2 min",
    "calories": "150 kcal",
    "difficulty": "Facile",
    "description": "Snack proteico 100% vegetale e biologico (piselli, quinoa, lino) in acqua fresca",
    "description_en": "100% organic plant-based protein snack (pea, quinoa, flaxseed) in cold water",
    "description_ro": "Gustare 100% vegetală și organică (mazăre, quinoa, in) în apă rece",
    "description_es": "Snack 100% vegetal y ecológico (guisantes, quinoa, lino) en agua fría",
    "ingredients": "2 misurini Tri Blend Select (26g), 250ml acqua fresca, 3 cubetti di ghiaccio.",
    "ingredients_en": "2 scoops Tri Blend Select (26g), 250ml cold water, 3 ice cubes.",
    "ingredients_ro": "2 măsuri Tri Blend Select (26g), 250ml apă rece, 3 cuburi gheață.",
    "ingredients_es": "2 cucharadas Tri Blend Select (26g), 250ml agua fría, 3 cubitos de hielo.",
    "protein": "20g",
    "carbs": "10g",
    "fats": "2.5g",
    "tip": "20g di proteine vegetali bio per proteggere la massa magra e favorire la sazietà.",
    "tip_en": "20g organic plant protein to protect lean muscle and promote lasting satiety.",
    "tip_ro": "20g proteine vegetale bio pentru susținerea masei musculare și sațietate prelungită.",
    "tip_es": "20g de proteína vegetal bio para proteger el músculo y mantener la saciedad.",
    "productKeys": [
      "triblend"
    ],
    "img": "https://images.unsplash.com/photo-1508736793122-f516e3ba5569?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1606755962773-d324e0a13086?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Mela Verde & Burro d Arachidi",
    "title_en": "Green Apple & Peanut Butter",
    "title_ro": "Măr Verde & Unt de Arahide",
    "title_es": "Manzana Verde & Mantequilla de Cacahuete",
    "category": "snack",
    "emoji": "🍏",
    "gradient": "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    "prepTime": "3 min",
    "calories": "155 kcal",
    "difficulty": "Facile",
    "description": "Una mela verde fresca a fette con un cucchiaino di burro d arachidi puro 🍏",
    "description_en": "Crisp green apple slices paired with 1 teaspoon of 100% pure peanut butter 🍏",
    "description_ro": "Un măr verde feliat cu 1 linguriță de unt pur de arahide 🍏",
    "description_es": "Una manzana verde en gajos con 1 cucharadita de mantequilla de cacahuete pura 🍏",
    "ingredients": "1 mela verde, 10g burro d arachidi 100%.",
    "ingredients_en": "1 crisp green apple, 10g pure peanut butter.",
    "ingredients_ro": "1 măr verde, 10g unt de arahide 100%.",
    "ingredients_es": "1 manzana verde, 10g mantequilla cacahuete 100%.",
    "protein": "4g",
    "carbs": "22g",
    "fats": "6g",
    "tip": "Gusto delizioso tra l acido della mela ed il nutriente dell arachide.",
    "tip_en": "A delicious blend of fruit fiber and satisfying healthy fats.",
    "tip_ro": "Gust delicios între aciditatea mărului și nutriția arahidelor.",
    "tip_es": "Combinación perfecta de fibra y grasas saludables.",
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1568702846914-96b305d2aaeb?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1568702846914-96b305d2aaeb?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Iced Coffee Mocha Booster ☕🍫",
    "title_en": "Iced Coffee Mocha Booster ☕🍫",
    "title_ro": "Iced Coffee Mocha Booster ☕🍫",
    "title_es": "Iced Coffee Mocha Booster ☕🍫",
    "category": "snack",
    "emoji": "☕",
    "gradient": "linear-gradient(135deg, #78350f 0%, #451a03 100%)",
    "prepTime": "2 min",
    "calories": "90 kcal",
    "difficulty": "Facile",
    "description": "High Protein Iced Coffee shakerato con ghiaccio e una spolverata di cacao amaro",
    "description_en": "High Protein Iced Coffee shaken with ice and a dusting of dark cocoa",
    "description_ro": "Cafea proteică rece Iced Coffee amestecată cu gheață și pudră de cacao pură",
    "description_es": "High Protein Iced Coffee mezclado con hielo y un toque de cacao desgrasado",
    "ingredients": "2 misurini High Protein Iced Coffee, 250ml acqua fredda, ghiaccio, cacao amaro in polvere.",
    "ingredients_en": "2 scoops High Protein Iced Coffee, 250ml cold water, ice, unsweetened cocoa.",
    "ingredients_ro": "2 măsuri High Protein Iced Coffee, 250ml apă rece, gheață, cacao pudră.",
    "ingredients_es": "2 cucharadas High Protein Iced Coffee, 250ml agua fría, hielo, cacao puro.",
    "protein": "15g",
    "carbs": "6g",
    "fats": "0.8g",
    "tip": "Sostiene concentrazione ed energia pomeridiana senza appesantire la digestione.",
    "tip_en": "Fuels afternoon concentration and clean energy with zero sugar crashes.",
    "tip_ro": "Susține concentrarea și energia de după-amiază fără calorii inutile.",
    "tip_es": "Mantiene la concentración y la energía por la tarde sin sensación de pesadez.",
    "productKeys": [
      "highproteinicedcoffee"
    ],
    "img": "https://images.unsplash.com/photo-1511690656952-34342bb7c2f2?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1509440159596-0249088772ff?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Tri-Blend Smoothie Frutti di Bosco 🫐",
    "title_en": "Tri-Blend Berry Vegan Smoothie 🫐",
    "title_ro": "Tri-Blend Smoothie Vegan cu Fructe de Pădure 🫐",
    "title_es": "Tri-Blend Smoothie Vegano de Arándanos 🫐",
    "category": "snack",
    "emoji": "🌱",
    "gradient": "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    "prepTime": "2 min",
    "calories": "165 kcal",
    "difficulty": "Facile",
    "description": "Smoothie proteico cremoso con Tri Blend Select e mirtilli freschi in acqua",
    "description_en": "Creamy plant-based protein smoothie with Tri Blend Select and fresh blueberries",
    "description_ro": "Smoothie proteic cremos cu Tri Blend Select și afine proaspete în apă",
    "description_es": "Smoothie cremoso con Tri Blend Select y arándanos frescos en agua",
    "ingredients": "2 misurini Tri Blend Select, 250ml acqua fresca, 30g mirtilli, ghiaccio.",
    "ingredients_en": "2 scoops Tri Blend Select, 250ml cold water, 30g blueberries, ice.",
    "ingredients_ro": "2 măsuri Tri Blend Select, 250ml apă rece, 30g afine, gheață.",
    "ingredients_es": "2 cucharadas Tri Blend Select, 250ml agua fría, 30g arándanos, hielo.",
    "protein": "20g",
    "carbs": "15g",
    "fats": "2.5g",
    "tip": "Fibre antiossidanti e proteine vegane biologiche per celebrare l ultimo giorno!",
    "tip_en": "Antioxidant-packed plant nutrition to celebrate your Day 10 milestone!",
    "tip_ro": "Fibre antioxidante și proteine vegane pentru celebrarea ultimei zile!",
    "tip_es": "Antioxidantes y proteína vegetal ecológica para festejar tu último día!",
    "productKeys": [
      "triblend"
    ],
    "img": "https://images.unsplash.com/photo-1498557850523-fd3d118b962e?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1534353473418-4cfa6c56fd38?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Tagliata di Pollo al Rosmarino, Zucca & Spinaci",
    "title_en": "Rosemary Chicken Breast with Pumpkin & Spinach",
    "title_ro": "Piept de Pui cu Rozmarin, Dovleac & Spanac",
    "title_es": "Pechuga de Pollo al Romero con Calabaza y Espinacas",
    "category": "pasti",
    "mealType": "both",
    "goalTag": "deficit",
    "emoji": "🍗",
    "gradient": "linear-gradient(135deg, #f59e0b 0%, #b45309 100%)",
    "prepTime": "18 min",
    "calories": "340 kcal",
    "difficulty": "Facile",
    "description": "Petto di pollo magro cotto alla piastra con erbe aromatiche, accompagnato da zucca al forno e spinaci saltati al limone.",
    "description_en": "Lean grilled chicken breast herb-seasoned, served with roasted butternut squash and lemon-sauteed fresh spinach.",
    "description_ro": "Piept de pui slab la grătar cu ierburi aromatice, servit cu dovleac copt și spanac proaspăt sotat cu lămâie.",
    "description_es": "Pechuga de pollo a la plancha con hierbas aromáticas, calabaza asada y espinacas salteadas al limón.",
    "ingredients": "160g petto di pollo magro, 200g zucca a fette, 150g spinaci freschi, 1 cucchiaino Olio EVO, rosmarino fresco, succo di limone, sale e pepe.",
    "ingredients_en": "160g lean chicken breast, 200g sliced pumpkin, 150g fresh spinach, 1 tsp extra virgin olive oil, fresh rosemary, lemon juice, pepper.",
    "ingredients_ro": "160g piept de pui slab, 200g dovleac feliat, 150g spanac proaspăt, 1 linguriță Ulei Măsline Extra Virgin, rozmarin, suc de lămâie.",
    "ingredients_es": "160g pechuga de pollo, 200g calabaza en rodajas, 150g espinacas frescas, 1 cucharadita Aceite Oliva Virgen Extra, romero, zumo de limón.",
    "protein": "38g",
    "carbs": "20g",
    "fats": "6g",
    "tip": "La zucca dona sazietà e dolcezza con pochissime calorie. Il limone massimizza l'assorbimento del ferro vegetale degli spinaci!",
    "tip_en": "Squash provides lasting satiety with very few calories. Fresh lemon boosts plant iron absorption from spinach!",
    "tip_ro": "Dovleacul aduce sațietate cu foarte puține calorii. Lămâia favorizează absorbția fierului din spanac!",
    "tip_es": "La calabaza sacia con poquísimas calorías y el limón potencia la asimilación del hierro vegetal.",
    "isRealFood": true,
    "productKeys": [],
    "img": "assets/balanced_lunch_chicken.png",
    "image": "https://images.unsplash.com/photo-1532550907401-a500c9a57435?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Filetto di Merluzzo alle Erbe, Patate Dolci & Asparagi",
    "title_en": "Herb-Crusted Cod with Sweet Potatoes & Asparagus",
    "title_ro": "File de Cod cu Ierburi, Cartofi Dulci & Sparanghel",
    "title_es": "Filete de Bacalao a las Hierbas, Boniato y Espárragos",
    "category": "pasti",
    "mealType": "cena",
    "goalTag": "deficit",
    "emoji": "🐟",
    "gradient": "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
    "prepTime": "20 min",
    "calories": "330 kcal",
    "difficulty": "Facile",
    "description": "Merluzzo fresco dorato in padella con timo e prezzemolo, cubetti di patata dolce al vapore e asparagi verdi drenanti.",
    "description_en": "Fresh golden cod fillet pan-seared with thyme and parsley, steamed sweet potato cubes, and cleansing asparagus spears.",
    "description_ro": "File de cod proaspăt rumenit la tigaie cu cimbru și pătrunjel, cuburi de cartof dulce la abur și sparanghel drenant.",
    "description_es": "Lomo de bacalao dorado a la sartén con tomillo y perejil, boniato al vapor y espárragos verdes drenantes.",
    "ingredients": "180g filetto di merluzzo fresco, 120g patate dolci a cubetti, 150g asparagi verdi, 1 cucchiaino Olio EVO, prezzemolo, pepe rosa.",
    "ingredients_en": "180g fresh cod fillet, 120g sweet potato cubes, 150g green asparagus, 1 tsp olive oil, parsley, pink pepper.",
    "ingredients_ro": "180g file de cod proaspăt, 120g cartofi dulci cuburi, 150g sparanghel verde, 1 linguriță ulei măsline, pătrunjel, piper.",
    "ingredients_es": "180g filete de bacalao fresco, 120g boniato en cubos, 150g espárragos verdes, 1 cucharadita aceite oliva, perejil, pimienta.",
    "protein": "36g",
    "carbs": "28g",
    "fats": "5g",
    "tip": "Cena iperproteica e ultra-digeribile: gli asparagi stimolano la diuresi notturna facendoti svegliare sgonfio e leggero.",
    "tip_en": "Ultra-lean high-protein dinner: asparagus naturally flushes excess water so you wake up flat and refreshed.",
    "tip_ro": "Cină hiperproteică și foarte ușoară: sparanghelul stimulează eliminarea retenției de apă pentru o dimineață fără balonare.",
    "tip_es": "Cena hiperproteica y ligera: los espárragos eliminan líquidos retenidos para despertar deshinchado.",
    "isRealFood": true,
    "productKeys": [],
    "img": "assets/lunch_cod_sweetpotato.png",
    "image": "https://images.unsplash.com/photo-1540420773420-3366772f4999?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Power Bowl: Salmone Selvaggio, Quinoa & Avocado",
    "title_en": "Power Bowl: Wild Salmon, Quinoa & Avocado",
    "title_ro": "Power Bowl: Somon Sălbatic, Quinoa & Avocado",
    "title_es": "Power Bowl: Salmón Salvaje, Quinoa y Aguacate",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "massa",
    "emoji": "🥑",
    "gradient": "linear-gradient(135deg, #059669 0%, #047857 100%)",
    "prepTime": "15 min",
    "calories": "460 kcal",
    "difficulty": "Facile",
    "description": "Trancio di salmone alla griglia su letto di quinoa reale, avocado a fettine, pomodorini e cetrioli croccanti.",
    "description_en": "Grilled salmon fillet over royal quinoa, fresh avocado slices, sweet cherry tomatoes, and crisp cucumbers.",
    "description_ro": "File de somon la grătar pe pat de quinoa regală, felii de avocado, roșii cherry și castraveți crocanți.",
    "description_es": "Lomo de salmón a la plancha sobre quinoa real, aguacate en rodajas, tomates cherry y pepino crujiente.",
    "ingredients": "150g filetto di salmone, 60g quinoa cotta, 40g avocado maturo, 100g pomodorini, cetriolo a rondelle, succo di lime, semi di sesamo.",
    "ingredients_en": "150g salmon fillet, 60g cooked quinoa, 40g ripe avocado, 100g cherry tomatoes, cucumber, lime juice, sesame seeds.",
    "ingredients_ro": "150g file de somon, 60g quinoa fiartă, 40g avocado copt, 100g roșii cherry, castravete, suc de lămâie verde, susan.",
    "ingredients_es": "150g filete de salmón, 60g quinoa cocida, 40g aguacate, 100g tomates cherry, pepino, zumo de lima, semillas de sésamo.",
    "protein": "38g",
    "carbs": "36g",
    "fats": "18g",
    "tip": "Ricco di acidi grassi essenziali Omega-3 e carboidrati complessi per stimolare la crescita muscolare e il recupero.",
    "tip_en": "Loaded with clean Omega-3s and complex carbs to nourish muscles and accelerate workout recovery.",
    "tip_ro": "Bogat în acizi grași Omega-3 și carbohidrați complecși pentru susținerea masei musculare și refacere.",
    "tip_es": "Rico en Omega-3 y carbohidratos complejos para nutrir los músculos y acelerar la recuperación.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Straccetti di Manzo Magro, Basmati & Broccoli",
    "title_en": "Lean Beef Strips with Basmati Rice & Broccoli",
    "title_ro": "Fâșii de Vită Slabă cu Orez Basmati & Broccoli",
    "title_es": "Tiras de Ternera Magra con Arroz Basmati y Brócoli",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "massa",
    "emoji": "🥩",
    "gradient": "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
    "prepTime": "15 min",
    "calories": "450 kcal",
    "difficulty": "Facile",
    "description": "Bocconcini di scamone di manzo magro saltati con zenzero e soia leggera, serviti con riso basmati e cime di broccoli al vapore.",
    "description_en": "Lean beef sirloin strips flash-seared with ginger and light tamari, paired with aromatic basmati rice and steamed broccoli florets.",
    "description_ro": "Bucăți de mușchi de vită slabă sotate cu ghimbir și sos de soia, servite cu orez basmati și buchețele de broccoli la abur.",
    "description_es": "Tiras de ternera magra salteadas con jengibre y soja baja en sal, con arroz basmati y ramilletes de brócoli al vapor.",
    "ingredients": "160g manzo magro a straccetti, 65g riso basmati bollito, 200g broccoli al vapore, 1 cucchiaio soia tamari, zenzero fresco tritato.",
    "ingredients_en": "160g lean beef strips, 65g boiled basmati rice, 200g steamed broccoli, 1 tbsp light tamari, fresh minced ginger.",
    "ingredients_ro": "160g fâșii de vită slabă, 65g orez basmati fiert, 200g broccoli la abur, 1 lingură soia tamari, ghimbir proaspăt ras.",
    "ingredients_es": "160g ternera magra en tiras, 65g arroz basmati cocido, 200g brócoli al vapor, 1 cucharada salsa de soja suave, jengibre.",
    "protein": "42g",
    "carbs": "44g",
    "fats": "9g",
    "tip": "Fonte eccellente di ferro eme altamente assimilabile, zinco e creatina naturale per supportare la forza e il tono muscolare.",
    "tip_en": "High-bioavailability heme iron, zinc, and natural creatine to boost muscle density and daily endurance.",
    "tip_ro": "Sursă excelentă de fier biodisponibil, zinc și creatină naturală pentru forță și tonifiere musculară.",
    "tip_es": "Fuente ideal de hierro hemo, zinc y creatina natural para mejorar la fuerza y la firmeza muscular.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1544025162-d76694265947?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1544025162-d76694265947?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Riso Venere con Gamberetti, Zucchine & Limone",
    "title_en": "Black Rice with Wild Shrimp, Zucchini & Lemon",
    "title_ro": "Orez Negru cu Creveți, Dovlecei & Lămâie",
    "title_es": "Arroz Negro con Langostinos, Calabacín y Limón",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "energia",
    "emoji": "🦐",
    "gradient": "linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)",
    "prepTime": "15 min",
    "calories": "390 kcal",
    "difficulty": "Facile",
    "description": "Riso venere integrale ricco di antociani e sali minerali con gamberi scottati, julienne di zucchine e scorzetta di limone bio.",
    "description_en": "Mineral-packed whole black rice loaded with anthocyanins, sauteed shrimp, julienned zucchini, and organic lemon zest.",
    "description_ro": "Orez negru integral bogat în antociani și minerale, cu creveți trași la tigaie, fâșii de dovlecei și coajă de lămâie.",
    "description_es": "Arroz negro integral con antioxidantes y minerales, langostinos salteados, calabacín en juliana y ralladura de limón.",
    "ingredients": "65g riso venere bollito, 140g gamberetti sgusciati, 1 zucchina media, scorza di limone bio, 1 cucchiaio Olio EVO, prezzemolo fresco.",
    "ingredients_en": "65g boiled black rice, 140g peeled shrimp, 1 medium zucchini, organic lemon zest, 1 tbsp olive oil, fresh parsley.",
    "ingredients_ro": "65g orez negru fiert, 140g creveți decorticați, 1 dovlecel mediu, coajă de lămâie bio, 1 lingură ulei măsline, pătrunjel.",
    "ingredients_es": "65g arroz negro cocido, 140g langostinos pelados, 1 calabacín mediano, ralladura de limón, 1 cucharada aceite oliva, perejil.",
    "protein": "30g",
    "carbs": "45g",
    "fats": "7g",
    "tip": "Il riso venere ha un indice glicemico basso che rilascia energia pulita e costante per tutto il pomeriggio senza colpi di sonno.",
    "tip_en": "Black rice has a low glycemic index providing sustained, clean energy without post-lunch crashes.",
    "tip_ro": "Orezul negru oferă energie constantă cu eliberare lentă pentru întreaga după-amiază fără senzație de somnolență.",
    "tip_es": "El arroz negro mantiene la energía estable toda la tarde sin bajones de azúcar ni pesadez.",
    "isRealFood": true,
    "productKeys": [],
    "img": "assets/lunch_shrimp_blackrice.png",
    "image": "https://images.unsplash.com/photo-1559847844-5315695dadae?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Omelette di Albumi con Funghi Trifolati & Segale",
    "title_en": "Egg White Omelette with Sauteed Mushrooms & Rye",
    "title_ro": "Omletă din Albușuri cu Ciuperci & Pâine de Secară",
    "title_es": "Tortilla de Claras con Champiñones y Pan de Centeno",
    "category": "pasti",
    "mealType": "cena",
    "goalTag": "deficit",
    "emoji": "🍳",
    "gradient": "linear-gradient(135deg, #d97706 0%, #b45309 100%)",
    "prepTime": "10 min",
    "calories": "280 kcal",
    "difficulty": "Facile",
    "description": "Frittata soffice di soli albumi e 1 uovo intero con funghi champignon saltati al prezzemolo e 1 fetta di pane di segale tostato.",
    "description_en": "Fluffy 3-egg white omelette with 1 whole egg, sauteed garlic mushrooms, and 1 slice of toasted whole rye bread.",
    "description_ro": "Omletă pufoasă din albușuri și 1 ou întreg cu ciuperci champignon călite cu pătrunjel și 1 felie de pâine de secară prăjită.",
    "description_es": "Tortilla esponjosa de claras y 1 huevo con champiñones al ajillo y 1 rebanada de pan de centeno tostado.",
    "ingredients": "160ml albumi d'uovo, 1 uovo intero biologico, 150g funghi champignon, 1 fetta pane 100% segale (35g), erba cipollina, pepe nero.",
    "ingredients_en": "160ml egg whites, 1 organic whole egg, 150g button mushrooms, 1 slice 100% rye bread (35g), chives, black pepper.",
    "ingredients_ro": "160ml albușuri de ou, 1 ou întreg bio, 150g ciuperci champignon, 1 felie pâine secară (35g), ceapă verde, piper.",
    "ingredients_es": "160ml claras de huevo, 1 huevo entero ecológico, 150g champiñones, 1 rebanada pan centeno (35g), cebollino, pimienta.",
    "protein": "28g",
    "carbs": "22g",
    "fats": "5g",
    "tip": "Cena ad altissima densità proteica e zero pesantezza. Favorisce la secrezione notturna dell'ormone GH e il dimagrimento!",
    "tip_en": "Ultra-lean high-protein dinner that promotes nighttime GH secretion and deep metabolic fat burning.",
    "tip_ro": "Cină bogată în proteine și ușor digerabilă, ideală pentru stimularea arderilor pe timpul nopții.",
    "tip_es": "Cena ligera hiperproteica que favorece el descanso profundo y la quema de grasa nocturna.",
    "isRealFood": true,
    "productKeys": [],
    "img": "assets/dinner_spinach_omelet.png",
    "image": "https://images.unsplash.com/photo-1512058564366-18510be2db19?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Orata al Cartoccio Mediterranea con Zucchine",
    "title_en": "Baked Sea Bream en Papillote with Zucchini & Olives",
    "title_ro": "Doradă la Cuptor în Papiotă cu Dovlecei & Măsline",
    "title_es": "Dorada al Horno en Papillote con Calabacín y Aceitunas",
    "category": "pasti",
    "mealType": "cena",
    "goalTag": "deficit",
    "emoji": "🐟",
    "gradient": "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
    "prepTime": "25 min",
    "calories": "320 kcal",
    "difficulty": "Facile",
    "description": "Filetto di orata o branzino cotto al vapore nel cartoccio al forno con pomodorini ciliegino, olive taggiasche, origano e zucchine.",
    "description_en": "Fresh sea bream fillet gently steam-baked en papillote with cherry tomatoes, Taggiasca olives, oregano, and zucchini.",
    "description_ro": "File de doradă copt la abur în hârtie de copt cu roșii cherry, măsline, oregano și dovlecei la grătar.",
    "description_es": "Filete de dorada fresca al horno en papillote con tomates cherry, aceitunas negras, orégano y calabacín.",
    "ingredients": "170g filetto di orata fresca, 6 pomodorini ciliegino, 6 olive denocciolate, 1 zucchina a rondelle, origano secco, 1 cucchiaino Olio EVO.",
    "ingredients_en": "170g fresh sea bream fillet, 6 cherry tomatoes, 6 pitted olives, 1 sliced zucchini, dried oregano, 1 tsp extra virgin olive oil.",
    "ingredients_ro": "170g file de doradă, 6 roșii cherry, 6 măsline fără sâmburi, 1 dovlecel feliat, oregano, 1 linguriță ulei măsline.",
    "ingredients_es": "170g filete de dorada, 6 tomates cherry, 6 aceitunas deshuesadas, 1 calabacín en rodajas, orégano, 1 cucharadita aceite oliva.",
    "protein": "34g",
    "carbs": "8g",
    "fats": "12g",
    "tip": "La cottura al cartoccio sigilla tutti i succhi e i nutrienti del pesce senza bisogno di aggiungere grassi in cottura.",
    "tip_en": "Baking en papillote traps delicate aromas and moisture without needing extra heavy oils.",
    "tip_ro": "Gătirea în papiotă păstrează sucurile și aromele naturale ale peștelui fără adaos inutil de grăsimi.",
    "tip_es": "El papillote concentra los sabores y nutrientes del pescado sin necesidad de añadir grasas extras.",
    "isRealFood": true,
    "productKeys": [],
    "img": "assets/balanced_dinner_fish.png",
    "image": "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Tacchino agli Agrumi, Finocchi Croccanti & Arancia",
    "title_en": "Citrus Turkey Breast with Fennel & Orange Salad",
    "title_ro": "Curcan cu Citrice, Salată de Fenicul & Portocală",
    "title_es": "Pavo a los Cítricos con Ensalada de Hinojo y Naranja",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "energia",
    "emoji": "🍊",
    "gradient": "linear-gradient(135deg, #ea580c 0%, #c2410c 100%)",
    "prepTime": "15 min",
    "calories": "350 kcal",
    "difficulty": "Facile",
    "description": "Bocconcini di fesa di tacchino marinati con succo d'arancia e zenzero, serviti con insalata fresca di finocchi e melograno.",
    "description_en": "Turkey breast tenderloins marinated in fresh orange and ginger juice, paired with crisp shaved fennel and pomegranate jewels.",
    "description_ro": "Bucăți de piept de curcan marinate în suc de portocale și ghimbir, servite cu salată crocantă de fenicul și rodie.",
    "description_es": "Pechuga de pavo marinada con naranja y jengibre, acompañada de ensalada fresca de hinojo crujiente y granada.",
    "ingredients": "160g fesa di tacchino, 1 finocchio medio a fettine sottili, 1/2 arancia a vivo, 1 cucchiaio chicchi di melograno, 1 cucchiaino Olio EVO.",
    "ingredients_en": "160g turkey breast, 1 shaved fennel bulb, 1/2 segmented orange, 1 tbsp pomegranate seeds, 1 tsp olive oil.",
    "ingredients_ro": "160g piept de curcan, 1 fenicul feliat fin, 1/2 portocală felii, 1 lingură boabe de rodie, 1 linguriță ulei măsline.",
    "ingredients_es": "160g pechuga de pavo, 1 hinojo cortado fino, 1/2 naranja en gajos, 1 cucharada granada, 1 cucharadita aceite oliva.",
    "protein": "37g",
    "carbs": "24g",
    "fats": "8g",
    "tip": "L'abbinamento finocchio-arancia azzera i gonfiori addominali e favorisce una digestione rapida e rinfrescante.",
    "tip_en": "Fennel and orange naturally relieve bloating while delivering high vitamin C and prebiotic fibers.",
    "tip_ro": "Combinația de fenicul și portocală elimină balonarea și asigură o digestie foarte ușoară.",
    "tip_es": "El hinojo con naranja calma el sistema digestivo y previene la inflamación abdominal.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Vellutata Detox di Zucca, Carote & Tofu Piastrato",
    "title_en": "Detox Pumpkin & Carrot Velouté with Grilled Tofu",
    "title_ro": "Supă Cremă Detox de Dovleac & Morcovi cu Tofu",
    "title_es": "Crema Detox de Calabaza y Zanahoria con Tofu a la Plancha",
    "category": "pasti",
    "mealType": "cena",
    "goalTag": "energia",
    "emoji": "🥣",
    "gradient": "linear-gradient(135deg, #ca8a04 0%, #a16207 100%)",
    "prepTime": "20 min",
    "calories": "310 kcal",
    "difficulty": "Facile",
    "description": "Crema tiepida e vellutata di verdure arancioni con cubetti di tofu dorati alla piastra e croccanti semi di zucca tostati.",
    "description_en": "Warm golden soup of roasted pumpkin and carrots topped with crispy seared tofu cubes and toasted pumpkin seeds.",
    "description_ro": "Supă caldă și fină din dovleac și morcovi, garnisită cu cuburi de tofu rumenite pe grătar și semințe de dovleac.",
    "description_es": "Crema suave templada de calabaza y zanahoria con dados de tofu dorado a la plancha y semillas tostadas.",
    "ingredients": "250g zucca cotta, 1 carota grande, 120g tofu al naturale compatto, 1 cucchiaio semi di zucca, curcuma in polvere, 1 cucchiaino Olio EVO.",
    "ingredients_en": "250g pumpkin, 1 large carrot, 120g firm tofu, 1 tbsp pumpkin seeds, turmeric, 1 tsp olive oil.",
    "ingredients_ro": "250g dovleac fiert, 1 morcov mare, 120g tofu ferm, 1 lingură semințe de dovleac, turmeric, 1 linguriță ulei măsline.",
    "ingredients_es": "250g calabaza, 1 zanahoria grande, 120g tofu firme, 1 cucharada semillas de calabaza, cúrcuma, 1 cucharadita aceite oliva.",
    "protein": "22g",
    "carbs": "28g",
    "fats": "10g",
    "tip": "Piatto 100% vegetale rilassante per il sistema nervoso, ricco di potassio e triptofano che favoriscono il sonno profondo.",
    "tip_en": "100% plant-based soothing meal packed with potassium and natural tryptophan to encourage restorative sleep.",
    "tip_ro": "Preparat 100% vegetal relaxant, bogat în potasiu și triptofan pentru un somn odihnitor.",
    "tip_es": "Plato 100% vegetal rico en potasio y triptófano natural que favorece la relajación y el descanso profundo.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1476718406336-bb5a9690ee2a?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1476718406336-bb5a9690ee2a?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Insalata Mediterranea: Tonno, Cannellini & Uovo",
    "title_en": "Mediterranean Salad: Tuna, Cannellini Beans & Egg",
    "title_ro": "Salată Mediteraneană: Ton, Fasole Cannellini & Ou",
    "title_es": "Ensalada Mediterránea: Atún, Alubias y Huevo Cocido",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "massa",
    "emoji": "🥗",
    "gradient": "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    "prepTime": "8 min",
    "calories": "420 kcal",
    "difficulty": "Facile",
    "description": "Piatto unico estivo e veloce: fagioli cannellini lessati, tonno al naturale, uovo sodo biologico, pomodori e cipolla rossa.",
    "description_en": "Quick nutrient-dense summer lunch: tender white cannellini beans, solid light tuna, hard-boiled organic egg, and sweet tomatoes.",
    "description_ro": "Prânz rapid și hrănitor: fasole cannellini fiartă, ton în suc propriu, ou fiert bio, roșii și ceapă roșie.",
    "description_es": "Almuerzo rápido y completo: alubias blancas cannellini, atún al natural, huevo cocido ecológico, tomates y cebolla roja.",
    "ingredients": "120g tonno al naturale sgocciolato, 1 uovo sodo, 100g fagioli cannellini cotti, rucola, pomodori maturi, 1 cucchiaio Olio EVO.",
    "ingredients_en": "120g drained natural tuna, 1 hard-boiled egg, 100g cooked cannellini beans, arugula, ripe tomatoes, 1 tbsp olive oil.",
    "ingredients_ro": "120g ton în suc propriu, 1 ou fiert, 100g fasole cannellini fiartă, rucola, roșii proaspete, 1 lingură ulei măsline.",
    "ingredients_es": "120g atún al natural escurrido, 1 huevo cocido, 100g alubias cannellini cocidas, rúcula, tomates, 1 cucharada aceite oliva.",
    "protein": "40g",
    "carbs": "30g",
    "fats": "12g",
    "tip": "Pronto in soli 5 minuti senza accendere i fornelli: unisce proteine nobili e fibre solubili per una sazietà duratura.",
    "tip_en": "Ready in 5 minutes with zero cooking required: merges complete animal proteins with plant fiber for rock-solid fullness.",
    "tip_ro": "Gata în 5 minute fără foc: combină proteine complete și fibre vegetale pentru energie și sațietate prelungită.",
    "tip_es": "Listo en 5 minutos sin cocinar: combina proteínas completas y fibra para mantenerte saciado toda la tarde.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1540420773420-3366772f4999?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Pollo al Curry con Riso Basmati & Zucchine",
    "title_en": "Mild Curry Chicken with Basmati Rice & Zucchini",
    "title_ro": "Pui cu Curry Dulce, Orez Basmati & Dovlecei",
    "title_es": "Pollo al Curry Suave con Arroz Basmati y Calabacín",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "massa",
    "emoji": "🍛",
    "gradient": "linear-gradient(135deg, #eab308 0%, #ca8a04 100%)",
    "prepTime": "18 min",
    "calories": "430 kcal",
    "difficulty": "Facile",
    "description": "Bocconcini di pollo al curry dolce cotti delicatamente con verdure, riso basmati aromatico e rondelle di zucchine alla piastra.",
    "description_en": "Tender chicken breast bites simmered in mild turmeric curry, served with fragrant basmati rice and grilled zucchini coins.",
    "description_ro": "Bucăți fragede de pui cu curry dulce și turmeric, servite cu orez basmati aromat și felii de dovlecel la grătar.",
    "description_es": "Tiras tiernas de pechuga de pollo al curry suave con cúrcuma, arroz basmati aromático y calabacín a la plancha.",
    "ingredients": "150g petto di pollo a dadini, 65g riso basmati, 1 cucchiaio curry dolce in polvere, 1 zucchina a rondelle, 1 cucchiaino Olio EVO.",
    "ingredients_en": "150g diced chicken breast, 65g basmati rice, 1 tbsp mild curry powder, 1 sliced zucchini, 1 tsp olive oil.",
    "ingredients_ro": "150g piept de pui cuburi, 65g orez basmati, 1 lingură pudră de curry, 1 dovlecel rondele, 1 linguriță ulei măsline.",
    "ingredients_es": "150g pechuga de pollo en dados, 65g arroz basmati, 1 cucharada curry suave, 1 calabacín en rodajas, 1 cucharadita aceite oliva.",
    "protein": "40g",
    "carbs": "45g",
    "fats": "7g",
    "tip": "La curcumina nel curry ha un potente effetto antiossidante e antinfiammatorio, ideale dopo le sessioni di allenamento.",
    "tip_en": "Active curcumin in curry speeds up muscular recovery and fights inflammation post-workout.",
    "tip_ro": "Curcumina din curry are efect antioxidant puternic și antiinflamator, perfect după antrenament.",
    "tip_es": "La curcumina del curry reduce la inflamación y favorece la recuperación muscular tras el ejercicio.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1506354666786-959d6d497f1a?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Spiedini di Salmone & Verdure con Quinoa alle Erbe",
    "title_en": "Salmon & Grilled Vegetable Skewers with Herb Quinoa",
    "title_ro": "Frigărui de Somon & Legume cu Quinoa cu Ierburi",
    "title_es": "Brochetas de Salmón y Verduras con Quinoa a las Hierbas",
    "category": "pasti",
    "mealType": "both",
    "goalTag": "deficit",
    "emoji": "🍢",
    "gradient": "linear-gradient(135deg, #f97316 0%, #c2410c 100%)",
    "prepTime": "20 min",
    "calories": "370 kcal",
    "difficulty": "Facile",
    "description": "Cubotti di salmone fresco alternati a peperoni, cipolla rossa e zucchine cotti alla griglia, serviti con quinoa all'aneto.",
    "description_en": "Succulent salmon cubes skewered with sweet bell peppers, red onions, and zucchini, served with dill-infused quinoa.",
    "description_ro": "Cuburi de somon proaspăt alternate cu ardei gras, ceapă roșie și dovlecei pe frigărui la grătar, servite cu quinoa și mărar.",
    "description_es": "Dados de salmón fresco en brochetas con pimiento, cebolla roja y calabacín a la plancha, servidos con quinoa al eneldo.",
    "ingredients": "140g filetto di salmone a cubotti, 1/2 peperone rosso, 1 zucchina, 40g quinoa cotta, aneto fresco, succo di limone, pepe.",
    "ingredients_en": "140g salmon fillet cubes, 1/2 red bell pepper, 1 zucchini, 40g cooked quinoa, fresh dill, lemon juice, pepper.",
    "ingredients_ro": "140g file de somon cuburi, 1/2 ardei roșu, 1 dovlecel, 40g quinoa fiartă, mărar proaspăt, suc de lămâie.",
    "ingredients_es": "140g salmón fresco en dados, 1/2 pimiento rojo, 1 calabacín, 40g quinoa cocida, eneldo fresco, zumo de limón.",
    "protein": "33g",
    "carbs": "25g",
    "fats": "14g",
    "tip": "Un pasto colorato ricco di carotenoidi e grassi buoni che stimola il metabolismo e favorisce la tonicità della pelle.",
    "tip_en": "Vibrant carotenoid-packed dish that enhances skin radiance and boosts active metabolism.",
    "tip_ro": "Masă colorată plină de carotenoizi și grăsimi sănătoase ce stimulează metabolismul și aspectul pielii.",
    "tip_es": "Plato colorido lleno de carotenoides y grasas saludables que reactiva el metabolismo y cuida la piel.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1525351484163-7529414344d8?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Petto di Pollo & Quinoa",
    "title_en": "Grilled Chicken & Quinoa",
    "title_ro": "Piept de Pui & Quinoa",
    "title_es": "Pechuga de Pollo & Quinoa",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "massa",
    "emoji": "🍗",
    "gradient": "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
    "prepTime": "15 min",
    "calories": "380 kcal",
    "difficulty": "Facile",
    "description": "Petto di pollo alla piastra (150g) con quinoa e zucchine grigliate 🥗",
    "description_en": "Grilled chicken breast (150g) with cooked quinoa and sliced grilled zucchini 🥗",
    "description_ro": "Piept de pui la grătar (150g) cu quinoa și dovlecei la grătar 🥗",
    "description_es": "Pechuga de pollo a la plancha (150g) con quinoa y calabacín a la plancha 🥗",
    "ingredients": "150g pollo magro, 60g quinoa cotta, 1 zucchina a fette, 1 cucchiaio Olio EVO, erbe aromatiche.",
    "ingredients_en": "150g lean chicken breast, 60g cooked quinoa, 1 sliced zucchini, 1 tbsp extra virgin olive oil, herbs.",
    "ingredients_ro": "150g piept de pui slab, 60g quinoa fiartă, 1 dovlecel feliat, 1 lingură Ulei Măsline Extra Virgin, ierburi.",
    "ingredients_es": "150g pollo magro, 60g quinoa cocida, 1 calabacín, 1 cucharada Aceite Oliva Virgen Extra, hierbas.",
    "protein": "38g",
    "carbs": "32g",
    "fats": "9g",
    "tip": "Mantieni il pollo succoso marinando prima con limone e rosmarino.",
    "tip_en": "Keep the chicken juicy by marinating with fresh lemon juice and rosemary.",
    "tip_ro": "Păstrează puiul suculent marinându-l cu lămâie și rozmarin.",
    "tip_es": "Marina el pollo con limón fresco y romero para que quede tierno y jugoso.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1532550907401-a500c9a57435?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Salmone al Vapore & Broccoli",
    "title_en": "Steamed Salmon & Broccoli",
    "title_ro": "Somon la Abur & Broccoli",
    "title_es": "Salmón al Vapor & Brócoli",
    "category": "pasti",
    "mealType": "cena",
    "goalTag": "massa",
    "emoji": "🐟",
    "gradient": "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
    "prepTime": "12 min",
    "calories": "410 kcal",
    "difficulty": "Facile",
    "description": "Salmone al vapore con broccoli croccanti ed un filo d olio extravergine 🐟",
    "description_en": "Steamed salmon fillet with crisp steamed broccoli and a drizzle of olive oil 🐟",
    "description_ro": "File de somon la abur cu broccoli crocant și puțin ulei de măsline 🐟",
    "description_es": "Salmón al vapor con brócoli crujiente y un toque de aceite de oliva 🐟",
    "ingredients": "150g filetto di salmone, 200g broccoli al vapore, succo di limone, 1 cucchiaino Olio EVO.",
    "ingredients_en": "150g salmon fillet, 200g steamed broccoli, fresh lemon juice, 1 tsp extra virgin olive oil.",
    "ingredients_ro": "150g file de somon, 200g broccoli la abur, suc de lămâie, 1 linguriță Ulei Măsline.",
    "ingredients_es": "150g lomo de salmón, 200g brócoli al vapor, zumo de limón, 1 cucharadita Aceite Oliva.",
    "protein": "34g",
    "carbs": "8g",
    "fats": "22g",
    "tip": "I grassi sani Omega-3 del salmone favoriscono il recupero ed il riposo notturno.",
    "tip_en": "Healthy Omega-3 fatty acids in salmon promote overnight recovery and deep sleep.",
    "tip_ro": "Grăsimile sănătoase Omega-3 din somon favorizează refacerea și somnul odihnitor.",
    "tip_es": "Los ácidos grasos Omega-3 favorecen la recuperación nocturna.",
    "isRealFood": true,
    "productKeys": [],
    "img": "assets/dinner_salmon_steamed.png",
    "image": "https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Merluzzo & Patate Dolci",
    "title_en": "Baked Cod & Sweet Potatoes",
    "title_ro": "Cod la Cuptor & Cartofi Dulci",
    "title_es": "Bacalao al Horno & Boniato",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "deficit",
    "emoji": "🐟",
    "gradient": "linear-gradient(135deg, #059669 0%, #047857 100%)",
    "prepTime": "20 min",
    "calories": "360 kcal",
    "difficulty": "Facile",
    "description": "Filetto di merluzzo al forno con patate dolci al vapore ed insalata mista 🥔",
    "description_en": "Oven-baked cod fillet with steamed sweet potato cubes and mixed green salad 🥔",
    "description_ro": "File de cod la cuptor cu cartofi dulci la abur și salată mixtă 🥔",
    "description_es": "Lomo de bacalao al horno con boniato al vapor y ensalada mixta 🥔",
    "ingredients": "180g filetto di merluzzo fresco, 100g patate dolci a cubetti, asparagi o insalata mista, olio EVO.",
    "ingredients_en": "180g fresh cod fillet, 100g sweet potato cubes, asparagus or mixed greens, olive oil.",
    "ingredients_ro": "180g file de cod proaspăt, 100g cartofi dulci cuburi, sparanghel sau salată mixtă, ulei măsline.",
    "ingredients_es": "180g filete de bacalao, 100g boniato en cubos, espárragos o ensalada, aceite de oliva.",
    "protein": "35g",
    "carbs": "30g",
    "fats": "6g",
    "tip": "Le patate dolci forniscono energia costante a lento rilascio.",
    "tip_en": "Sweet potatoes provide steady, slow-release complex carbohydrates.",
    "tip_ro": "Cartofii dulci oferă energie constantă cu eliberare lentă.",
    "tip_es": "El boniato proporciona energía constante de absorción lenta.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1534939561126-855b8675edd7?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1547496502-affa22d38842?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Omelette di Albumi & Spinaci",
    "title_en": "Egg White & Spinach Omelette",
    "title_ro": "Omletă din Albușuri & Spanac",
    "title_es": "Tortilla de Claras & Espinacas",
    "category": "pasti",
    "mealType": "cena",
    "goalTag": "deficit",
    "emoji": "🍳",
    "gradient": "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
    "prepTime": "10 min",
    "calories": "290 kcal",
    "difficulty": "Facile",
    "description": "Frittata di soli albumi (3) con spinaci freschi ed una fetta di pane integrale 🍳",
    "description_en": "Fluffy 3-egg white omelette with baby spinach and one slice of whole-grain toast 🍳",
    "description_ro": "Omletă din 3 albușuri cu spanac proaspăt și o felie de pâine integrală 🍳",
    "description_es": "Tortilla de 3 claras con espinacas frescas y una tostada integral 🍳",
    "ingredients": "150ml albumi d uovo, 100g spinaci freschi, 1 fetta pane di segale/integrale, pepe nero.",
    "ingredients_en": "150ml egg whites, 100g fresh spinach, 1 slice rye or whole-grain bread, black pepper.",
    "ingredients_ro": "150ml albușuri de ou, 100g spanac proaspăt, 1 felie pâine de secară/integrală, piper.",
    "ingredients_es": "150ml claras de huevo, 100g espinacas frescas, 1 rebanada pan integral, pimienta.",
    "protein": "26g",
    "carbs": "18g",
    "fats": "5g",
    "tip": "Cena leggera e iperproteica per rigenerare i muscoli.",
    "tip_en": "High-protein, low-calorie light dinner to replenish muscles.",
    "tip_ro": "Cină ușoară și bogată în proteine pentru refacerea musculară.",
    "tip_es": "Cena hiperproteica y ligera para regenerar los músculos.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1525351484163-7529414344d8?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Riso Venere & Gamberetti",
    "title_en": "Black Rice & Steamed Prawns",
    "title_ro": "Orez Negru & Creveți",
    "title_es": "Arroz Negro & Langostinos",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "energia",
    "emoji": "🦐",
    "gradient": "linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)",
    "prepTime": "15 min",
    "calories": "390 kcal",
    "difficulty": "Facile",
    "description": "Riso venere nero con gamberetti al vapore, pomodorini e rucola fresca 🦐",
    "description_en": "Nutty black rice with steamed prawns, cherry tomatoes, and fresh rocket 🦐",
    "description_ro": "Orez negru cu creveți la abur, roșii cherry și rucola proaspătă 🦐",
    "description_es": "Arroz negro con langostinos al vapor, tomates cherry y rúcula fresca 🦐",
    "ingredients": "60g riso venere bollito, 120g gamberetti sgusciati, pomodorini cherry, rucola, succo di limone.",
    "ingredients_en": "60g cooked black rice, 120g peeled prawns, cherry tomatoes, fresh arugula, lemon juice.",
    "ingredients_ro": "60g orez negru fiert, 120g creveți decorticați, roșii cherry, rucola, suc de lămâie.",
    "ingredients_es": "60g arroz negro cocido, 120g langostinos pelados, tomates cherry, rúcula, zumo de limón.",
    "protein": "28g",
    "carbs": "42g",
    "fats": "8g",
    "tip": "Il riso venere è ricco di sali minerali ed antociani protettivi.",
    "tip_en": "Black rice is rich in mineral salts and protective anthocyanins.",
    "tip_ro": "Orezul negru este bogat în săruri minerale și antociani.",
    "tip_es": "El arroz negro es rico en minerales y antocianinas protectoras.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1559742811-822873691df8?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Pesce Bianco al Limone & Fagiolini",
    "title_en": "Lemon White Fish & Green Beans",
    "title_ro": "Pește Alb cu Lămâie & Păstăi",
    "title_es": "Pescado Blanco con Limón & Judías Verdes",
    "category": "pasti",
    "mealType": "cena",
    "goalTag": "deficit",
    "emoji": "🐟",
    "gradient": "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
    "prepTime": "15 min",
    "calories": "370 kcal",
    "difficulty": "Facile",
    "description": "Trancio di nasello o salmone alla piastra con fagiolini lessi al limone 🐟",
    "description_en": "Pan-seared white fish fillet with steamed green beans and fresh parsley 🐟",
    "description_ro": "File de pește alb la grătar cu fasole verde la abur și lămâie 🐟",
    "description_es": "Filete de pescado blanco a la plancha con judías verdes al vapor y limón 🐟",
    "ingredients": "160g filetto di pesce, 150g fagiolini verdi al vapore, limone fresco, prezzemolo.",
    "ingredients_en": "160g white fish fillet (hake/sea bass), 150g steamed green beans, lemon juice, parsley.",
    "ingredients_ro": "160g file de pește alb, 150g fasole verde la abur, lămâie proaspătă, pătrunjel.",
    "ingredients_es": "160g filete pescado blanco, 150g judías verdes al vapor, limón fresco, perejil.",
    "protein": "32g",
    "carbs": "10g",
    "fats": "16g",
    "tip": "Mantenere porzioni leggere di sera migliora il sonno profondo.",
    "tip_en": "Keeping evening portions lean improves sleep quality and morning lightness.",
    "tip_ro": "Porțiile ușoare seara îmbunătățesc somnul profund.",
    "tip_es": "Cenar ligero por la noche mejora el descanso profundo.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1559847844-5315695dadae?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1534939561126-855b8675edd7?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Tacchino Arrosto & Asparagi",
    "title_en": "Roast Turkey Breast & Asparagus",
    "title_ro": "Curcan la Cuptor & Sparanghel",
    "title_es": "Pavo Asado & Espárragos",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "deficit",
    "emoji": "🍗",
    "gradient": "linear-gradient(135deg, #059669 0%, #047857 100%)",
    "prepTime": "15 min",
    "calories": "375 kcal",
    "difficulty": "Facile",
    "description": "Tacchino arrosto a fette (140g) con riso basmati e asparagi verdi al vapore 🍗",
    "description_en": "Sliced roast turkey breast (140g) with basmati rice and steamed green asparagus 🍗",
    "description_ro": "Friptură de curcan (140g) cu orez basmati și sparanghel verde la abur 🍗",
    "description_es": "Pechuga de pavo asada (140g) con arroz basmati y espárragos verdes al vapor 🍗",
    "ingredients": "140g petto di tacchino, 60g riso basmati bollito, 150g asparagi freschi.",
    "ingredients_en": "140g turkey breast, 60g boiled basmati rice, 150g fresh asparagus.",
    "ingredients_ro": "140g piept de curcan, 60g orez basmati fiert, 150g sparanghel proaspăt.",
    "ingredients_es": "140g pechuga de pavo, 60g arroz basmati cocido, 150g espárragos frescos.",
    "protein": "36g",
    "carbs": "35g",
    "fats": "5g",
    "tip": "Gli asparagi hanno naturali proprietà drenanti ed antigonfiore.",
    "tip_en": "Asparagus provides natural cleansing and anti-bloating benefits.",
    "tip_ro": "Sparanghelul are proprietăți naturale drenante.",
    "tip_es": "Los espárragos tienen propiedades drenantes naturales.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1598515214211-89d3c73ae83b?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Zuppa di Lenticchie & Crostini",
    "title_en": "Warm Red Lentil Soup",
    "title_ro": "Supă Caldă de Linte Roșie",
    "title_es": "Sopa de Lentejas Rojas & Picatostes",
    "category": "pasti",
    "mealType": "cena",
    "goalTag": "energia",
    "emoji": "🍲",
    "gradient": "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
    "prepTime": "20 min",
    "calories": "330 kcal",
    "difficulty": "Facile",
    "description": "Zuppa tiepida di lenticchie rosse con verdure miste e crostini integrali 🍲",
    "description_en": "Comforting red lentil and vegetable soup with whole-grain croutons 🍲",
    "description_ro": "Supă de linte roșie cu legume mixte și crutoane integrale 🍲",
    "description_es": "Sopa templada de lentejas rojas con verduras y pan integral tostado 🍲",
    "ingredients": "60g lenticchie rosse decorticate, carota, sedano, zucchina, 1 fetta pane integrale.",
    "ingredients_en": "60g red split lentils, diced carrot, celery, zucchini, 1 slice whole-grain bread.",
    "ingredients_ro": "60g linte roșie, morcov, țelină, dovlecel, 1 felie pâine integrală.",
    "ingredients_es": "60g lentejas rojas, zanahoria, apio, calabacín, 1 rebanada pan integral.",
    "protein": "22g",
    "carbs": "44g",
    "fats": "4g",
    "tip": "Le lenticchie rosse decorticate sono facilmente digeribili di sera.",
    "tip_en": "Red split lentils are gentle on the digestive system in the evening.",
    "tip_ro": "Lintea roșie este ușor digerabilă seara.",
    "tip_es": "Las lentejas rojas son ligeras y fáciles de digerir por la noche.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1547592166-23ac45744acd?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Quinoa Bowl con Ceci & Menta",
    "title_en": "Quinoa Bowl with Chickpeas & Mint",
    "title_ro": "Bol de Quinoa cu Năut & Mentă",
    "title_es": "Bowl de Quinoa con Garbanzos & Menta",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "massa",
    "emoji": "🥗",
    "gradient": "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
    "prepTime": "12 min",
    "calories": "400 kcal",
    "difficulty": "Facile",
    "description": "Quinoa con ceci bolliti, pomodorini, cetrioli e menta fresca tritata 🥗",
    "description_en": "Nutrient-rich quinoa with cooked chickpeas, cherry tomatoes, cucumber and fresh mint 🥗",
    "description_ro": "Quinoa cu năut fiert, roșii cherry, castraveți și mentă proaspătă 🥗",
    "description_es": "Quinoa con garbanzos cocidos, tomates cherry, pepino y menta fresca 🥗",
    "ingredients": "60g quinoa, 100g ceci cotta, cetriolo a dadini, menta fresca, olio EVO.",
    "ingredients_en": "60g quinoa, 100g cooked chickpeas, diced cucumber, fresh mint, extra virgin olive oil.",
    "ingredients_ro": "60g quinoa, 100g năut fiert, castravete cuburi, mentă proaspătă, ulei măsline.",
    "ingredients_es": "60g quinoa, 100g garbanzos cocidos, pepino en dados, menta fresca, aceite oliva.",
    "protein": "16g",
    "carbs": "52g",
    "fats": "10g",
    "tip": "Pasto vegetale completo di tutti gli aminoacidi essenziali.",
    "tip_en": "A 100% plant-based meal complete with all 9 essential amino acids.",
    "tip_ro": "Masă vegetală completă cu toți aminoacizii esențiali.",
    "tip_es": "Plato vegetal completo con todos los aminoácidos esenciales.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Pollo al Curry & Zucchine",
    "title_en": "Curry Chicken & Zucchini",
    "title_ro": "Pui cu Curry & Dovlecei",
    "title_es": "Pollo al Curry & Calabacín",
    "category": "pasti",
    "mealType": "cena",
    "goalTag": "massa",
    "emoji": "🍗",
    "gradient": "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
    "prepTime": "15 min",
    "calories": "350 kcal",
    "difficulty": "Facile",
    "description": "Bocconcini di petto di pollo al curry con zucchine e carote a julienne 🍛",
    "description_en": "Tender chicken breast bites in aromatic curry with julienned zucchini and carrots 🍛",
    "description_ro": "Bucăți de piept de pui cu curry, dovlecei și morcovi julienne 🍛",
    "description_es": "Tiras de pechuga de pollo al curry con calabacín y zanahoria en juliana 🍛",
    "ingredients": "150g petto di pollo a bocconcini, curry in polvere, 1 zucchina, 1 carota.",
    "ingredients_en": "150g chicken breast pieces, mild curry powder, 1 zucchini, 1 carrot.",
    "ingredients_ro": "150g piept de pui, pudră de curry, 1 dovlecel, 1 morcov.",
    "ingredients_es": "150g pechuga pollo, curry en polvo, 1 calabacín, 1 zanahoria.",
    "protein": "37g",
    "carbs": "12g",
    "fats": "7g",
    "tip": "La curcuma nel curry ha forti proprietà antinfiammatorie.",
    "tip_en": "Turmeric in curry contains potent natural anti-inflammatory properties.",
    "tip_ro": "Curcuma din curry are puternice proprietăți antiinflamatoare.",
    "tip_es": "La cúrcuma en el curry aporta potentes propiedades antiinflamatorias.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1598515214211-89d3c73ae83b?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Spaghetti Integrali al Basilico",
    "title_en": "Whole-Grain Basil Spaghetti",
    "title_ro": "Spaghete Integrale cu Busuioc",
    "title_es": "Espaguetis Integrales a la Albahaca",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "massa",
    "emoji": "🍝",
    "gradient": "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
    "prepTime": "12 min",
    "calories": "385 kcal",
    "difficulty": "Facile",
    "description": "Spaghetti integrali (70g) con pomodorini freschi, basilico e scaglie di parmigiano 🍝",
    "description_en": "Whole-wheat spaghetti (70g) tossed with fresh cherry tomatoes, basil and parmesan 🍝",
    "description_ro": "Spaghete integrale (70g) cu roșii cherry, busuioc proaspăt și parmezan 🍝",
    "description_es": "Espaguetis integrales (70g) con tomates cherry, albahaca fresca y parmesano 🍝",
    "ingredients": "70g spaghetti integrali, 150g pomodorini, basilico, 10g parmigiano.",
    "ingredients_en": "70g whole-wheat pasta, 150g cherry tomatoes, fresh basil, 10g shaved parmesan.",
    "ingredients_ro": "70g spaghete integrale, 150g roșii cherry, busuioc, 10g parmezan.",
    "ingredients_es": "70g espaguetis integrales, 150g tomates cherry, albahaca, 10g parmesano.",
    "protein": "16g",
    "carbs": "58g",
    "fats": "8g",
    "tip": "La pasta integrale mantiene basso l indice glicemico.",
    "tip_en": "Whole-grain pasta ensures a low glycemic index and lasting energy.",
    "tip_ro": "Pastele integrale mențin indicele glicemic scăzut.",
    "tip_es": "La pasta integral mantiene bajo el índice glucémico.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1546548970-71785318a17b?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1547592166-23ac45744acd?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Pesce Spada & Finocchi",
    "title_en": "Grilled Swordfish & Fennel Salad",
    "title_ro": "Pește Spadă & Fenicul",
    "title_es": "Pez Espada & Hinojo",
    "category": "pasti",
    "mealType": "cena",
    "goalTag": "energia",
    "emoji": "🐟",
    "gradient": "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
    "prepTime": "15 min",
    "calories": "340 kcal",
    "difficulty": "Facile",
    "description": "Trancio di pesce spada alla griglia con insalata di finocchi ed arance 🍊",
    "description_en": "Grilled swordfish steak with a crisp fennel and juicy orange salad 🍊",
    "description_ro": "Trunchi de pește spadă la grătar cu salată de fenicul și portocale 🍊",
    "description_es": "Lomo de pez espada a la plancha con ensalada de hinojo y naranja 🍊",
    "ingredients": "150g pesce spada, 1 finocchio, spicchi d arancia, olio EVO.",
    "ingredients_en": "150g swordfish steak, 1 bulb fennel, orange segments, olive oil.",
    "ingredients_ro": "150g pește spadă, 1 fenicul, felii de portocală, ulei măsline.",
    "ingredients_es": "150g pez espada, 1 hinojo, gajos naranja, aceite oliva.",
    "protein": "32g",
    "carbs": "14g",
    "fats": "10g",
    "tip": "Il finocchio sgonfia l addome ed agevola la digestione.",
    "tip_en": "Fennel naturally soothes the digestive tract and eliminates bloating.",
    "tip_ro": "Feniculul reduce balonarea abdominală și facilitează digestia.",
    "tip_es": "El hinojo desinflama el abdomen y facilita la digestión.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Insalata Mediterranea al Tonno",
    "title_en": "Mediterranean Tuna Salad",
    "title_ro": "Salată Mediteraneană cu Ton",
    "title_es": "Ensalada Mediterránea con Atún",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "energia",
    "emoji": "🥗",
    "gradient": "linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)",
    "prepTime": "10 min",
    "calories": "395 kcal",
    "difficulty": "Facile",
    "description": "Insalata mista con tonno al naturale (100g), olive nere, uovo sodo e mais 🥗",
    "description_en": "Mixed green salad with natural canned tuna (100g), black olives, boiled egg and sweetcorn 🥗",
    "description_ro": "Salată mixtă cu ton în suc propriu (100g), măsline negre, ou fiert și porumb 🥗",
    "description_es": "Ensalada mixta con atún al natural (100g), aceitunas negras, huevo cocido y maíz 🥗",
    "ingredients": "100g tonno al naturale, 1 uovo sodo, insalata, olive, 30g mais.",
    "ingredients_en": "100g drained tuna, 1 hard-boiled egg, salad greens, olives, 30g sweetcorn.",
    "ingredients_ro": "100g ton în suc propriu, 1 ou fiert, salată verde, măsline, 30g porumb.",
    "ingredients_es": "100g atún al natural, 1 huevo cocido, lechuga, aceitunas, 30g maíz.",
    "protein": "34g",
    "carbs": "15g",
    "fats": "18g",
    "tip": "L uovo sodo apporta colina per il metabolismo lipidico.",
    "tip_en": "Eggs supply natural choline to support healthy fat metabolism.",
    "tip_ro": "Oul fiert furnizează colină pentru metabolismul lipidelor.",
    "tip_es": "El huevo cocido aporta colina para el metabolismo de las grasas.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1546793665-c74683f339c1?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Vellutata di Zucca & Tofu",
    "title_en": "Velvety Pumpkin Soup & Tofu",
    "title_ro": "Supă Cremă de Dovleac & Tofu",
    "title_es": "Crema de Calabaza & Tofu",
    "category": "pasti",
    "mealType": "cena",
    "goalTag": "energia",
    "emoji": "🍲",
    "gradient": "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
    "prepTime": "20 min",
    "calories": "310 kcal",
    "difficulty": "Facile",
    "description": "Zuppa vellutata di zucca con semi tostati e cubetti di tofu alla piastra 🥣",
    "description_en": "Creamy pumpkin soup topped with toasted seeds and pan-seared tofu cubes 🥣",
    "description_ro": "Supă cremă de dovleac cu semințe prăjite și cuburi de tofu la grătar 🥣",
    "description_es": "Crema suave de calabaza con semillas tostadas y dados de tofu a la plancha 🥣",
    "ingredients": "200g zucca, 1 carota, 100g tofu piastra, 1 cucchiaio semi zucca.",
    "ingredients_en": "200g butternut pumpkin, 1 carrot, 100g pan-seared tofu, 1 tbsp pumpkin seeds.",
    "ingredients_ro": "200g dovleac, 1 morcov, 100g tofu la grătar, 1 lingură semințe de dovleac.",
    "ingredients_es": "200g calabaza, 1 zanahoria, 100g tofu plancha, 1 cucharada semillas calabaza.",
    "protein": "18g",
    "carbs": "28g",
    "fats": "9g",
    "tip": "La zucca è idratante, ricca di potassio e distensiva.",
    "tip_en": "Butternut pumpkin is hydrating, potassium-rich and calming.",
    "tip_ro": "Dovleacul este hidratant, bogat în potasiu și relaxant.",
    "tip_es": "La calabaza es hidratante, rica en potasio y reconfortante.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1574484284002-952d92456975?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1546548970-71785318a17b?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Pollo al Limone & Riso Integrale",
    "title_en": "Lemon Herb Chicken & Brown Rice",
    "title_ro": "Pui cu Lămâie & Orez Brun",
    "title_es": "Pollo al Limón & Arroz Integral",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "deficit",
    "emoji": "🍗",
    "gradient": "linear-gradient(135deg, #059669 0%, #047857 100%)",
    "prepTime": "18 min",
    "calories": "380 kcal",
    "difficulty": "Facile",
    "description": "Bocconcini di pollo al limone con riso integrale ed spinaci al vapore 🍗",
    "description_en": "Pan-seared lemon chicken tenders with brown rice and steamed garden spinach 🍗",
    "description_ro": "Bucăți de pui cu lămâie, orez brun și spanac la abur 🍗",
    "description_es": "Tiras de pollo al limón con arroz integral y espinacas al vapor 🍗",
    "ingredients": "150g petto di pollo, succo di limone, 60g riso integrale, 150g spinaci.",
    "ingredients_en": "150g chicken breast, fresh lemon juice, 60g brown rice, 150g spinach.",
    "ingredients_ro": "150g piept de pui, suc de lămâie, 60g orez brun, 150g spanac.",
    "ingredients_es": "150g pechuga pollo, zumo limón, 60g arroz integral, 150g espinacas.",
    "protein": "37g",
    "carbs": "36g",
    "fats": "6g",
    "tip": "Il limone massimizza l assorbimento del ferro dagli spinaci.",
    "tip_en": "Lemon juice enhances iron absorption from the green spinach.",
    "tip_ro": "Lămâia maximizează absorbția fierului din spanac.",
    "tip_es": "El limón maximiza la absorción del hierro de las espinacas.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1594007654729-407eedc4be65?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Pasta di Farro al Pesto",
    "title_en": "Spelt Pasta with Light Pesto",
    "title_ro": "Paste din Alac cu Pesto",
    "title_es": "Pasta de Espelta al Pesto",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "massa",
    "emoji": "🍝",
    "gradient": "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
    "prepTime": "12 min",
    "calories": "390 kcal",
    "difficulty": "Facile",
    "description": "Pasta di farro integrale (70g) con pesto leggero di basilico e fagiolini 🍝",
    "description_en": "Whole spelt pasta (70g) with light basil pesto and tender green beans 🍝",
    "description_ro": "Paste integrale din alac (70g) cu pesto ușor de busuioc și fasole verde 🍝",
    "description_es": "Pasta de espelta integral (70g) con pesto ligero de albahaca y judías verdes 🍝",
    "ingredients": "70g pasta di farro, 1 cucchiaio pesto, 80g fagiolini.",
    "ingredients_en": "70g spelt pasta, 1 tbsp light pesto, 80g green beans.",
    "ingredients_ro": "70g paste din alac, 1 lingură pesto, 80g fasole verde.",
    "ingredients_es": "70g pasta espelta, 1 cucharada pesto, 80g judías verdes.",
    "protein": "14g",
    "carbs": "54g",
    "fats": "11g",
    "tip": "Il farro dona fibra insolubile a lenta digestione.",
    "tip_en": "Spelt delivers slow-digesting insoluble fiber for sustained satiety.",
    "tip_ro": "Alacul oferă fibre insolubile cu digestie lentă.",
    "tip_es": "La espelta aporta fibra insoluble de lenta asimilación.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1551183053-bf91a1d81141?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1546793665-c74683f339c1?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Polpette di Tacchino & Broccoli",
    "title_en": "Baked Turkey Meatballs & Broccoli",
    "title_ro": "Chifteluțe de Curcan & Broccoli",
    "title_es": "Albóndigas de Pavo & Brócoli",
    "category": "pasti",
    "mealType": "cena",
    "goalTag": "deficit",
    "emoji": "🍗",
    "gradient": "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
    "prepTime": "20 min",
    "calories": "340 kcal",
    "difficulty": "Facile",
    "description": "Polpette di tacchino magro al forno con purè leggero di cavolfiore e broccoli 🥦",
    "description_en": "Lean baked turkey meatballs served with mashed cauliflower and steamed broccoli 🥦",
    "description_ro": "Chifteluțe din curcan la cuptor cu piure ușor de conopidă și broccoli 🥦",
    "description_es": "Albóndigas de pavo al horno con puré suave de coliflor y brócoli 🥦",
    "ingredients": "140g macinato tacchino magro, erbe, 200g cavolfiore vapore frullato.",
    "ingredients_en": "140g lean ground turkey, herbs, 200g steamed blended cauliflower.",
    "ingredients_ro": "140g carne tocată de curcan slabă, ierburi, 200g conopidă la abur pasată.",
    "ingredients_es": "140g carne picada pavo, hierbas, 200g coliflor vapor triturada.",
    "protein": "35g",
    "carbs": "12g",
    "fats": "7g",
    "tip": "Il purè di cavolfiore abbatte i carboidrati serali.",
    "tip_en": "Cauliflower mash keeps evening carbohydrates low and digestion fast.",
    "tip_ro": "Piureul de conopidă reduce carbohidrații de seară.",
    "tip_es": "El puré de coliflor reduce los carbohidratos en la cena.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1529042410759-befb1204b468?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1574484284002-952d92456975?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Piadina Integrale Bresaola & Rucola",
    "title_en": "Whole-Grain Wrap with Lean Beef & Arugula",
    "title_ro": "Wrap Integral cu Vită Slabă & Rucola",
    "title_es": "Wrap Integral con Ternera Magra & Rúcula",
    "category": "pasti",
    "mealType": "pranzo",
    "goalTag": "massa",
    "emoji": "🥗",
    "gradient": "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
    "prepTime": "5 min",
    "calories": "390 kcal",
    "difficulty": "Facile",
    "description": "Piadina integrale sottile con bresaola (80g), rucola e scaglie di grana 🌯",
    "description_en": "Thin whole-wheat wrap with lean bresaola/roast beef (80g), rocket and parmesan flakes 🌯",
    "description_ro": "Wrap integral subțire cu bresaola/vită slabă (80g), rucola și fulgi de parmezan 🌯",
    "description_es": "Wrap fino 100% integral con bresaola/ternera (80g), rúcula y lascas de parmesano 🌯",
    "ingredients": "1 piadina 100% integrale, 80g bresaola, rucola, 10g scaglie grana.",
    "ingredients_en": "1 100% whole-grain wrap, 80g bresaola or roast beef, fresh arugula, 10g parmesan.",
    "ingredients_ro": "1 wrap 100% integral, 80g bresaola sau vită, rucola, 10g parmezan.",
    "ingredients_es": "1 wrap integral, 80g bresaola o ternera, rúcula, 10g parmesano.",
    "protein": "35g",
    "carbs": "32g",
    "fats": "10g",
    "tip": "Pranzo gustoso e velocissimo ricchissimo di proteine.",
    "tip_en": "Quick, high-protein lunch packed with flavor to celebrate Day 10.",
    "tip_ro": "Prânz gustos, rapid și foarte bogat în proteine.",
    "tip_es": "Almuerzo sabroso, rápido y cargado de proteínas.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Zuppa di Farro & Legumi",
    "title_en": "Ancient Grain & Legume Stew",
    "title_ro": "Mâncare de Cereale Antice & Leguminoase",
    "title_es": "Guiso de Cereales Antiguos & Legumbres",
    "category": "pasti",
    "mealType": "cena",
    "goalTag": "massa",
    "emoji": "🍲",
    "gradient": "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
    "prepTime": "20 min",
    "calories": "340 kcal",
    "difficulty": "Facile",
    "description": "Zuppa di farro e legumi misti con verdure grigliate di stagione 🍲",
    "description_en": "Hearty warm spelt and mixed legume stew with roasted seasonal vegetables 🍲",
    "description_ro": "Mâncare caldă de alac și leguminoase mixte cu legume coapte de sezon 🍲",
    "description_es": "Guiso templado de espelta y legumbres con verduras asadas de temporada 🍲",
    "ingredients": "50g farro, 80g legumi misti, zucchine e melanzane grigliate.",
    "ingredients_en": "50g spelt, 80g mixed beans/lentils, grilled zucchini and eggplant.",
    "ingredients_ro": "50g alac, 80g leguminoase mixte, dovlecei și vinete la grătar.",
    "ingredients_es": "50g espelta, 80g legumbres mixtas, calabacín y berenjena asada.",
    "protein": "18g",
    "carbs": "48g",
    "fats": "5g",
    "tip": "Hai completato 10 giorni straordinari! Misurati ed invia il report.",
    "tip_en": "You did it! Measure your results and send your final report to your Coach.",
    "tip_ro": "Ai reușit! Măsoară-te și trimite raportul final Coach-ului tău.",
    "tip_es": "¡Lo lograste! Mídete y envía el reporte final a tu Coach.",
    "isRealFood": true,
    "productKeys": [],
    "img": "https://images.unsplash.com/photo-1541832676-9b763b0239ab?w=600&auto=format&fit=crop&q=80",
    "image": "https://images.unsplash.com/photo-1551183053-bf91a1d81141?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "La Regola dei 10.000 Passi",
    "title_en": "The 10,000 Steps Rule",
    "title_ro": "Regula celor 10.000 de Pași",
    "title_es": "La regla de los 10.000 pasos",
    "category": "consigli",
    "emoji": "👟",
    "gradient": "linear-gradient(135deg, #b2ebf2 0%, #00838f 100%)",
    "prepTime": "-",
    "calories": "-300 kcal",
    "difficulty": "Facile",
    "description": "Mantenersi attivi ogni giorno (NEAT) è fondamentale per massimizzare il deficit calorico.",
    "description_en": "Staying active every day (NEAT) is key to maximizing caloric deficit.",
    "description_ro": "A rămâne activ în fiecare zi (NEAT) este esențial pentru a maximiza deficitul caloric.",
    "description_es": "Mantenerse activo a diario (NEAT) es fundamental para maximizar el déficit calórico.",
    "ingredients": "Fai le scale invece di prendere l'ascensore. Parcheggia più lontano.",
    "ingredients_en": "Take the stairs instead of the elevator. Park further away.",
    "ingredients_ro": "Ia scările în loc de lift. Parchează mai departe.",
    "ingredients_es": "Sube por las escaleras en vez del ascensor. Aparca más lejos.",
    "protein": "-",
    "carbs": "-",
    "fats": "-",
    "tip": "Imposta un timer ogni ora per alzarti e fare 2 minuti di camminata.",
    "tip_en": "Set a timer every hour to get up and take a 2-minute walk.",
    "tip_ro": "Imposta un timer ogni ora per alzarti e fare 2 minuti di camminata.",
    "tip_es": "Imposta un timer ogni ora per alzarti e fare 2 minuti di camminata.",
    "productKeys": [
      "cr7"
    ],
    "image": "https://images.unsplash.com/photo-1502680390469-be75c86b636f?w=800&auto=format&fit=crop&q=85"
  },
  {
    "title": "Non Saltare i Pasti",
    "title_en": "Don't Skip Meals",
    "title_ro": "Nu Sări Peste Mese",
    "title_es": "No te saltes comidas",
    "category": "consigli",
    "emoji": "⏰",
    "gradient": "linear-gradient(135deg, #ffcdd2 0%, #c62828 100%)",
    "prepTime": "-",
    "calories": "-",
    "difficulty": "Facile",
    "description": "Saltare i pasti abbassa il metabolismo e porta a inevitabili abbuffate nervose più tardi.",
    "description_en": "Skipping meals slows your metabolism and leads to inevitable nervous binge eating later.",
    "description_ro": "Săritul peste mese îți încetinește metabolismul și duce la episoade inevitabile de mâncat emoțional.",
    "description_es": "Saltarse comidas ralentiza el metabolismo y conduce a inevitables atracones nerviosos más tarde.",
    "ingredients": "Struttura 3 pasti principali e 2 spuntini sani.",
    "ingredients_en": "Structure 3 main meals and 2 healthy snacks.",
    "ingredients_ro": "Structurați 3 mese principale și 2 gustări sănătoase.",
    "ingredients_es": "Estructura 3 comidas principales y 2 snacks saludables.",
    "protein": "-",
    "carbs": "-",
    "fats": "-",
    "tip": "Prepara i tuoi Shake F1 la sera prima se al mattino sei sempre di corsa!",
    "tip_en": "Prepare your F1 Shakes the night before if you are always in a rush in the morning!",
    "tip_ro": "Prepara i tuoi Shake F1 la sera prima se al mattino sei sempre di corsa!",
    "tip_es": "Prepara i tuoi Shake F1 la sera prima se al mattino sei sempre di corsa!",
    "productKeys": [
      "formula1"
    ],
    "image": "https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=800&auto=format&fit=crop&q=85"
  }
];

// ==========================================

// GLOBAL CONSTANTS & MULTI-STORE BACKEND

// ==========================================


// ==========================================
// CORE GLOBAL CONSTANTS & MULTI-STORE BACKEND
// ==========================================

const API_BASE_URL = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
  ? 'http://localhost:3000/api/program10'
  : 'https://automazione-email.vercel.app/api/program10';

const COMMUNITY_CHATS = {
  it: [],
  en: [],
  ro: [],
  es: []
};

const COMMUNITY_ANSWERS = {
  it: [],
  en: [],
  ro: [],
  es: []
};

function getAssetUrl(assetPath) {
  if (!assetPath) return '';
  if (assetPath.startsWith('http://') || assetPath.startsWith('https://') || assetPath.startsWith('data:image')) {
    return assetPath;
  }
  const cleanKey = assetPath.replace(/^assets\//, '').replace(/\.[^/.]+$/, '');
  if (typeof window !== 'undefined' && window.ShopifyAssets && window.ShopifyAssets[cleanKey]) {
    return window.ShopifyAssets[cleanKey];
  }
  return assetPath;
}

function getUserCaloricProfile(profile, currentWeight) {
  const p = profile || {};
  const weight = parseFloat(currentWeight !== null && currentWeight !== undefined ? currentWeight : (p.startWeight || 70));
  const height = parseFloat(p.height || 165);
  const age = parseFloat(p.age || 35);
  const gender = (p.gender || 'female').toLowerCase();
  const lifestyle = (p.lifestyleType || 'sedentario').toLowerCase();
  const gymFreq = (p.gymFrequency || 'mai').toLowerCase();

  const heightM = height / 100;
  const bmi = weight / (heightM * heightM);

  let bmiCategory = 'normal';
  if (bmi < 18.5) bmiCategory = 'underweight';
  else if (bmi < 25) bmiCategory = 'normal';
  else if (bmi < 30) bmiCategory = 'overweight';
  else bmiCategory = 'obese';

  let bmr = (10 * weight) + (6.25 * height) - (5 * age);
  if (gender === 'male' || gender === 'uomo' || gender === 'm') {
    bmr += 5;
  } else {
    bmr -= 161;
  }

  let activityMult = 1.2;
  if (lifestyle === 'moderato' || lifestyle === 'moderatamente_attivo') activityMult = 1.4;
  else if (lifestyle === 'attivo' || lifestyle === 'molto_attivo') activityMult = 1.6;
  if (gymFreq === '1-2' || gymFreq === '1-2 volte') activityMult += 0.1;
  else if (gymFreq === '3-4' || gymFreq === '3-4 volte' || gymFreq === '3-5') activityMult += 0.2;
  else if (gymFreq === '5+' || gymFreq === 'tutti i giorni') activityMult += 0.3;

  const tdee = Math.round(bmr * activityMult);
  const targetCalories = Math.max(1200, Math.round(tdee - 450));
  const proteinGrams = Math.round(weight * 1.6);
  const waterLiters = Math.max(2.0, +(weight * 0.035).toFixed(1));

  return {
    bmi: +bmi.toFixed(1),
    bmiCategory,
    bmr: Math.round(bmr),
    tdee,
    targetCalories,
    proteinGrams,
    waterLiters
  };
}

const syncWithBackend = async () => {
  const storeId = getStoreId();
  const email = state.profile && state.profile.email ? state.profile.email.trim() : "";

  try {
    const resConfig = await fetch(`${API_BASE_URL}/config?store_id=${storeId}`);
    if (resConfig.ok) {
      const dataConfig = await resConfig.json();
      if (dataConfig.success && dataConfig.config) {
        state.storeConfig = dataConfig.config;
        const subtitleEl = document.querySelector(".brand-subtitle");
        if (subtitleEl && dataConfig.config.distributor_role) {
          subtitleEl.textContent = dataConfig.config.distributor_role;
        }
      }
    }
  } catch (e) {
    console.warn("[BackendSync] Config notice:", e);
  }

  try {
    const resLb = await fetch(`${API_BASE_URL}/leaderboard?store_id=${storeId}`);
    if (resLb.ok) {
      const dataLb = await resLb.json();
      if (dataLb.success && (dataLb.leaderboard || dataLb.participants)) {
        state.storeLeaderboard = dataLb.leaderboard || dataLb.participants;
        if (document.getElementById("page-classifica")?.classList.contains("active")) {
          if (typeof renderLeaderboard === "function") renderLeaderboard();
        }
      }
    }
  } catch (e) {
    console.warn("[BackendSync] Leaderboard notice:", e);
  }

  if (email && email.includes('@')) {
    try {
      const resLogs = await fetch(`${API_BASE_URL}/daily-logs?store_id=${storeId}&email=${encodeURIComponent(email)}`);
      if (resLogs.ok) {
        const dataLogs = await resLogs.json();
        if (dataLogs.success && dataLogs.logs) {
          Object.keys(dataLogs.logs).forEach(day => {
            const idx = parseInt(day, 10) - 1;
            if (idx >= 0 && idx < 10) {
              state.dailyLogs[idx] = { ...state.dailyLogs[idx], ...dataLogs.logs[day] };
            }
          });
          if (typeof loadActiveDayLogs === 'function') loadActiveDayLogs();
          if (typeof updateDailyScoreUI === 'function') updateDailyScoreUI();
        }
      }
    } catch (e) {
      console.warn("[BackendSync] Daily logs notice:", e);
    }
  }
};

const syncLeaderboardWithBackend = async () => {
  const storeId = getStoreId();
  try {
    const res = await fetch(`${API_BASE_URL}/leaderboard?store_id=${storeId}`);
    if (res.ok) {
      const data = await res.json();
      if (data && data.success && Array.isArray(data.participants || data.leaderboard)) {
        state.storeLeaderboard = data.participants || data.leaderboard;
        if (typeof renderLeaderboard === "function") renderLeaderboard();
      }
    }
  } catch (err) {
    console.warn("[LeaderboardSync] Notice:", err);
  }
};

// ==========================================
// GROUP COMPARISON & LEADERBOARD (DOWNLINE DRIVEN)
// ==========================================

const renderLeaderboard = async () => {
  const container = document.getElementById("leaderboard-items");
  if (!container) return;

  const currentEmail = (state.profile && state.profile.email || "").toLowerCase().trim();
  const currentName = (state.profile && state.profile.name || "Sfidante").trim();
  const youBadgeText = (state.lang === 'en' ? 'You' : (state.lang === 'ro' ? 'Tu' : (state.lang === 'es' ? 'Tú' : 'Tu')));
  const storeId = getStoreId();

  // 1. Resolve Network Context (Coach ID or Sponsor ID)
  const isCoach = !!(state.profile && (state.profile.isDistributor || state.profile.myHerbalifeId));
  const myCoachId = (state.profile && (state.profile.myHerbalifeId || state.profile.coachId || '')).trim();
  const sponsorId = (state.profile && (state.profile.sponsorId || state.profile.uplineHerbalifeId || '')).trim();
  const activeNetworkId = isCoach ? (myCoachId || sponsorId) : (sponsorId || myCoachId);

  // Show loading indicator
  container.innerHTML = `
    <div style="text-align: center; padding: 28px 16px; color: var(--text-muted);">
      <div style="display: inline-block; width: 24px; height: 24px; border: 3px solid rgba(16,185,129,0.25); border-top-color: #10B981; border-radius: 50%; animation: spin 0.8s linear infinite;"></div>
      <p style="margin-top: 10px; font-size: 13px; font-weight: 600;">${state.lang === 'it' ? 'Caricamento partecipanti del gruppo downline...' : 'Loading downline challenge group...'}</p>
    </div>
  `;

  // 2. Compute Current User ("Tu") real metrics
  const currentDay = Math.min(10, Math.max(1, state.activeDay || 1));
  const userStartWeight = parseFloat((state.profile && state.profile.startWeight) || 70);
  const userValidLogs = Array.isArray(state.dailyLogs)
    ? state.dailyLogs.filter(l => l && l.weight !== null && !isNaN(parseFloat(l.weight)))
    : [];
  const userCurrentWeight = userValidLogs.length > 0
    ? parseFloat(userValidLogs[userValidLogs.length - 1].weight)
    : userStartWeight;
  const userLostKg = Math.max(0, userStartWeight - userCurrentWeight);
  const userLossPct = parseFloat(((userLostKg / (userStartWeight || 1)) * 100).toFixed(1));
  const userPoints = Array.isArray(state.dailyLogs)
    ? state.dailyLogs.reduce((acc, logItem, idx) => {
        if (idx + 1 > currentDay) return acc;
        return acc + (typeof calculateDailyScore === 'function' ? calculateDailyScore(logItem) : 0);
      }, 0)
    : 0;

  const currentUserItem = {
    id: 'current_user',
    name: currentName,
    email: currentEmail,
    avatar: (state.profile && state.profile.avatar) || "🏃",
    photo: (state.profile && state.profile.photo) || (window.ShopifyAssets && window.ShopifyAssets.wellness_coach_avatar) || "assets/wellness_coach_avatar.png",
    weightLossPct: userLossPct,
    points: userPoints,
    trend: userLossPct > 0 ? "up" : "stable",
    isUser: true
  };

  let participants = [];

  // 3. Query Backend for Coach Downline & Clients
  try {
    const fetchPromises = [];
    
    // Query coach clients if a coach ID exists
    if (activeNetworkId) {
      fetchPromises.push(
        fetch(`${API_BASE_URL}/coach/clients?coach_id=${encodeURIComponent(activeNetworkId)}&store_id=${storeId}`)
          .then(r => r.ok ? r.json() : null)
          .catch(() => null)
      );
    }
    
    // Also query store leaderboard
    fetchPromises.push(
      fetch(`${API_BASE_URL}/leaderboard?store_id=${storeId}`)
        .then(r => r.ok ? r.json() : null)
        .catch(() => null)
    );

    // If super admin, also query admin users
    if (typeof isSuperAdminEmail === 'function' && isSuperAdminEmail(currentEmail)) {
      fetchPromises.push(
        fetch(`${API_BASE_URL}/admin/users?admin_email=${encodeURIComponent(currentEmail)}`)
          .then(r => r.ok ? r.json() : null)
          .catch(() => null)
      );
    }

    const results = await Promise.all(fetchPromises);
    const seen = new Map();

    // Process coach clients & downline
    const coachClientsRes = results[0];
    if (coachClientsRes && coachClientsRes.success && Array.isArray(coachClientsRes.clients)) {
      coachClientsRes.clients.forEach(c => {
        if (!c || !c.name) return;
        const email = (c.email || '').toLowerCase().trim();
        if (email.endsWith('@program10.local') || email.startsWith('chat_')) return;

        // Calculate metrics from client's profile & daily logs
        const startW = parseFloat(c.profile?.startWeight || 70);
        const logs = Array.isArray(c.dailyLogs) ? c.dailyLogs : Object.values(c.dailyLogs || {});
        const validLogs = logs.filter(l => l && l.weight !== null && !isNaN(parseFloat(l.weight)));
        const currW = validLogs.length > 0 ? parseFloat(validLogs[validLogs.length - 1].weight) : startW;
        const lostKg = Math.max(0, startW - currW);
        const lossPct = parseFloat(((lostKg / (startW || 1)) * 100).toFixed(1));

        let points = 0;
        if (logs.length > 0) {
          points = logs.reduce((acc, l) => acc + (typeof calculateDailyScore === 'function' ? calculateDailyScore(l) : 0), 0);
        }
        if (points === 0 && c.compliance) {
          points = Math.round((c.compliance / 100) * 850);
        }

        const key = email || c.name.toLowerCase().trim();
        seen.set(key, {
          id: c.id,
          name: c.name,
          email: email,
          avatar: c.avatar || "👤",
          photo: c.photo || null,
          weightLossPct: lossPct,
          points: points,
          trend: lossPct > 0 ? "up" : "stable",
          isUser: (currentEmail && email === currentEmail) || (c.name.toLowerCase() === currentName.toLowerCase())
        });
      });
    }

    // Process store leaderboard or admin users
    results.slice(1).forEach(res => {
      if (!res) return;
      const list = res.participants || res.leaderboard || res.users || [];
      if (Array.isArray(list)) {
        list.forEach(p => {
          if (!p || !p.name) return;
          const email = (p.email || '').toLowerCase().trim();
          if (email.endsWith('@program10.local') || email.startsWith('chat_')) return;
          const key = email || p.name.toLowerCase().trim();
          if (!seen.has(key)) {
            seen.set(key, {
              id: p.id,
              name: p.name,
              email: email,
              avatar: p.avatar || "👤",
              photo: p.photo || null,
              weightLossPct: parseFloat(p.weightLossPct || 0),
              points: parseInt(p.points || 0, 10),
              trend: p.trend || "stable",
              isUser: (currentEmail && email === currentEmail) || (p.name.toLowerCase() === currentName.toLowerCase())
            });
          }
        });
      }
    });

    // Always inject the current user into seen map
    const userKey = currentEmail || currentName.toLowerCase().trim();
    seen.set(userKey, currentUserItem);

    participants = Array.from(seen.values());
  } catch (err) {
    console.warn("[Leaderboard Downline Sync] Notice:", err);
    participants = [currentUserItem];
  }

  // 4. Filter and Sort
  participants.sort((a, b) => {
    const lossA = parseFloat(a.weightLossPct || 0);
    const lossB = parseFloat(b.weightLossPct || 0);
    if (lossB !== lossA) return lossB - lossA;
    return (b.points || 0) - (a.points || 0);
  });

  // 5. If only current user is in the group and no other downlines exist yet
  if (participants.length === 1 && participants[0].isUser) {
    const coachDisplayName = activeNetworkId ? `Coach ${activeNetworkId}` : (storeId ? storeId.toUpperCase() : '');
    container.innerHTML = `
      <div class="leaderboard-item-row leaderboard-current-user">
        <div class="col-rank rank-cell" style="color: #FBBF24; font-weight: 800;">1</div>
        <div class="col-avatar">
          <img src="${currentUserItem.photo}" alt="${currentUserItem.name}" class="leaderboard-user-photo" onerror="this.onerror=null; this.src='assets/wellness_coach_avatar.png';">
        </div>
        <div class="col-name">
          <span class="participant-name-text">${currentUserItem.name}</span>
          <span class="badge badge-you">${youBadgeText}</span>
        </div>
        <div class="col-loss">-${parseFloat(currentUserItem.weightLossPct || 0).toFixed(1)}%</div>
        <div class="col-points"><span class="pts-badge">${currentUserItem.points || 0} pts</span></div>
        <div class="col-trend">${currentUserItem.trend === 'up' ? '🔺' : '➖'}</div>
      </div>
      <div style="text-align: center; padding: 28px 16px; margin-top: 12px; background: rgba(255,255,255,0.02); border-radius: 12px; border: 1px dashed rgba(255,255,255,0.1);">
        <div style="font-size: 28px; margin-bottom: 8px;">👥</div>
        <h4 style="font-size: 14px; font-weight: 700; color: var(--text-primary); margin-bottom: 6px;">
          ${state.lang === 'it' ? `Gruppo Squadra ${coachDisplayName}` : `Team Group ${coachDisplayName}`}
        </h4>
        <p style="font-size: 12px; color: var(--text-muted); max-width: 440px; margin: 0 auto 12px; line-height: 1.5;">
          ${state.lang === 'it'
            ? (isCoach
                ? 'Non ci sono ancora sfidanti o distributori collegati alla tua downline in questa sfida. Condividi il tuo link referral per far entrare i tuoi clienti!'
                : 'Sei il primo del tuo gruppo registrato per la sfida! Non appena gli altri membri della downline effettueranno i check-in, appariranno qui.')
            : 'No challengers connected to this downline group yet.'}
        </p>
        ${isCoach && activeNetworkId ? `
          <button type="button" class="btn-primary-glow" onclick="if(typeof copyCoachReferralLink==='function') copyCoachReferralLink(); else alert('Link: ' + window.location.origin + window.location.pathname + '?coach=${activeNetworkId}');" style="padding: 7px 14px; font-size: 12px;">
            🔗 ${state.lang === 'it' ? 'Copia Link Invito Downline' : 'Copy Downline Invite Link'}
          </button>
        ` : ''}
      </div>
    `;
    return;
  }

  // 6. Render Full Downline Participants Rows
  container.innerHTML = participants.map((item, idx) => {
    const isMe = item.isUser ||
                 (currentEmail && item.email && item.email.toLowerCase() === currentEmail) ||
                 (item.name && item.name.toLowerCase() === currentName.toLowerCase()) ||
                 (item.name && item.name.includes('(Tu)'));

    const rankNum = idx + 1;
    const rankColor = rankNum === 1 ? '#FBBF24' : (rankNum === 2 ? '#94A3B8' : (rankNum === 3 ? '#B45309' : '#64748B'));
    const trendIcon = item.trend === "up" ? "🔺" : (item.trend === "down" ? "🔻" : "➖");

    let photoUrl = "assets/wellness_coach_avatar.png";
    if (isMe) {
      photoUrl = (state.profile && state.profile.photo) ||
                 (window.ShopifyAssets && window.ShopifyAssets.wellness_coach_avatar) ||
                 "assets/wellness_coach_avatar.png";
    } else if (item.photo && typeof item.photo === 'string' && item.photo.length > 5) {
      photoUrl = item.photo;
    }

    const cleanName = item.name.replace(/\s*\(Tu\)\s*/gi, '').trim();

    return `
      <div class="leaderboard-item-row ${isMe ? 'leaderboard-current-user' : ''}">
        <div class="col-rank rank-cell" style="color: ${rankColor}; font-weight: 800;">${rankNum}</div>
        <div class="col-avatar">
          <img src="${photoUrl}" alt="${cleanName}" class="leaderboard-user-photo" onerror="this.onerror=null; this.src='assets/wellness_coach_avatar.png';">
        </div>
        <div class="col-name">
          <span class="participant-name-text">${cleanName}</span>
          ${isMe ? `<span class="badge badge-you">${youBadgeText}</span>` : ''}
        </div>
        <div class="col-loss">-${parseFloat(item.weightLossPct || 0).toFixed(1)}%</div>
        <div class="col-points"><span class="pts-badge">${item.points || 0} pts</span></div>
        <div class="col-trend">${trendIcon}</div>
      </div>
    `;
  }).join('');
};

const initGoalSelection = () => {
  document.querySelectorAll(".goal-option-card").forEach(card => {
    card.addEventListener("click", () => {
      document.querySelectorAll(".goal-option-card").forEach(c => c.classList.remove("selected"));
      card.classList.add("selected");
      const goal = card.getAttribute("data-goal");
      if (goal && state.profile) {
        state.profile.targetGoal = goal;
        saveStateToStorage();
      }
    });
  });
};

const initPackagesSelection = () => {
  document.querySelectorAll(".package-cta-btn").forEach(btn => {
    btn.addEventListener("click", (e) => {
      const pkg = btn.getAttribute("data-package");
      if (pkg && state.profile) {
        state.profile.kitType = pkg;
        saveStateToStorage();
      }
    });
  });
};




// ==========================================

// STORE PRODUCTS CATALOG & MULTI-STORE RESOLVERS

// ==========================================

const STORE_PRODUCTS_CATALOG = {
  "herballeato": {
    "domain": "https://herballeato.com",
    "products": {
      "formula1": {
        "id": "formula1",
        "title": "Formula 1 Frullato Sostituto del Pasto (780g)",
        "title_en": "Formula 1 Shake Mix (780g)",
        "title_ro": "Shake Formula 1 Înlocuitor de Masă (780g)",
        "title_es": "Batido Formula 1 Sustitutivo de Comida (780g)",
        "url": "https://herballeato.com/products/formula-1-nutritional-shake-mix-780-g",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/pc-4462-za_df2e4c8c-1e24-4f81-995a-c21d8fa2a632.png"
      },
      "pdm": {
        "id": "pdm",
        "title": "Protein Drink Mix (PDM)",
        "title_en": "Protein Drink Mix (PDM)",
        "title_ro": "Protein Drink Mix (PDM)",
        "title_es": "Protein Drink Mix (PDM)",
        "url": "https://herballeato.com/products/protein-drink-mix-588-g",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/protein-drink-mix-vanilla-588g-2601-za.png"
      },
      "tea": {
        "id": "tea",
        "title": "Infuso a Base di Erbe Termogenico (50g)",
        "title_en": "Instant Herbal Beverage (50g)",
        "title_ro": "Ceai Instant pe Bază de Plante (50g)",
        "title_es": "Bebida Instantánea de Hierbas (50g)",
        "url": "https://herballeato.com/products/infuso-a-base-di-erbe-50g",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/pc-0105-za.png"
      },
      "aloemax": {
        "id": "aloemax",
        "title": "AloeMax Concentrato 97% Puro Aloe",
        "title_en": "AloeMax 97% Pure Aloe Juice",
        "title_ro": "AloeMax Suc Pur de Aloe 97%",
        "title_es": "AloeMax Jugo Puro de Aloe 97%",
        "url": "https://herballeato.com/products/aloemax-473-ml",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/aloemax-concentrate-473ml-0006-za.png"
      },
      "phytocomplete": {
        "id": "phytocomplete",
        "title": "Phyto Complete con Fiit-NS™",
        "title_en": "Phyto Complete with Fiit-NS™",
        "title_ro": "Phyto Complete cu Fiit-NS™",
        "title_es": "Phyto Complete con Fiit-NS™",
        "url": "https://herballeato.com/products/phyto-complete-60-capsule",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/phyto-complete-60-tablets-234k-za.png"
      },
      "collagen": {
        "id": "collagen",
        "title": "Collagene Skin Booster (Verisol® P)",
        "title_en": "Collagen Skin Booster (Verisol® P)",
        "title_ro": "Collagen Skin Booster (Verisol® P)",
        "title_es": "Collagen Skin Booster (Verisol® P)",
        "url": "https://herballeato.com/products/collagene-skin-booster",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/collagen-skin-booster-strawberry-and-mint-171g-076k-za.png"
      },
      "mineralcomplex": {
        "id": "mineralcomplex",
        "title": "Mineral Complex Plus (Potassio & Magnesio)",
        "title_en": "Mineral Complex Plus (Electrolytes)",
        "title_ro": "Mineral Complex Plus (Potasiu & Magneziu)",
        "title_es": "Mineral Complex Plus (Potasio y Magnesio)",
        "url": "https://herballeato.com/products/mineral-complex-plus",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/mineral-complex-plus.png"
      },
      "nightmode": {
        "id": "nightmode",
        "title": "Night Mode (Estratto di Zafferano)",
        "title_en": "Night Mode (Saffron Extract)",
        "title_ro": "Night Mode (Extract de Șofran)",
        "title_es": "Night Mode (Extracto de Azafrán)",
        "url": "https://herballeato.com/products/night-mode-camomilla-e-pesca",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/nightmode.png"
      },
      "restore": {
        "id": "restore",
        "title": "Herbalife24® Restore",
        "title_en": "Herbalife24® Restore",
        "title_ro": "Herbalife24® Restore",
        "title_es": "Herbalife24® Restore",
        "url": "https://herballeato.com/products/h24-restore-30-capsule",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/h24-restore-30-capsules-1424-za.png"
      },
      "cr7drive": {
        "id": "cr7drive",
        "title": "Herbalife24® CR7 Drive",
        "title_en": "Herbalife24® CR7 Drive",
        "title_ro": "Herbalife24® CR7 Drive",
        "title_es": "Herbalife24® CR7 Drive",
        "url": "https://herballeato.com/products/h24-cr7-drive-barattolo-540g",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/cr7.png"
      },
      "cr7": {
        "id": "cr7",
        "title": "Herbalife24® CR7 Drive",
        "title_en": "Herbalife24® CR7 Drive",
        "title_ro": "Herbalife24® CR7 Drive",
        "title_es": "Herbalife24® CR7 Drive",
        "url": "https://herballeato.com/products/h24-cr7-drive-barattolo-540g",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/cr7.png"
      },
      "rebuildstrength": {
        "id": "rebuildstrength",
        "title": "Herbalife24® Rebuild Strength (1000g)",
        "title_en": "Herbalife24® Rebuild Strength (1000g)",
        "title_ro": "Herbalife24® Rebuild Strength (1000g)",
        "title_es": "Herbalife24® Rebuild Strength (1000g)",
        "url": "https://herballeato.com/products/h24-rebuild-strength-cioccolato-1000g",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/rebuild-strength.png"
      },
      "fibre": {
        "id": "fibre",
        "title": "Bebida con Avena, Mela e Fibre (204g)",
        "title_en": "Oat Apple Fibre Drink (204g)",
        "title_ro": "Băutură cu Ovăz, Măr și Fibre (204g)",
        "title_es": "Bebida con Avena, Manzana y Fibra (204g)",
        "url": "https://herballeato.com/products/bevanda-multiffibre-204g",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/multifibre.png"
      },
      "liftoff": {
        "id": "liftoff",
        "title": "Liftoff® Integratore Energetico Effervescente",
        "title_en": "Liftoff® Energy Drink (10 Tabs)",
        "title_ro": "Liftoff® Băutură Energizantă Efervescentă",
        "title_es": "Liftoff® Complemento Energético Efervescente",
        "url": "https://herballeato.com/products/liftoff-10-bustine",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/liftoff.png"
      },
      "proteinbar": {
        "id": "proteinbar",
        "title": "Barrette Proteiche Herbalife (14x35g)",
        "title_en": "Protein Bars (14x35g)",
        "title_ro": "Batoane Proteice Herbalife (14x35g)",
        "title_es": "Barritas con Proteínas Herbalife (14x35g)",
        "url": "https://herballeato.com/products/barrette-alle-proteine-14-pezzi",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/protein-bars.png"
      },
      "soybeans": {
        "id": "soybeans",
        "title": "Noccioline di Soia Tostate (12x21.5g)",
        "title_en": "Roasted Soy Beans (12x21.5g)",
        "title_ro": "Boabe de Soia Prăjite (12x21.5g)",
        "title_es": "Frutos de Soja Tostados (12x21.5g)",
        "url": "https://herballeato.com/products/noccioline-di-soia-tostate-12-bustine",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/soy-beans.png"
      },
      "proteinchips": {
        "id": "proteinchips",
        "title": "Protein Chips Herbalife (10x30g)",
        "title_en": "Protein Chips (10x30g)",
        "title_ro": "Protein Chips (10x30g)",
        "title_es": "Protein Chips (10x30g)",
        "url": "https://herballeato.com/products/protein-chips",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/protein-chips.png"
      },
      "icedcoffee": {
        "id": "icedcoffee",
        "title": "High Protein Iced Coffee (308g)",
        "title_en": "High Protein Iced Coffee (308g)",
        "title_ro": "High Protein Iced Coffee (308g)",
        "title_es": "High Protein Iced Coffee (308g)",
        "url": "https://herballeato.com/products/high-protein-iced-coffee-308g",
        "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/iced-coffee.png"
      }
    }
  },
  "mylifestylemotion": {
    "domain": "https://mylifestylemotion.com",
    "products": {
      "formula1": { "id": "formula1", "title": "Formula 1 Frullato Sostituto del Pasto (780g)", "url": "https://mylifestylemotion.com/products/formula-1-nutritional-shake-mix-780-g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/pc-4462-za_df2e4c8c-1e24-4f81-995a-c21d8fa2a632.png" },
      "pdm": { "id": "pdm", "title": "Protein Drink Mix (PDM)", "url": "https://mylifestylemotion.com/products/protein-drink-mix-588-g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/protein-drink-mix-vanilla-588g-2601-za.png" },
      "tea": { "id": "tea", "title": "Infuso a Base di Erbe Termogenico (50g)", "url": "https://mylifestylemotion.com/products/infuso-a-base-di-erbe-50g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/pc-0105-za.png" },
      "aloemax": { "id": "aloemax", "title": "AloeMax Concentrato 97% Puro Aloe", "url": "https://mylifestylemotion.com/products/aloemax-473-ml", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/aloemax-concentrate-473ml-0006-za.png" },
      "phytocomplete": { "id": "phytocomplete", "title": "Phyto Complete con Fiit-NS™", "url": "https://mylifestylemotion.com/products/phyto-complete-60-capsule", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/phyto-complete-60-tablets-234k-za.png" },
      "collagen": { "id": "collagen", "title": "Collagene Skin Booster (Verisol® P)", "url": "https://mylifestylemotion.com/products/collagene-skin-booster", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/collagen-skin-booster-strawberry-and-mint-171g-076k-za.png" },
      "mineralcomplex": { "id": "mineralcomplex", "title": "Mineral Complex Plus", "url": "https://mylifestylemotion.com/products/mineral-complex-plus", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/mineral-complex-plus.png" },
      "nightmode": { "id": "nightmode", "title": "Night Mode", "url": "https://mylifestylemotion.com/products/night-mode-camomilla-e-pesca", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/nightmode.png" },
      "restore": { "id": "restore", "title": "Herbalife24® Restore", "url": "https://mylifestylemotion.com/products/h24-restore-30-capsule", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/h24-restore-30-capsules-1424-za.png" },
      "cr7drive": { "id": "cr7drive", "title": "Herbalife24® CR7 Drive", "url": "https://mylifestylemotion.com/products/h24-cr7-drive-barattolo-540g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/cr7.png" },
      "cr7": { "id": "cr7", "title": "Herbalife24® CR7 Drive", "url": "https://mylifestylemotion.com/products/h24-cr7-drive-barattolo-540g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/cr7.png" },
      "rebuildstrength": { "id": "rebuildstrength", "title": "Herbalife24® Rebuild Strength", "url": "https://mylifestylemotion.com/products/h24-rebuild-strength-cioccolato-1000g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/rebuild-strength.png" },
      "fibre": { "id": "fibre", "title": "Bebida con Avena, Mela e Fibre", "url": "https://mylifestylemotion.com/products/bevanda-multiffibre-204g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/multifibre.png" },
      "liftoff": { "id": "liftoff", "title": "Liftoff®", "url": "https://mylifestylemotion.com/products/liftoff-10-bustine", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/liftoff.png" },
      "proteinbar": { "id": "proteinbar", "title": "Barrette Proteiche", "url": "https://mylifestylemotion.com/products/barrette-alle-proteine-14-pezzi", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/protein-bars.png" },
      "soybeans": { "id": "soybeans", "title": "Noccioline di Soia Tostate", "url": "https://mylifestylemotion.com/products/noccioline-di-soia-tostate-12-bustine", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/soy-beans.png" },
      "proteinchips": { "id": "proteinchips", "title": "Protein Chips", "url": "https://mylifestylemotion.com/products/protein-chips", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/protein-chips.png" },
      "icedcoffee": { "id": "icedcoffee", "title": "High Protein Iced Coffee", "url": "https://mylifestylemotion.com/products/high-protein-iced-coffee-308g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/iced-coffee.png" }
    }
  },
  "herbaally": {
    "domain": "https://herbaally.com",
    "products": {
      "formula1": { "id": "formula1", "title": "Formula 1 Shake Mix (780g)", "url": "https://herbaally.com/products/formula-1-shake-mix-vanilla-cream-780-g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/pc-4462-za_df2e4c8c-1e24-4f81-995a-c21d8fa2a632.png" },
      "pdm": { "id": "pdm", "title": "Protein Drink Mix (PDM)", "url": "https://herbaally.com/products/protein-drink-mix-vanilla-588-g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/protein-drink-mix-vanilla-588g-2601-za.png" },
      "tea": { "id": "tea", "title": "Instant Herbal Beverage (50g)", "url": "https://herbaally.com/products/instant-herbal-beverage-with-tea-extracts-original-50-g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/pc-0105-za.png" },
      "aloemax": { "id": "aloemax", "title": "Herbal Aloe Concentrate / AloeMax", "url": "https://herbaally.com/products/aloemax-473-ml", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/aloemax-concentrate-473ml-0006-za.png" },
      "phytocomplete": { "id": "phytocomplete", "title": "Phyto Complete with Fiit-NS™", "url": "https://herbaally.com/products/phyto-complete-60-tablets", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/phyto-complete-60-tablets-234k-za.png" },
      "collagen": { "id": "collagen", "title": "Collagen Skin Booster", "url": "https://herbaally.com/products/collagen-skin-booster-strawberry-and-mint-171-g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/collagen-skin-booster-strawberry-and-mint-171g-076k-za.png" },
      "mineralcomplex": { "id": "mineralcomplex", "title": "Herbalifeline / Mineral Complex", "url": "https://herbaally.com/products/mineral-complex-plus", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/mineral-complex-plus.png" },
      "nightmode": { "id": "nightmode", "title": "Night Mode (Saffron)", "url": "https://herbaally.com/products/night-mode-chamomile-and-peach-180g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/nightmode.png" },
      "restore": { "id": "restore", "title": "Herbalife24® Restore", "url": "https://herbaally.com/products/h24-restore-30-capsules", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/h24-restore-30-capsules-1424-za.png" },
      "cr7drive": { "id": "cr7drive", "title": "Herbalife24® CR7 Drive", "url": "https://herbaally.com/products/h24-cr7-drive-canister-540g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/cr7.png" },
      "cr7": { "id": "cr7", "title": "Herbalife24® CR7 Drive", "url": "https://herbaally.com/products/h24-cr7-drive-canister-540g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/cr7.png" },
      "rebuildstrength": { "id": "rebuildstrength", "title": "Herbalife24® Rebuild Strength", "url": "https://herbaally.com/products/h24-rebuild-strength-chocolate-1000g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/rebuild-strength.png" },
      "fibre": { "id": "fibre", "title": "Oat Apple Fibre Drink", "url": "https://herbaally.com/products/oat-apple-fibre-drink-204-g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/multifibre.png" },
      "liftoff": { "id": "liftoff", "title": "Liftoff® Energy", "url": "https://herbaally.com/products/liftoff-effervescent-energy-drink", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/liftoff.png" },
      "proteinbar": { "id": "proteinbar", "title": "Protein Bars", "url": "https://herbaally.com/products/protein-bars-vanilla-almond-14x35-g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/protein-bars.png" },
      "soybeans": { "id": "soybeans", "title": "Roasted Soy Beans", "url": "https://herbaally.com/products/roasted-soy-beans-12x21-5g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/soy-beans.png" },
      "proteinchips": { "id": "proteinchips", "title": "Protein Chips", "url": "https://herbaally.com/products/protein-chips", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/protein-chips.png" },
      "icedcoffee": { "id": "icedcoffee", "title": "High Protein Iced Coffee", "url": "https://herbaally.com/products/high-protein-iced-coffee-308g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/iced-coffee.png" }
    }
  },
  "yourwellnesspath": {
    "domain": "https://your-wellness-path.myshopify.com",
    "products": {
      "formula1": { "id": "formula1", "title": "Shake Formula 1 Înlocuitor de Masă (780g)", "url": "https://your-wellness-path.myshopify.com/products/formula-1-nutritional-shake-mix-780-g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/pc-4462-za_df2e4c8c-1e24-4f81-995a-c21d8fa2a632.png" },
      "pdm": { "id": "pdm", "title": "Protein Drink Mix (PDM)", "url": "https://your-wellness-path.myshopify.com/products/protein-drink-mix-588-g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/protein-drink-mix-vanilla-588g-2601-za.png" },
      "tea": { "id": "tea", "title": "Ceai Instant pe Bază de Plante (50g)", "url": "https://your-wellness-path.myshopify.com/products/infuso-a-base-di-erbe-50g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/pc-0105-za.png" },
      "aloemax": { "id": "aloemax", "title": "AloeMax Concentrat 97% Suc Pur de Aloe", "url": "https://your-wellness-path.myshopify.com/products/aloemax-473-ml", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/aloemax-concentrate-473ml-0006-za.png" },
      "phytocomplete": { "id": "phytocomplete", "title": "Phyto Complete cu Fiit-NS™", "url": "https://your-wellness-path.myshopify.com/products/phyto-complete-60-capsule", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/phyto-complete-60-tablets-234k-za.png" },
      "collagen": { "id": "collagen", "title": "Collagen Skin Booster (Verisol® P)", "url": "https://your-wellness-path.myshopify.com/products/collagene-skin-booster", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/collagen-skin-booster-strawberry-and-mint-171g-076k-za.png" },
      "mineralcomplex": { "id": "mineralcomplex", "title": "Mineral Complex Plus", "url": "https://your-wellness-path.myshopify.com/products/mineral-complex-plus", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/mineral-complex-plus.png" },
      "nightmode": { "id": "nightmode", "title": "Night Mode", "url": "https://your-wellness-path.myshopify.com/products/night-mode-camomilla-e-pesca", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/nightmode.png" },
      "restore": { "id": "restore", "title": "Herbalife24® Restore", "url": "https://your-wellness-path.myshopify.com/products/h24-restore-30-capsule", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/h24-restore-30-capsules-1424-za.png" },
      "cr7drive": { "id": "cr7drive", "title": "Herbalife24® CR7 Drive", "url": "https://your-wellness-path.myshopify.com/products/h24-cr7-drive-barattolo-540g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/cr7.png" },
      "cr7": { "id": "cr7", "title": "Herbalife24® CR7 Drive", "url": "https://your-wellness-path.myshopify.com/products/h24-cr7-drive-barattolo-540g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/cr7.png" },
      "rebuildstrength": { "id": "rebuildstrength", "title": "Herbalife24® Rebuild Strength", "url": "https://your-wellness-path.myshopify.com/products/h24-rebuild-strength-cioccolato-1000g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/rebuild-strength.png" },
      "fibre": { "id": "fibre", "title": "Băutură cu Ovăz, Măr și Fibre", "url": "https://your-wellness-path.myshopify.com/products/bevanda-multiffibre-204g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/multifibre.png" },
      "liftoff": { "id": "liftoff", "title": "Liftoff®", "url": "https://your-wellness-path.myshopify.com/products/liftoff-10-bustine", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/liftoff.png" },
      "proteinbar": { "id": "proteinbar", "title": "Batoane Proteice", "url": "https://your-wellness-path.myshopify.com/products/barrette-alle-proteine-14-pezzi", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/protein-bars.png" },
      "soybeans": { "id": "soybeans", "title": "Boabe de Soia Prăjite", "url": "https://your-wellness-path.myshopify.com/products/noccioline-di-soia-tostate-12-bustine", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/soy-beans.png" },
      "proteinchips": { "id": "proteinchips", "title": "Protein Chips", "url": "https://your-wellness-path.myshopify.com/products/protein-chips", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/protein-chips.png" },
      "icedcoffee": { "id": "icedcoffee", "title": "High Protein Iced Coffee", "url": "https://your-wellness-path.myshopify.com/products/high-protein-iced-coffee-308g", "image": "https://cdn.shopify.com/s/files/1/0838/9342/0251/files/iced-coffee.png" }
    }
  }
};



const getStoreId = () => {
  if (typeof window !== 'undefined') {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const s = urlParams.get('store');
      if (s && ['herballeato', 'mylifestylemotion', 'herbaally', 'yourwellnesspath'].includes(s.toLowerCase())) {
        return s.toLowerCase();
      }
      const host = window.location.hostname;
      if (host.includes('mylifestylemotion')) return 'mylifestylemotion';
      if (host.includes('herballeato')) return 'herballeato';
      if (host.includes('your-wellness-path') || host.includes('yourwellnesspath')) return 'yourwellnesspath';
      if (host.includes('herbaally')) return 'herbaally';
    } catch(e) {}
  }
  return 'herballeato';
};

const getProductCardHtml = (productKey) => {
  const storeId = getStoreId();
  const cat = (typeof STORE_PRODUCTS_CATALOG !== 'undefined' && STORE_PRODUCTS_CATALOG[storeId]) 
    ? STORE_PRODUCTS_CATALOG[storeId] 
    : (typeof STORE_PRODUCTS_CATALOG !== 'undefined' ? STORE_PRODUCTS_CATALOG.herballeato : null);
  
  if (!cat || !cat.products || !cat.products[productKey]) return '';
  const prod = cat.products[productKey];
  const lang = (typeof state !== 'undefined' && state.lang) ? state.lang : 'it';
  const cta = lang === 'en' ? 'View Product ↗' : (lang === 'ro' ? 'Vezi Produsul ↗' : (lang === 'es' ? 'Ver Producto ↗' : 'Vedi Prodotto ↗'));
  
  return '<div class="coach-product-pill" style="margin: 6px 0; padding: 8px 12px; background: rgba(16,185,129,0.1); border: 1px solid #10B981; border-radius: 8px; display: inline-flex; align-items: center; justify-content: space-between; gap: 12px; width: 100%; box-sizing: border-box;">' +
    '<div style="display:flex; align-items:center; gap:8px;">' +
      '<span style="font-size:18px;">🌿</span>' +
      '<span style="font-weight:600; font-size:13px;">' + prod.title + '</span>' +
    '</div>' +
    '<a href="' + prod.url + '" target="_blank" rel="noopener noreferrer" style="color:#10B981; font-weight:700; font-size:12px; text-decoration:none; padding:4px 10px; background:#fff; border-radius:6px; white-space:nowrap; border:1px solid #10B981;">' + cta + '</a>' +
  '</div>';
};




// ==========================================

// TRANSLATIONS DICTIONARY (IT, EN, RO, ES)

// ==========================================

const TRANSLATIONS = {
  "it": {
    "brand_title": "Programma 10g",
    "brand_subtitle": "Distributore Indipendente",
    "nav_diario": "Diario di Bordo",
    "nav_confronto": "Confronto Gruppo",
    "nav_andamento": "Andamento & Report",
    "nav_piano": "Andamento & Report",
    "nav_community": "Community Chat",
    "nav_scanner": "Scanner AI Piatto",
    "nav_coach": "Coach AI",
    "nav_ricette": "Ricette & Consigli",
    "nav_profilo": "Profilo & Setup",
    "nav_diario_lbl": "Diario",
    "nav_piano_lbl": "Scheda",
    "nav_community_lbl": "Gruppo",
    "nav_scanner_lbl": "Scanner AI",
    "nav_coach_lbl": "Coach AI",
    "nav_profilo_lbl": "Profilo",
    "hdr_andamento": "Andamento & Report",
    "hdr_andamento_sub": "Grafici di andamento, strategia nutrizionale, macro e report",
    "hdr_piano": "Scheda Nutrizionale & Report",
    "hdr_piano_sub": "Strategia nutrizionale, fabbisogno calorico e traguardi",
    "tab_all": "Tutte",
    "tab_shakes": "Frullati F1",
    "tab_snacks": "Spuntini Sani",
    "tab_workouts": "🏋️ Video Allenamenti",
    "btn_watch_workout_videos": "Guarda i Video Allenamenti",
    "tab_tips": "💡 Perché è Importante",
    "tab_why_important": "💡 Perché è Importante",
    "badge_why_important": "PERCHÉ È IMPORTANTE",
    "btn_read_full_guide": "📖 Leggi Guida Completa →",
    "focus_banner_prefix": "💡 Perché è Importante — Giorno",
    "focus_banner_btn": "Leggi Guida",
    "guide_modal_understood": "👍 Ho Capito! Applica al Mio Benessere",
    "guide_modal_rec_prods": "🌿 Integrazione Herbalife Consigliata in Questa Guida:",
    "guide_modal_view_prod": "Vedi Prodotto ↗",
    "search_recipes_placeholder": "Cerca ingredienti o ricette...",
    "bot_welcome_msg": "Ciao sono il tuo assistente AI.",
    "chip_sleep": "😴 Consigli Sonno & Riposo",
    "chip_q_sleep": "Cosa mi consigli per dormire meglio?",
    "chip_bloat": "🦵 Sgonfiare Gambe & Pancia",
    "chip_q_bloat": "Cosa posso prendere per sgonfiare le gambe e la pancia?",
    "chip_diet_foods": "🥗 Alimenti Sani & Dieta",
    "chip_q_diet_foods": "Quali alimenti mi consigli per non gonfiare la pancia e stare leggera?",
    "chip_weight": "🔥 Kit Dimagrimento",
    "chip_q_weight": "Quali prodotti mi consigli per dimagrire?",
    "chip_snack_idea": "🍎 Idee Spuntino Fit",
    "chip_q_snack_idea": "Consigliami uno spuntino sano e saziante",
    "chip_breakfast": "☀️ Colazione Ideale",
    "chip_q_breakfast": "Cosa mangio a colazione nel programma?",
    "chip_water": "💧 Idratazione & Detox",
    "chip_q_water": "Quanta acqua devo bere al giorno?",
    "chip_energy": "⚡ Più Energia & Focus",
    "chip_q_energy": "Come posso avere più energia durante il giorno?",
    "chip_recovery": "🏋️ Recupero Post-Workout",
    "chip_q_recovery": "Cosa prendo dopo l'allenamento per il recupero muscolare?",
    "chip_collagen": "✨ Pelle & Collagene",
    "chip_q_collagen": "Cosa mi consigli per la bellezza della pelle e il collagene?",
    "chip_evening_hunger": "🌙 Fame la Sera?",
    "chip_q_evening_hunger": "Come gestire la fame la sera senza sensi di colpa?",
    "chip_ideal_dinner": "🍽️ Cena Ideale",
    "chip_q_ideal_dinner": "Cosa preparo per una cena ideale e leggera?",
    "chip_herbal_tea": "🌿 Termogenico & Erbe",
    "chip_q_herbal_tea": "Come e quando bere l'infuso a base di erbe?",
    "chip_analyze": "📊 Analizza Progressi Oggi",
    "chip_q_analyze": "Analizza i miei progressi di oggi",
    "chip_motivation": "💪 Motivazione Coach",
    "chip_q_motivation": "Ho bisogno di motivazione, dammi la carica!"
  },
  "en": {
    "brand_title": "10-Day Program",
    "brand_subtitle": "Independent Distributor",
    "nav_diario": "Daily Log",
    "nav_confronto": "Group Comparison",
    "nav_andamento": "Progress & Reports",
    "nav_piano": "Progress & Reports",
    "nav_community": "Community Chat",
    "nav_scanner": "AI Meal Scanner",
    "nav_coach": "AI Coach",
    "nav_ricette": "Recipes & Tips",
    "nav_profilo": "Profile & Setup",
    "nav_diario_lbl": "Daily Log",
    "nav_piano_lbl": "Plan",
    "nav_community_lbl": "Group",
    "nav_scanner_lbl": "AI Scanner",
    "nav_coach_lbl": "AI Coach",
    "nav_profilo_lbl": "Profile",
    "hdr_andamento": "Progress & Reports",
    "hdr_andamento_sub": "Progress charts, nutritional strategy, macros and reports",
    "hdr_piano": "Nutritional Plan & Reports",
    "hdr_piano_sub": "Nutritional strategy, caloric needs and milestones",
    "tab_all": "All",
    "tab_shakes": "F1 Shakes",
    "tab_snacks": "Healthy Snacks",
    "tab_workouts": "🏋️ Video Workouts",
    "btn_watch_workout_videos": "Watch Workout Videos",
    "tab_tips": "💡 Why It Matters",
    "tab_why_important": "💡 Why It Matters",
    "badge_why_important": "WHY IT MATTERS",
    "btn_read_full_guide": "📖 Read Full Guide →",
    "focus_banner_prefix": "💡 Why It Matters — Day",
    "focus_banner_btn": "Read Guide",
    "guide_modal_understood": "👍 Understood! Apply to My Wellness",
    "guide_modal_rec_prods": "🌿 Recommended Herbalife Nutrition in This Guide:",
    "guide_modal_view_prod": "View Product ↗",
    "search_recipes_placeholder": "Search ingredients or recipes...",
    "bot_welcome_msg": "Hi! I am your AI Wellness Coach.",
    "chip_sleep": "😴 Sleep & Rest Tips",
    "chip_q_sleep": "What do you recommend for better sleep and waking up refreshed?",
    "chip_bloat": "🦵 De-Bloat Legs & Belly",
    "chip_q_bloat": "What can I take to reduce bloating in legs and belly?",
    "chip_diet_foods": "🥗 Clean Foods & Diet",
    "chip_q_diet_foods": "Which clean foods do you recommend to avoid bloating?",
    "chip_weight": "🔥 Weight Loss Kit",
    "chip_q_weight": "Which products do you recommend for weight loss?",
    "chip_snack_idea": "🍎 Healthy Snack Ideas",
    "chip_q_snack_idea": "Suggest a healthy, high-protein and satisfying afternoon snack",
    "chip_breakfast": "☀️ Ideal Breakfast",
    "chip_q_breakfast": "What should I have for breakfast in the program?",
    "chip_water": "💧 Hydration & Detox",
    "chip_q_water": "How much water should I drink daily?",
    "chip_energy": "⚡ More Daily Energy",
    "chip_q_energy": "How can I get more energy throughout the day?",
    "chip_recovery": "🏋️ Post-Workout Recovery",
    "chip_q_recovery": "What should I take after my workout for muscle recovery?",
    "chip_collagen": "✨ Skin Glow & Collagen",
    "chip_q_collagen": "What do you recommend for skin glow, firmness and collagen?",
    "chip_evening_hunger": "🌙 Evening Cravings?",
    "chip_q_evening_hunger": "How can I manage late-night hunger without guilt?",
    "chip_ideal_dinner": "🍽️ Ideal Dinner",
    "chip_q_ideal_dinner": "What should I cook for an ideal, light, easily digestible dinner?",
    "chip_herbal_tea": "🌿 Herbal Tea & Metabolism",
    "chip_q_herbal_tea": "How and when should I drink the Instant Herbal Beverage?",
    "chip_analyze": "📊 Analyze Today's Progress",
    "chip_q_analyze": "Analyze my progress logged today and give me feedback",
    "chip_motivation": "💪 Coach Motivation",
    "chip_q_motivation": "I need motivation, boost my energy for the challenge!"
  },
  "ro": {
    "brand_title": "Programul de 10 Zile",
    "brand_subtitle": "Distribuitor Independent",
    "nav_diario": "Jurnal Zilnic",
    "nav_confronto": "Comparație Grup",
    "nav_andamento": "Evoluție & Raport",
    "nav_piano": "Evoluție & Raport",
    "nav_community": "Chat Comunitate",
    "nav_scanner": "Scanner AI Farfurie",
    "nav_coach": "Coach AI",
    "nav_ricette": "Rețete & Sfaturi",
    "nav_profilo": "Profil & Setări",
    "nav_diario_lbl": "Jurnal",
    "nav_piano_lbl": "Plan",
    "nav_community_lbl": "Grup",
    "nav_scanner_lbl": "Scanner AI",
    "nav_coach_lbl": "Coach AI",
    "nav_profilo_lbl": "Profil",
    "hdr_andamento": "Evoluție & Rapoarte",
    "hdr_andamento_sub": "Grafice de progres, strategie nutrițională, macronutrienți și rapoarte",
    "hdr_piano": "Plan Nutrițional & Rapoarte",
    "hdr_piano_sub": "Strategie nutrițională, necesar caloric și obiective",
    "tab_all": "Toate",
    "tab_shakes": "Shake-uri F1",
    "tab_snacks": "Gustări Sănătoase",
    "tab_workouts": "🏋️ Video Antrenamente",
    "btn_watch_workout_videos": "Vezi Video Antrenamente",
    "tab_tips": "💡 De Ce Este Important",
    "tab_why_important": "💡 De Ce Este Important",
    "badge_why_important": "DE CE ESTE IMPORTANT",
    "btn_read_full_guide": "📖 Citește Ghidul Complet →",
    "focus_banner_prefix": "💡 De Ce Este Important — Ziua",
    "focus_banner_btn": "Citește Ghidul",
    "guide_modal_understood": "👍 Am Înțeles! Aplică la Bunăstarea Mea",
    "guide_modal_rec_prods": "🌿 Nutriție Herbalife Recomandată în Acest Ghid:",
    "guide_modal_view_prod": "Vezi Produs ↗",
    "search_recipes_placeholder": "Caută ingrediente sau rețete...",
    "bot_welcome_msg": "Bună! Sunt asistentul tău AI de wellness.",
    "chip_sleep": "😴 Sfaturi Somn & Odihnă",
    "chip_q_sleep": "Ce îmi recomanzi pentru un somn mai bun și odihnitor?",
    "chip_bloat": "🦵 Dezumflare Picioare & Abdomen",
    "chip_q_bloat": "Ce pot consuma pentru a reduce retenția de apă și balonarea?",
    "chip_diet_foods": "🥗 Alimente Sănătoase & Dietă",
    "chip_q_diet_foods": "Ce alimente îmi recomanzi pentru a evita balonarea și a mă simți ușoară?",
    "chip_weight": "🔥 Pachet Slăbire",
    "chip_q_weight": "Ce produse îmi recomanzi pentru slăbire și arderea grăsimilor?",
    "chip_snack_idea": "🍎 Idei Gustare Fit",
    "chip_q_snack_idea": "Recomandă-mi o gustare sănătoasă, proteică și sățioasă",
    "chip_breakfast": "☀️ Micul Dejun Ideal",
    "chip_q_breakfast": "Ce consum la micul dejun în program?",
    "chip_water": "💧 Hidratare & Detox",
    "chip_q_water": "Câtă apă trebuie să beau zilnic?",
    "chip_energy": "⚡ Energie & Vitalitate",
    "chip_q_energy": "Cum pot avea mai multă energie pe tot parcursul zilei?",
    "chip_recovery": "🏋️ Refacere Post-Antrenament",
    "chip_q_recovery": "Ce consum după antrenament pentru refacerea musculară?",
    "chip_collagen": "✨ Piele & Colagen",
    "chip_q_collagen": "Ce îmi recomanzi pentru frumusețea pielii și colagen?",
    "chip_evening_hunger": "🌙 Foame Seara?",
    "chip_q_evening_hunger": "Cum gestionez foamea de seară fără vinovăție?",
    "chip_ideal_dinner": "🍽️ Cina Ideală",
    "chip_q_ideal_dinner": "Ce pregătesc pentru o cină ideală și ușoară?",
    "chip_herbal_tea": "🌿 Ceai Termogenic & Plante",
    "chip_q_herbal_tea": "Cum și când să beau ceaiul instant pe bază de plante?",
    "chip_analyze": "📊 Analizează Progresul Azi",
    "chip_q_analyze": "Analizează progresul meu înregistrat azi în jurnal",
    "chip_motivation": "💪 Motivație Coach",
    "chip_q_motivation": "Am nevoie de motivație, dă-mi energie pentru program!"
  },
  "es": {
    "brand_title": "Programa 10 Días",
    "brand_subtitle": "Distribuidor Independiente",
    "nav_diario": "Diario de a Bordo",
    "nav_confronto": "Comparación de Grupo",
    "nav_andamento": "Progreso & Informes",
    "nav_piano": "Progreso & Informes",
    "nav_community": "Chat Comunitario",
    "nav_scanner": "Escáner AI de Plato",
    "nav_coach": "Coach AI",
    "nav_ricette": "Recetas & Consejos",
    "nav_profilo": "Perfil & Ajustes",
    "nav_diario_lbl": "Diario",
    "nav_piano_lbl": "Plan",
    "nav_community_lbl": "Grupo",
    "nav_scanner_lbl": "Escáner AI",
    "nav_coach_lbl": "Coach AI",
    "nav_profilo_lbl": "Perfil",
    "hdr_andamento": "Progreso & Informes",
    "hdr_andamento_sub": "Gráficos de evolución, estrategia nutricional, macros e informes",
    "hdr_piano": "Ficha Nutricional & Informes",
    "hdr_piano_sub": "Estrategia nutricional, necesidades calóricas y metas",
    "tab_all": "Todas",
    "tab_shakes": "Batidos F1",
    "tab_snacks": "Snacks Saludables",
    "tab_workouts": "🏋️ Video Entrenamientos",
    "btn_watch_workout_videos": "Ver Video Entrenamientos",
    "tab_tips": "💡 Por Qué Es Importante",
    "tab_why_important": "💡 Por Qué Es Importante",
    "badge_why_important": "POR QUÉ ES IMPORTANTE",
    "btn_read_full_guide": "📖 Leer Guía Completa →",
    "focus_banner_prefix": "💡 Por Qué Es Importante — Día",
    "focus_banner_btn": "Leer Guía",
    "guide_modal_understood": "👍 ¡Entendido! Aplicar a mi Bienestar",
    "guide_modal_rec_prods": "🌿 Nutrición Herbalife Recomendada en Esta Guía:",
    "guide_modal_view_prod": "Ver Producto ↗",
    "search_recipes_placeholder": "Buscar ingredientes o recetas...",
    "bot_welcome_msg": "¡Hola! Soy tu asistente de bienestar AI.",
    "chip_sleep": "😴 Consejos de Sueño & Descanso",
    "chip_q_sleep": "¿Qué me recomiendas para dormir mejor y despertar con energía?",
    "chip_bloat": "🦵 Deshinchar Piernas y Abdomen",
    "chip_q_bloat": "¿Qué puedo tomar para reducir la hinchazón en piernas y vientre?",
    "chip_diet_foods": "🥗 Comida Sana & Dieta",
    "chip_q_diet_foods": "¿Qué alimentos me recomiendas para evitar la hinchazón y sentirme ligera?",
    "chip_weight": "🔥 Kit para Adelgazar",
    "chip_q_weight": "¿Qué productos me recomiendas para perder peso y quemar grasa?",
    "chip_snack_idea": "🍎 Ideas de Snacks Fit",
    "chip_q_snack_idea": "Recomiéndame un snack saludable, proteico y saciante para la tarde",
    "chip_breakfast": "☀️ Desayuno Ideal",
    "chip_q_breakfast": "¿Qué desayuno en el programa para tener energía constante?",
    "chip_water": "💧 Hidratación y Detox",
    "chip_q_water": "¿Cuánta agua debo beber al día?",
    "chip_energy": "⚡ Más Energía y Foco",
    "chip_q_energy": "¿Cómo puedo tener más energía durante el día y evitar el cansancio?",
    "chip_recovery": "🏋️ Recuperación Post-Entreno",
    "chip_q_recovery": "¿Qué tomo después del entrenamiento para la recuperación muscular?",
    "chip_collagen": "✨ Piel y Colágeno",
    "chip_q_collagen": "¿Qué me recomiendas para la belleza de la piel, luminosidad y colágeno?",
    "chip_evening_hunger": "🌙 ¿Hambre por la Noche?",
    "chip_q_evening_hunger": "¿Cómo controlar los antojos nocturnos y qué comer sin culpa?",
    "chip_ideal_dinner": "🍽️ Cena Ideal",
    "chip_q_ideal_dinner": "¿Qué preparo para una cena ideal, ligera y fácil de digerir?",
    "chip_herbal_tea": "🌿 Té Termogénico & Hierbas",
    "chip_q_herbal_tea": "¿Cómo y cuándo tomar la Infusión de Hierbas para mejores resultados?",
    "chip_analyze": "📊 Analizar Progreso de Hoy",
    "chip_q_analyze": "Analiza mi progreso registrado hoy en el diario y dame feedback",
    "chip_motivation": "💪 Motivación Coach",
    "chip_q_motivation": "¡Necesito motivación, dame fuerzas para dar el máximo en el reto!"
  }
};



// ==========================================

// STATE MANAGEMENT

// ==========================================

let state = {
  userId: (typeof window !== "undefined" ? (localStorage.getItem("program10_uid") || ("usr_" + Math.random().toString(36).substring(2, 9))) : "usr_default"),
  activeDay: 1,
  lang: "it",
  theme: "dark",
  profile: {
    name: "Sfidante",
    email: "",
    avatar: "🏃",
    gender: "donna",
    age: 32,
    height: 170,
    startWeight: 75.0,
    targetWeight: 68.0,
    waterGoal: 2.5,
    kitType: "avanzato",
    chest: null,
    waist: null,
    hips: null,
    sponsorName: "",
    sponsorPhone: "+393331234567",
    sponsorEmail: "",
    sponsorId: "",
    sponsorPhoto: null,
    isDistributor: false,
    myHerbalifeId: "",
    herbalifeIdStatus: "unverified",
    bodyShape: "normale",
    lifestyleType: "sedentario",
    gymFrequency: "nessuna",
    coffeeCount: 1,
    alcoholUsage: "no",
    sleepQuality: "buona",
    stressLevel: "medio",
    hasWalks: false,
    hasSauna: false,
    hasColdShower: false,
    hasMeditation: false,
    hasFasting: false,
    dietType: "onnivora",
    currentDiet: "",
    supplements: "",
    illnesses: "",
    medications: "",
    healthProblems: ""
  },
  dailyLogs: Array.from({ length: 10 }, (_, i) => ({
    day: i + 1,
    water: 0,
    shakesCount: 0,
    snack: false,
    meal: false,
    steps: 0,
    km: 0,
    exType: "nessuno",
    exDuration: 0,
    weight: null,
    score: 0,
    notes: "",
    completed: false
  })),
  reminders: {
    enabled: true,
    colazione: "08:00",
    idratazione: "11:00",
    spuntino: "16:00",
    cena: "20:00"
  },
  badgesUnlocked: {
    waterChamp: false,
    shakeLover: false,
    perfectDay: false,
    finisher: false
  },
  chatHistory: [],
  communityMessages: [],
  programStartDate: null
};

// Authentication helper: returns true if the user has a valid authenticated session
function isUserAuthenticated() {
  if (typeof window !== 'undefined' && window.ShopifyCustomer && window.ShopifyCustomer.email && window.ShopifyCustomer.email.includes('@')) {
    return true;
  }
  if (state && state.profile && state.profile.email && state.profile.email.includes('@') && !state.profile.email.includes('program10.local')) {
    return true;
  }
  return false;
}

const loadStateFromStorage = () => {
  if (typeof localStorage === "undefined") return;
  const stored = localStorage.getItem("herbalife_programma10_advanced_state");
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      state = { 
        ...state, 
        ...parsed, 
        profile: { ...state.profile, ...(parsed.profile || {}) },
        reminders: { ...state.reminders, ...(parsed.reminders || {}) },
        badgesUnlocked: { ...state.badgesUnlocked, ...(parsed.badgesUnlocked || {}) },
        communityMessages: (parsed.communityMessages && Array.isArray(parsed.communityMessages)) 
          ? parsed.communityMessages.filter(m => m && !m.bot && !['Elena V.', 'Marco R.', 'Giulia T.', 'Thabo M.', 'Andrei C.', 'Sponsor Coach'].includes(m.sender))
          : []
      };
      if (!parsed.lang_manually_selected) {
        state.lang = "it";
      }
    } catch (e) {
      console.error("Failed to parse storage state:", e);
    }
  } else {
    // Fresh state defaults
    state.lang = "it";
    state.theme = "dark";
    state.profile.name = "Sfidante";
    state.profile.avatar = "🏃";
    state.profile.sponsorPhone = "+393331234567";
    state.communityMessages = [];
    state.dailyLogs = Array.from({ length: 10 }, (_, i) => ({
      day: i + 1,
      water: 0,
      shakesCount: 0,
      snack: false,
      meal: false,
      steps: 0,
      km: 0,
      exType: "nessuno",
      exDuration: 0,
      weight: null,
      score: 0,
      notes: "",
      completed: false
    }));
    saveStateToStorage();
  }
  
  // Auto-set programStartDate if missing (first ever load)
  if (!state.programStartDate) {
    state.programStartDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
    saveStateToStorage();
  }
};

// Auto-advance day based on programStartDate (calendar days elapsed)
const autoAdvanceDay = () => {
  if (!state.programStartDate) return;
  const start = new Date(state.programStartDate + 'T00:00:00');
  const now = new Date();
  const startDay = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diffMs = today - startDay;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const computedDay = Math.min(10, Math.max(1, diffDays + 1));
  if (computedDay !== state.activeDay) {
    state.activeDay = computedDay;
    saveStateToStorage();
    console.log("[AutoDay] Advanced to Day " + computedDay + " (started: " + state.programStartDate + ")");
  }
};

const saveStateToStorage = () => {
  if (typeof localStorage === "undefined") return;
  try {
    const stateToSave = { ...state };
    if (Array.isArray(stateToSave.communityMessages) && stateToSave.communityMessages.length > 20) {
      stateToSave.communityMessages = stateToSave.communityMessages.slice(-20);
    }
    localStorage.setItem("herbalife_programma10_advanced_state", JSON.stringify(stateToSave));
  } catch (e) {
    console.error("Failed to save state to localStorage:", e);
  }
};



// ==========================================

// COACH GUIDES & ACADEMY

// ==========================================

const COACH_GUIDES = [
  // 1. ACQUA & IDRATAZIONE
  {
    id: "guide_water",
    icon: "💧",
    category: "idratazione",
    gradient: "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
    productKeys: ["aloemax", "tea", "hydrate"],
    title: "💧 Perché è importante bere acqua?",
    title_en: "💧 Why is Drinking Water So Important?",
    title_ro: "💧 De ce este important să bei apă?",
    title_es: "💧 ¿Por qué es importante beber agua?",
    desc: "L'acqua è essenziale per il corretto funzionamento dell'organismo ed è coinvolta in ogni processo metabolico, energetico e digestivo.",
    desc_en: "Water is essential for every physiological function, metabolic pathway, energy level, and digestive process.",
    desc_ro: "Apa este esențială pentru funcționarea organismului și este implicată în fiecare proces metabolic și digestiv.",
    desc_es: "El agua es esencial para el correcto funcionamiento del cuerpo y está involucrada en todos los procesos metabólicos.",
    keyPoints: [
      "Mantiene l'idratazione cellulare ed evita mal di testa e stanchezza",
      "Supporta concentrazione, memoria ed efficienza mentale",
      "Favorisce la regolarità intestinale e la digestione",
      "Supporta l'attività fisica e la termoregolazione",
      "Aiuta a distinguere la vera fame dalla sete"
    ],
    keyPoints_en: [
      "Maintains cellular hydration and prevents fatigue and headaches",
      "Supports mental clarity, focus, and cognitive function",
      "Promotes healthy bowel regularity and smooth digestion",
      "Enhances physical performance and body temperature regulation",
      "Helps differentiate true hunger from dehydration signals"
    ],
    keyPoints_ro: [
      "Menține hidratarea celulară și previne oboseala și durerile de cap",
      "Susține claritatea mentală, concentrarea și memoria",
      "Favorizează tranzitul intestinal regulat și digestia ușoară",
      "Susține performanța fizică și termoreglarea",
      "Ajută la diferențierea foamei reale de setea mascată"
    ],
    keyPoints_es: [
      "Mantiene la hidratación celular y previene fatiga y dolores de cabeza",
      "Mejora la concentración, la memoria y el rendimiento mental",
      "Favorece la regularidad intestinal y la digestión ligera",
      "Apoya la actividad física y la regulación térmica",
      "Ayuda a distinguir el hambre real de la simple deshidratación"
    ],
    htmlContent: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🌊 I 7 Benefici Fondamentali dell'Acqua</h4>
        <ul class="guide-bullets-list">
          <li><strong>💧 1. Mantiene l'idratazione:</strong> Regola l'equilibrio dei liquidi, previene affaticamento e mal di testa e supporta cellule e organi.</li>
          <li><strong>🧠 2. Supporta concentrazione ed energia:</strong> Il cervello è composto all'80% d'acqua. Una lieve disidratazione (1-2%) riduce focus e lucidità.</li>
          <li><strong>🚽 3. Favorisce la regolarità intestinale:</strong> Ammorbidisce le feci e, con fibre e movimento, sostiene una digestione leggera.</li>
          <li><strong>🏃‍♀️ 4. Supporta l'attività fisica:</strong> Previene crampi, lubrifica le articolazioni e compensa il sudore.</li>
          <li><strong>🌡️ 5. Regola la temperatura:</strong> Disperde il calore corporeo in eccesso attraverso la traspirazione.</li>
          <li><strong>🫘 6. Supporta la funzione renale:</strong> Aiuta i reni a filtrare ed espellere le scorie metaboliche.</li>
          <li><strong>🍽️ 7. Aiuta nella gestione della fame:</strong> Bere prima dei pasti idrata e aiuta a distinguere la sete dalla fame nervosa.</li>
        </ul>
      </div>

      <div class="guide-section-block">
        <h4 class="guide-section-heading">🎯 Obiettivo Quotidiano (~2 - 2.5 L)</h4>
        <p style="margin: 0 0 10px; font-size: 13px;">Distribuisci l'acqua durante la giornata anziché berla tutta insieme:</p>
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; font-size: 12.5px;">
          <div style="background: rgba(255,255,255,0.05); padding: 8px 12px; border-radius: 8px;">🌅 <strong>Mattina:</strong> 500 ml</div>
          <div style="background: rgba(255,255,255,0.05); padding: 8px 12px; border-radius: 8px;">☀️ <strong>Metà Giorno:</strong> 500 ml</div>
          <div style="background: rgba(255,255,255,0.05); padding: 8px 12px; border-radius: 8px;">🌤️ <strong>Pomeriggio:</strong> 500 ml</div>
          <div style="background: rgba(255,255,255,0.05); padding: 8px 12px; border-radius: 8px;">🌙 <strong>Sera:</strong> 500 ml</div>
        </div>
      </div>

      <div class="guide-section-block">
        <h4 class="guide-section-heading">💡 7 Strategie Se Fai Fatica a Bere</h4>
        <ul class="guide-bullets-list">
          <li><strong>Bottiglia sempre in vista:</strong> Tienila sulla scrivania o in borsa.</li>
          <li><strong>Bottiglia graduata (1L o 2L):</strong> Visualizzare l'obiettivo stimola la motivazione.</li>
          <li><strong>Promemoria ⏰:</strong> Un reminder ogni 1-2 ore trasforma il bere in un gesto automatico.</li>
          <li><strong>Associa l'acqua alle routine:</strong> Al risveglio, prima dei pasti e prima del workout.</li>
          <li><strong>Rendila gustosa 🍋:</strong> Aromatizzala con <strong>AloeMax</strong>, <strong>Infuso a Base di Erbe</strong> o <strong>Herbalife24® Hydrate</strong>.</li>
          <li><strong>Piccoli sorsi frequenti:</strong> Non ingurgitare grandi quantità tutte insieme.</li>
        </ul>
      </div>
    `,
    htmlContent_en: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🌊 7 Essential Benefits of Drinking Water</h4>
        <ul class="guide-bullets-list">
          <li><strong>💧 1. Maintains optimal hydration:</strong> Balances fluid levels, prevents fatigue and headaches, and supports cell & organ health.</li>
          <li><strong>🧠 2. Boosts brain power & focus:</strong> The brain is ~80% water. Even mild dehydration (1-2%) significantly impairs concentration.</li>
          <li><strong>🚽 3. Promotes digestive regularity:</strong> Softens stool and, combined with dietary fiber, keeps your gut light and flat.</li>
          <li><strong>🏃‍♀️ 4. Powers physical stamina:</strong> Prevents cramps, cushions joints, and replenishes sweat losses during workouts.</li>
          <li><strong>🌡️ 5. Regulates body temperature:</strong> Disperses excess body heat through natural perspiration.</li>
          <li><strong>🫘 6. Supports kidney function:</strong> Helps your kidneys flush metabolic waste and toxins via urine.</li>
          <li><strong>🍽️ 7. Controls appetite & cravings:</strong> Thirst is often mistaken for hunger. Drinking before meals helps control portions naturally.</li>
        </ul>
      </div>

      <div class="guide-section-block">
        <h4 class="guide-section-heading">🎯 Daily Target (~2 - 2.5 Liters)</h4>
        <p style="margin: 0 0 10px; font-size: 13px;">Spread your water intake consistently throughout the day:</p>
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; font-size: 12.5px;">
          <div style="background: rgba(255,255,255,0.05); padding: 8px 12px; border-radius: 8px;">🌅 <strong>Morning:</strong> 500 ml</div>
          <div style="background: rgba(255,255,255,0.05); padding: 8px 12px; border-radius: 8px;">☀️ <strong>Midday:</strong> 500 ml</div>
          <div style="background: rgba(255,255,255,0.05); padding: 8px 12px; border-radius: 8px;">🌤️ <strong>Afternoon:</strong> 500 ml</div>
          <div style="background: rgba(255,255,255,0.05); padding: 8px 12px; border-radius: 8px;">🌙 <strong>Evening:</strong> 500 ml</div>
        </div>
      </div>

      <div class="guide-section-block">
        <h4 class="guide-section-heading">💡 7 Practical Hacks If You Struggle to Drink</h4>
        <ul class="guide-bullets-list">
          <li><strong>Keep a bottle in plain sight:</strong> On your desk or in your bag.</li>
          <li><strong>Use a marked bottle (1L / 2L):</strong> Tracking visual progress builds consistency.</li>
          <li><strong>Set hourly reminders ⏰:</strong> Turn drinking into a seamless subconscious habit.</li>
          <li><strong>Anchor water to routines:</strong> Upon waking, before each meal, and before training.</li>
          <li><strong>Make it delicious 🍋:</strong> Infuse with <strong>AloeMax</strong>, <strong>Instant Herbal Beverage</strong>, or <strong>Herbalife24® Hydrate</strong>.</li>
          <li><strong>Frequent small sips:</strong> Avoid chugging huge volumes at once.</li>
        </ul>
      </div>
    `,
    htmlContent_ro: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🌊 Cele 7 Beneficii Esențiale ale Apei</h4>
        <ul class="guide-bullets-list">
          <li><strong>💧 1. Menține hidratarea optimă:</strong> Echilibrează fluidele corpului și previne stările de oboseală.</li>
          <li><strong>🧠 2. Susține concentrarea și energia:</strong> Creierul este 80% apă; deshidratarea reduce focusul.</li>
          <li><strong>🚽 3. Favorizează digestia:</strong> Menține tranzitul intestinal regulat și abdomenul suplu.</li>
          <li><strong>🏃‍♀️ 4. Susține activitatea fizică:</strong> Previne crampele și lubrifiază articulațiile.</li>
          <li><strong>🌡️ 5. Reglează temperatura:</strong> Elimină excesul de căldură prin transpirație.</li>
          <li><strong>🫘 6. Susține funcția renală:</strong> Ajută la filtrarea și eliminarea toxinelor.</li>
          <li><strong>🍽️ 7. Controlează apetitul:</strong> Paharul de apă băut înainte de masă previne supraalimentarea.</li>
        </ul>
      </div>
    `,
    htmlContent_es: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🌊 Los 7 Beneficios Vitales del Agua</h4>
        <ul class="guide-bullets-list">
          <li><strong>💧 1. Mantiene la hidratación celular:</strong> Previene fatiga y apoya los órganos vitales.</li>
          <li><strong>🧠 2. Mejora la lucidez mental:</strong> Mantiene la atención y el rendimiento cerebral.</li>
          <li><strong>🚽 3. Favorece la digestión:</strong> Regula el tránsito intestinal y un abdomen plano.</li>
          <li><strong>🏃‍♀️ 4. Potencia el ejercicio:</strong> Evita calambres y compensa el sudor.</li>
          <li><strong>🍽️ 5. Ayuda a controlar el apetito:</strong> Calma la falsa sensación de hambre.</li>
        </ul>
      </div>
    `
  },

  // 2. SONNO & RECUPERO
  {
    id: "guide_sleep",
    icon: "😴",
    category: "sonno",
    gradient: "linear-gradient(135deg, #312e81 0%, #1e1b4b 100%)",
    productKeys: ["nightmode", "restore"],
    title: "😴 Perché è importante dormire bene?",
    title_en: "😴 Why is Quality Sleep So Important?",
    title_ro: "😴 De ce este important să dormi bine?",
    title_es: "😴 ¿Por qué es importante dormir bien?",
    desc: "Il sonno è il momento in cui il corpo rigenera i tessuti, riequilibra gli ormoni di fame e sazietà e resetta il sistema nervoso.",
    desc_en: "Sleep is when your body restores cellular health, balances hunger hormones, and resets mental focus.",
    desc_ro: "Somnul este momentul esențial în care corpul se regenerează, echilibrează hormonii și resetează creierul.",
    desc_es: "El sueño es el momento en que tu cuerpo regenera tejidos, equilibra las hormonas del hambre y repara el sistema nervioso.",
    keyPoints: [
      "Rigenerazione profonda di muscoli, pelle e organi",
      "Riequilibrio di Leptina e Grelina (controllo appetito)",
      "Miglioramento di umore, lucidità mentale e reattività",
      "Protezione del sistema immunitario e riduzione del cortisolo",
      "Target ideale: 7-9 ore continuative e ristoratrici"
    ],
    keyPoints_en: [
      "Deep physical repair of muscles, skin, and cellular tissue",
      "Hormonal reset of Leptin & Ghrelin (hunger & satiety control)",
      "Elevated mood, mental sharpness, and stress reduction",
      "Immune system strengthening and lowered cortisol levels",
      "Optimal target: 7-9 continuous, restorative hours nightly"
    ],
    keyPoints_ro: [
      "Regenerare profundă a mușchilor, pielii și organelor",
      "Reechilibrare hormonală a Leptinei și Grelinei (control apetit)",
      "Îmbunătățirea stării de spirit și a clarității mentale",
      "Întărirea imunității și reducerea nivelului de cortizol",
      "Obiectiv optim: 7-9 ore de somn odihnitor pe noapte"
    ],
    keyPoints_es: [
      "Reparación celular profunda de músculos, piel y órganos",
      "Equilibrio hormonal de Leptina y Grelina (control del apetito)",
      "Mejora del humor, lucidez mental y menor estrés",
      "Fortalece el sistema inmune y disminuye el cortisol",
      "Meta ideal: 7-9 horas continuas y reparadoras cada noche"
    ],
    htmlContent: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🌙 I 7 Benefici Vitali del Sonno</h4>
        <ul class="guide-bullets-list">
          <li><strong>🛌 1. Recupero fisico profondo:</strong> Ripara le microlesioni muscolari e rigenera i tessuti.</li>
          <li><strong>🧠 2. Memoria e concentrazione:</strong> Nel sonno REM il cervello consolida i ricordi e smaltisce le tossine.</li>
          <li><strong>⚡ 3. Energia e vitalità:</strong> Ricarica le scorte cellulari per affrontare la giornata con slancio.</li>
          <li><strong>😊 4. Equilibrio emotivo:</strong> Riduce lo stress e stabilizza l'umore.</li>
          <li><strong>🍽️ 5. Controllo di fame e sazietà:</strong> Dormire poco aumenta la Grelina (fame) e abbassa la Leptina (sazietà).</li>
          <li><strong>🛡️ 6. Sistema immunitario forte:</strong> Durante il riposo si sintetizzano citochine protettive.</li>
          <li><strong>❤️ 7. Salute cardiocircolatoria:</strong> Pressione e battito rallentano, concedendo riposo al cuore.</li>
        </ul>
      </div>

      <div class="guide-section-block">
        <h4 class="guide-section-heading">💡 Le 9 Regole d'Oro per un Sonno Perfetto</h4>
        <ol class="guide-bullets-list" style="padding-left: 20px;">
          <li><strong>Orari stabili:</strong> Vai a dormire e svegliati alla stessa ora.</li>
          <li><strong>Routine serale rilassante:</strong> Ultimi 45 minuti a luci soffuse con lettura o musica calma.</li>
          <li><strong>Spegni gli schermi 📱:</strong> La luce blu blocca la melatonina naturale.</li>
          <li><strong>No caffeina dopo le 15:00-16:00:</strong> Evita stimolanti nel tardo pomeriggio.</li>
          <li><strong>Camera fresca e buia (18-20°C):</strong> L'ambiente ideale per il riposo profondo.</li>
          <li><strong>Integrazione serale:</strong> Gusta <strong>Night Mode</strong> (zafferano e camomilla) e 1 capsula di <strong>H24 Restore</strong> 30 minuti prima di coricarti.</li>
        </ol>
      </div>
    `,
    htmlContent_en: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🌙 7 Vital Benefits of Restorative Sleep</h4>
        <ul class="guide-bullets-list">
          <li><strong>🛌 1. Deep cellular repair:</strong> Restores muscle micro-tears, collagen, and vital organs.</li>
          <li><strong>🧠 2. Memory & brain detox:</strong> REM sleep cleanses metabolic waste via the glymphatic system.</li>
          <li><strong>⚡ 3. Sustained daily vitality:</strong> Recharges glycogen stores so you wake up full of energy.</li>
          <li><strong>😊 4. Emotional stability:</strong> Lowers cortisol, easing anxiety and stress reactivity.</li>
          <li><strong>🍽️ 5. Hunger hormone regulation:</strong> Sleep deprivation spikes Ghrelin (hunger) and crashes Leptin (fullness), driving junk food cravings!</li>
          <li><strong>🛡️ 6. Robust immune defenses:</strong> Cellular cytokines are produced during deep sleep.</li>
          <li><strong>❤️ 7. Cardiovascular rest:</strong> Blood pressure drops, allowing the heart to rest and recover.</li>
        </ul>
      </div>

      <div class="guide-section-block">
        <h4 class="guide-section-heading">💡 The 9 Golden Rules for Perfect Sleep</h4>
        <ol class="guide-bullets-list" style="padding-left: 20px;">
          <li><strong>Fixed sleep schedule:</strong> Wake and sleep at consistent times every day.</li>
          <li><strong>Calming wind-down routine:</strong> Dim the lights 45 minutes before bedtime.</li>
          <li><strong>Screen curfew 📱:</strong> Blue light halts natural melatonin production.</li>
          <li><strong>Cut caffeine after 3 PM:</strong> Protect deep REM cycles from stimulants.</li>
          <li><strong>Cool & dark room (18-20°C):</strong> The biological sweet spot for restful sleep.</li>
          <li><strong>Targeted evening nutrition:</strong> Sip <strong>Night Mode</strong> (saffron & chamomile) and take 1 capsule of <strong>H24 Restore</strong> 30 minutes before bed.</li>
        </ol>
      </div>
    `,
    htmlContent_ro: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🌙 Beneficiile Somnului Odihnitor</h4>
        <ul class="guide-bullets-list">
          <li><strong>🛌 1. Refacere musculară:</strong> Repară țesuturile și fibrele musculare.</li>
          <li><strong>🍽️ 2. Reglare hormonală:</strong> Controlează hormonii foamei și previne poftele nocturne.</li>
          <li><strong>🛡️ 3. Imunitate:</strong> Întărește apărarea naturală a organismului.</li>
        </ul>
      </div>
    `,
    htmlContent_es: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🌙 Beneficios de un Sueño Reparador</h4>
        <ul class="guide-bullets-list">
          <li><strong>🛌 1. Regeneración profunda:</strong> Repara tejidos y fibras musculares.</li>
          <li><strong>🍽️ 2. Control hormonal del apetito:</strong> Equilibra Leptina y Grelina.</li>
          <li><strong>🛡️ 3. Sistema inmune fuerte:</strong> Protege tu organismo.</li>
        </ul>
      </div>
    `
  },

  // 3. GESTIONE DELLA FAME & SNACK INTELLIGENTI
  {
    id: "guide_hunger",
    icon: "🍽️",
    category: "nutrizione",
    gradient: "linear-gradient(135deg, #ea580c 0%, #c2410c 100%)",
    productKeys: ["proteinbar", "proteinchips", "icedcoffee", "triblend", "pdm"],
    title: "🍽️ Perché è importante gestire la fame?",
    title_en: "🍽️ Why Managing Hunger is Key?",
    title_ro: "🍽️ De ce este important să gestionezi foamea?",
    title_es: "🍽️ ¿Por qué es importante gestionar el hambre?",
    desc: "Avere una fame equilibrata ti dà energia costante, concentrazione e pieno controllo. Non devi combattere la fame, devi imparare a nutrirla bene.",
    desc_en: "Balanced hunger provides steady energy and control. You don't fight hunger; you manage it with proper nutrition.",
    desc_ro: "O senzație de foame echilibrată îți oferă energie constantă. Nu trebuie să lupți cu foamea, ci să o gestionezi inteligent.",
    desc_es: "Gestionar el hambre te aporta energía estable y control. No debes luchar contra el hambre, sino aprender a nutrirte bien.",
    keyPoints: [
      "Costruisci pasti sazianti unendo proteine, fibre, carboidrati e grassi sani",
      "Non arrivare ai pasti troppo affamata saltando spuntini",
      "Distingui la fame biologica dalla fame emotiva e dalla sete",
      "Snack intelligenti: Barrette Herbalife, Chips proteiche, Iced Coffee, Tri-Blend"
    ],
    keyPoints_en: [
      "Build filling meals combining lean protein, dietary fiber, complex carbs & healthy fats",
      "Never arrive famished by skipping smart mid-morning & afternoon snacks",
      "Differentiate physical hunger from emotional eating and dehydration",
      "Smart Herbalife snacks: Protein Bars, Protein Chips, Iced Coffee, Tri-Blend"
    ],
    keyPoints_ro: [
      "Compune mese sățioase cu proteine, fibre, carbohidrați complecși și grăsimi sănătoase",
      "Nu ajunge înfometată la mesele principale; folosește gustări inteligente",
      "Diferențiază foamea fizică de foamea emoțională sau de sete",
      "Gustări inteligente: Batoane proteice, Chipsuri proteice, Iced Coffee, Tri-Blend"
    ],
    keyPoints_es: [
      "Construye comidas saciantes combinando proteínas, fibras, carbohidratos y grasas buenas",
      "Evita llegar con hambre feroz incluyendo meriendas inteligentes",
      "Distingue el hambre física del hambre emocional y la deshidratación",
      "Snacks inteligentes: Barritas de Proteína, Chips proteicos, Iced Coffee, Tri-Blend"
    ],
    htmlContent: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🥗 Gli 8 Pilastri per Gestire la Fame</h4>
        <ul class="guide-bullets-list">
          <li><strong>🍗 1. Pasti completi e sazianti:</strong> Proteine nobili, fibre, carboidrati complessi e grassi sani.</li>
          <li><strong>⏰ 2. Non arrivare al pasto affamata:</strong> Gli spuntini proteici stabilizzano la glicemia.</li>
          <li><strong>🥚 3. Priorità alle proteine:</strong> Rallentano lo svuotamento gastrico e danno sazietà duratura.</li>
          <li><strong>🌾 4. Fibre e verdure:</strong> Creano volume nello stomaco.</li>
          <li><strong>💧 5. Bevi acqua prima dei pasti:</strong> Evita di confondere la sete con la fame.</li>
          <li><strong>😴 6. Dormi 7-9 ore:</strong> Il sonno bilancia la grelina.</li>
          <li><strong>🧘‍♀️ 7. Riconosci la fame emotiva:</strong> Chiediti: <em>"Ho fame o sono stressata?"</em></li>
          <li><strong>🍫 8. Zero privazioni punitive:</strong> Conta la misura e la qualità.</li>
        </ul>
      </div>
    `,
    htmlContent_en: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🥗 8 Pillars to Master Hunger & Satiety</h4>
        <ul class="guide-bullets-list">
          <li><strong>🍗 1. Nutrient-dense, balanced meals:</strong> Combine lean proteins, dietary fiber, complex carbs, and healthy fats (EVO oil, avocado).</li>
          <li><strong>⏰ 2. Avoid extreme hunger:</strong> Skipping meals leads to evening rebound binging.</li>
          <li><strong>🥚 3. Prioritize clean protein:</strong> Slows gastric emptying and sustains satiety for hours.</li>
          <li><strong>🌾 4. Fiber-rich veggies:</strong> Adds volume and balances post-meal glucose absorption.</li>
          <li><strong>💧 5. Drink water first:</strong> Thirst signals are frequently misinterpreted as food cravings.</li>
          <li><strong>😴 6. Sleep 7-9 hours:</strong> Sleep deprivation triggers surging Ghrelin levels.</li>
          <li><strong>🧘‍♀️ 7. Identify emotional triggers:</strong> Ask yourself: <em>"Am I physically hungry or stressed/bored?"</em></li>
          <li><strong>🍫 8. No extreme deprivation:</strong> Balance and moderation always outperform unsustainable restriction.</li>
        </ul>
      </div>
    `,
    htmlContent_ro: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🥗 Pilonii Gestionării Foamei</h4>
        <ul class="guide-bullets-list">
          <li><strong>🍗 1. Mese echilibrate:</strong> Proteine, fibre și grăsimi sănătoase.</li>
          <li><strong>⏰ 2. Fără înfometare:</strong> Gustările proteice mențin glicemia stabilă.</li>
          <li><strong>💧 3. Hidratare:</strong> Bea un pahar cu apă înainte de a mânca.</li>
        </ul>
      </div>
    `,
    htmlContent_es: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🥗 Claves para Gestionar el Hambre</h4>
        <ul class="guide-bullets-list">
          <li><strong>🍗 1. Platos saciantes:</strong> Proteínas magras, verduras y grasas buenas.</li>
          <li><strong>⏰ 2. Regularidad:</strong> No pases horas en ayuno extremo.</li>
          <li><strong>💧 3. Hidratación:</strong> Bebe agua antes de las comidas.</li>
        </ul>
      </div>
    `
  },

  // 4. CAMMINARE & NEAT (10.000 PASSI)
  {
    id: "guide_walking",
    icon: "🚶‍♀️",
    category: "movimento",
    gradient: "linear-gradient(135deg, #059669 0%, #047857 100%)",
    productKeys: ["hydrate", "cr7"],
    title: "🚶‍♀️ Perché è importante camminare ogni giorno (NEAT & 10.000 Passi)?",
    title_en: "🚶‍♀️ Why Daily Walking & NEAT Are Crucial?",
    title_ro: "🚶‍♀️ De ce este important să mergi pe jos zilnic?",
    title_es: "🚶‍♀️ ¿Por qué es fundamental caminar a diario (10.000 pasos)?",
    desc: "I passi quotidiani sono il modo più semplice per aumentare il consumo calorico, sgonfiare le gambe, migliorare la digestione e ridurre lo stress.",
    desc_en: "Daily steps are the simplest way to boost calorie burn, drain leg fluids, improve digestion, and lower stress.",
    desc_ro: "Pașii zilnici sunt cel mai simplu mod de a crește consumul de calorii, a drena picioarele și a îmbunătăți digestia.",
    desc_es: "Los pasos diarios aumentan el gasto calórico basal, drenan las piernas y mejoran la digestión y el bienestar mental.",
    keyPoints: [
      "Supporta il cuore, la circolazione venosa e la salute cardiovascolare",
      "Aumenta il dispendio energetico quotidiano (NEAT) senza stress articolare",
      "Una camminata di 10-15 min dopo i pasti favorisce la digestione e la glicemia",
      "Progressione graduale: 3.000 → 5.000 → 8.000 → 10.000 passi",
      "Reintegra sempre i sali minerali con Herbalife24® Hydrate"
    ],
    keyPoints_en: [
      "Strengthens heart, venous blood circulation & cardiovascular health",
      "Dramatically increases daily energy expenditure (NEAT) with zero joint impact",
      "A 10-15 min post-meal walk accelerates digestion and controls blood glucose",
      "Progressive ramp-up: 3,000 → 5,000 → 8,000 → 10,000 steps",
      "Replenish lost electrolytes with Herbalife24® Hydrate or CR7 Drive"
    ],
    keyPoints_ro: [
      "Susține inima, circulația sângelui și sănătatea cardiovasculară",
      "Crește consumul caloric zilnic (NEAT) fără impact articular",
      "O plimbare de 10-15 min după masă îmbunătățește digestia și glicemia",
      "Progresie treptată: 3.000 → 5.000 → 8.000 → 10.000 pași",
      "Rehidratează-te cu Herbalife24® Hydrate sau CR7 Drive"
    ],
    keyPoints_es: [
      "Fortalece el corazón y activa el retorno venoso de las piernas",
      "Aumenta el gasto calórico diario (NEAT) sin impacto articular",
      "Caminar 10-15 min tras las comidas mejora la digestión y la glucemia",
      "Aumento gradual: 3.000 → 5.000 → 8.000 → 10.000 pasos",
      "Repón sales minerales con Herbalife24® Hydrate o CR7 Drive"
    ],
    htmlContent: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🏃‍♀️ I 6 Grandi Benefici della Camminata Quotidiana</h4>
        <ul class="guide-bullets-list">
          <li><strong>❤️ 1. Salute cardiovascolare:</strong> Stimola il cuore e riduce la sedentarietà.</li>
          <li><strong>🔥 2. Aumenta il consumo calorico (NEAT):</strong> Brucia energia costante tutto il giorno.</li>
          <li><strong>🦵 3. Attiva la pompa plantare:</strong> Sgonfia caviglie e gambe pesanti.</li>
          <li><strong>🧠 4. Rigenera la mente:</strong> Abbassa il cortisolo e rasserena i pensieri.</li>
          <li><strong>🍽️ 5. Migliora la digestione:</strong> 15 minuti dopo i pasti stabilizzano la glicemia.</li>
          <li><strong>⚡ 6. Combatte la sedentarietà:</strong> Spezza le ore sedute al PC.</li>
        </ul>
      </div>
    `,
    htmlContent_en: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🏃‍♀️ 6 Powerful Health Benefits of Daily Steps</h4>
        <ul class="guide-bullets-list">
          <li><strong>❤️ 1. Cardiovascular wellness:</strong> Elevates heart efficiency, oxygen delivery, and circulation.</li>
          <li><strong>🔥 2. Higher metabolic burn (NEAT):</strong> Active movement burns more calories throughout 24 hours than 1 gym hour alone!</li>
          <li><strong>🦵 3. Calf muscle pump activation:</strong> Drives pooled fluid from ankles upward, relieving heavy leg swelling.</li>
          <li><strong>🧠 4. Mental reset & endorphins:</strong> Reduces cortisol stress and clears brain fog.</li>
          <li><strong>🍽️ 5. Post-meal glucose stabilization:</strong> 10-15 minutes of light walking shuttles carbohydrates straight to muscle tissue.</li>
          <li><strong>⚡ 6. Breaks sedentary patterns:</strong> Counters long desk-bound sitting hours.</li>
        </ul>
      </div>
    `,
    htmlContent_ro: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🏃‍♀️ Beneficiile Mișcării Zilnice</h4>
        <ul class="guide-bullets-list">
          <li><strong>❤️ 1. Sănătate cardiovasculară:</strong> Activează circulația și oxigenează țesuturile.</li>
          <li><strong>🦵 2. Picioare suple:</strong> Pompează lichidele acumulate în glezne.</li>
          <li><strong>🍽️ 3. Digestie excelentă:</strong> 15 minute de mers după masă reduc glicemia.</li>
        </ul>
      </div>
    `,
    htmlContent_es: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🏃‍♀️ Beneficios del Movimiento Diario</h4>
        <ul class="guide-bullets-list">
          <li><strong>❤️ 1. Salud cardiovascular:</strong> Activa el corazón y oxigena las células.</li>
          <li><strong>🦵 2. Piernas ligeras:</strong> Estimula el retorno venoso y linfático.</li>
          <li><strong>🍽️ 3. Digestión rápida:</strong> Caminar tras comer equilibra la glucemia.</li>
        </ul>
      </div>
    `
  },

  // 5. NON SALTARE I PASTI & COLAZIONE F1+PDM
  {
    id: "guide_skip_meals",
    icon: "⏰",
    category: "nutrizione",
    gradient: "linear-gradient(135deg, #d97706 0%, #b45309 100%)",
    productKeys: ["formula1", "pdm", "phytocomplete"],
    title: "⏰ Perché è importante non saltare i pasti?",
    title_en: "⏰ Why You Should Never Skip Meals?",
    title_ro: "⏰ De ce este important să nu sari peste mese?",
    title_es: "⏰ ¿Por qué es importante no saltarse comidas?",
    desc: "Mangiare con regolarità fornisce nutrienti ed energia costante. Saltare i pasti per 'mangiare meno' innesca solo fame nervosa e rallentamento metabolico.",
    desc_en: "Eating regularly sustains metabolic rate and steady energy. Skipping meals triggers primal rebound hunger.",
    desc_ro: "Mesele regulate mențin energia stabilă. Săritul peste mese încetinește metabolismul și provoacă pofte nocturne.",
    desc_es: "Comer con regularidad mantiene el metabolismo activo. Saltarse comidas solo genera atracones nocturnos.",
    keyPoints: [
      "Energia costante senza cali di concentrazione o stanchezza improvvisa",
      "Evita di arrivare alla sera affamata con abbuffate incontrollate",
      "Nutre la massa magra e preserva il tasso metabolico basale",
      "Soluzione salva-tempo: Frullato Formula 1 + PDM (22g proteine, 220 kcal)"
    ],
    keyPoints_en: [
      "Steady, reliable energy without cognitive crashes or sudden fatigue",
      "Prevents entering dinner in extreme hunger mode leading to binging",
      "Protects lean muscle tissue and preserves resting metabolic rate",
      "Quick 2-minute solution: Formula 1 + PDM Shake (22g protein, 220 kcal)"
    ],
    keyPoints_ro: [
      "Energie constantă fără scăderi bruște de concentrare sau oboseală",
      "Previne înfometarea extremă la cină și supraalimentarea",
      "Protejează masa musculară și menține rata metabolică activă",
      "Soluție rapidă: Shake Formula 1 + PDM (22g proteine, 220 kcal)"
    ],
    keyPoints_es: [
      "Energía estable sin bajones de concentración ni cansancio repentino",
      "Evita llegar a la cena con hambre voraz e incontrolable",
      "Protege la masa muscular magra y activa el metabolismo basal",
      "Solución rápida: Batido Formula 1 + PDM (22g proteína, 220 kcal)"
    ],
    htmlContent: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">⚡ 6 Motivi per Mangiare con Regolarità</h4>
        <ul class="guide-bullets-list">
          <li><strong>⚡ 1. Energia costante:</strong> Evita picchi e crolli glicemici.</li>
          <li><strong>🧠 2. Lucidità mentale:</strong> Scegli con calma porzioni e cibi nutrienti.</li>
          <li><strong>🍫 3. Zero abbuffate:</strong> Elimina le voglie compulsive di zuccheri serali.</li>
          <li><strong>🥤 4. Soluzione Express:</strong> Shake Formula 1 + PDM in 2 minuti con 22g di proteine pure a sole 220 kcal.</li>
        </ul>
      </div>
    `,
    htmlContent_en: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">⚡ 6 Crucial Reasons for Meal Regularity</h4>
        <ul class="guide-bullets-list">
          <li><strong>⚡ 1. Sustained fuel:</strong> Avoids insulin spikes and midday energy dips.</li>
          <li><strong>🧠 2. Clear food decisions:</strong> When not famished, you choose wholesome portions calmly.</li>
          <li><strong>🍫 3. Zero night cravings:</strong> Eliminates irresistible refined sugar cravings.</li>
          <li><strong>🥤 4. Fast & Complete:</strong> Formula 1 + PDM Shake delivers 22g protein and 25 vitamins in just 2 minutes (220 kcal).</li>
        </ul>
      </div>
    `,
    htmlContent_ro: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">⚡ De Ce Să Mănânci Regulat</h4>
        <ul class="guide-bullets-list">
          <li><strong>⚡ 1. Energie stabilă:</strong> Fără căderi de energie la prânz.</li>
          <li><strong>🥤 2. Mic Dejun Ideal:</strong> Shake Formula 1 + PDM în 2 minute (22g proteine, 220 kcal).</li>
        </ul>
      </div>
    `,
    htmlContent_es: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">⚡ Por Qué Comer con Regularidad</h4>
        <ul class="guide-bullets-list">
          <li><strong>⚡ 1. Energía constante:</strong> Sin caídas bruscas de azúcar en sangre.</li>
          <li><strong>🥤 2. Desayuno Ideal:</strong> Batido Formula 1 + PDM en 2 minutos (22g proteína, 220 kcal).</li>
        </ul>
      </div>
    `
  },

  // 6. IL PIATTO BILANCIATO (LA REGOLA DEI 3 TERZI)
  {
    id: "guide_balanced_plate",
    icon: "🍽️",
    category: "nutrizione",
    gradient: "linear-gradient(135deg, #15803d 0%, #166534 100%)",
    productKeys: ["phytocomplete", "aloemax", "tea"],
    title: "🍽️ Come preparare un pasto bilanciato (La Regola dei 3 Terzi)?",
    title_en: "🍽️ How to Build a Balanced Plate (The 3-Thirds Rule)?",
    title_ro: "🍽️ Cum să pregătești o masă echilibrată (Regula celor 3 Treimi)?",
    title_es: "🍽️ ¿Cómo preparar un plato equilibrado (La regla de los 3 tercios)?",
    desc: "Mangiare sano non significa pesare ogni grammo con l'ansia. Dividi il piatto in 3 parti: 1/3 verdure, 1/3 proteine magre, 1/3 carboidrati + grassi sani.",
    desc_en: "Healthy eating doesn't require obsessive weighing. Divide your plate: 1/3 veggies, 1/3 lean protein, 1/3 complex carbs + healthy fats.",
    desc_ro: "Nu trebuie să cântărești totul. Împarte farfuria: 1/3 legume, 1/3 proteine slabe, 1/3 carbohidrați complecși + grăsimi bune.",
    desc_es: "Comer sano no es pesar cada gramo. Divide tu plato: 1/3 verduras, 1/3 proteínas limpias, 1/3 carbohidratos + grasas saludables.",
    keyPoints: [
      "1/3 del piatto: Verdure di stagione ricche di fibre, vitamine e volume",
      "1/3 del piatto: Proteine nobili (pollo, pesce, uova, legumi, tofu)",
      "1/3 del piatto: Carboidrati complessi (riso, quinoa, patate dolci, farro, pasta integrale)",
      "Grassi di qualità in moderazione (olio EVO a crudo, avocado, frutta secca)",
      "Libera dall'ansia della bilancia creando pasti vari e sazianti"
    ],
    keyPoints_en: [
      "1/3 Plate: Seasonal vegetables rich in fiber, micronutrients & volume",
      "1/3 Plate: Lean proteins (fish, chicken, eggs, legumes, tofu)",
      "1/3 Plate: Complex carbohydrates (brown/basmati rice, sweet potatoes, quinoa, oats)",
      "Healthy fats in moderation (raw extra virgin olive oil, avocado, nuts)",
      "Eliminates kitchen scale anxiety while building delicious, balanced satiety"
    ],
    keyPoints_ro: [
      "1/3 Farfurie: Legume de sezon bogate în fibre, vitamine și volum",
      "1/3 Farfurie: Proteine slabe (pește, pui, ouă, leguminoase, tofu)",
      "1/3 Farfurie: Carbohidrați complecși (orez brun, cartofi dulci, quinoa)",
      "Grăsimi sănătoase cu moderație (ulei de măsline extravirgin, avocado, nuci)",
      "Te scapă de grija cântăririi obsesive a alimentelor"
    ],
    keyPoints_es: [
      "1/3 del Plato: Verduras de temporada ricas en fibra, vitaminas y volumen",
      "1/3 del Plato: Proteínas limpias (pescado, pollo, huevos, legumbres, tofu)",
      "1/3 del Plato: Carbohidratos complejos (arroz integral, batata, quinoa, avena)",
      "Grasas saludables con moderación (aceite de oliva virgen extra, aguacate, nueces)",
      "Te libera del estrés de la báscula y asegura una nutrición completa"
    ],
    htmlContent: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🥗 La Formula Visiva del Piatto Sano</h4>
        <ul class="guide-bullets-list">
          <li><strong>🥦 1/3 VERDURE (Fibre & Volume):</strong> Zucchine, broccoli, asparagi, finocchi, spinaci, insalate.</li>
          <li><strong>🍗 1/3 PROTEINE (Sazietà & Muscoli):</strong> Pesce bianco o azzurro, pollo/tacchino, uova, tofu, yogurt greco.</li>
          <li><strong>🍚 1/3 CARBOIDRATI (Energia Pulita):</strong> Riso basmati o integrale, quinoa, patate dolci, farro, pasta integrale.</li>
          <li><strong>🥑 + GRASSI BUONI:</strong> 1 cucchiaio di olio extravergine d'oliva a crudo o 1/4 di avocado.</li>
        </ul>
      </div>
    `,
    htmlContent_en: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🥗 The Visual Balanced Plate Blueprint</h4>
        <ul class="guide-bullets-list">
          <li><strong>🥦 1/3 VEGETABLES (Fiber & Volume):</strong> Broccoli, asparagus, spinach, zucchini, crisp salads, bell peppers.</li>
          <li><strong>🍗 1/3 LEAN PROTEIN (Satiety & Muscle):</strong> Wild fish, chicken/turkey breast, eggs, tofu, Greek yogurt, lentils.</li>
          <li><strong>🍚 1/3 COMPLEX CARBS (Clean Energy):</strong> Brown/basmati rice, sweet potato, quinoa, oats, whole wheat pasta.</li>
          <li><strong>🥑 + HEALTHY FATS:</strong> 1 tbsp raw extra virgin olive oil, 1/4 avocado, or a small handful of almonds.</li>
        </ul>
      </div>
    `,
    htmlContent_ro: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🥗 Formula Farfuriei Echilibrate</h4>
        <ul class="guide-bullets-list">
          <li><strong>🥦 1/3 LEGUME:</strong> Broccoli, spanac, dovlecei, salată verde.</li>
          <li><strong>🍗 1/3 PROTEINE:</strong> Pește, pui, ouă, leguminoase.</li>
          <li><strong>🍚 1/3 CARBOHIDRAȚI:</strong> Orez brun, cartofi dulci, quinoa.</li>
          <li><strong>🥑 + GRĂSIMI BUNE:</strong> Ulei de măsline extravirgin, avocado.</li>
        </ul>
      </div>
    `,
    htmlContent_es: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🥗 La Fórmula del Plato Saludable</h4>
        <ul class="guide-bullets-list">
          <li><strong>🥦 1/3 VERDURAS:</strong> Brócoli, espinacas, calabacín, ensaladas frescas.</li>
          <li><strong>🍗 1/3 PROTEÍNAS:</strong> Pescado, pollo, pavo, huevos, tofu.</li>
          <li><strong>🍚 1/3 CARBOHIDRATOS:</strong> Arroz integral, batatas, quinoa, avena.</li>
          <li><strong>🥑 + GRASAS SALUDABLES:</strong> Aceite de oliva virgen extra, aguacate.</li>
        </ul>
      </div>
    `
  },

  // 7. DRENAGGIO LIQUIDI & GAMBE LEGGERE
  {
    id: "guide_bloat",
    icon: "🦵",
    category: "drenaggio",
    gradient: "linear-gradient(135deg, #0d9488 0%, #0f766e 100%)",
    productKeys: ["tea", "mineralcomplex", "hydrate", "niteworks", "liftoff", "aloemax"],
    title: "🦵 Perché è importante drenare i liquidi & sgonfiare le gambe?",
    title_en: "🦵 Why Draining Fluid Retention & Heavy Legs Matters?",
    title_ro: "🦵 De ce este important drenajul retenției de apă & picioarelor?",
    title_es: "🦵 ¿Por qué es importante eliminar la retención y deshinchar piernas?",
    desc: "I liquidi ristagnano facilmente negli arti inferiori per gravità e microcircolo rallentato. Scopri il protocollo per gambe snelle, leggere e sgonfie.",
    desc_en: "Fluid tends to pool in lower extremities from sitting and sluggish circulation. Discover the protocol for light, toned legs.",
    desc_ro: "Retenția de apă se acumulează ușor în picioare. Descoperă protocolul pentru picioare ușoare și suple.",
    desc_es: "Los líquidos se acumulan en las piernas por mala circulación. Descubre el protocolo para piernas ligeras y tonificadas.",
    keyPoints: [
      "Riequilibrio idro-salino intracellulare con Magnesio e Potassio",
      "Azione termogenica e drenante dell'Infuso a Base di Erbe",
      "Stimolazione dell'Ossido Nitrico e del microcircolo con Niteworks®",
      "Energia effervescente e drenaggio con LiftOff®",
      "Idratazione profonda ipotonica con Herbalife24® Hydrate"
    ],
    keyPoints_en: [
      "Intracellular mineral balance with bioavailable Magnesium & Potassium",
      "Thermogenic lymphatic drainage with Instant Herbal Beverage Tea",
      "Nighttime nitric oxide vascular support with Niteworks®",
      "Effervescent microcirculation boost with LiftOff®",
      "Deep cellular hypotonic hydration with Herbalife24® Hydrate"
    ],
    keyPoints_ro: [
      "Reechilibrare hidrosalină cu Magneziu și Potasiu biodisponibil",
      "Acțiune termogenică și drenaj limfatic cu Ceaiul pe Bază de Plante",
      "Stimularea oxidului nitric și a microcirculației cu Niteworks®",
      "Energie efervescentă și drenaj cu LiftOff®",
      "Hidratare celulară hipotonă cu Herbalife24® Hydrate"
    ],
    keyPoints_es: [
      "Equilibrio hidrosalino intracelular con Magnesio y Potasio",
      "Acción termogénica y drenaje con el Concentrado de Hierbas",
      "Estimulación del óxido nítrico y microcirculación con Niteworks®",
      "Energía efervescente y drenaje con LiftOff®",
      "Hidratación celular hipotónica con Herbalife24® Hydrate"
    ],
    htmlContent: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🌿 Il Protocollo Completo per Gambe Leggere</h4>
        <ul class="guide-bullets-list">
          <li><strong>🍃 Infuso a Base di Erbe:</strong> Drena i liquidi extracellulari e attiva il metabolismo.</li>
          <li><strong>💧 Mineral Complex Plus:</strong> Rimineralizza e contrasta i cuscinetti di liquidi.</li>
          <li><strong>⚡ Herbalife24® Hydrate:</strong> Idratazione cellulare senza calorie (<1 kcal).</li>
          <li><strong>🌙 Niteworks®:</strong> Nutre i vasi sanguigni con L-Arginina e stimola l'ossido nitrico durante la notte.</li>
          <li><strong>🚀 LiftOff®:</strong> Compresse effervescenti con Taurina, Guaranà e Vitamina C per risvegliare il microcircolo e contrastare la spossatezza e la pesantezza agli arti inferiori.</li>
          <li><strong>🌿 AloeMax:</strong> Purifica il tratto digestivo e sgonfia l'addome.</li>
        </ul>
      </div>
    `,
    htmlContent_en: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🌿 Complete Protocol for Light, Toned Legs</h4>
        <ul class="guide-bullets-list">
          <li><strong>🍃 Instant Herbal Beverage:</strong> Flushes excess extracellular fluids and fires up metabolism.</li>
          <li><strong>💧 Mineral Complex Plus / Hydrate:</strong> Restores mineral balance and fights fluid pooling.</li>
          <li><strong>⚡ Herbalife24® Hydrate:</strong> Pure calorie-free (<1 kcal) cellular hydration.</li>
          <li><strong>🌙 Niteworks®:</strong> Fuels blood vessels with L-Arginine, enhancing nighttime nitric oxide and vascular elasticity.</li>
          <li><strong>🚀 LiftOff®:</strong> Effervescent energy with Taurine, Guarana and Vitamin C to stimulate leg microcirculation and defeat fatigue.</li>
          <li><strong>🌿 AloeMax:</strong> Purifies digestion and flattens bloating.</li>
        </ul>
      </div>
    `,
    htmlContent_ro: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🌿 Protocolul Complet pentru Picioare Ușoare</h4>
        <ul class="guide-bullets-list">
          <li><strong>🍃 Ceai pe Bază de Plante:</strong> Drenează retenția și activează metabolismul.</li>
          <li><strong>⚡ Herbalife24® Hydrate:</strong> Hidratare celulară hipotonă.</li>
          <li><strong>🌙 Niteworks®:</strong> Susține oxidul nitric nocturn și microcirculația.</li>
          <li><strong>🚀 LiftOff®:</strong> Energie efervescentă pentru picioare ușoare.</li>
          <li><strong>🌿 AloeMax:</strong> Purifică tractul digestiv și elimină balonarea.</li>
        </ul>
      </div>
    `,
    htmlContent_es: `
      <div class="guide-section-block">
        <h4 class="guide-section-heading">🌿 Protocolo Completo para Piernas Ligeras</h4>
        <ul class="guide-bullets-list">
          <li><strong>🍃 Concentrado de Hierbas:</strong> Drena líquidos y activa el metabolismo.</li>
          <li><strong>⚡ Herbalife24® Hydrate:</strong> Hidratación celular sin calorías.</li>
          <li><strong>🌙 Niteworks®:</strong> Nutre los vasos sanguíneos y estimula el óxido nítrico nocturno.</li>
          <li><strong>🚀 LiftOff®:</strong> Energía efervescente para piernas descansadas.</li>
          <li><strong>🌿 AloeMax:</strong> Purifica la digestión y deshincha el abdomen.</li>
        </ul>
      </div>
    `
  }
];



// ==========================================

// WORKOUT VIDEOS

// ==========================================

const WORKOUT_VIDEOS = [
  {
    "id": "workout_day_01",
    "dayNumber": 1,
    "vimeoId": "570902348",
    "vimeoHash": "42493e69fe",
    "vimeoUrl": "https://vimeo.com/570902348/42493e69fe",
    "category": "fase1",
    "phase": "fase1",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 01 — Sessione 01: Workout Start & Kickoff",
    "title_en": "Day 01 — Session 01: Workout Start & Kickoff",
    "title_ro": "Ziua 01 — Sesiunea 01: Workout Start & Kickoff",
    "title_es": "Día 01 — Sesión 01: Workout Start & Kickoff",
    "desc": "Sessione inaugurale del percorso per attivare il corpo, risvegliare il metabolismo e iniziare con la giusta carica.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_02",
    "dayNumber": 2,
    "vimeoId": "570903198",
    "vimeoHash": "e1f3e62860",
    "vimeoUrl": "https://vimeo.com/570903198/e1f3e62860",
    "category": "fase1",
    "phase": "fase1",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 02 — Sessione 02: Workout Energy & Flow",
    "title_en": "Day 02 — Session 02: Workout Energy & Flow",
    "title_ro": "Ziua 02 — Sesiunea 02: Workout Energy & Flow",
    "title_es": "Día 02 — Sesión 02: Workout Energy & Flow",
    "desc": "Routine dinamica e stimolante per dare continuità al movimento e mantenere alto il consumo calorico.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_03",
    "dayNumber": 3,
    "vimeoId": "570906707",
    "vimeoHash": "68fedf0b3b",
    "vimeoUrl": "https://vimeo.com/570906707/68fedf0b3b",
    "category": "fase1",
    "phase": "fase1",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1574680096145-d05b474e2155?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 03 — Sessione 03: Workout Boost & Movimento",
    "title_en": "Day 03 — Session 03: Workout Boost & Movement",
    "title_ro": "Ziua 03 — Sesiunea 03: Workout Boost & Mișcare",
    "title_es": "Día 03 — Sesión 03: Workout Boost & Movimiento",
    "desc": "Allenamento completo per stimolare il tono muscolare e consolidare l abitudine al movimento quotidiano.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_04",
    "dayNumber": 4,
    "vimeoId": "570907908",
    "vimeoHash": "9e651f733b",
    "vimeoUrl": "https://vimeo.com/570907908/9e651f733b",
    "category": "fase1",
    "phase": "fase1",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 04 — Sessione 04: Workout Tone & Vitalità",
    "title_en": "Day 04 — Session 04: Workout Tone & Vitality",
    "title_ro": "Ziua 04 — Sesiunea 04: Workout Tonus & Vitalitate",
    "title_es": "Día 04 — Sesión 04: Workout Tono & Vitalidad",
    "desc": "Sessione mirata a dare tono, agilità e forza funzionale a tutto il corpo.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_05",
    "dayNumber": 5,
    "vimeoId": "570911912",
    "vimeoHash": "b332d2b308",
    "vimeoUrl": "https://vimeo.com/570911912/b332d2b308",
    "category": "fase1",
    "phase": "fase1",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1538805060514-97d9cc17730c?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 05 — Sessione 05: Workout Rhythm & Ritmo",
    "title_en": "Day 05 — Session 05: Workout Rhythm & Pace",
    "title_ro": "Ziua 05 — Sesiunea 05: Workout Rhythm & Ritm",
    "title_es": "Día 05 — Sesión 05: Workout Rhythm & Ritmo",
    "desc": "Esercizi a ritmo costante per potenziare la resistenza e bruciare calorie con il sorriso.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_06",
    "dayNumber": 6,
    "vimeoId": "570912494",
    "vimeoHash": "0e10d12dff",
    "vimeoUrl": "https://vimeo.com/570912494/0e10d12dff",
    "category": "fase1",
    "phase": "fase1",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 06 — Sessione 06: Workout Power & Costanza",
    "title_en": "Day 06 — Session 06: Workout Power & Consistency",
    "title_ro": "Ziua 06 — Sesiunea 06: Workout Power & Consecvență",
    "title_es": "Día 06 — Sesión 06: Workout Power & Constancia",
    "desc": "Ultimo allenamento della prima settimana per chiudere il primo ciclo con il massimo dell energia.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_07",
    "dayNumber": 7,
    "vimeoId": "570913356",
    "vimeoHash": "31f0d24636",
    "vimeoUrl": "https://vimeo.com/570913356/31f0d24636",
    "category": "rest",
    "phase": "fase1",
    "isRest": true,
    "duration": "15-20 min",
    "intensity": "Dolce / Rigenerante",
    "intensity_en": "Gentle / Restorative",
    "intensity_ro": "Ușor / Regenerant",
    "intensity_es": "Suave / Regenerador",
    "calories": "~60-90 kcal",
    "equipment": "Tappetino & Relax",
    "equipment_en": "Mat & Relax",
    "equipment_ro": "Saltea & Relax",
    "equipment_es": "Esterilla & Relax",
    "coverImg": "https://images.unsplash.com/photo-1549576490-b0b4831ef60a?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 07 — Sessione 07: Recupero Attivo & Rigenerazione (Rest Day)",
    "title_en": "Day 07 — Session 07: Active Recovery & Rest (Rest Day)",
    "title_ro": "Ziua 07 — Sesiunea 07: Recuperare Activă & Relaxare (Rest Day)",
    "title_es": "Día 07 — Sesión 07: Recuperación Activa y Descanso (Rest Day)",
    "desc": "Sessione rigenerante di mobilità, allungamento e respiro per rilassare la muscolatura e prepararsi alla Fase 2.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Nel giorno di recupero, bevi una tazza calda di Infuso e Aloe per favorire il drenaggio e la distensione muscolare!",
    "nutritionTip_en": "On recovery days, enjoy warm Herbal Tea and Aloe to support cellular hydration and muscle relaxation!",
    "nutritionTip_ro": "În ziua de recuperare, consumă Ceai cald și Aloe pentru relaxare musculară!",
    "nutritionTip_es": "¡En el día de descanso, disfruta de Té y Aloe para apoyar la relajación muscular!",
    "productKeys": [
      "aloemax",
      "tea",
      "nightmode"
    ]
  },
  {
    "id": "workout_day_08",
    "dayNumber": 8,
    "vimeoId": "570913489",
    "vimeoHash": "aa507a33e8",
    "vimeoUrl": "https://vimeo.com/570913489/aa507a33e8",
    "category": "fase2",
    "phase": "fase2",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 08 — Sessione 08: Workout Booster & Focus",
    "title_en": "Day 08 — Session 08: Workout Booster & Focus",
    "title_ro": "Ziua 08 — Sesiunea 08: Workout Booster & Focus",
    "title_es": "Día 08 — Sesión 08: Workout Booster & Enfoque",
    "desc": "Inizio della seconda fase: alziamo il livello di determinazione ed efficacia del movimento.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_09",
    "dayNumber": 9,
    "vimeoId": "570915586",
    "vimeoHash": "be6433bbaa",
    "vimeoUrl": "https://vimeo.com/570915586/be6433bbaa",
    "category": "fase2",
    "phase": "fase2",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1574680096145-d05b474e2155?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 09 — Sessione 09: Workout Dinamico",
    "title_en": "Day 09 — Session 09: Dynamic Workout",
    "title_ro": "Ziua 09 — Sesiunea 09: Workout Dinamic",
    "title_es": "Día 09 — Sesión 09: Workout Dinámico",
    "desc": "Movimenti funzionali per stimolare la coordinazione, il tono e il dispendio energetico.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_10",
    "dayNumber": 10,
    "vimeoId": "570918610",
    "vimeoHash": "dd887c25b1",
    "vimeoUrl": "https://vimeo.com/570918610/dd887c25b1",
    "category": "fase2",
    "phase": "fase2",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 10 — Sessione 10: Workout Resistenza & Grinta",
    "title_en": "Day 10 — Session 10: Endurance & Grit Workout",
    "title_ro": "Ziua 10 — Sesiunea 10: Workout Rezistență & Energie",
    "title_es": "Día 10 — Sesión 10: Workout Resistencia & Fuerza",
    "desc": "Supera la metà del percorso con una routine energizzante ricca di motivazione.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_11",
    "dayNumber": 11,
    "vimeoId": "570920402",
    "vimeoHash": "d9db80100b",
    "vimeoUrl": "https://vimeo.com/570920402/d9db80100b",
    "category": "fase2",
    "phase": "fase2",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1538805060514-97d9cc17730c?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 11 — Sessione 11: Workout Intensity & Tono",
    "title_en": "Day 11 — Session 11: Workout Intensity & Tone",
    "title_ro": "Ziua 11 — Sesiunea 11: Workout Intensitate & Tonus",
    "title_es": "Día 11 — Sesión 11: Workout Intensidad & Tono",
    "desc": "Sessione ad alta efficacia per consolidare i progressi e tonificare i muscoli.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_12",
    "dayNumber": 12,
    "vimeoId": "570922423",
    "vimeoHash": "eda8b085ab",
    "vimeoUrl": "https://vimeo.com/570922423/eda8b085ab",
    "category": "fase2",
    "phase": "fase2",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 12 — Sessione 12: Workout Active & Forma",
    "title_en": "Day 12 — Session 12: Workout Active & Shape",
    "title_ro": "Ziua 12 — Sesiunea 12: Workout Activ & Formă",
    "title_es": "Día 12 — Sesión 12: Workout Activo & Forma",
    "desc": "Lavoro completo per stimolare la tonicità muscolare e la sensazione di leggerezza.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_13",
    "dayNumber": 13,
    "vimeoId": "584284479",
    "vimeoHash": "bfa14cc363",
    "vimeoUrl": "https://vimeo.com/584284479/bfa14cc363",
    "category": "fase2",
    "phase": "fase2",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 13 — Sessione 13: Workout Determination",
    "title_en": "Day 13 — Session 13: Workout Determination",
    "title_ro": "Ziua 13 — Sesiunea 13: Workout Determinare",
    "title_es": "Día 13 — Sesión 13: Workout Determinación",
    "desc": "Sessione per consolidare la costanza e completare al meglio la seconda fase.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_14",
    "dayNumber": 14,
    "vimeoId": "584285406",
    "vimeoHash": "79393c6920",
    "vimeoUrl": "https://vimeo.com/584285406/79393c6920",
    "category": "rest",
    "phase": "fase2",
    "isRest": true,
    "duration": "15-20 min",
    "intensity": "Dolce / Rigenerante",
    "intensity_en": "Gentle / Restorative",
    "intensity_ro": "Ușor / Regenerant",
    "intensity_es": "Suave / Regenerador",
    "calories": "~60-90 kcal",
    "equipment": "Tappetino & Relax",
    "equipment_en": "Mat & Relax",
    "equipment_ro": "Saltea & Relax",
    "equipment_es": "Esterilla & Relax",
    "coverImg": "https://images.unsplash.com/photo-1549576490-b0b4831ef60a?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 14 — Sessione 14: Ricarica & Decompressione (Rest Day)",
    "title_en": "Day 14 — Session 14: Recharge & Decompress (Rest Day)",
    "title_ro": "Ziua 14 — Sesiunea 14: Reîncărcare & Relaxare (Rest Day)",
    "title_es": "Día 14 — Sesión 14: Recarga y Descompresión (Rest Day)",
    "desc": "Momento dedicato al recupero attivo, alla flessibilità e alla ricarica prima dell ultima fase.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Nel giorno di recupero, bevi una tazza calda di Infuso e Aloe per favorire il drenaggio e la distensione muscolare!",
    "nutritionTip_en": "On recovery days, enjoy warm Herbal Tea and Aloe to support cellular hydration and muscle relaxation!",
    "nutritionTip_ro": "În ziua de recuperare, consumă Ceai cald și Aloe pentru relaxare musculară!",
    "nutritionTip_es": "¡En el día de descanso, disfruta de Té y Aloe para apoyar la relajación muscular!",
    "productKeys": [
      "aloemax",
      "tea",
      "nightmode"
    ]
  },
  {
    "id": "workout_day_15",
    "dayNumber": 15,
    "vimeoId": "584285576",
    "vimeoHash": "b76ed72804",
    "vimeoUrl": "https://vimeo.com/584285576/b76ed72804",
    "category": "fase3",
    "phase": "fase3",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1574680096145-d05b474e2155?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 15 — Sessione 15: Workout Level Up",
    "title_en": "Day 15 — Session 15: Workout Level Up",
    "title_ro": "Ziua 15 — Sesiunea 15: Workout Level Up",
    "title_es": "Día 15 — Sesión 15: Workout Level Up",
    "desc": "Apertura della terza fase: aumenta l intensità e porta la tua forma fisica al livello successivo.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_16",
    "dayNumber": 16,
    "vimeoId": "584286378",
    "vimeoHash": "f66a714d5f",
    "vimeoUrl": "https://vimeo.com/584286378/f66a714d5f",
    "category": "fase3",
    "phase": "fase3",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 16 — Sessione 16: Workout Peak Flow",
    "title_en": "Day 16 — Session 16: Workout Peak Flow",
    "title_ro": "Ziua 16 — Sesiunea 16: Workout Peak Flow",
    "title_es": "Día 16 — Sesión 16: Workout Peak Flow",
    "desc": "Movimenti continui per massimizzare la resistenza e la reattività muscolare.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_17",
    "dayNumber": 17,
    "vimeoId": "584287235",
    "vimeoHash": "8487b0423a",
    "vimeoUrl": "https://vimeo.com/584287235/8487b0423a",
    "category": "fase3",
    "phase": "fase3",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1538805060514-97d9cc17730c?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 17 — Sessione 17: Workout Momentum & Forza",
    "title_en": "Day 17 — Session 17: Workout Momentum & Strength",
    "title_ro": "Ziua 17 — Sesiunea 17: Workout Momentum & Forță",
    "title_es": "Día 17 — Sesión 17: Workout Momentum & Fuerza",
    "desc": "Esercizi guidati per consolidare forza, stabilità e postura.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_18",
    "dayNumber": 18,
    "vimeoId": "584288199",
    "vimeoHash": "d645cab1e3",
    "vimeoUrl": "https://vimeo.com/584288199/d645cab1e3",
    "category": "fase3",
    "phase": "fase3",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 18 — Sessione 18: Workout High Energy",
    "title_en": "Day 18 — Session 18: Workout High Energy",
    "title_ro": "Ziua 18 — Sesiunea 18: Workout High Energy",
    "title_es": "Día 18 — Sesión 18: Workout High Energy",
    "desc": "Sessione ad alto impatto per dare il massimo verso il rush finale.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_19",
    "dayNumber": 19,
    "vimeoId": "584289254",
    "vimeoHash": "4c16fbc4d2",
    "vimeoUrl": "https://vimeo.com/584289254/4c16fbc4d2",
    "category": "fase3",
    "phase": "fase3",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 19 — Sessione 19: Workout Impact & Vitalità",
    "title_en": "Day 19 — Session 19: Workout Impact & Vitality",
    "title_ro": "Ziua 19 — Sesiunea 19: Workout Impact & Vitalitate",
    "title_es": "Día 19 — Sesión 19: Workout Impact & Vitalidad",
    "desc": "Ritmo incalzante per sentirsi al top della condizione e dell energia.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_20",
    "dayNumber": 20,
    "vimeoId": "584290104",
    "vimeoHash": "5447fab1ca",
    "vimeoUrl": "https://vimeo.com/584290104/5447fab1ca",
    "category": "fase3",
    "phase": "fase3",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 20 — Sessione 20: Workout Total Determination",
    "title_en": "Day 20 — Session 20: Workout Total Determination",
    "title_ro": "Ziua 20 — Sesiunea 20: Workout Total Determination",
    "title_es": "Día 20 — Sesión 20: Workout Total Determination",
    "desc": "La penultima sessione: metti tutta la tua energia e senti la trasformazione compiuta.",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  },
  {
    "id": "workout_day_21",
    "dayNumber": 21,
    "vimeoId": "584291184",
    "vimeoHash": "c30670c918",
    "vimeoUrl": "https://vimeo.com/584291184/c30670c918",
    "category": "fase3",
    "phase": "fase3",
    "isRest": false,
    "duration": "20-30 min",
    "intensity": "Guidato / Adattabile",
    "intensity_en": "Guided / All Levels",
    "intensity_ro": "Ghidat / Adaptabil",
    "intensity_es": "Guiado / Adaptable",
    "calories": "~160-230 kcal",
    "equipment": "Corpo Libero & Tappetino",
    "equipment_en": "Bodyweight & Mat",
    "equipment_ro": "Greutatea Corpului & Saltea",
    "equipment_es": "Peso Corporal y Esterilla",
    "coverImg": "https://images.unsplash.com/photo-1574680096145-d05b474e2155?w=600&auto=format&fit=crop&q=80",
    "title": "Giorno 21 — Sessione 21: Traguardo & Grand Finale",
    "title_en": "Day 21 — Session 21: Milestone & Grand Finale",
    "title_ro": "Ziua 21 — Sesiunea 21: Final de Program & Sărbătoare",
    "title_es": "Día 21 — Sesión 21: Meta y Gran Final",
    "desc": "Sessione conclusiva per celebrare il completamento del percorso e la tua nuova forma fisica!",
    "desc_en": "Follow the guided session with your Coach. Focus on technique, breath, and consistency.",
    "desc_ro": "Urmează sesiunea ghidată de antrenament alături de Coach-ul tău.",
    "desc_es": "Sigue la sesión guiada con tu Coach para avanzar paso a paso en tu transformación.",
    "exercises": [
      "Riscaldamento articolare e attivazione (3-5 min)",
      "Circuito guidato con progressioni ed esercizi",
      "Lavoro cardiovascolare e respirazione controllata",
      "Defaticamento, stretching e postura finale"
    ],
    "nutritionTip": "Integra una porzione di H24 Rebuild Strength o Formula 1 entro 30 minuti dal workout per nutrire la massa magra!",
    "nutritionTip_en": "Enjoy H24 Rebuild Strength or an F1 shake within 30 mins to nourish your lean muscles!",
    "nutritionTip_ro": "Consumă H24 Rebuild Strength sau shake Formula 1 după antrenament!",
    "nutritionTip_es": "¡Toma H24 Rebuild Strength o un batido Formula 1 tras el workout!",
    "productKeys": [
      "cr7",
      "rebuildstrength",
      "aloemax",
      "tea"
    ]
  }
];




// ==========================================
// DETERMINISTIC COACH AI FALLBACK ENGINE
// ==========================================

const handleBotReply = (query) => {
  const q = (query || "").toLowerCase();
  const lang = (typeof state !== 'undefined' && state.lang) ? state.lang : "it";

  const getP = (key) => {
    if (typeof getProductCardHtml === 'function') {
      const html = getProductCardHtml(key);
      if (html) return '<div class="coach-product-recommendation">' + html + '</div>';
    }
    return '';
  };

  // 1. SONNO / SLEEP / REST
  if (q.includes("sonno") || q.includes("dormi") || q.includes("ripos") || q.includes("sleep") || q.includes("insonn") || q.includes("somn") || q.includes("sueño") || q.includes("descans")) {
    if (lang === 'en') {
      return "😴 <strong>Deep Sleep & Recovery Protocol:</strong><br><br>Quality sleep is essential for muscle recovery, hormonal balance, and fat loss.<br><br>• <strong>Golden Rules:</strong> Turn off screens 45 minutes before bedtime, keep your room cool and dark, avoid heavy carbohydrate meals late at night.<br>• <strong>Evening Ritual:</strong> Drink a soothing herbal chamomile infusion and integrate <strong>Night Mode</strong> (saffron extract & B-vitamins) 30 minutes before sleep for deep, restorative rest.<br><br>" + getP('nightmode') + getP('restore');
    }
    if (lang === 'ro') {
      return "😴 <strong>Protocol pentru Somn Profund & Regenerare:</strong><br><br>Somnul calitativ este fundamentul arderii grăsimilor și refacerii musculare.<br><br>• <strong>Reguli de Aur:</strong> Oprește ecranele cu 45 de minute înainte de culcare, aerisește dormitorul și evită mesele grele seara.<br>• <strong>Ritual de Seară:</strong> Bea o infuzie caldă de plante și integrează <strong>Night Mode</strong> (extract de șofran și vitamine B) cu 30 de minute înainte de culcare.<br><br>" + getP('nightmode') + getP('restore');
    }
    if (lang === 'es') {
      return "😴 <strong>Protocolo de Sueño Profundo y Recuperación:</strong><br><br>Un descanso reparador es crucial para optimizar el metabolismo, regular el cortisol y quemar grasa eficientemente.<br><br>• <strong>Reglas Clave:</strong> Apaga pantallas 45 minutos antes de dormir y mantén el dormitorio fresco.<br>• <strong>Ritual Nocturno:</strong> Integra <strong>Night Mode</strong> (extracto de azafrán y vitaminas B) o <strong>H24 Restore</strong> 30 minutos antes de acostarte para despertar con máxima vitalidad.<br><br>" + getP('nightmode') + getP('restore');
    }
    return "😴 <strong>Protocollo Sonno Profondo & Riposo Rigenerante:</strong><br><br>Un sonno di qualità è fondamentale per ridurre i livelli di cortisolo (l'ormone dello stress), ottimizzare il metabolismo e favorire il recupero muscolare.<br><br>• <strong>Regole d'Oro per la Notte:</strong> Spegni gli schermi a luce blu 45 minuti prima di coricarti, mantieni la camera fresca e buia, ed evita zuccheri semplici o caffeina nel tardo pomeriggio.<br>• <strong>Rituale di Rilassamento:</strong> Concediti una tisana calda e integra <strong>Night Mode</strong> (a base di estratto di zafferano e camomilla) oppure <strong>H24 Restore</strong> 30 minuti prima di dormire per un risveglio energico e rigenerato.<br><br>" + getP('nightmode') + getP('restore');
  }

  // 2. GAMBE & PANCIA SGONFIA / BLOAT / DRENAGGIO
  if (q.includes("sgonfi") || q.includes("gonfi") || q.includes("gambe") || q.includes("pancia") || q.includes("ritenzion") || q.includes("bloat") || q.includes("balon") || q.includes("deshinch") || q.includes("retenc")) {
    if (lang === 'en') {
      return "🦵 <strong>De-Bloat Protocol (Legs & Tummy):</strong><br><br>Fluid retention and bloating are usually caused by excess sodium, low water intake, or sluggish digestion.<br><br>• <strong>Actionable Steps:</strong> Drink at least 2.5L water daily, reduce refined salt, and take a 15-min brisk walk.<br>• <strong>Herbal Integration:</strong> Sip <strong>AloeMax</strong> (pure aloe vera for gut soothing) and <strong>Mineral Complex Plus</strong> (potassium & magnesium for electrolyte balance) throughout the morning.<br><br>" + getP('aloemax') + getP('mineralcomplex') + getP('tea');
    }
    if (lang === 'ro') {
      return "🦵 <strong>Protocol pentru Dezumflarea Picioarelor & Abdomenului:</strong><br><br>Retenția de apă și balonarea apar din cauza excesului de sare, hidratării insuficiente sau digestiei lente.<br><br>• <strong>Pași Concreți:</strong> Bea minim 2.5L de apă pe zi, redu alimentele procesate și fă o plimbare de 15 minute.<br>• <strong>Integrare Herbalife:</strong> Integrează <strong>AloeMax</strong> în apa de dimineață și <strong>Mineral Complex Plus</strong> (potasiu și magneziu) pentru susținerea echilibrului hidric.<br><br>" + getP('aloemax') + getP('mineralcomplex') + getP('tea');
    }
    if (lang === 'es') {
      return "🦵 <strong>Protocolo para Deshinchar Piernas y Abdomen:</strong><br><br>La retención de líquidos y la hinchazón abdominal se deben principalmente al exceso de sal, falta de agua o digestión pesada.<br><br>• <strong>Acciones Clave:</strong> Bebe al menos 2.5L de agua al día y camina 15-20 minutos diarios.<br>• <strong>Nutrición Herbalife:</strong> Integra <strong>AloeMax</strong> (concentrado de aloe puro para el bienestar digestivo) y <strong>Mineral Complex Plus</strong> (potasio y magnesio) para favorecer el equilibrio hídrico.<br><br>" + getP('aloemax') + getP('mineralcomplex') + getP('tea');
    }
    return "🦵 <strong>Protocollo Gambe Leggere & Addome Sgonfio:</strong><br><br>La sensazione di gonfiore e la ritenzione idrica derivano spesso da uno scarso apporto idrico, eccesso di sodio o digestione rallentata.<br><br>• <strong>Cosa Fare Subito:</strong> Bevi almeno 2.5 litri d'acqua al giorno a piccoli sorsi, limita il sale raffinato e cammina a passo svelto per attivare il microcircolo linfatico.<br>• <strong>Integrazione Mirata:</strong> Integra <strong>AloeMax</strong> (97% puro succo di aloe per purificare il tratto digerente), <strong>Mineral Complex Plus</strong> (ricco di potassio e magnesio per l'equilibrio elettrolitico) e 1 tazza di <strong>Infuso a Base di Erbe</strong>.<br><br>" + getP('aloemax') + getP('mineralcomplex') + getP('tea');
  }

  // 3. KIT DIMAGRIMENTO / PERDITA PESO / WEIGHT LOSS
  if (q.includes("dimagr") || q.includes("peso") || q.includes("grass") || q.includes("weight") || q.includes("slăbi") || q.includes("adelgaz") || q.includes("kilos")) {
    if (lang === 'en') {
      return "🔥 <strong>Weight Management & Fat Loss Protocol:</strong><br><br>Achieving sustainable fat loss requires nutrient density and a controlled caloric deficit without hunger.<br><br>• <strong>Formula:</strong> Replace 2 meals a day with delicious Formula 1 + PDM Shakes (high protein, 25 vitamins & minerals). Have 1 colorful balanced meal and 2 healthy snacks.<br>• <strong>Metabolism Boost:</strong> Sip Instant Herbal Beverage and take Phyto Complete (rich in natural caffeine and guarana).<br><br>" + getP('formula1') + getP('pdm') + getP('phytocomplete') + getP('tea');
    }
    if (lang === 'ro') {
      return "🔥 <strong>Protocol pentru Slăbire & Controlul Greutății:</strong><br><br>Slăbirea sănătoasă înseamnă nutriție bogată în proteine și deficit caloric fără senzație de foame.<br><br>• <strong>Strategie:</strong> Înlocuiește 2 mese principale pe zi cu Shake Formula 1 + PDM (22g proteine, 25 vitamine). Consumă 1 masă colorată echilibrată și 2 gustări sănătoase.<br>• <strong>Activare Metabolică:</strong> Bea Ceai pe Bază de Plante și integrează Phyto Complete înainte de mese.<br><br>" + getP('formula1') + getP('pdm') + getP('phytocomplete') + getP('tea');
    }
    if (lang === 'es') {
      return "🔥 <strong>Protocolo para Control de Peso y Pérdida de Grasa:</strong><br><br>Perder grasa de forma duradera requiere nutrición de alta densidad y déficit calórico sin pasar hambre.<br><br>• <strong>Estructura Diaria:</strong> Sustituye 2 comidas principales por Batido Formula 1 + PDM (22g proteína noble, solo ~220 kcal). Haz 1 comida principal equilibrada y 2 snacks ricos en proteína.<br>• <strong>Apoyo Metabólico:</strong> Bebe Infusión a Base de Hierbas y toma Phyto Complete.<br><br>" + getP('formula1') + getP('pdm') + getP('phytocomplete') + getP('tea');
    }
    return "🔥 <strong>Kit Dimagrimento & Controllo del Peso:</strong><br><br>Perdere massa grassa in modo sano e tonico richiede un deficit calorico controllato, preservando la massa muscolare magra.<br><br>• <strong>Strategia Quotidiana:</strong> Sostituisci 2 pasti al giorno (es. colazione e cena) con lo squisito <strong>Shake Formula 1 + PDM</strong> (22g di proteine pure e 25 micronutrienti con sole 220 kcal). Fai 1 pranzo libero bilanciato e 2 spuntini proteici.<br>• <strong>Attivatore Metabolico:</strong> Integra <strong>Phyto Complete</strong> (a base di Fiit-NS™ e caffeina naturale da guaranà) e <strong>Infuso a Base di Erbe</strong> per stimolare la termogenesi.<br><br>" + getP('formula1') + getP('pdm') + getP('phytocomplete') + getP('tea');
  }

  // 4. SPUNTINI FIT / SNACK IDEAS
  if (q.includes("spuntin") || q.includes("snack") || q.includes("gustar") || q.includes("merenda") || q.includes("fame")) {
    if (lang === 'en') {
      return "🍎 <strong>Fit & High-Protein Snack Ideas:</strong><br><br>A quality snack maintains stable blood sugar and prevents evening binges.<br><br>• <strong>Option 1:</strong> Herbalife Protein Bar (10g protein, chocolate & vanilla deliciousness).<br>• <strong>Option 2:</strong> Roasted Soy Beans (9g plant protein, crunchy and savory).<br>• <strong>Option 3:</strong> 1 sliced apple with 1 spoon of peanut butter or 150g Greek yogurt 0% with cinnamon.<br><br>" + getP('proteinbar') + getP('soybeans') + getP('pdm');
    }
    if (lang === 'ro') {
      return "🍎 <strong>Idei de Gustări Sănătoase & Proteice:</strong><br><br>O gustare proteică menține nivelul de zahăr din sânge stabil și previne foamea de seară.<br><br>• <strong>Opțiunea 1:</strong> Baton Proteic Herbalife (10g proteine, ciocolată și vanilie).<br>• <strong>Opțiunea 2:</strong> Boabe de Soia Prăjite Herbalife (9g proteine, crocante și sărate).<br>• <strong>Opțiunea 3:</strong> 1 măr feliat cu scorțișoară sau 150g iaurt grecesc 0% grăsime.<br><br>" + getP('proteinbar') + getP('soybeans') + getP('pdm');
    }
    if (lang === 'es') {
      return "🍎 <strong>Ideas de Snacks Fit y Proteicos:</strong><br><br>Un snack rico en proteína estabiliza la glucosa y evita los atracones nocturnos.<br><br>• <strong>Opción 1:</strong> Barrita con Proteínas Herbalife (10g proteína noble, sabor chocolate o vainilla).<br>• <strong>Opción 2:</strong> Frutos de Soja Tostados (9g proteína vegetal, crujientes).<br>• <strong>Opción 3:</strong> 1 manzana con una pizca de canela o 150g de yogur griego 0% con nueces.<br><br>" + getP('proteinbar') + getP('soybeans') + getP('pdm');
    }
    return "🍎 <strong>Idee Spuntino Fit & Sazianti:</strong><br><br>Lo spuntino di metà mattina e metà pomeriggio è fondamentale per mantenere costante la glicemia e proteggere la massa magra.<br><br>• <strong>Opzione 1 (Pratica & Gourmet):</strong> 1 <strong>Barretta Proteica Herbalife</strong> (10g di proteine, ricoperta di cioccolato, circa 140 kcal).<br>• <strong>Opzione 2 (Salata & Croccante):</strong> 1 bustina di <strong>Noccioline di Soia Tostate</strong> (9g di proteine vegetali, solo 110 kcal).<br>• <strong>Opzione 3 (Fresca):</strong> 1 mela a fette con cannella, oppure 150g di yogurt greco 0% con 1 misurino di PDM.<br><br>" + getP('proteinbar') + getP('soybeans') + getP('pdm');
  }

  // 5. ALIMENTI SANI & DIETA / HEALTHY FOODS
  if (q.includes("aliment") || q.includes("cibo") || q.includes("mangiare") || q.includes("dieta") || q.includes("food") || q.includes("diet") || q.includes("mâncare") || q.includes("comida")) {
    if (lang === 'en') {
      return "🥗 <strong>Clean Eating & De-Bloat Foods Guide:</strong><br><br>Focusing on colorful, unprocessed whole foods optimizes digestion and vitality.<br><br>• <strong>Plate Formula:</strong> 50% low-GI green vegetables (zucchini, asparagus, spinach, fennel), 25% lean proteins (chicken breast, wild salmon, cod, tofu, organic eggs), 25% complex carbs (quinoa, basmati rice, sweet potatoes).<br>• <strong>Dressing:</strong> 1 tbsp extra virgin olive oil, lemon juice, fresh herbs.<br>• <strong>Fiber:</strong> Integrate Oat Apple Fibre to support daily prebiotic gut health.<br><br>" + getP('fibre') + getP('formula1');
    }
    if (lang === 'ro') {
      return "🥗 <strong>Ghid de Alimentație Sănătoasă & Digestie Ușoară:</strong><br><br>Alimentele integrale și proaspete susțin digestia și vitalitatea zilnică.<br><br>• <strong>Formula Farfuriei:</strong> 50% legume verzi cu indice glicemic redus (dovlecei, spanac, sparanghel, fenicul), 25% proteine slabe (piept de pui, somon, cod, ouă de țară, tofu), 25% carbohidrați complecși (orez basmati, quinoa, cartof dulce).<br>• <strong>Asezonare:</strong> 1 lingură ulei de măsline extravirgin, lămâie, ierburi aromatice.<br>• <strong>Fibre:</strong> Integrează Fibre din Măr și Ovăz pentru sănătatea microbiomului intestinal.<br><br>" + getP('fibre') + getP('formula1');
    }
    if (lang === 'es') {
      return "🥗 <strong>Guía de Comida Sana y Ligera:</strong><br><br>Priorizar alimentos frescos y nutritivos optimiza la digestión y la energía.<br><br>• <strong>Fórmula del Plato:</strong> 50% verduras verdes de bajo índice glucémico (calabacín, espinacas, espárragos, hinojo), 25% proteínas limpias (pechuga de pollo, salmón, bacalao, huevos camperos, tofu), 25% carbohidratos complejos (quinoa, arroz basmati, batata).<br>• <strong>Aliño:</strong> 1 cucharada de aceite de oliva virgen extra, limón y hierbas.<br>• <strong>Fibra:</strong> Integra Fibra de Avena y Manzana para mejorar el tránsito intestinal diario.<br><br>" + getP('fibre') + getP('formula1');
    }
    return "🥗 <strong>Guida agli Alimenti Sani & Digestione Leggera:</strong><br><br>Una nutrizione colorata e varia sostiene l'organismo e regala leggerezza.<br><br>• <strong>Formula del Piatto Unico:</strong> 50% verdure a basso indice glicemico (zucchine, finocchi, spinaci, asparagi, broccoli), 25% proteine magre di alta qualità (petto di pollo o tacchino, salmone selvaggio, merluzzo, uova biologiche, tofu), 25% carboidrati complessi ricchi di fibre (riso basmati, quinoa, patate dolci).<br>• <strong>Condimento:</strong> 1 cucchiaio di olio extravergine d'oliva a crudo, succo di limone ed erbe aromatiche.<br>• <strong>Fibre & Microbioma:</strong> Integra 1 misurino di <strong>Multifibre Mela e Avena</strong> nel tuo shake o in acqua per favorire la regolarità intestinale.<br><br>" + getP('fibre') + getP('formula1');
  }

  // 6. COLAZIONE IDEALE / BREAKFAST
  if (q.includes("colazion") || q.includes("breakfast") || q.includes("mic dejun") || q.includes("desayun")) {
    if (lang === 'en') {
      return "☀️ <strong>The 3-Step Ideal Herbalife Breakfast:</strong><br><br>Start your day with balanced nutrition and steady energy:<br>1. <strong>Hydrate & Soothe:</strong> 250ml water + 3 caps of <strong>AloeMax</strong>.<br>2. <strong>Ignite & Focus:</strong> 1 mug of hot water + 1/2 tsp of <strong>Herbal Tea Concentrate</strong>.<br>3. <strong>Nourish & Fuel:</strong> Gourmet Shake with 2 scoops <strong>Formula 1</strong> + 1 scoop <strong>PDM</strong>.<br><br>" + getP('formula1') + getP('aloemax') + getP('tea');
    }
    if (lang === 'ro') {
      return "☀️ <strong>Micul Dejun Ideal Herbalife în 3 Pași:</strong><br><br>Începe ziua cu nutriție celulară completă și energie:<br>1. <strong>Hidratare:</strong> 250ml apă călduță + 3 capace <strong>AloeMax</strong>.<br>2. <strong>Activare:</strong> O cană de ceai fierbinte cu 1/2 linguriță <strong>Ceai Instant de Plante</strong>.<br>3. <strong>Nutriție:</strong> Shake cremos cu 2 măsuri <strong>Formula 1</strong> + 1 măsură <strong>PDM</strong>.<br><br>" + getP('formula1') + getP('aloemax') + getP('tea');
    }
    if (lang === 'es') {
      return "☀️ <strong>El Desayuno Ideal Herbalife en 3 Pasos:</strong><br><br>Comienza tu día con nutrición completa y energía constante:<br>1. <strong>Hidrata:</strong> 250ml de agua tibia + 3 tapones de <strong>AloeMax</strong>.<br>2. <strong>Activa:</strong> 1 taza de agua caliente con 1/2 cucharadita de <strong>Té Herbalife</strong>.<br>3. <strong>Nutre:</strong> Batido gourmet con 2 cucharadas de <strong>Fórmula 1</strong> + 1 de <strong>PDM</strong>.<br><br>" + getP('formula1') + getP('aloemax') + getP('tea');
    }
    return "☀️ <strong>La Colazione Ideale Herbalife in 3 Passi:</strong><br><br>Il modo più efficace per risvegliare il metabolismo ed evitare cali di zuccheri a metà mattina:<br><br>1. <strong>Drena & Depura:</strong> 1 bicchiere d'acqua con 3 tappini di <strong>AloeMax</strong>.<br>2. <strong>Attiva il Metabolismo:</strong> 1 tazza calda di <strong>Infuso a Base di Erbe</strong> (gusto limone o pesca).<br>3. <strong>Nutri le Cellule:</strong> Frullato con 2 misurini di <strong>Formula 1</strong> + 1 misurino di <strong>PDM</strong> in 250ml d'acqua o latte vegetale.<br><br>" + getP('formula1') + getP('aloemax') + getP('tea');
  }

  // 7. ENERGIA & VITALITA / ENERGY / FOCUS
  if (q.includes("energi") || q.includes("vitalit") || q.includes("stanche") || q.includes("focus") || q.includes("energy") || q.includes("oboseal") || q.includes("cansan")) {
    if (lang === 'en') {
      return "⚡ <strong>Vitality & Peak Energy Protocol:</strong><br><br>Midday fatigue is often caused by dehydration, vitamin depletion, or glucose spikes.<br><br>• <strong>Strategy:</strong> Drink 1.5L water with AloeMax and Herbal Tea before 2 PM.<br>• <strong>Workout Energy:</strong> Sip CR7 Drive during physical activity.<br>• <strong>Immune Defense:</strong> Take Phyto Complete with breakfast.<br><br>" + getP('tea') + getP('cr7') + getP('phytocomplete');
    }
    if (lang === 'ro') {
      return "⚡ <strong>Protocol pentru Energie Maximă & Focus:</strong><br><br>Oboseala de la prânz este declanșată de deshidratare sau lipsă de micronutrienți esențiali.<br><br>• <strong>Soluție:</strong> Bea 1.5L apă cu AloeMax și Ceai Instant până în ora 14:00.<br>• <strong>Performanță Fizică:</strong> Consumă CR7 Drive în timpul efortului fizic.<br>• <strong>Vitalitate:</strong> Integrează Phyto Complete la micul dejun.<br><br>" + getP('tea') + getP('cr7') + getP('phytocomplete');
    }
    if (lang === 'es') {
      return "⚡ <strong>Protocolo de Vitalidad y Energía Diaria:</strong><br><br>El bajón de energía de media tarde suele deberse a deshidratación o picos de glucosa.<br><br>• <strong>Solución:</strong> Bebe 1.5L de agua con AloeMax y Té Herbalife antes de las 14:00.<br>• <strong>Rendimiento:</strong> Disfruta de CR7 Drive durante la actividad física.<br>• <strong>Activación:</strong> Toma Phyto Complete por la mañana.<br><br>" + getP('tea') + getP('cr7') + getP('phytocomplete');
    }
    return "⚡ <strong>Protocollo Massima Energia & Focus Mentale:</strong><br><br>La stanchezza a metà giornata è quasi sempre figlia di disidratazione o sbalzi glicemici post-pranzo.<br><br>• <strong>Azione Immediata:</strong> Bevi 1 tazza fumante di <strong>Infuso a Base di Erbe</strong> appena avverti un calo di concentrazione.<br>• <strong>Ricarica Elettrolitica:</strong> Durante l'attività fisica, idratati con <strong>H24 CR7 Drive</strong> per ripristinare glicogeno e sali minerali.<br>• <strong>Metabolismo:</strong> Integra <strong>Phyto Complete</strong> per un supporto continuo di vitamina C e B3.<br><br>" + getP('tea') + getP('cr7') + getP('phytocomplete');
  }

  // 8. RECUPERO MUSCOLARE / WORKOUT RECOVERY
  if (q.includes("recuper") || q.includes("allenamen") || q.includes("muscol") || q.includes("post-workout") || q.includes("workout") || q.includes("refacer") || q.includes("muscular")) {
    if (lang === 'en') {
      return "🏋️ <strong>Post-Workout Muscle Recovery Protocol:</strong><br><br>The first 30 minutes after training are the golden window for muscle protein synthesis and recovery.<br><br>• <strong>Formula:</strong> Take H24 Rebuild Strength (25g whey & casein protein + BCAAs and L-Glutamine).<br>• <strong>Night Repair:</strong> Integrate Restore capsules before sleep.<br><br>" + getP('rebuildstrength') + getP('restore') + getP('cr7');
    }
    if (lang === 'ro') {
      return "🏋️ <strong>Protocol de Refacere Musculară Post-Antrenament:</strong><br><br>Primele 30 de minute după antrenament reprezintă fereastra metabolică optimă pentru refacerea țesutului muscular.<br><br>• <strong>Nutriție:</strong> Consumă H24 Rebuild Strength (25g proteine din zer și cazeină + BCAA și L-Glutamină).<br>• <strong>Regenerare Nocturnă:</strong> Integrează capsulele Restore înainte de culcare.<br><br>" + getP('rebuildstrength') + getP('restore') + getP('cr7');
    }
    if (lang === 'es') {
      return "🏋️ <strong>Protocolo de Recuperación Muscular Post-Entreno:</strong><br><br>Los 30 minutos posteriores al ejercicio son la ventana anabólica clave para reparar y tonificar las fibras musculares.<br><br>• <strong>Nutrición Óptima:</strong> Toma H24 Rebuild Strength (25g proteína de suero y caseína + BCAAs y L-Glutamina).<br>• <strong>Reparación Nocturna:</strong> Integra Restore antes de acostarte.<br><br>" + getP('rebuildstrength') + getP('restore') + getP('cr7');
    }
    return "🏋️ <strong>Protocollo Recupero Muscolare Post-Allenamento:</strong><br><br>I primi 30 minuti dopo l'attività fisica rappresentano la 'finestra anabolica' in cui i muscoli assorbono aminoacidi alla massima velocità.<br><br>• <strong>Nutrizione Post-Workout:</strong> Assumi <strong>H24 Rebuild Strength</strong> (25g di proteine di altissima qualità da siero e caseina, con BCAA, ferro e L-Glutammina).<br>• <strong>Notte & Antiossidanti:</strong> Integra 1 capsula di <strong>H24 Restore</strong> prima di coricarti per contrastare lo stress ossidativo e sostenere il sistema immunitario.<br><br>" + getP('rebuildstrength') + getP('restore') + getP('cr7');
  }

  // 9. COLLAGENE & PELLE / SKIN GLOW
  if (q.includes("colagen") || q.includes("collagene") || q.includes("pelle") || q.includes("skin") || q.includes("rughe") || q.includes("luminos") || q.includes("piel")) {
    if (lang === 'en') {
      return "✨ <strong>Collagen & Glowing Skin Protocol:</strong><br><br>Radiant skin starts with cellular hydration and bioactive collagen peptides.<br><br>• <strong>Daily Ritual:</strong> Mix 1 scoop of Collagen Skin Booster into 250ml water (Verisol® P collagen peptides clinically proven to reduce eye wrinkles and improve skin elasticity in 4 weeks).<br>• <strong>Hydration:</strong> Add 3 caps of AloeMax daily.<br><br>" + getP('collagen') + getP('aloemax');
    }
    if (lang === 'ro') {
      return "✨ <strong>Protocol pentru Piele Strălucitoare & Colagen:</strong><br><br>Frumusețea pielii începe cu hidratare celulară și peptide bioactive de colagen.<br><br>• <strong>Ritual Zilnic:</strong> Dizolvă 1 măsură de Collagen Skin Booster în 250ml apă (peptide de colagen Verisol® P cu eficacitate dovedită clinic în 4 săptămâni).<br>• <strong>Hidratare:</strong> Adaugă 3 capace de AloeMax zilnic.<br><br>" + getP('collagen') + getP('aloemax');
    }
    if (lang === 'es') {
      return "✨ <strong>Protocolo de Colágeno y Belleza de la Piel:</strong><br><br>Una piel radiante y firme depende de la nutrición celular y péptidos bioactivos.<br><br>• <strong>Ritual Diario:</strong> Mezcla 1 cucharada de Collagen Skin Booster en 250ml de agua (con péptidos bioactivos Verisol® P que reducen arrugas y mejoran la elasticidad en 4 semanas).<br>• <strong>Hidratación:</strong> Integra 3 tapones de AloeMax a diario.<br><br>" + getP('collagen') + getP('aloemax');
    }
    return "✨ <strong>Protocollo Bellezza Pelle, Elasticità & Collagene:</strong><br><br>La luminosità e la compattezza cutanea partono dall'idratazione profonda del derma e dai peptidi bioattivi di collagene.<br><br>• <strong>Rituale di Bellezza:</strong> Sciogli 1 misurino di <strong>Collagen Skin Booster</strong> (al gusto fragola e limone, con peptidi Verisol® P, biotina, selenio e zinco) in 250ml d'acqua ogni mattina.<br>• <strong>Idratazione Lenitiva:</strong> Bevi <strong>AloeMax</strong> a digiuno per purificare la pelle dall'interno.<br><br>" + getP('collagen') + getP('aloemax');
  }

  // 10. FAME LA SERA / EVENING CRAVINGS
  if (q.includes("fame la sera") || q.includes("fame sera") || q.includes("notte") || q.includes("cravings") || q.includes("foame seara") || q.includes("hambre noche") || q.includes("antojo")) {
    if (lang === 'en') {
      return "🌙 <strong>How to Beat Evening Cravings:</strong><br><br>Late-night hunger is often triggered by inadequate daytime protein intake or emotional fatigue.<br><br>• <strong>Action Steps:</strong> Make sure your lunch had at least 25g protein and your afternoon snack was filling.<br>• <strong>Guilt-Free Fix:</strong> Sip a warm Herbal Tea or Night Mode infusion, or have 1 Herbalife Protein Bar.<br><br>" + getP('nightmode') + getP('proteinbar') + getP('tea');
    }
    if (lang === 'ro') {
      return "🌙 <strong>Cum să Controlezi Foamea de Seară:</strong><br><br>Poftele nocturne apar când mesele din timpul zilei nu au conținut suficiente proteine.<br><br>• <strong>Pași Concreți:</strong> Asigură-te că ai consumat gustarea proteică de la ora 16:00.<br>• <strong>Soluție Ușoară:</strong> Bea o cană de ceai cald sau Night Mode, sau consumă 1 Baton Proteic Herbalife.<br><br>" + getP('nightmode') + getP('proteinbar') + getP('tea');
    }
    if (lang === 'es') {
      return "🌙 <strong>Cómo Controlar el Hambre Nocturna:</strong><br><br>Los antojos por la noche ocurren cuando el aporte proteico durante el día ha sido insuficiente.<br><br>• <strong>Solución:</strong> Asegúrate de hacer tu merienda proteica a las 16:00-17:00.<br>• <strong>Opción sin Culpa:</strong> Toma una infusión caliente de Night Mode o 1 Barrita con Proteínas.<br><br>" + getP('nightmode') + getP('proteinbar') + getP('tea');
    }
    return "🌙 <strong>Come Gestire la Fame la Sera Senza Sensi di Colpa:</strong><br><br>Gli attacchi di fame notturni si verificano quasi sempre quando il pranzo o lo spuntino pomeridiano erano carenti di proteine o fibre sazianti.<br><br>• <strong>Cosa Fare:</strong> Bevi una tisana calda o 1 tazza di <strong>Night Mode</strong> (il sapore di zafferano e camomilla placa la mente e stimola il rilassamento).<br>• <strong>Spuntino Salva-Dieta:</strong> Se senti appetito reale, concediti 1 <strong>Barretta Proteica Herbalife</strong> o 1 tazza di latte vegetale con mezzo misurino di Formula 1.<br><br>" + getP('nightmode') + getP('proteinbar') + getP('tea');
  }

  // 11. CENA IDEALE / DINNER
  if (q.includes("cena") || q.includes("dinner") || q.includes("cină")) {
    if (lang === 'en') {
      return "🍽️ <strong>The Ideal Light & Nutritious Dinner:</strong><br><br>For optimal fat loss and digestion:<br>• <strong>Option A (Weight Loss Accelerator):</strong> Formula 1 Shake + 1 scoop PDM with a small warm soup.<br>• <strong>Option B (Balanced Plate):</strong> Grilled fish or chicken breast (150g) + large bowl of steamed broccoli or zucchini dressed with 1 tbsp olive oil.<br><br>" + getP('formula1') + getP('pdm');
    }
    if (lang === 'ro') {
      return "🍽️ <strong>Cina Ideală, Ușoară & Nutritivă:</strong><br><br>Pentru slăbire eficientă și digestie excelentă:<br>• <strong>Opțiunea A (Accelerare Slăbire):</strong> Shake cremos Formula 1 + 1 măsură PDM.<br>• <strong>Opțiunea B (Farfurie Echilibrată):</strong> 150g pește alb la cuptor sau piept de curcan cu dovlecei și broccoli la abur.<br><br>" + getP('formula1') + getP('pdm');
    }
    if (lang === 'es') {
      return "🍽️ <strong>La Cena Ideal, Ligera y Nutritiva:</strong><br><br>Para maximizar la quema de grasa nocturna:<br>• <strong>Opción A (Máxima Eficacia):</strong> Batido cremoso Fórmula 1 + 1 cucharada de PDM.<br>• <strong>Opción B (Plato Equilibrado):</strong> 150g de pescado blanco o pollo a la plancha con espinacas y calabacín al vapor.<br><br>" + getP('formula1') + getP('pdm');
    }
    return "🍽️ <strong>La Cena Ideale, Leggera & Nutriente:</strong><br><br>Per favorire il riposo notturno e massimizzare la lipolisi:<br><br>• <strong>Opzione A (Massima Efficacia Dimagrimento):</strong> Sostituisci la cena con lo <strong>Shake Formula 1 + PDM</strong> (leggero, saziante e pronto in 2 minuti).<br>• <strong>Opzione B (Piatto Leggero):</strong> 150g di merluzzo o petto di tacchino ai ferri con abbondanti zucchine, finocchi o broccoli cotti al vapore, conditi con 1 cucchiaio d'olio EVO.<br><br>" + getP('formula1') + getP('pdm');
  }

  // 12. INFUSO ERBE / TERMOGENICO / TEA
  if (q.includes("infuso") || q.includes("termogen") || q.includes("erbe") || q.includes("tea") || q.includes("ceai") || q.includes("té") || q.includes("hierbas")) {
    if (lang === 'en') {
      return "🌿 <strong>Instant Herbal Beverage (Thermogenic Tea):</strong><br><br>Formulated with green and black tea extracts, hibiscus, and cardamom to boost metabolism and vitality.<br><br>• <strong>How to use:</strong> Dissolve 1/2 tsp in 250ml hot or cold water. Drink 2-3 cups daily before 4 PM.<br><br>" + getP('tea');
    }
    if (lang === 'ro') {
      return "🌿 <strong>Ceai Instant pe Bază de Plante (Termogenic):</strong><br><br>Conține extracte din ceai verde și negru, hibiscus, nalbă și cardamom pentru activarea metabolismului.<br><br>• <strong>Cum se folosește:</strong> Dizolvă 1/2 linguriță în 250ml apă caldă sau rece. Se consumă 2-3 căni pe zi până la ora 16:00.<br><br>" + getP('tea');
    }
    if (lang === 'es') {
      return "🌿 <strong>Bebida Instantánea a Base de Hierbas:</strong><br><br>Con extractos de té verde y negro, hibisco y cardamomo para acelerar el metabolismo y aportar vitalidad.<br><br>• <strong>Modo de empleo:</strong> Disuelve 1/2 cucharadita en 250ml de agua caliente o fría. Toma 2-3 tazas al día hasta las 16:00.<br><br>" + getP('tea');
    }
    return "🌿 <strong>Infuso a Base di Erbe & Azione Termogenica:</strong><br><br>A base di estratti di tè verde e nero, fiori di ibisco, malva e semi di cardamomo per favorire la termogenesi e la vitalità.<br><br>• <strong>Come usarlo:</strong> Sciogli mezzo cucchiaino in 250-300ml d'acqua calda o fresca. Bevilo a digiuno al mattino e a metà pomeriggio.<br><br>" + getP('tea');
  }

  // 13. IDRATAZIONE / WATER / APA / AGUA
  if (q.includes("acqua") || q.includes("water") || q.includes("apă") || q.includes("agua") || q.includes("idrat")) {
    if (lang === 'en') {
      return "💧 <strong>Hydration Protocol:</strong><br><br>Aim for at least 2.5 - 3.0 Liters of water daily.<br>• Sip consistently throughout the day.<br>• Add AloeMax and Herbal Tea to turn plain water into a metabolism booster.<br><br>" + getP('aloemax') + getP('tea');
    }
    if (lang === 'ro') {
      return "💧 <strong>Protocol de Hidratare & Detox:</strong><br><br>Obiectivul zilnic recomandat este de <strong>2.5 - 3.0 litri de apă</strong>.<br>• Bea constant pe tot parcursul zilei.<br>• Adaugă AloeMax și Ceai de Plante pentru susținerea digestiei.<br><br>" + getP('aloemax') + getP('tea');
    }
    if (lang === 'es') {
      return "💧 <strong>Protocolo de Hidratación y Detox:</strong><br><br>El objetivo diario recomendado es de <strong>2.5 - 3.0 litros de agua</strong>.<br>• Bebe sorbos constantes durante toda la jornada.<br>• Añade AloeMax e Infusión de Hierbas para potenciar la hidratación.<br><br>" + getP('aloemax') + getP('tea');
    }
    return "💧 <strong>Protocollo Idratazione & Detox:</strong><br><br>L'obiettivo ideale è di <strong>2.5 - 3.0 litri d'acqua al giorno</strong> (circa 10-12 bicchieri).<br><br>• <strong>Consiglio d'Oro:</strong> Prepara una bottiglia da 1.5L al mattino con 3 tappini di <strong>AloeMax</strong> e mezzo cucchiaino di <strong>Infuso a Base di Erbe</strong> da sorseggiare fino al pomeriggio.<br><br>" + getP('aloemax') + getP('tea');
  }

  // 14. ANALIZZA PROGRESSI / ANALYZE PROGRESS
  if (q.includes("analizz") || q.includes("progress") || q.includes("oggi") || q.includes("analyze") || q.includes("progres")) {
    const todayLog = (typeof state !== 'undefined' && state.dailyLogs && state.dailyLogs[state.activeDay - 1]) ? state.dailyLogs[state.activeDay - 1] : { water: 0, score: 0, steps: 0, shakesCount: 0 };
    if (lang === 'en') {
      return "📊 <strong>Today's Progress Analysis (Day " + (state.activeDay || 1) + "):</strong><br><br>• <strong>Logged Score:</strong> " + (todayLog.score || 0) + "/100 pts<br>• <strong>Water Drunk:</strong> " + (todayLog.water || 0) + "L / " + (state.profile.waterGoal || 2.5) + "L<br>• <strong>Formula 1 Shakes:</strong> " + (todayLog.shakesCount || 0) + "/2<br>• <strong>Steps / Walking:</strong> " + (todayLog.steps || 0) + " steps<br><br>💡 <em>" + ((todayLog.score || 0) >= 80 ? "Outstanding execution today! You're fully in the fat-burning zone!" : "Keep completing your daily checks in the Diary to reach top score!") + "</em>";
    }
    if (lang === 'ro') {
      return "📊 <strong>Analiza Progresului de Azi (Ziua " + (state.activeDay || 1) + "):</strong><br><br>• <strong>Punctaj Zi:</strong> " + (todayLog.score || 0) + "/100 pt<br>• <strong>Apă Înregistrată:</strong> " + (todayLog.water || 0) + "L / " + (state.profile.waterGoal || 2.5) + "L<br>• <strong>Shake-uri Formula 1:</strong> " + (todayLog.shakesCount || 0) + "/2<br>• <strong>Pași:</strong> " + (todayLog.steps || 0) + " pași<br><br>💡 <em>" + ((todayLog.score || 0) >= 80 ? "Excelentă performanță astăzi! Ești în plin proces de transformare!" : "Continuă să bifezi activitățile în Jurnal pentru a atinge punctajul maxim!") + "</em>";
    }
    if (lang === 'es') {
      return "📊 <strong>Análisis de Progreso de Hoy (Día " + (state.activeDay || 1) + "):</strong><br><br>• <strong>Puntuación del Día:</strong> " + (todayLog.score || 0) + "/100 pt<br>• <strong>Agua Registrada:</strong> " + (todayLog.water || 0) + "L / " + (state.profile.waterGoal || 2.5) + "L<br>• <strong>Batidos Formula 1:</strong> " + (todayLog.shakesCount || 0) + "/2<br>• <strong>Pasos:</strong> " + (todayLog.steps || 0) + " pasos<br><br>💡 <em>" + ((todayLog.score || 0) >= 80 ? "¡Excelente trabajo hoy! ¡Estás en la zona óptima de resultados!" : "¡Completa las actividades restantes en el Diario para sumar el máximo de puntos!") + "</em>";
    }
    return "📊 <strong>Analisi dei Tuoi Progressi di Oggi (Giorno " + (state.activeDay || 1) + "):</strong><br><br>• <strong>Punteggio Raggiunto:</strong> " + (todayLog.score || 0) + "/100 pt<br>• <strong>Idratazione:</strong> " + (todayLog.water || 0) + "L registrati su " + (state.profile.waterGoal || 2.5) + "L obiettivo<br>• <strong>Shake Formula 1:</strong> " + (todayLog.shakesCount || 0) + "/2 completati<br>• <strong>Movimento:</strong> " + (todayLog.steps || 0) + " passi<br><br>💡 <em>" + ((todayLog.score || 0) >= 80 ? "Prestazione fantastica! Sei nella zona metabolica ottimale, continua così!" : "Ricorda di completare tutte le spunte nel Diario di Bordo per raggiungere il punteggio massimo!") + "</em>";
  }

  // 15. MOTIVAZIONE / MOTIVATION
  if (q.includes("motiva") || q.includes("carica") || q.includes("forza") || q.includes("arrend") || q.includes("ánimo")) {
    if (lang === 'en') {
      return "💪 <strong>Coach Motivation:</strong><br><br>Every healthy choice you make today is compounding into the body and energy you deserve. Stay consistent and focused — you've got this! 🌟";
    }
    if (lang === 'ro') {
      return "💪 <strong>Motivația Coach-ului Tău:</strong><br><br>Fiecare alegere sănătoasă de azi te aduce mai aproape de corpul și energia pe care le dorești. Fii consecventă — rezultatele vor fi vizibile! 🌟";
    }
    if (lang === 'es') {
      return "💪 <strong>La Fuerza de tu Coach:</strong><br><br>Cada vaso de agua, cada batido y cada paso cuentan. Los grandes cambios se construyen con pequeñas victorias diarias. ¡Tú puedes con todo! 🌟";
    }
    return "💪 <strong>La Carica del Tuo Coach:</strong><br><br>Ricorda perché hai iniziato: ogni bicchiere d'acqua, ogni shake bilanciato e ogni camminata stanno trasformando il tuo corpo dall'interno. I piccoli passi quotidiani creano risultati straordinari! Sei sulla strada giusta, continua con determinazione! 🌟";
  }

  // DEFAULT FALLBACK BOT REPLY
  if (lang === 'en') {
    return "🌟 <strong>AI Wellness Coach:</strong><br><br>I'm here to guide you in your 10-Day Challenge journey! You can ask me about:<br>• <strong>Delicious Formula 1 recipes</strong><br>• <strong>Hydration and de-bloat tips</strong><br>• <strong>Evening cravings and fit snacks</strong><br>• <strong>Herbalife product combinations for your goal</strong><br><br>Feel free to type your question or click any of the topic badges above!";
  }
  if (lang === 'ro') {
    return "🌟 <strong>Asistent Wellness AI:</strong><br><br>Sunt aici să te ghidez în Programul tău de 10 Zile! Mă poți întreba despre:<br>• <strong>Rețete delicioase Formula 1 și mese sănătoase</strong><br>• <strong>Sfaturi pentru hidratare și eliminarea retenției</strong><br>• <strong>Gustări proteice și pofte de seară</strong><br>• <strong>Produse Herbalife potrivite pentru tine</strong><br><br>Scrie orice întrebare sau alege o temă din lista de mai sus!";
  }
  if (lang === 'es') {
    return "🌟 <strong>Asistente de Bienestar AI:</strong><br><br>¡Estoy aquí para ayudarte en tu Reto de 10 Días! Puedes preguntarme sobre:<br>• <strong>Recetas de batidos Formula 1 y comidas</strong><br>• <strong>Consejos de hidratación y deshinchar piernas y abdomen</strong><br>• <strong>Snacks saciantes y antojos de noche</strong><br>• <strong>Productos Herbalife para tu objetivo</strong><br><br>¡Escribe tu mensaje o pulsa cualquiera de los botones de arriba!";
  }
  return "🌟 <strong>Assistente Benessere AI:</strong><br><br>Sono qui per guidarti passo dopo passo nel tuo Programma 10 Giorni! Puoi chiedermi:<br>• <strong>Ricette gourmet Formula 1 e pasti bilanciati</strong><br>• <strong>Consigli per sgonfiare gambe e addome e idratazione</strong><br>• <strong>Come gestire la fame la sera e idee spuntino</strong><br>• <strong>Integrazione Herbalife personalizzata per il tuo obiettivo</strong><br><br>Scrivi la tua domanda o clicca sui pulsanti tematici qui sopra!";
};

const applyLanguage = (lang) => {
  state.lang = lang;
  document.querySelectorAll("[data-i18n]").forEach(el => {
    const key = el.getAttribute("data-i18n");
    if (TRANSLATIONS[lang] && TRANSLATIONS[lang][key]) {
      if (el.tagName === 'INPUT' && el.getAttribute('type') === 'text') {
        el.placeholder = TRANSLATIONS[lang][key];
      } else {
        el.textContent = TRANSLATIONS[lang][key];
      }
    }
  });

  // Update chip badges and their data-question
  document.querySelectorAll(".suggestion-chips .chip").forEach(chip => {
    const key = chip.getAttribute("data-i18n");
    if (TRANSLATIONS[lang] && TRANSLATIONS[lang][key]) {
      chip.textContent = TRANSLATIONS[lang][key];
    }
    const qKey = key ? key.replace('chip_', 'chip_q_') : '';
    if (TRANSLATIONS[lang] && TRANSLATIONS[lang][qKey]) {
      chip.setAttribute("data-question", TRANSLATIONS[lang][qKey]);
    }
  });

  const langSelect = document.getElementById("lang-select");
  if (langSelect) langSelect.value = lang;
  
  const searchInput = document.getElementById("recipes-search-input");
  if (searchInput && TRANSLATIONS[lang] && TRANSLATIONS[lang].search_recipes_placeholder) {
    searchInput.placeholder = TRANSLATIONS[lang].search_recipes_placeholder;
  }

  try { renderDailyCoachTipCard(); } catch(e) {}
  try { renderDaySelector(); } catch(e) {}
  try {
    const activeTab = document.querySelector("#recipes-categories-tabs .tab-btn.active");
    const activeCat = activeTab ? activeTab.getAttribute("data-category") : "all";
    renderRecipes(activeCat);
  } catch(e) {}

  saveStateToStorage();
};

const updateAppLanguage = () => {
  applyLanguage(state.lang || "it");
};




// ==========================================

// COACH DAILY TIPS BY DAY (DAYS 1 TO 10)

// ==========================================

// Comprehensive Coach Daily Advice Database (Days 1 to 10) in IT, EN, RO, ES
// Strictly compliant with Herbalife guidelines (zero unapproved claims, only authorized wellness & nutrition guidance)

const COACH_DAILY_TIPS_BY_DAY = {
  it: {
    1: {
      badge: "🌅 Giorno 1 • Risveglio Metabolico & Detox",
      summary: "Benvenuta nel tuo primo giorno! Oggi l'obiettivo principale è riattivare l'idratazione profonda, risvegliare dolcemente il metabolismo ed impostare la routine mattutina vincente.",
      morning: "Bevi un bicchiere d'acqua tiepida con 3 tappini di AloeMax e 1/2 cucchiaino di Infuso a Base di Erbe a digiuno. Subito dopo, prepara il tuo primo Shake Formula 1 + PDM (22g di proteine pure, cremoso e altamente saziante).",
      lunch: "Formula del piatto unico: 50% verdure fresche o al vapore (zucchine, finocchi, spinaci), 25% proteine magre (petto di pollo, merluzzo o uova) e 25% carboidrati integrali (riso basmati o quinoa).",
      afternoon: "Niente cali di energia: concediti uno snack proteico (1 Barretta Proteica Herbalife o 150g di yogurt greco con cannella) e bevi acqua con regolarità.",
      evening: "Cena leggera: Formula 1 Shake oppure trancio di pesce al vapore con verdure. Riduci il sale per evitare ritenzioni notturne e punta a 7-8 ore di sonno rigenerante.",
      productKeys: ["aloemax", "tea", "formula1", "pdm"]
    },
    2: {
      badge: "⚡ Giorno 2 • Idratazione & Combustione Grassi",
      summary: "Il secondo giorno consolida le buone abitudini. Oggi aumentiamo l'apporto idrico e stimoliamo la termogenesi per favorire il drenaggio dei liquidi in eccesso.",
      morning: "Replica la colazione vincente: AloeMax + Infuso caldo, seguiti dal Frullato Formula 1 con gusto a tua scelta. Ti sentirai leggera ed energica per tutta la mattinata.",
      lunch: "Piatto colorato e nutriente. Integra 1 misurino di Multifibre Mela e Avena nel tuo shake o con acqua per sostenere la motilità intestinale e la prolungata sazietà.",
      afternoon: "Camminata attiva di 25-30 minuti a passo svelto o sessione di tonificazione express: stimola il consumo calorico e risveglia il microcircolo linfatico.",
      evening: "Se avverti languorino serale, prepara un infuso caldo rilassante con una spruzzata di AloeMax o 1 tazza di Night Mode per placare l'appetito a zero calorie.",
      productKeys: ["aloemax", "tea", "formula1", "fibre"]
    },
    3: {
      badge: "🌿 Giorno 3 • Termogenesi & Controllo Fame",
      summary: "Il corpo entra nel pieno ritmo della trasformazione! La glicemia si stabilizza e i picchi di fame improvvisi lasciano spazio a un'energia lucida e costante.",
      morning: "Aggiungi un pizzico di cannella o zenzero al tuo Frullato Formula 1 per un gusto gourmet e un naturale supporto termogenico.",
      lunch: "Inizia il pranzo con verdure crude croccanti (finocchi, sedano, cetrioli) + proteine di qualità. Integra Phyto Complete prima del pasto per supportare il metabolismo dei lipidi.",
      afternoon: "Bevi 1 tazza di Infuso a Base di Erbe fumante a metà pomeriggio per stimolare la concentrazione mentale e l'attività termogenica.",
      evening: "Cena altamente digeribile: passato di verdure con proteine magre oppure Shake Formula 1. Spegni schermi e smartphone 30 minuti prima di dormire per massimizzare il riposo.",
      productKeys: ["phytocomplete", "tea", "formula1", "pdm"]
    },
    4: {
      badge: "🦵 Giorno 4 • Sgonfiare Gambe & Addome Piatto",
      summary: "Oggi noterai i primi evidenti risultati allo specchio: gambe più leggere, addome sgonfio e maggiore reattività fisica.",
      morning: "Formula 1 + PDM preparato con acqua fresca e ghiaccio per una consistenza extra-cremosa. AloeMax a digiuno per lenire il tratto digerente.",
      lunch: "Non temere i grassi buoni: condisci con 1 cucchiaio di olio extravergine d'oliva a crudo per assorbire le vitamine liposolubili. Integra Mineral Complex Plus per l'equilibrio di potassio e magnesio.",
      afternoon: "Snack croccante: 1 bustina di Noccioline di Soia Tostate (9g di proteine vegetali) con 1 grande bicchiere d'acqua.",
      evening: "Allunga i muscoli: 10 minuti di stretching per le gambe e posizione con gambe alzate al muro per 5 minuti per facilitare il ritorno venoso.",
      productKeys: ["aloemax", "mineralcomplex", "soybeans", "tea"]
    },
    5: {
      badge: "📊 Giorno 5 • Giro di Boa & Risultati Tangibili",
      summary: "Sei a metà del tuo Programma 10 Giorni! Celebra questo traguardo con orgoglio: il tuo organismo ha abbandonato le vecchie abitudini e sta lavorando al massimo.",
      morning: "Misura il girovita e registralo nel diario di bordo. I primi centimetri persi ti daranno la carica per affrontare la seconda metà con ancora più entusiasmo!",
      lunch: "Varia le fonti proteiche: prova una porzione di salmone al forno o tofu grigliato con asparagi e quinoa.",
      afternoon: "Aumenta leggermente l'attività: aggiungi 1.500 passi alla tua camminata quotidiana o esegui una routine di tonificazione glutei e addome.",
      evening: "Cena leggera e bilanciata. Regalati una tazza di tisana rilassante prima di dormire, focalizzandoti sul traguardo finale.",
      productKeys: ["formula1", "pdm", "aloemax", "tea"]
    },
    6: {
      badge: "✨ Giorno 6 • Ricette Gourmet & Tono Muscolare",
      summary: "La costanza porta risultati duraturi! Sperimenta le ricette gourmet dell'Academy per scoprire sapori nuovi e mantenere altissima la motivazione.",
      morning: "Sperimenta una ricetta speciale dalla sezione Ricette: es. Shake Cioco-Banana & Mandorle o Frutti di Bosco Express con F1 + PDM.",
      lunch: "Carboidrati intelligenti a basso indice glicemico (patata dolce, riso venere o farro) abbinati a proteine magre per sostenere i muscoli senza appesantire.",
      afternoon: "Ricarica antiossidante: integra Collagen Skin Booster in 250ml d'acqua per nutrire la pelle dall'interno e donare luminosità al viso.",
      evening: "Omelette soffice con albumi e spinaci freschi, accompagnata da insalata mista con succo di limone.",
      productKeys: ["collagen", "formula1", "pdm", "tea"]
    },
    7: {
      badge: "🏆 Giorno 7 • 1 Settimana di Successi & Metabolismo Attivo",
      summary: "1 settimana intera completata! Il tuo livello di energia quotidiana è nettamente superiore e la tua digestione è fluida e leggera.",
      morning: "Sorseggia l'Infuso a Base di Erbe caldo per svegliare dolcemente la mente. Frullato F1 + PDM ricco di micronutrienti essenziali.",
      lunch: "Mastica lentamente ogni boccone per almeno 20 volte: la corretta masticazione favorisce l'assorbimento dei nutrienti e aumenta la sazietà.",
      afternoon: "Sessione di camminata a tempo di musica o routine Tabata HIIT per moltiplicare il consumo calorico post-allenamento.",
      evening: "Pesce bianco al cartoccio con erbe aromatiche e pomodorini o Formula 1 Shake per una digestione ultraleggera.",
      productKeys: ["tea", "formula1", "aloemax", "phytocomplete"]
    },
    8: {
      badge: "🔥 Giorno 8 • Sprint Finale & Massima Definizione",
      summary: "Mancano solo 3 giorni! Ora il tuo corpo risponde velocemente a ogni stimolo positivo. Mantieni altissima la concentrazione.",
      morning: "Inizia con acqua, AloeMax e Infuso caldo. Shake Formula 1 alla vaniglia arricchito con Multifibre Mela e Avena.",
      lunch: "Insalatona mista ricca di erbe fresche (basilico, prezzemolo, rucola), petto di tacchino ai ferri e 1 cucchiaio di olio extravergine d'oliva.",
      afternoon: "High Protein Iced Coffee con ghiaccio oppure Barretta Proteica Herbalife per un break fresco e proteico.",
      evening: "AloeMax prima di coricarti per favorire la naturale detossinazione notturna e svegliarti con addome piatto.",
      productKeys: ["aloemax", "fibre", "proteinbar", "tea"]
    },
    9: {
      badge: "⚡ Giorno 9 • Penultimo Giorno & Grinta Pura",
      summary: "Penultimo giorno del programma! La tua forma fisica e il tuo benessere hanno fatto un salto di qualità straordinario.",
      morning: "Shake Formula 1 + PDM con la massima cura e dedizione. Bevi la tua tazza d'Infuso per accendere la concentrazione.",
      lunch: "Pasto bilanciato e pulito. Evita zuccheri nascosti o salse industriali: gusta la freschezza degli alimenti sani.",
      afternoon: "Completa tutti i task del diario di bordo e bevi il tuo ultimo litro d'acqua della giornata entro le 18:00.",
      evening: "Prepara il corpo e la mente per il grande giorno finale di domani: cena leggera e 8 ore piene di sonno ristoratore.",
      productKeys: ["formula1", "pdm", "tea", "nightmode"]
    },
    10: {
      badge: "🌟 Giorno 10 • Traguardo Raggiunto & Grande Festa!",
      summary: "Congratulazioni! Hai completato i 10 Giorni di Trasformazione! Hai dimostrato a te stessa/o che con costanza e la giusta nutrizione i risultati arrivano davvero.",
      morning: "Gusta la tua colazione celebrativa Formula 1 + PDM! Misura peso, girovita, fianchi e inserisci i dati finali nel diario.",
      lunch: "Pranzo sano e bilanciato: goditi la tua nuova consapevolezza nutrizionale e il benessere che provi nel corpo.",
      afternoon: "Scatta la tua foto di progresso ed esporta il tuo Report PDF o condividi il successo con il tuo Coach!",
      evening: "I 10 Giorni non sono una fine, ma un nuovo inizio: continua con la colazione equilibrata e le sane abitudini ogni giorno!",
      productKeys: ["formula1", "pdm", "aloemax", "tea", "collagen"]
    }
  },
  en: {
    1: {
      badge: "🌅 Day 1 • Metabolic Wake-Up & Detox",
      summary: "Welcome to Day 1! Today's main focus is deep cellular hydration, gently awakening your metabolism, and establishing your winning morning routine.",
      morning: "Drink a warm glass of water with 3 caps of AloeMax and 1/2 tsp of Instant Herbal Beverage on an empty stomach. Follow up with your Formula 1 + PDM Shake (22g pure protein, creamy and satisfying).",
      lunch: "Balanced plate formula: 50% fresh or steamed vegetables (zucchini, fennel, spinach), 25% lean protein (chicken breast, cod, organic eggs), and 25% whole carbs (basmati rice or quinoa).",
      afternoon: "Keep energy steady: enjoy an Herbalife Protein Bar or Greek yogurt with cinnamon and sip water regularly throughout the afternoon.",
      evening: "Light dinner: Formula 1 Shake or steamed fish with green vegetables. Minimize added salt to avoid overnight water retention and aim for 7-8 hours of sleep.",
      productKeys: ["aloemax", "tea", "formula1", "pdm"]
    },
    2: {
      badge: "⚡ Day 2 • Hydration & Fat Burning",
      summary: "Day 2 builds consistency. Today we step up water intake and ignite thermogenesis to flush excess fluids and boost cellular energy.",
      morning: "Repeat the winning morning ritual: AloeMax + hot Herbal Tea, followed by your favorite Formula 1 shake flavor. You'll feel light and energetic all morning.",
      lunch: "Colorful nutritious meal. Mix 1 scoop of Oat Apple Fibre into water or your shake to support healthy digestion and lasting satiety.",
      afternoon: "25-30 minute brisk walk or quick bodyweight workout: activates calorie expenditure and improves lymphatic microcirculation.",
      evening: "If late-night cravings strike, sip warm herbal tea with AloeMax or 1 cup of Night Mode to soothe your appetite with zero calories.",
      productKeys: ["aloemax", "tea", "formula1", "fibre"]
    },
    3: {
      badge: "🌿 Day 3 • Thermogenesis & Appetite Control",
      summary: "Your body is in full transformation rhythm! Blood sugar levels stabilize, and sudden hunger spikes fade into steady, clear energy.",
      morning: "Add a dash of cinnamon or ginger to your Formula 1 Shake for gourmet taste and natural thermogenic synergy.",
      lunch: "Start lunch with crunchy raw vegetables (fennel, cucumber, celery) + lean protein. Take Phyto Complete before your meal to support lipid metabolism.",
      afternoon: "Enjoy a hot cup of Instant Herbal Beverage in the afternoon to sharpen focus and ignite metabolic rate.",
      evening: "Easily digestible dinner: light vegetable soup with lean protein or Formula 1 Shake. Turn off screens 30 minutes before bed for restful sleep.",
      productKeys: ["phytocomplete", "tea", "formula1", "pdm"]
    },
    4: {
      badge: "🦵 Day 4 • De-Bloat Legs & Flat Tummy",
      summary: "Today you'll see visible results in the mirror: lighter legs, a flatter abdomen, and greater physical lightness.",
      morning: "Formula 1 + PDM blended with cold water and ice for an ultra-creamy texture. AloeMax first thing to soothe your digestive tract.",
      lunch: "Healthy fats matter: drizzle 1 tbsp extra virgin olive oil over your salad to absorb fat-soluble vitamins. Take Mineral Complex Plus for electrolyte balance.",
      afternoon: "Crunchy fit snack: 1 pack of Roasted Soy Beans (9g plant protein) with a large glass of water.",
      evening: "Lengthen your muscles: 10 minutes of gentle leg stretching and legs-up-the-wall pose for 5 minutes to assist lymphatic return.",
      productKeys: ["aloemax", "mineralcomplex", "soybeans", "tea"]
    },
    5: {
      badge: "📊 Day 5 • Halfway Milestone & Tangible Progress",
      summary: "You are halfway through your 10-Day Challenge! Celebrate this milestone: your body has left old habits behind and is performing at its best.",
      morning: "Measure your waistline and log it in your diary. Seeing lost centimeters will fire you up for an incredible second half!",
      lunch: "Diversify your protein: try baked wild salmon or grilled tofu paired with steamed asparagus and quinoa.",
      afternoon: "Step up your movement: add 1,500 extra steps to your daily count or complete a glute and core sculpting routine.",
      evening: "Light balanced dinner. Enjoy a relaxing herbal tea before bed, keeping your eyes on the final transformation goal.",
      productKeys: ["formula1", "pdm", "aloemax", "tea"]
    },
    6: {
      badge: "✨ Day 6 • Gourmet Recipes & Muscle Tone",
      summary: "Consistency produces lasting results! Explore the Academy recipes to discover delicious flavors and keep motivation sky-high.",
      morning: "Try a special recipe from the Recipes tab: e.g. Choco-Banana Almond Shake or Berry Express with F1 + PDM.",
      lunch: "Smart low-GI carbs (sweet potato, black rice, or spelt) combined with lean protein to fuel muscles without sluggishness.",
      afternoon: "Antioxidant boost: dissolve Collagen Skin Booster in 250ml water to nourish skin from within and promote a radiant glow.",
      evening: "Fluffy egg white omelet with fresh baby spinach and a crisp green salad dressed with lemon juice.",
      productKeys: ["collagen", "formula1", "pdm", "tea"]
    },
    7: {
      badge: "🏆 Day 7 • 1 Full Week Completed!",
      summary: "1 full week in the books! Your daily energy is noticeably higher, and your digestion is smooth, light, and effortless.",
      morning: "Sip warm Herbal Tea to awaken your mind. Fuel up with Formula 1 + PDM packed with essential vitamins and minerals.",
      lunch: "Chew each bite slowly: proper chewing enhances nutrient absorption and signals fullness to the brain in 20 minutes.",
      afternoon: "Brisk musical walk or a short Tabata HIIT workout to multiply post-exercise calorie burn.",
      evening: "Parchment-baked white fish with Mediterranean herbs and cherry tomatoes or Formula 1 Shake for effortless digestion.",
      productKeys: ["tea", "formula1", "aloemax", "phytocomplete"]
    },
    8: {
      badge: "🔥 Day 8 • Final Sprint & Maximum Definition",
      summary: "Only 3 days left! Your body is now highly responsive to every healthy choice. Keep your focus sharp.",
      morning: "Start with water, AloeMax, and warm tea. Vanilla Formula 1 Shake enriched with 1 scoop of Oat Apple Fibre.",
      lunch: "Vibrant salad with fresh herbs (basil, parsley, arugula), grilled turkey breast, and 1 tbsp extra virgin olive oil.",
      afternoon: "High Protein Iced Coffee over ice or an Herbalife Protein Bar for a refreshing protein boost.",
      evening: "AloeMax before bed to support natural overnight detox pathways and wake up with a flat, relaxed stomach.",
      productKeys: ["aloemax", "fibre", "proteinbar", "tea"]
    },
    9: {
      badge: "⚡ Day 9 • Penultimate Day & Peak Motivation",
      summary: "Penultimate challenge day! Your fitness, stamina, and body confidence have made an extraordinary leap forward.",
      morning: "Formula 1 + PDM Shake prepared with passion. Sip your Herbal Tea to ignite peak mental clarity.",
      lunch: "Clean, wholesome plate. Avoid hidden sugars or processed sauces: taste the real flavor of fresh, healthy ingredients.",
      afternoon: "Complete all logbook tasks and finish your daily hydration goal before 6:00 PM.",
      evening: "Prepare body and mind for tomorrow's grand finale: light dinner and 8 full hours of deep, restful sleep.",
      productKeys: ["formula1", "pdm", "tea", "nightmode"]
    },
    10: {
      badge: "🌟 Day 10 • Finish Line & Celebration!",
      summary: "Congratulations! You completed the 10-Day Transformation Challenge! You proved that dedication and optimal nutrition bring real, lasting results.",
      morning: "Enjoy your celebratory Formula 1 + PDM Breakfast! Log your final weight, waist, and hip measurements in the diary.",
      lunch: "Balanced, healthy lunch: celebrate your new nutritional awareness and the vibrant energy you feel in your body.",
      afternoon: "Take your progress photo, download your PDF Report, and share your amazing transformation with your Coach!",
      evening: "Day 10 is not the end, but a powerful beginning: carry these healthy habits forward into your daily lifestyle!",
      productKeys: ["formula1", "pdm", "aloemax", "tea", "collagen"]
    }
  },
  ro: {
    1: {
      badge: "🌅 Ziua 1 • Activare Metabolică & Detox",
      summary: "Bun venit în prima zi a programului! Obiectivul de azi este hidratarea profundă, trezirea metabolismului și stabilirea rutinei de dimineață.",
      morning: "Bea un pahar de apă călduță cu 3 capace de AloeMax și 1/2 linguriță de Ceai pe Bază de Plante pe stomacul gol. Continuă cu Shake-ul Formula 1 + PDM (22g proteine pure, cremos și sățios).",
      lunch: "Formula farfuriei ideale: 50% legume verzi proaspete sau la abur (dovlecei, spanac, fenicul), 25% proteine slabe (pui, pește alb, ouă) și 25% carbohidrați complecși (orez basmati sau quinoa).",
      afternoon: "Fără căderi de energie: consumă un Baton Proteic Herbalife sau iaurt grecesc 0% cu scorțișoară și bea apă constant cu înghițituri mici.",
      evening: "Cină ușoară: Shake Formula 1 sau pește la abur cu legume. Redu sarea pentru a evita retenția de apă peste noapte și odihnește-te 7-8 ore.",
      productKeys: ["aloemax", "tea", "formula1", "pdm"]
    },
    2: {
      badge: "⚡ Ziua 2 • Hidratare & Ardere Grăsimi",
      summary: "A doua zi consolidează obiceiurile bune. Creștem aportul de apă și stimulăm termogeneza pentru eliminarea retenției de apă.",
      morning: "Repetă rutina de dimineață: AloeMax + Ceai cald, urmate de Shake-ul tău Formula 1 preferat. Te vei simți ușoară și plină de energie.",
      lunch: "Farfurie colorată și hrănitoare. Adaugă o măsură de Fibre din Măr și Ovăz în apă sau în shake pentru o digestie optimă și sațietate.",
      afternoon: "Plimbare alertă de 25-30 de minute sau antrenament rapid: stimulează consumul caloric și activează circulația limfatică.",
      evening: "Dacă simți poftă de seară, bea un ceai cald cu puțin AloeMax sau 1 cană de Night Mode pentru relaxare fără calorii.",
      productKeys: ["aloemax", "tea", "formula1", "fibre"]
    },
    3: {
      badge: "🌿 Ziua 3 • Termogeneză & Controlul Apetitului",
      summary: "Corpul tău intră în ritmul complet al transformării! Glicemia se stabilizează, iar poftele dispar, lăsând loc unei energii constante.",
      morning: "Adaugă un praf de scorțișoară sau ghimbir în Shake-ul Formula 1 pentru un gust delicios și efect termogenic natural.",
      lunch: "Începe prânzul cu legume crude crocante + proteine slabe. Integrează Phyto Complete înainte de masă pentru susținerea metabolismului grăsimilor.",
      afternoon: "Consumă o cană caldă de Ceai Instant de Plante după-amiaza pentru claritate mentală și activare metabolică.",
      evening: "Cină ușoară: supă cremă de legume cu proteine slabe sau Shake Formula 1. Închide ecranele cu 30 de minute înainte de culcare.",
      productKeys: ["phytocomplete", "tea", "formula1", "pdm"]
    },
    4: {
      badge: "🦵 Ziua 4 • Dezumflare Picioare & Abdomen Plat",
      summary: "Azi vei observa primele rezultate vizibile în oglindă: picioare mai ușoare, abdomen dezumflat și vitalitate crescută.",
      morning: "Formula 1 + PDM preparat cu apă rece și gheață pentru o textură extra-cremoasă. AloeMax pe stomacul gol pentru calmarea tractului digestiv.",
      lunch: "Include grăsimi sănătoase: adaugă 1 lingură de ulei de măsline extravirgin peste salată. Integrează Mineral Complex Plus pentru echilibrul de potasiu și magneziu.",
      afternoon: "Gustare crocantă: 1 pachet de Boabe de Soia Prăjite (9g proteine vegetale) cu un pahar mare de apă.",
      evening: "Întinde-ți mușchii: 10 minute de stretching pentru picioare și 5 minute cu picioarele ridicate pe perete pentru drenaj limfatic.",
      productKeys: ["aloemax", "mineralcomplex", "soybeans", "tea"]
    },
    5: {
      badge: "📊 Ziua 5 • Jumătatea Programului & Progres",
      summary: "Ești la jumătatea Programului de 10 Zile! Sărbătorește acest moment: corpul tău a lăsat în urmă vechile obiceiuri și lucrează excelent.",
      morning: "Măsoară circumferința taliei și noteaz-o în jurnal. Primii centimetri pierduți îți vor da impulsul necesar pentru a doua jumătate a provocării!",
      lunch: "Variază sursele de proteine: alege somon la cuptor sau tofu la grătar cu sparanghel și quinoa.",
      afternoon: "Adaugă 1.500 de pași la plimbarea zilnică sau fă un antrenament scurt pentru tonifierea fesierilor și abdomenului.",
      evening: "Cină echilibrată și ușoară. Bucură-te de un ceai cald înainte de culcare, concentrându-te pe rezultatul final.",
      productKeys: ["formula1", "pdm", "aloemax", "tea"]
    },
    6: {
      badge: "✨ Ziua 6 • Rețete Gourmet & Tonifiere",
      summary: "Consecvența aduce rezultate de durată! Descoperă rețetele gourmet din secțiunea Rețete pentru gusturi noi și motivație maximă.",
      morning: "Încearcă o rețetă specială: de exemplu Shake Ciocolată-Banană cu Migdale sau Fructe de Pădure Express cu F1 + PDM.",
      lunch: "Carbohidrați complecși (cartof dulce, orez negru sau hrișcă) alături de proteine slabe pentru susținerea masei musculare fără somnolență.",
      afternoon: "Susținere pentru piele: dizolvă Collagen Skin Booster în 250ml apă pentru hidratarea pielii și un ten luminos.",
      evening: "Omletă din albușuri cu spanac proaspăt și salată verde cu lămâie.",
      productKeys: ["collagen", "formula1", "pdm", "tea"]
    },
    7: {
      badge: "🏆 Ziua 7 • 1 Săptămână Împlinită!",
      summary: "O săptămână completă finalizată! Nivelul tău de energie este mult mai ridicat, iar digestia este ușoară și eficientă.",
      morning: "Bea Ceaiul cald pentru activarea minții. Shake Formula 1 + PDM plin de vitamine și minerale esențiale.",
      lunch: "Mestecă fiecare îmbucătură lent: mestecatul corect optimizează digestia și transmite senzația de sațietate în 20 de minute.",
      afternoon: "Plimbare alertă cu muzică plăcută sau o sesiune scurtă de exerciții cardio pentru accelerarea arderii caloriilor.",
      evening: "Pește alb la cuptor cu ierburi aromatice și roșii cherry sau Shake Formula 1 pentru o digestie ușoară.",
      productKeys: ["tea", "formula1", "aloemax", "phytocomplete"]
    },
    8: {
      badge: "🔥 Ziua 8 • Sprintul Final & Definire",
      summary: "Mai sunt doar 3 zile! Corpul tău răspunde rapid la fiecare alegere sănătoasă. Păstrează concentrarea la cote maxime.",
      morning: "Începe cu apă, AloeMax și Ceai cald. Shake Formula 1 de vanilie îmbogățit cu Fibre din Măr și Ovăz.",
      lunch: "Salată proaspătă cu ierburi aromatice (busuioc, pătrunjel, rucola), piept de curcan la grătar și 1 lingură ulei de măsline.",
      afternoon: "High Protein Iced Coffee cu gheață sau un Baton Proteic Herbalife pentru o gustare răcoritoare și proteică.",
      evening: "AloeMax înainte de culcare pentru susținerea proceselor naturale de detoxifiere nocturnă.",
      productKeys: ["aloemax", "fibre", "proteinbar", "tea"]
    },
    9: {
      badge: "⚡ Ziua 9 • Penultima Zi & Energie Maximă",
      summary: "Penultima zi a provocării! Forma ta fizică și starea generală de bine au făcut un salt extraordinar.",
      morning: "Shake Formula 1 + PDM preparat cu dedicare. Bea Ceaiul tău de plante pentru claritate și energie.",
      lunch: "Mâncare simplă și curată. Evită sosurile industriale și bucură-te de gustul autentic al ingredientelor proaspete.",
      afternoon: "Bifează toate activitățile în jurnal și atinge obiectivul de hidratare înainte de ora 18:00.",
      evening: "Pregătește-ți corpul și mintea pentru marea zi de mâine: cină ușoară și 8 ore de somn odihnitor.",
      productKeys: ["formula1", "pdm", "tea", "nightmode"]
    },
    10: {
      badge: "🌟 Ziua 10 • Linia de Sosire & Sărbătoare!",
      summary: "Felicitări! Ai finalizat cu succes Programul de 10 Zile! Ți-ai demonstrat că prin consecvență și nutriție corectă rezultatele sunt reale și vizibile.",
      morning: "Bucură-te de Micul Dejun festiv Formula 1 + PDM! Notează greutatea și măsurătorile finale în jurnal.",
      lunch: "Prânz sănătos și echilibrat: bucură-te de noua ta educație nutrițională și de starea minunată de sănătate.",
      afternoon: "Fă poza de progres, descarcă Raportul PDF și împărtășește reușita cu Coach-ul tău!",
      evening: "Ziua 10 nu este sfârșitul, ci începutul unui nou stil de viață: continuă cu micul dejun echilibrat în fiecare zi!",
      productKeys: ["formula1", "pdm", "aloemax", "tea", "collagen"]
    }
  },
  es: {
    1: {
      badge: "🌅 Día 1 • Activación Metabólica & Detox",
      summary: "¡Bienvenida a tu primer día! El objetivo de hoy es hidratarte profundamente, despertar el metabolismo y establecer tu rutina matutina ganadora.",
      morning: "Bebe un vaso de agua tibia con 3 tapones de AloeMax y 1/2 cucharadita de Té Herbalife en ayunas. Continúa con tu Batido Fórmula 1 + PDM (22g de proteína noble, cremoso y saciante).",
      lunch: "Fórmula del plato equilibrado: 50% verduras frescas o al vapor (calabacín, espinacas, hinojo), 25% proteínas limpias (pollo, pescado blanco, huevos) y 25% carbohidratos complejos (arroz basmati o quinoa).",
      afternoon: "Sin bajones de energía: disfruta de una Barrita con Proteínas Herbalife o yogur griego 0% con canela y bebe agua con regularidad.",
      evening: "Cena ligera: Batido Fórmula 1 o pescado al vapor con verduras verdes. Reduce la sal para evitar retención de líquidos y duerme 7-8 horas.",
      productKeys: ["aloemax", "tea", "formula1", "pdm"]
    },
    2: {
      badge: "⚡ Día 2 • Hidratación & Quema de Grasa",
      summary: "El segundo día consolida los buenos hábitos. Aumentamos la hidratación y activamos la termogénesis para eliminar líquidos retenidos.",
      morning: "Repite el ritual ganador: AloeMax + Té caliente, seguidos de tu Batido Fórmula 1 favorito. Te sentirás ligera y llena de energía toda la mañana.",
      lunch: "Plato colorido y nutritivo. Mezcla 1 cucharada de Fibra de Avena y Manzana en agua o en tu batido para favorecer la digestión y la saciedad.",
      afternoon: "Caminata activa de 25-30 minutos o rutina rápida de tonificación: estimula el gasto calórico y activa la circulación linfática.",
      evening: "Si sientes hambre por la noche, toma una infusión caliente con AloeMax o 1 taza de Night Mode para calmar el apetito con cero calorías.",
      productKeys: ["aloemax", "tea", "formula1", "fibre"]
    },
    3: {
      badge: "🌿 Día 3 • Termogénesis & Control del Apetito",
      summary: "¡Tu cuerpo entra en el ritmo óptimo de transformación! La glucosa se estabiliza y los antojos desaparecen, dando paso a una energía limpia y constante.",
      morning: "Añade una pizca de canela o jengibre a tu Batido Fórmula 1 para un toque gourmet y un efecto termogénico natural.",
      lunch: "Empieza con verduras crudas crujientes + proteínas limpias. Toma Phyto Complete antes del almuerzo para apoyar el metabolismo de las grasas.",
      afternoon: "Disfruta de una taza caliente de Té Herbalife por la tarde para mantener la concentración y activar el metabolismo.",
      evening: "Cena fácil de digerir: crema de verduras con proteína magra o Batido Fórmula 1. Apaga las pantallas 30 minutos antes de dormir.",
      productKeys: ["phytocomplete", "tea", "formula1", "pdm"]
    },
    4: {
      badge: "🦵 Día 4 • Piernas Ligeras & Vientre Plano",
      summary: "Hoy notarás los primeros cambios en el espejo: piernas más deshinchadas, abdomen plano y mayor ligereza corporal.",
      morning: "Fórmula 1 + PDM preparado con agua fría y hielo para una textura extra cremosa. AloeMax en ayunas para calmar el sistema digestivo.",
      lunch: "Las grasas buenas son esenciales: aliña con 1 cucharada de aceite de oliva virgen extra para absorber vitaminas liposolubles. Toma Mineral Complex Plus para el equilibrio de potasio y magnesio.",
      afternoon: "Snack crujiente: 1 paquete de Frutos de Soja Tostados (9g de proteína vegetal) con un gran vaso de agua.",
      evening: "Estira los músculos: 10 minutos de estiramientos de piernas y 5 minutos con las piernas elevadas en la pared para favorecer el retorno venoso.",
      productKeys: ["aloemax", "mineralcomplex", "soybeans", "tea"]
    },
    5: {
      badge: "📊 Día 5 • Mitad del Reto & Resultados Claros",
      summary: "¡Estás en la mitad del Reto de 10 Días! Celebra este logro: tu cuerpo ha dejado atrás los malos hábitos y está rindiendo al máximo.",
      morning: "Mide tu cintura y anótala en el diario. ¡Ver los primeros centímetros perdidos te dará máxima motivación para la segunda mitad!",
      lunch: "Varía tus proteínas: prueba salmón al horno o tofu a la plancha con espárragos y quinoa.",
      afternoon: "Añade 1.500 pasos a tu caminata diaria o realiza una sesión de tonificación para glúteos y abdomen.",
      evening: "Cena ligera y equilibrada. Disfruta de una infusión relajante antes de dormir con la mente puesta en la meta final.",
      productKeys: ["formula1", "pdm", "aloemax", "tea"]
    },
    6: {
      badge: "✨ Día 6 • Recetas Gourmet & Tono Muscular",
      summary: "¡La constancia genera resultados duraderos! Explora las recetas gourmet para descubrir nuevos sabores y mantener la motivación arriba.",
      morning: "Prueba una receta especial: como el Batido Choco-Plátano y Almendras o Frutos Rojos Express con F1 + PDM.",
      lunch: "Carbohidratos inteligentes de bajo índice glucémico (batata, arroz negro o espelta) con proteína limpia para alimentar los músculos sin pesadez.",
      afternoon: "Cuidado antioxidante: disuelve Collagen Skin Booster en 250ml de agua para nutrir la piel desde el interior y aportar luminosidad.",
      evening: "Tortilla francesa de claras con espinacas frescas y ensalada con limón.",
      productKeys: ["collagen", "formula1", "pdm", "tea"]
    },
    7: {
      badge: "🏆 Día 7 • ¡1 Semana Completa Superada!",
      summary: "¡1 semana entera conseguida! Tu nivel de energía diario es mucho más alto y tu digestión es ligera y ágil.",
      morning: "Toma tu Té caliente para activar la mente. Batido Fórmula 1 + PDM cargado de vitaminas y minerales esenciales.",
      lunch: "Mastica cada bocado lentamente: una buena masticación optimiza la digestión y transmite saciedad al cerebro.",
      afternoon: "Caminata a buen ritmo con música o sesión Tabata HIIT para acelerar la quema de calorías post-entreno.",
      evening: "Pescado blanco al horno con hierbas aromáticas y tomates cherry o Batido Fórmula 1 para una digestión ultraligera.",
      productKeys: ["tea", "formula1", "aloemax", "phytocomplete"]
    },
    8: {
      badge: "🔥 Día 8 • Sprint Final & Máxima Definición",
      summary: "¡Solo quedan 3 días! Tu cuerpo responde con rapidez a cada elección saludable. Mantén el foco al 100%.",
      morning: "Empieza con agua, AloeMax y Té caliente. Batido Fórmula 1 de vainilla enriquecido con Fibra de Avena y Manzana.",
      lunch: "Ensalada variada con hierbas frescas (albahaca, perejil, rúcula), pechuga de pavo a la plancha y 1 cucharada de aceite de oliva.",
      afternoon: "High Protein Iced Coffee con hielo o una Barrita con Proteínas Herbalife para una merienda rica y refrescante.",
      evening: "AloeMax antes de acostarte para apoyar la desintoxicación nocturna natural y despertar con el abdomen relajado.",
      productKeys: ["aloemax", "fibre", "proteinbar", "tea"]
    },
    9: {
      badge: "⚡ Día 9 • Penúltimo Día & Máxima Energía",
      summary: "¡Penúltimo día del reto! Tu forma física y tu bienestar han dado un salto de calidad extraordinario.",
      morning: "Batido Fórmula 1 + PDM preparado con dedicación. Bebe tu taza de Té para encender la concentración.",
      lunch: "Comida limpia y equilibrada. Evita salsas industriales y disfruta de la frescura de los alimentos saludables.",
      afternoon: "Completa tus registros en el diario y bebe tu último litro de agua antes de las 18:00.",
      evening: "Prepara cuerpo y mente para el gran día final de mañana: cena ligera y 8 horas completas de descanso reparador.",
      productKeys: ["formula1", "pdm", "tea", "nightmode"]
    },
    10: {
      badge: "🌟 Día 10 • ¡Llegada a la Meta & Gran Celebración!",
      summary: "¡Enhorabuena! ¡Has completado el Reto de Transformación de 10 Días! Has demostrado que con constancia y la nutrición adecuada los resultados llegan de verdad.",
      morning: "¡Disfruta de tu Desayuno de celebración Fórmula 1 + PDM! Registra tu peso y medidas finales en el diario.",
      lunch: "Almuerzo sano y equilibrado: celebra tu nuevo conocimiento nutricional y la vitalidad que sientes en tu cuerpo.",
      afternoon: "Hazte la foto de progreso, descarga tu Informe en PDF y comparte tu éxito con tu Coach.",
      evening: "El Día 10 no es el final, sino el inicio de un estilo de vida saludable: ¡continúa con tu desayuno equilibrado cada día!",
      productKeys: ["formula1", "pdm", "aloemax", "tea", "collagen"]
    }
  }
};





// ==========================================
// DAILY COACH ADVICE UI ENGINE (DAYS 1 TO 10)
// ==========================================

const renderDailyCoachTipCard = () => {
  const card = document.getElementById("top-coach-tip-card") || document.getElementById("top-coach-tip-carousel-card");
  if (!card) return;

  const day = Math.max(1, Math.min(10, state.activeDay || 1));
  const lang = state.lang || 'it';
  const langData = (typeof COACH_DAILY_TIPS_BY_DAY !== 'undefined' && COACH_DAILY_TIPS_BY_DAY[lang])
    ? COACH_DAILY_TIPS_BY_DAY[lang]
    : ((typeof COACH_DAILY_TIPS_BY_DAY !== 'undefined' && COACH_DAILY_TIPS_BY_DAY.it) ? COACH_DAILY_TIPS_BY_DAY.it : null);
  
  if (!langData) return;
  const dayTip = langData[day] || langData[1];
  if (!dayTip) return;

  // Title translation
  const titleEl = document.getElementById("daily-tip-title");
  if (titleEl) {
    if (lang === 'en') titleEl.textContent = `💡 Coach Advice for Day ${day}`;
    else if (lang === 'ro') titleEl.textContent = `💡 Sfatul Coach-ului pentru Ziua ${day}`;
    else if (lang === 'es') titleEl.textContent = `💡 Consejo del Coach para el Día ${day}`;
    else titleEl.textContent = `💡 Il Consiglio del Coach per il Giorno ${day}`;
  }

  // Badge / Focus tag
  const badgeEl = document.getElementById("daily-tip-focus-badge");
  if (badgeEl) {
    badgeEl.textContent = dayTip.badge;
  }

  // Summary
  const summaryEl = document.getElementById("daily-tip-summary");
  if (summaryEl) {
    summaryEl.textContent = dayTip.summary;
  }

  // Pillar labels
  const lblMorning = document.getElementById("tip-pillar-lbl-morning");
  const lblLunch = document.getElementById("tip-pillar-lbl-lunch");
  const lblAfternoon = document.getElementById("tip-pillar-lbl-afternoon");
  const lblEvening = document.getElementById("tip-pillar-lbl-evening");

  if (lblMorning) lblMorning.textContent = lang === 'en' ? 'Morning & Wake-Up' : (lang === 'ro' ? 'Dimineață & Trezire' : (lang === 'es' ? 'Mañana & Despertar' : 'Mattina & Risveglio'));
  if (lblLunch) lblLunch.textContent = lang === 'en' ? 'Lunch & Nutrition' : (lang === 'ro' ? 'Prânz & Nutriție' : (lang === 'es' ? 'Almuerzo & Nutrición' : 'Pranzo & Nutrizione'));
  if (lblAfternoon) lblAfternoon.textContent = lang === 'en' ? 'Afternoon & Fit Snack' : (lang === 'ro' ? 'După-amiază & Gustare' : (lang === 'es' ? 'Tarde & Snack Fit' : 'Pomeriggio & Snack'));
  if (lblEvening) lblEvening.textContent = lang === 'en' ? 'Evening & Rest' : (lang === 'ro' ? 'Seară & Relaxare' : (lang === 'es' ? 'Noche & Descanso' : 'Sera & Riposo'));

  // Pillar texts
  const pMorning = document.getElementById("tip-pillar-morning");
  const pLunch = document.getElementById("tip-pillar-lunch");
  const pAfternoon = document.getElementById("tip-pillar-afternoon");
  const pEvening = document.getElementById("tip-pillar-evening");

  if (pMorning) pMorning.textContent = dayTip.morning;
  if (pLunch) pLunch.textContent = dayTip.lunch;
  if (pAfternoon) pAfternoon.textContent = dayTip.afternoon;
  if (pEvening) pEvening.textContent = dayTip.evening;

  // Products
  const prodContainer = document.getElementById("daily-tip-product-container");
  if (prodContainer) {
    if (dayTip.productKeys && dayTip.productKeys.length > 0 && typeof getProductCardHtml === 'function') {
      const prodHeader = lang === 'en' ? '🛍️ Recommended by your Coach for today:' : (lang === 'ro' ? '🛍️ Produse recomandate de Coach azi:' : (lang === 'es' ? '🛍️ Productos recomendados hoy:' : '🛍️ Prodotti consigliati dal Coach per oggi:'));
      let html = `<div style="font-weight: 700; font-size: 11.5px; color: #10B981; letter-spacing: 0.5px; text-transform: uppercase; margin-bottom: 8px;">${prodHeader}</div>`;
      html += '<div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 8px;">';
      dayTip.productKeys.forEach(pk => {
        html += getProductCardHtml(pk);
      });
      html += '</div>';
      prodContainer.innerHTML = html;
      prodContainer.style.display = 'block';
    } else {
      prodContainer.innerHTML = '';
      prodContainer.style.display = 'none';
    }
  }
};

const initDailyCoachTipCard = () => {
  renderDailyCoachTipCard();
};

const initCoachTipCarousel = () => {
  renderDailyCoachTipCard();
};

const updateCoachTipsUI = () => {
  renderDailyCoachTipCard();
};

const calculateDailyScore = (dayLog) => {
  if (!dayLog) return 0;
  let score = 0;
  
  if (dayLog.shakesCount >= 2) score += 20;
  else if (dayLog.shakesCount === 1) score += 10;
  
  const waterTarget = (state.profile && state.profile.waterGoal) ? (state.profile.waterGoal * 1000) : 2500;
  if ((dayLog.water || 0) >= waterTarget) {
    score += 20;
  } else if ((dayLog.water || 0) > 0) {
    score += Math.round(20 * (dayLog.water / waterTarget));
  }
  
  if (dayLog.snack) score += 15;
  if (dayLog.meal) score += 15;
  
  if ((dayLog.exDuration || 0) >= 30 || (dayLog.steps || 0) >= 8000) {
    score += 15;
  } else if ((dayLog.exDuration || 0) > 0 || (dayLog.steps || 0) > 0) {
    const stepRatio = Math.min(1, (dayLog.steps || 0) / 8000);
    const exRatio = Math.min(1, (dayLog.exDuration || 0) / 30);
    score += Math.round(15 * Math.max(stepRatio, exRatio));
  }
  
  if (dayLog.weight !== null && dayLog.weight !== undefined && dayLog.weight !== '') score += 15;
  
  return Math.min(100, Math.max(0, score));
};

const getChallengeStats = () => {
  let daysCompleted = 0;
  let scoreTotal = 0;
  let totalWaterMl = 0;
  let latestWeight = state.profile ? state.profile.startWeight : 70;
  
  if (state.dailyLogs && Array.isArray(state.dailyLogs)) {
    state.dailyLogs.forEach((log) => {
      const hasActivity = (log.shakesCount > 0) || (log.water > 0) || log.snack || log.meal || (log.steps > 0) || (log.exDuration > 0) || (log.weight !== null && log.weight !== undefined && log.weight !== '');
      if (hasActivity) {
        daysCompleted++;
        scoreTotal += calculateDailyScore(log);
      }
      totalWaterMl += Number(log.water) || 0;
      if (log.weight !== null && log.weight !== undefined && log.weight !== '') {
        latestWeight = parseFloat(log.weight);
      }
    });
  }

  const weightLoss = ((state.profile && state.profile.startWeight) ? state.profile.startWeight : 70) - latestWeight;
  const avgScore = daysCompleted > 0 ? Math.round(scoreTotal / daysCompleted) : 0;
  
  return {
    daysCompleted,
    scoreTotal,
    avgScore,
    totalWaterMl,
    latestWeight,
    weightLoss: +weightLoss.toFixed(1)
  };
};

const updateDailyScoreUI = () => {
  const day = Math.max(1, Math.min(10, state.activeDay || 1));
  const log = (state.dailyLogs && state.dailyLogs[day - 1]) ? state.dailyLogs[day - 1] : {};
  const score = calculateDailyScore(log);
  
  const scoreText = document.getElementById("score-text");
  if (scoreText) scoreText.textContent = score;

  const scoreCompact = document.getElementById("top-score-value-compact");
  if (scoreCompact) scoreCompact.textContent = score;

  const circle = document.getElementById("score-circle") || document.getElementById("score-radial-progress");
  if (circle) {
    const strokeDasharray = 251.2;
    const offset = strokeDasharray - (strokeDasharray * score) / 100;
    circle.style.strokeDashoffset = offset;
  }
  
  const feedback = document.getElementById("score-feedback-text");
  if (feedback) {
    const l = state.lang || 'it';
    if (score === 0) {
      feedback.textContent = l === "it" ? "Inizia la giornata compilando la checklist!" : (l === "ro" ? "Începe ziua completând checklistul!" : (l === "es" ? "¡Empieza el día completando la checklist!" : "Start your day by completing the logs!"));
    } else if (score < 45) {
      feedback.textContent = l === "it" ? "Buon inizio! Continua così." : (l === "ro" ? "Un bun început! Continuă așa." : (l === "es" ? "¡Buen comienzo! Sigue así." : "Good start! Keep tracking."));
    } else if (score < 80) {
      feedback.textContent = l === "it" ? "Ottimo lavoro! Stai andando forte." : (l === "ro" ? "Excelentă muncă! Te descurci minunat." : (l === "es" ? "¡Gran trabajo! Vas genial." : "Great job! You are doing amazing."));
    } else if (score < 100) {
      feedback.textContent = l === "it" ? "Quasi al massimo! Ti manca pochissimo." : (l === "ro" ? "Aproape de maxim! Mai e foarte puțin." : (l === "es" ? "¡Casi al máximo! Te falta muy poco." : "Almost there! Just a bit more."));
    } else {
      feedback.textContent = l === "it" ? "Giorno perfetto! 100 punti ottenuti! 🌟" : (l === "ro" ? "Zi perfectă! 100 puncte obținute! 🌟" : (l === "es" ? "¡Día perfecto! ¡100 puntos conseguidos! 🌟" : "Perfect day! 100 points unlocked! 🌟"));
    }
  }
};

const renderDaySelector = () => {
  const listEl = document.getElementById("day-selector-list");
  if (!listEl) return;
  listEl.innerHTML = "";
  
  for (let i = 1; i <= 10; i++) {
    const log = (state.dailyLogs && state.dailyLogs[i - 1]) ? state.dailyLogs[i - 1] : {};
    const isCompleted = calculateDailyScore(log) === 100;
    
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = `day-btn ${state.activeDay === i ? "active" : ""} ${isCompleted ? "completed" : ""}`;
    const dict = (typeof TRANSLATIONS !== 'undefined' && TRANSLATIONS[state.lang]) ? TRANSLATIONS[state.lang] : {};
    const dayWord = dict.lbl_day || "Giorno";
    btn.innerHTML = `
      <span data-i18n="lbl_day">${dayWord}</span>
      <span style="font-size: 20px; font-weight: 800;">${i}</span>
      <span class="day-status-dot"></span>
    `;
    
    btn.addEventListener("click", () => {
      state.activeDay = i;
      saveStateToStorage();
      renderDaySelector();
      if (typeof loadActiveDayLogs === 'function') loadActiveDayLogs();
      if (typeof renderDailyCoachTipCard === 'function') renderDailyCoachTipCard();
      if (typeof updateHeaderMetadata === 'function') updateHeaderMetadata();
    });
    
    listEl.appendChild(btn);
  }

  const dict = (typeof TRANSLATIONS !== 'undefined' && TRANSLATIONS[state.lang]) ? TRANSLATIONS[state.lang] : {};
  const dayWord = dict.lbl_day || "Giorno";
  const badgeLabel = document.getElementById("day-badge-label");
  if (badgeLabel) badgeLabel.textContent = `${dayWord} ${state.activeDay || 1}`;
};

const loadActiveDayLogs = () => {
  const day = Math.max(1, Math.min(10, state.activeDay || 1));
  const log = (state.dailyLogs && state.dailyLogs[day - 1]) ? state.dailyLogs[day - 1] : {};

  const shakesSelect = document.getElementById("select-shakes-count");
  if (shakesSelect) shakesSelect.value = log.shakesCount || 0;

  const chkSnack = document.getElementById("chk-snack");
  if (chkSnack) chkSnack.checked = !!log.snack;

  const chkMeal = document.getElementById("chk-meal");
  if (chkMeal) chkMeal.checked = !!log.meal;

  const stepsInput = document.getElementById("input-daily-steps");
  if (stepsInput) stepsInput.value = log.steps || "";

  const kmInput = document.getElementById("input-daily-km");
  if (kmInput) kmInput.value = log.km || "";

  const exSelect = document.getElementById("select-exercise-type");
  if (exSelect) exSelect.value = log.exType || "nessuno";

  const exDurationInput = document.getElementById("input-exercise-duration");
  if (exDurationInput) exDurationInput.value = log.exDuration || "";

  const weightInput = document.getElementById("input-daily-weight");
  if (weightInput) weightInput.value = log.weight !== null && log.weight !== undefined ? log.weight : "";

  const dict = (typeof TRANSLATIONS !== 'undefined' && TRANSLATIONS[state.lang]) ? TRANSLATIONS[state.lang] : {};
  const dayLbl = dict.lbl_day || "Giorno";
  const badgeLabel = document.getElementById("day-badge-label");
  if (badgeLabel) badgeLabel.textContent = `${dayLbl} ${day}`;

  // Update Daily Coach Tip card for the active day!
  if (typeof renderDailyCoachTipCard === 'function') {
    renderDailyCoachTipCard();
  }

  // Update Daily Coach Focus Banner (Perché è Importante)
  if (typeof renderDailyCoachFocusBanner === 'function') {
    renderDailyCoachFocusBanner();
  }

  // Update UI components
  if (typeof updateDailyScoreUI === 'function') updateDailyScoreUI();
  if (typeof updateProgressRing === 'function') updateProgressRing();
  if (typeof renderWaterCups === 'function') renderWaterCups();
  if (typeof updateChallengeSummaryUI === 'function') updateChallengeSummaryUI();
  if (typeof restoreScannerState === 'function') restoreScannerState();
};


const updateChallengeSummaryUI = () => {
  const stats = getChallengeStats();
  
  document.getElementById("stat-weight-loss").textContent = `${stats.weightLoss > 0 ? "-" : ""}${Math.abs(stats.weightLoss)} kg`;
  document.getElementById("stat-avg-score").textContent = `${stats.avgScore} pt`;
  document.getElementById("stat-days-completed").textContent = `${stats.daysCompleted}/10`;
  
  const detailsWeight = document.getElementById("detail-total-lost");
  if (detailsWeight) detailsWeight.textContent = `${stats.weightLoss > 0 ? "-" : ""}${Math.abs(stats.weightLoss)} kg`;
  
  const complianceVal = document.getElementById("detail-compliance-rate");
  if (complianceVal) {
    const compliancePct = Math.round((stats.avgScore / 100) * 100);
    complianceVal.textContent = `${compliancePct}%`;
  }
  
  const waterTotalEl = document.getElementById("detail-total-water");
  if (waterTotalEl) waterTotalEl.textContent = `${stats.totalWaterL} L`;

  if (typeof updateProgressProfileCardUI === "function") {
    updateProgressProfileCardUI();
  }
};

const updateHeaderMetadata = () => {
  const dict = TRANSLATIONS[state.lang];
  if (!dict) return;
  
  const titles = {
    "page-diario": dict.nav_diario,
    "page-classifica": dict.nav_confronto,
    "page-grafici": dict.hdr_andamento || dict.nav_andamento,
    "page-piano": dict.hdr_andamento || dict.nav_andamento,
    "page-community": dict.nav_community,
    "page-scanner": dict.nav_scanner,
    "page-coach": dict.nav_coach,
    "page-ricette": dict.nav_ricette,
    "page-pacchetti": dict.packages_title || "I Pacchetti del Programma 10 Giorni",
    "page-profilo": dict.nav_profilo,
    "page-coach-dashboard": dict.title_coach_dashboard || dict.nav_coach_dashboard || "Pannello di Controllo Coach",
    "page-super-admin": "Super Admin Central"
  };
  
  const subtitles = {
    "page-diario": `${dict.lbl_day || 'Giorno'} ${state.activeDay} - ${dict.hdr_diario_sub}`,
    "page-classifica": dict.desc_group_comp,
    "page-grafici": dict.hdr_andamento_sub || "Grafici di andamento, strategia nutrizionale, macro e report",
    "page-piano": dict.hdr_andamento_sub || "Grafici di andamento, strategia nutrizionale, macro e report",
    "page-community": dict.chat_status_members,
    "page-scanner": "",
    "page-coach": dict.hdr_coach_sub || "Ciao sono il tuo assistente AI.",
    "page-ricette": dict.hdr_ricette_sub || "Ricette Formula 1, video allenamenti e guide pratiche del Coach",
    "page-pacchetti": dict.packages_subtitle || "Scegli il livello di supporto e integrazione ideale per iniziare il tuo percorso.",
    "page-profilo": dict.title_settings_sub,
    "page-coach-dashboard": dict.desc_coach_dashboard || "Gestisci i tuoi iscritti, approva i distributori del tuo team e monitora i loro progressi in tempo reale.",
    "page-super-admin": "Supervisione globale e gestione utenti per tutti gli store Herbalife."
  };

  const activePage = document.querySelector(".app-page.active");
  if (activePage) {
    const id = activePage.id;
    const titleEl = document.getElementById("page-title");
    const subEl = document.getElementById("page-subtitle");
    if (titleEl) titleEl.textContent = titles[id] || "Programma 10 Giorni";
    if (subEl) {
      const subText = subtitles[id] || "";
      subEl.textContent = subText;
      subEl.style.display = subText ? "block" : "none";
    }
  }
};

// ==========================================
// WHATSAPP-STYLE AUDIO FEEDBACK (WEB AUDIO API)
// ==========================================
function playMessageSentSound() {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    const ctx = new AudioContext();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    
    osc.type = "sine";
    osc.frequency.setValueAtTime(880, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(1760, ctx.currentTime + 0.08);
    
    gain.gain.setValueAtTime(0.08, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.08);
    
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + 0.08);
  } catch (e) {}
}

function playMessageNotificationSound() {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    const ctx = new AudioContext();
    const now = ctx.currentTime;
    
    const osc1 = ctx.createOscillator();
    const gain1 = ctx.createGain();
    osc1.type = "sine";
    osc1.frequency.setValueAtTime(587.33, now);
    gain1.gain.setValueAtTime(0.12, now);
    gain1.gain.exponentialRampToValueAtTime(0.001, now + 0.12);
    osc1.connect(gain1);
    gain1.connect(ctx.destination);
    osc1.start(now);
    osc1.stop(now + 0.12);

    const osc2 = ctx.createOscillator();
    const gain2 = ctx.createGain();
    osc2.type = "sine";
    osc2.frequency.setValueAtTime(880, now + 0.10);
    gain2.gain.setValueAtTime(0.14, now + 0.10);
    gain2.gain.exponentialRampToValueAtTime(0.001, now + 0.30);
    osc2.connect(gain2);
    gain2.connect(ctx.destination);
    osc2.start(now + 0.10);
    osc2.stop(now + 0.30);
  } catch (e) {}
}

// ==========================================
// CENTRALIZED SUPABASE REAL-TIME CLIENT & DB ENGINE
// ==========================================
const SUPABASE_REST_URL = 'https://zqrishzkvstkhmhttvpd.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpxcmlzaHprdnN0a2htaHR0dnBkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk0Mzg4MDAsImV4cCI6MjA5NTAxNDgwMH0.xSFxo4rNyq6AeJhZho4Afzz3e98jU_0HxgtJ7LsP07E';

let supabaseMasterClient = null;
let realtimeChatChannel = null;

function waitForSupabaseSDK(timeoutMs = 4000) {
  return new Promise((resolve) => {
    if (typeof window !== 'undefined' && window.supabase && window.supabase.createClient) {
      resolve(window.supabase);
      return;
    }
    const start = Date.now();
    const timer = setInterval(() => {
      if (typeof window !== 'undefined' && window.supabase && window.supabase.createClient) {
        clearInterval(timer);
        resolve(window.supabase);
      } else if (Date.now() - start > timeoutMs) {
        clearInterval(timer);
        resolve(null);
      }
    }, 40);
  });
}

function getSupabaseClient() {
  if (supabaseMasterClient) return supabaseMasterClient;
  if (typeof window !== 'undefined' && window.supabase && window.supabase.createClient) {
    try {
      supabaseMasterClient = window.supabase.createClient(SUPABASE_REST_URL, SUPABASE_ANON_KEY, {
        db: { schema: 'email_automation' },
        realtime: { params: { eventsPerSecond: 10 } }
      });
      return supabaseMasterClient;
    } catch (err) {
      console.warn("[Supabase Master] Init error:", err);
    }
  }
  return null;
}

function subscribeToCommunityChatRealtime() {
  const client = getSupabaseClient();
  if (!client) {
    waitForSupabaseSDK().then((sdk) => {
      if (sdk) subscribeToCommunityChatRealtime();
    });
    return;
  }

  const currentUserId = state.userId || getUserId();
  state.userId = currentUserId;
  const storeId = getStoreId();
  const channelName = 'p10_community_chat_' + storeId;

  if (realtimeChatChannel) {
    try { realtimeChatChannel.unsubscribe(); } catch (e) {}
  }

  realtimeChatChannel = client.channel(channelName, {
    config: {
      broadcast: { self: false },
      presence: { key: currentUserId }
    }
  });

  realtimeChatChannel
    .on('broadcast', { event: 'new_chat_message' }, (payload) => {
      const incomingMsg = payload.payload;
      if (!incomingMsg) return;
      if (incomingMsg.userId === currentUserId) return;
      console.log("[WhatsApp Live] Broadcast received from peer:", incomingMsg);

      const activeChan = getActiveChatChannel();
      const msgChanId = incomingMsg.channel_id || 'global';
      
      if (msgChanId === activeChan.id || (msgChanId === 'global' && activeChan.id === 'global')) {
        state.communityMessages = mergeCommunityMessages(state.communityMessages, [incomingMsg]);
        saveStateToStorage();
        renderCommunityChat();
        scrollToChatBottom();
        playMessageNotificationSound();
      } else {
        // Increment unread count for the other channel
        if (!state.unreadChannelCounts) state.unreadChannelCounts = {};
        state.unreadChannelCounts[msgChanId] = (state.unreadChannelCounts[msgChanId] || 0) + 1;
        if (typeof renderChatChannelsList === "function") renderChatChannelsList();
        playMessageNotificationSound();
      }
    })
    .on('postgres_changes', { event: 'INSERT', schema: 'email_automation', table: 'contacts' }, async (payload) => {
      try {
        const row = payload.new;
        if (!row) return;
        // Verify if inserted contact is a chat message for this store
        const isStoreChat = row.email && (row.email.startsWith(`chat_${storeId}`) || row.email.startsWith(`chat_`));
        if (isStoreChat && row.id) {
          // On-demand single contact fetch (1 row, zero disk burst)
          const singleUrl = `${SUPABASE_REST_URL}/rest/v1/contacts?id=eq.${row.id}&select=id,name,created_at,metadata_json`;
          const sRes = await fetch(singleUrl, {
            headers: {
              'apikey': SUPABASE_ANON_KEY,
              'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
              'Accept-Profile': 'email_automation'
            }
          });
          if (sRes.ok) {
            const data = await sRes.json();
            if (data && data[0] && data[0].metadata_json) {
              const meta = data[0].metadata_json;
              if (meta.type === 'program10_chat_message' && (meta.store_id || 'herbaally') === storeId) {
                const isFromOther = meta.userId !== currentUserId;
                const activeChan = getActiveChatChannel();
                const msgChanId = meta.channel_id || 'global';

                const newMsg = {
                  id: data[0].id,
                  userId: meta.userId || null,
                  created_at: data[0].created_at,
                  sender: meta.sender || data[0].name || "Partecipante",
                  avatar: meta.avatar || "👤",
                  photo: meta.photo || null,
                  text: meta.text || "",
                  attachment: meta.attachment || null,
                  bot: !!meta.bot,
                  channel_type: meta.channel_type || 'global',
                  channel_id: msgChanId,
                  sender_email: meta.sender_email || null,
                  recipient_email: meta.recipient_email || null,
                  recipient_coach_id: meta.recipient_coach_id || null,
                  isUser: meta.userId === currentUserId,
                  time: meta.time || new Date(data[0].created_at).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }),
                  timestamp: Number(meta.timestamp) || new Date(data[0].created_at).getTime()
                };

                if (msgChanId === activeChan.id || (msgChanId === 'global' && activeChan.id === 'global')) {
                  state.communityMessages = mergeCommunityMessages(state.communityMessages, [newMsg]);
                  saveStateToStorage();
                  renderCommunityChat();
                  scrollToChatBottom();
                  if (isFromOther && !meta.bot) {
                    playMessageNotificationSound();
                  }
                } else if (isFromOther) {
                  if (!state.unreadChannelCounts) state.unreadChannelCounts = {};
                  state.unreadChannelCounts[msgChanId] = (state.unreadChannelCounts[msgChanId] || 0) + 1;
                  if (typeof renderChatChannelsList === "function") renderChatChannelsList();
                  if (!meta.bot) playMessageNotificationSound();
                }
              }
            }
          }
        }
      } catch (rtErr) {
        console.warn("[CommunityChat Realtime] Change handling notice:", rtErr);
      }
    })
    .on('presence', { event: 'sync' }, () => {
      const presenceState = realtimeChatChannel.presenceState();
      const onlineCount = Math.max(1, Object.keys(presenceState).length);
      const onlineLabel = document.getElementById("wa-online-counter");
      const activeChan = getActiveChatChannel();
      if (onlineLabel && activeChan.id === 'global') {
        const statusText = state.lang === 'it' 
          ? `🟢 ${onlineCount} online ora • In tempo reale` 
          : (state.lang === 'ro' 
            ? `🟢 ${onlineCount} online acum • În timp real` 
            : (state.lang === 'es' 
              ? `🟢 ${onlineCount} en línea ahora • En tempo real` 
              : `🟢 ${onlineCount} online now • Real-time`));
        onlineLabel.textContent = statusText;
      }
    })
    .subscribe(async (status) => {
      if (status === 'SUBSCRIBED') {
        const userName = (state.profile && state.profile.name) ? state.profile.name : "Sfidante";
        await realtimeChatChannel.track({
          userId: currentUserId,
          name: userName,
          online_at: new Date().toISOString()
        });
      }
    });
}

// ==========================================
// WHATSAPP-STYLE COMMUNITY & MULTI-CHANNEL ENGINE
// ==========================================

let coachDownlineContactsCache = [];

async function fetchCoachDownlineContacts() {
  const p = state.profile || {};
  const isSuperAdminUser = isCurrentSuperAdmin();
  const coachId = (p.myHerbalifeId || "").trim();
  const storeId = getStoreId();

  if (!isSuperAdminUser && (!p.isDistributor || p.herbalifeIdStatus !== 'verified' || !coachId)) {
    coachDownlineContactsCache = [];
    return coachDownlineContactsCache;
  }

  try {
    if (isSuperAdminUser) {
      const adminEmail = (window.ShopifyCustomerEmail || p.email || "alinaciobotaru.roma@gmail.com").toLowerCase().trim();
      const res = await fetch(`${API_BASE_URL}/admin/users?admin_email=${encodeURIComponent(adminEmail)}`);
      const data = await res.json();
      if (data.success && Array.isArray(data.users)) {
        coachDownlineContactsCache = data.users.filter(u => u.email && !u.email.includes("alinaciobotaru.roma@gmail.com"));
        return coachDownlineContactsCache;
      }
    } else {
      const res = await fetch(`${API_BASE_URL}/coach/clients?coach_id=${encodeURIComponent(coachId)}&store_id=${storeId}`);
      const data = await res.json();
      if (data.success && Array.isArray(data.clients)) {
        coachDownlineContactsCache = data.clients;
        return coachDownlineContactsCache;
      }
    }
  } catch (err) {
    console.warn("[Downline Contacts] Notice:", err.message);
  }
  return coachDownlineContactsCache;
}

function getActiveChatChannel() {
  if (!state.activeChatChannel) {
    state.activeChatChannel = {
      id: 'global',
      type: 'global',
      title: 'Wellness Hub Community 🥤💪',
      sub: '🟢 Online in tempo reale',
      avatar: '🥤',
      photo: null
    };
  }
  return state.activeChatChannel;
}

window.switchChatChannel = function(chan) {
  state.activeChatChannel = chan;
  if (!state.unreadChannelCounts) state.unreadChannelCounts = {};
  state.unreadChannelCounts[chan.id] = 0;

  // 1. Update Chat Header
  const titleEl = document.getElementById("wa-header-title-el");
  const avatarWrap = document.getElementById("wa-header-avatar-wrap");
  const badgeEl = document.getElementById("wa-header-badge-el");
  const statusEl = document.getElementById("wa-online-counter");
  const inputField = document.getElementById("community-chat-input-field");

  if (titleEl) titleEl.textContent = chan.title;
  
  if (avatarWrap) {
    if (chan.photo) {
      avatarWrap.innerHTML = `<img src="${chan.photo}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">`;
    } else {
      avatarWrap.innerHTML = `<span style="font-size: 20px;">${chan.avatar || '💬'}</span>`;
    }
  }

  if (badgeEl) {
    badgeEl.style.display = "inline-flex";
    if (chan.type === 'global') {
      badgeEl.textContent = "Community";
      badgeEl.style.background = "rgba(37, 211, 102, 0.2)";
      badgeEl.style.color = "#25D366";
    } else if (chan.type === 'upline_direct') {
      badgeEl.textContent = "🌟 Upline Coach";
      badgeEl.style.background = "rgba(16, 185, 129, 0.25)";
      badgeEl.style.color = "#10B981";
    } else if (chan.type === 'broadcast_downline') {
      badgeEl.textContent = "📣 Team Broadcast";
      badgeEl.style.background = "rgba(245, 158, 11, 0.25)";
      badgeEl.style.color = "#F59E0B";
    } else if (chan.type === 'superadmin_broadcast') {
      badgeEl.textContent = "👑 Super Admin";
      badgeEl.style.background = "rgba(236, 72, 153, 0.25)";
      badgeEl.style.color = "#EC4899";
    } else {
      badgeEl.textContent = "💬 Privata";
      badgeEl.style.background = "rgba(56, 189, 248, 0.25)";
      badgeEl.style.color = "#38BDF8";
    }
  }

  if (statusEl) {
    statusEl.textContent = chan.sub || "In tempo reale";
  }

  if (inputField) {
    if (chan.type === 'broadcast_downline') {
      inputField.placeholder = state.lang === 'it' 
        ? "Invia un annuncio broadcast a tutta la tua downline... 📣" 
        : "Send a broadcast announcement to all your downline... 📣";
    } else if (chan.type === 'upline_direct') {
      inputField.placeholder = state.lang === 'it'
        ? `Scrivi un messaggio privato a ${chan.title.split(' ')[0]}...`
        : `Write a private message to ${chan.title.split(' ')[0]}...`;
    } else if (chan.type === 'direct_client') {
      inputField.placeholder = `Scrivi a ${chan.title}...`;
    } else {
      inputField.placeholder = state.lang === 'it' ? "Scrivi un messaggio nella community..." : "Write a message in community...";
    }
  }

  if (typeof renderChatChannelsList === "function") renderChatChannelsList();
  // Clear local feed and fetch fresh for this channel
  state.communityMessages = [];
  renderCommunityChat();
  fetchCommunityMessages();
};

window.renderChatChannelsList = function() {
  const container = document.getElementById("community-channels-wrapper");
  if (!container) return;

  const p = state.profile || {};
  const activeChan = getActiveChatChannel();
  const isSuperAdminUser = isCurrentSuperAdmin();
  const isCoach = (p.isDistributor && p.herbalifeIdStatus === 'verified') || isSuperAdminUser;
  const uplineId = (p.sponsorId || "").trim();
  const uplineName = (p.sponsorName && p.sponsorName.trim() !== "") ? p.sponsorName.trim() : "Coach Herbalife";
  const myCoachId = (p.myHerbalifeId || "").trim();

  // Role Badge in sidebar
  const roleBadge = document.getElementById("chat-active-role-badge");
  if (roleBadge) {
    if (isSuperAdminUser) {
      roleBadge.textContent = "👑 Super Admin";
      roleBadge.style.background = "rgba(236, 72, 153, 0.2)";
      roleBadge.style.color = "#EC4899";
    } else if (isCoach) {
      roleBadge.textContent = "💼 Coach Verificato";
      roleBadge.style.background = "rgba(56, 189, 248, 0.2)";
      roleBadge.style.color = "#38BDF8";
    } else {
      roleBadge.textContent = "🏃 Sfidante";
      roleBadge.style.background = "rgba(16, 185, 129, 0.15)";
      roleBadge.style.color = "#10B981";
    }
  }

  let html = "";

  // 1. SECTION: COMMUNITY STORE
  html += `
    <div class="channel-group-section">
      <div class="channel-group-title">
        <span>🌐</span> ${state.lang === 'it' ? 'Community Store' : 'Store Community'}
      </div>
      <div class="channel-item-card ${activeChan.id === 'global' ? 'active' : ''}" data-chan-id="global" data-chan-type="global">
        <div class="channel-avatar-wrap" style="background: linear-gradient(135deg, #25D366, #128C7E); color: white;">
          🥤
        </div>
        <div class="channel-card-info">
          <span class="channel-card-name">Wellness Hub Globale</span>
          <span class="channel-card-sub" style="color: #25D366; font-weight: 600;">Tutti gli sfidanti attivi</span>
        </div>
      </div>
    </div>
  `;

  // 2. SECTION: UPLINE COACH (if specified)
  if (uplineId) {
    const uplineChanId = `upline_${uplineId}`;
    const unread = (state.unreadChannelCounts && state.unreadChannelCounts[uplineChanId]) || 0;
    const unreadHtml = unread > 0 ? `<span class="channel-badge-unread">${unread}</span>` : '';
    const avatarHtml = p.sponsorPhoto 
      ? `<img src="${p.sponsorPhoto}">` 
      : `<span>🌟</span>`;

    html += `
      <div class="channel-group-section">
        <div class="channel-group-title">
          <span>🌟</span> ${state.lang === 'it' ? 'Il Tuo Coach Upline' : 'Your Upline Coach'}
        </div>
        <div class="channel-item-card ${activeChan.id === uplineChanId ? 'active' : ''}" data-chan-id="${uplineChanId}" data-chan-type="upline_direct">
          <div class="channel-avatar-wrap" style="background: rgba(16, 185, 129, 0.2); border: 1.5px solid #10B981;">
            ${avatarHtml}
          </div>
          <div class="channel-card-info">
            <span class="channel-card-name">${uplineName} (Coach)</span>
            <span class="channel-card-sub">Distributore ID: ${uplineId}</span>
          </div>
          ${unreadHtml}
        </div>
      </div>
    `;
  }

  // 3. SECTION: TEAM DOWNLINE (for Verified Coaches / Super Admin)
  if (isCoach && (myCoachId || isSuperAdminUser)) {
    const broadcastChanId = `broadcast_${myCoachId || 'team'}`;
    const unreadBc = (state.unreadChannelCounts && state.unreadChannelCounts[broadcastChanId]) || 0;
    const unreadBcHtml = unreadBc > 0 ? `<span class="channel-badge-unread">${unreadBc}</span>` : '';

    html += `
      <div class="channel-group-section">
        <div class="channel-group-title">
          <span>💼</span> ${state.lang === 'it' ? 'Gestione Downline' : 'Team Downline'}
        </div>
        
        <!-- Broadcast Channel -->
        <div class="channel-item-card ${activeChan.id === broadcastChanId ? 'active' : ''}" data-chan-id="${broadcastChanId}" data-chan-type="broadcast_downline">
          <div class="channel-avatar-wrap" style="background: linear-gradient(135deg, #F59E0B, #D97706); color: white;">
            📣
          </div>
          <div class="channel-card-info">
            <span class="channel-card-name">Broadcast al Mio Team</span>
            <span class="channel-card-sub" style="color: #F59E0B; font-weight: 600;">Invia a tutta la tua downline</span>
          </div>
          ${unreadBcHtml}
        </div>
    `;

    // Downline Individual Clients
    if (Array.isArray(coachDownlineContactsCache) && coachDownlineContactsCache.length > 0) {
      coachDownlineContactsCache.forEach(client => {
        const clientEmail = (client.email || "").toLowerCase().trim();
        const clientChanId = `direct_${clientEmail.replace(/[^a-z0-9]/g, '_')}`;
        const unreadCl = (state.unreadChannelCounts && state.unreadChannelCounts[clientChanId]) || 0;
        const unreadClHtml = unreadCl > 0 ? `<span class="channel-badge-unread">${unreadCl}</span>` : '';
        const clientAvatar = client.photo 
          ? `<img src="${client.photo}">` 
          : `<span>${client.avatar || '👤'}</span>`;

        html += `
          <div class="channel-item-card ${activeChan.id === clientChanId ? 'active' : ''}" data-chan-id="${clientChanId}" data-chan-type="direct_client" data-email="${clientEmail}" data-name="${client.name || 'Sfidante'}">
            <div class="channel-avatar-wrap" style="background: rgba(56, 189, 248, 0.15); border: 1px solid rgba(56, 189, 248, 0.4);">
              ${clientAvatar}
            </div>
            <div class="channel-card-info">
              <span class="channel-card-name">${client.name || 'Sfidante'}</span>
              <span class="channel-card-sub">${clientEmail}</span>
            </div>
            ${unreadClHtml}
          </div>
        `;
      });
    }

    html += `</div>`;
  }

  // 4. SECTION: SUPER ADMIN OFFICIAL ANNOUNCEMENTS
  if (isSuperAdminUser) {
    const adminChanId = 'superadmin_broadcast';
    html += `
      <div class="channel-group-section">
        <div class="channel-group-title">
          <span>👑</span> ${state.lang === 'it' ? 'Rete Globale' : 'Global Network'}
        </div>
        <div class="channel-item-card ${activeChan.id === adminChanId ? 'active' : ''}" data-chan-id="${adminChanId}" data-chan-type="superadmin_broadcast">
          <div class="channel-avatar-wrap" style="background: linear-gradient(135deg, #EC4899, #8B5CF6); color: white;">
            👑
          </div>
          <div class="channel-card-info">
            <span class="channel-card-name">Annuncio Rete Super Admin</span>
            <span class="channel-card-sub" style="color: #EC4899; font-weight: 600;">Broadcast a tutta la rete</span>
          </div>
        </div>
      </div>
    `;
  }

  container.innerHTML = html;

  // Bind click handlers to all channel items
  container.querySelectorAll(".channel-item-card").forEach(card => {
    card.onclick = () => {
      const chanId = card.getAttribute("data-chan-id");
      const chanType = card.getAttribute("data-chan-type");
      let chanTitle = card.querySelector(".channel-card-name")?.textContent || "Chat";
      let chanSub = card.querySelector(".channel-card-sub")?.textContent || "In tempo reale";
      let chanAvatar = "💬";
      let chanPhoto = null;

      if (chanType === 'global') {
        chanAvatar = '🥤';
        chanTitle = 'Wellness Hub Community 🥤💪';
      } else if (chanType === 'upline_direct') {
        chanAvatar = '🌟';
        chanPhoto = p.sponsorPhoto || null;
      } else if (chanType === 'broadcast_downline') {
        chanAvatar = '📣';
      } else if (chanType === 'superadmin_broadcast') {
        chanAvatar = '👑';
      } else if (chanType === 'direct_client') {
        const clientEmail = card.getAttribute("data-email");
        const client = coachDownlineContactsCache.find(c => (c.email || "").toLowerCase().trim() === clientEmail);
        if (client) {
          chanPhoto = client.photo || null;
          chanAvatar = client.avatar || '👤';
        }
      }

      window.switchChatChannel({
        id: chanId,
        type: chanType,
        title: chanTitle,
        sub: chanSub,
        avatar: chanAvatar,
        photo: chanPhoto,
        recipient_email: card.getAttribute("data-email") || (chanType === 'upline_direct' ? p.sponsorEmail : null),
        recipient_coach_id: chanType === 'broadcast_downline' ? myCoachId : (chanType === 'upline_direct' ? uplineId : null)
      });

      const sidebar = document.getElementById("community-channels-sidebar");
      if (sidebar && sidebar.classList.contains("mobile-open")) {
        sidebar.classList.remove("mobile-open");
        const backdrop = document.getElementById("channels-backdrop");
        if (backdrop) backdrop.remove();
      }
    };
  });
};

const mergeCommunityMessages = (currentArr = [], newArr = []) => {
  const map = new Map();
  const normalizeText = (t) => (t || "").trim().toLowerCase();
  
  const getItemKey = (item) => {
    if (item.id && typeof item.id === 'string' && item.id.startsWith('seed_')) {
      return item.id;
    }
    if (item.userId && item.timestamp) {
      return `${item.userId}_${item.timestamp}_${normalizeText(item.text).slice(0, 15)}`;
    }
    return item.id ? String(item.id) : `m_${item.timestamp || '0'}_${normalizeText(item.text).slice(0, 15)}`;
  };

  // 1. Add existing messages
  currentArr.forEach(item => {
    if (!item) return;
    map.set(getItemKey(item), item);
  });
  
  // 2. Merge new incoming messages
  newArr.forEach(item => {
    if (!item) return;
    const key = getItemKey(item);
    const existing = map.get(key);
    map.set(key, { ...(existing || {}), ...item, isUser: existing ? existing.isUser : item.isUser });
  });

  return Array.from(map.values()).sort((a, b) => {
    const tA = Number(a.timestamp) || (a.created_at ? new Date(a.created_at).getTime() : 0);
    const tB = Number(b.timestamp) || (b.created_at ? new Date(b.created_at).getTime() : 0);
    return tA - tB;
  });
};

const scrollToChatBottom = () => {
  const box = document.getElementById("community-messages-box");
  if (!box) return;
  box.scrollTop = box.scrollHeight;
  requestAnimationFrame(() => {
    box.scrollTop = box.scrollHeight;
  });
  setTimeout(() => {
    if (box) box.scrollTop = box.scrollHeight;
  }, 60);
  setTimeout(() => {
    if (box) box.scrollTop = box.scrollHeight;
  }, 250);
};

const renderCommunityChat = () => {
  try {
    const box = document.getElementById("community-messages-box");
    if (!box) return;
    
    const currentUserId = state.userId || getUserId();
    const currentUserName = (state.profile && state.profile.name) ? String(state.profile.name).trim().toLowerCase() : "";
    const activeChan = getActiveChatChannel();

    box.innerHTML = "";

    // Date Divider (Oggi)
    const dateDiv = document.createElement("div");
    dateDiv.className = "wa-date-divider";
    dateDiv.textContent = state.lang === 'it' ? "Oggi" : (state.lang === 'ro' ? "Astăzi" : (state.lang === 'es' ? "Hoy" : "Today"));
    box.appendChild(dateDiv);
    
    const validMessages = (state.communityMessages || []).filter(m => m && typeof m === 'object');
    
    if (validMessages.length === 0) {
      const emptyDiv = document.createElement("div");
      emptyDiv.className = "chat-empty-state";
      emptyDiv.style.cssText = "text-align: center; padding: 48px 16px; color: var(--text-muted);";
      
      let emptyTitle = state.lang === 'it' ? 'Nessun messaggio in questa chat' : 'No messages in this chat yet';
      let emptySub = state.lang === 'it' ? 'Scrivi un messaggio per iniziare la conversazione!' : 'Write a message to start the conversation!';
      
      if (activeChan.type === 'broadcast_downline') {
        emptyTitle = state.lang === 'it' ? 'Nessun annuncio broadcast inviato' : 'No broadcast announcements yet';
        emptySub = state.lang === 'it' ? 'Invia un promemoria o una parola di incoraggiamento alla tua downline!' : 'Send a reminder or words of encouragement to your downline!';
      }

      emptyDiv.innerHTML = `
        <span style="font-size: 36px; display: block; margin-bottom: 10px;">${activeChan.avatar || '💬'}</span>
        <p style="font-size: 14px; font-weight: 700; color: var(--text-primary); margin-bottom: 4px;">${emptyTitle}</p>
        <p style="font-size: 12px; line-height: 1.5;">${emptySub}</p>
      `;
      box.appendChild(emptyDiv);
      return;
    }

    let lastRow = null;
    validMessages.forEach((msg) => {
      try {
        const isCurrentUser = (msg.userId && msg.userId === currentUserId) || msg.isUser || (!msg.bot && currentUserName && String(msg.sender || "").trim().toLowerCase() === currentUserName);
        const isCoach = !!msg.bot || msg.sender_role === 'coach' || msg.sender_role === 'super_admin';

        const row = document.createElement("div");
        row.className = `wa-message-row ${isCoach && !isCurrentUser ? 'coach' : (isCurrentUser ? 'sent' : 'received')}`;
        
        let senderName = msg.sender || (state.lang === 'it' ? "Sfidante" : "Challenger");
        if (msg.bot) senderName = "🌟 Coach Herbalife";
        else if (msg.sender_role === 'super_admin') senderName = `👑 ${senderName} (Super Admin)`;
        else if (msg.sender_role === 'coach') senderName = `🌟 ${senderName} (Coach)`;

        let attachmentHtml = "";
        if (msg.attachment) {
          attachmentHtml = `<img src="${msg.attachment}" class="wa-message-image" alt="Foto condivisa" onclick="window.open(this.src)">`;
        }

        const timeStr = msg.time || (msg.created_at ? new Date(msg.created_at).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }) : "12:00");
        const ticksHtml = isCurrentUser ? `<span class="wa-ticks">✓✓</span>` : "";

        row.innerHTML = `
          <div class="wa-message-bubble">
            ${!isCurrentUser ? `<div class="wa-sender-header"><span class="wa-sender-name">${senderName}</span></div>` : ''}
            ${attachmentHtml}
            <p class="wa-message-text">${msg.text || ""}</p>
            <div class="wa-message-meta">
              <span class="wa-message-time">${timeStr}</span>
              ${ticksHtml}
            </div>
          </div>
        `;

        box.appendChild(row);
        lastRow = row;
      } catch (cardErr) {
        console.warn("[CommunityChat] Card render notice:", cardErr);
      }
    });
    
    scrollToChatBottom();
  } catch (err) {
    console.warn("[CommunityChat] Render error:", err);
  }
};

let lastCommunityFetchTs = 0;
let communityChatPollingInterval = null;

const fetchCommunityMessages = async () => {
  const now = Date.now();
  if (now - lastCommunityFetchTs < 1500) return;
  lastCommunityFetchTs = now;

  const currentUserId = state.userId || getUserId();
  state.userId = currentUserId;
  const storeId = getStoreId();
  const activeChan = getActiveChatChannel();

  try {
    const apiUrl = `${API_BASE_URL}/community?store_id=${storeId}&channel_type=${activeChan.type}&channel_id=${encodeURIComponent(activeChan.id)}&user_email=${encodeURIComponent(state.profile?.email || '')}&coach_id=${encodeURIComponent(state.profile?.myHerbalifeId || '')}`;
    const res = await fetch(apiUrl, { cache: 'no-store' });
    if (res.ok) {
      const data = await res.json();
      if (data && data.success && Array.isArray(data.messages)) {
        const cloudMessages = data.messages.map((m) => ({
          ...m,
          isUser: m.userId === currentUserId || (state.profile?.email && m.sender_email && m.sender_email.toLowerCase() === state.profile.email.toLowerCase())
        }));
        const merged = mergeCommunityMessages(state.communityMessages || [], cloudMessages);
        state.communityMessages = merged;
        saveStateToStorage();
        renderCommunityChat();
      }
    }
  } catch (err) {
    console.warn("[CommunityChat] Fetch notice:", err);
  }
};

const startCommunityChatPolling = () => {
  if (communityChatPollingInterval) clearInterval(communityChatPollingInterval);
  // Initial one-time fetch on launch
  fetchCommunityMessages();

  // Intelligent fallback interval: 60s (60000ms) ONLY when tab is visible
  communityChatPollingInterval = setInterval(() => {
    if (typeof document !== 'undefined' && document.visibilityState === 'visible') {
      fetchCommunityMessages();
    }
  }, 60000);

  // Sync on tab focus / visibilitychange
  if (typeof window !== 'undefined' && !window._p10VisibilityBound) {
    window._p10VisibilityBound = true;
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        fetchCommunityMessages();
      }
    });
  }
};

// ==========================================
// BULLETPROOF ATOMIC CHAT SUBMISSION HANDLER
// ==========================================
let tempAttachment = null;

window.submitCommunityChatMessage = async function() {
  const input = document.getElementById("community-chat-input-field");
  if (!input) return;

  const query = input.value ? input.value.trim() : "";
  if (!query && !tempAttachment) return;

  // 1. Reset inputs IMMEDIATELY so UI feels instant
  input.value = "";
  const attachmentToSend = tempAttachment;
  tempAttachment = null;
  const previewBar = document.getElementById("wa-attachment-preview-bar");
  if (previewBar) previewBar.style.display = "none";
  const photoInput = document.getElementById("community-chat-photo-input");
  if (photoInput) photoInput.value = "";
  const photoBtn = document.getElementById("community-chat-photo-btn");
  if (photoBtn) photoBtn.style.color = "#8696a0";

  const currentUserId = state.userId || getUserId();
  state.userId = currentUserId;
  const userName = (state.profile && state.profile.name && String(state.profile.name).trim() !== "") 
    ? String(state.profile.name).trim() 
    : (state.lang === 'it' ? "Sfidante" : "Challenger");
  const userAvatar = (state.profile && state.profile.avatar) ? state.profile.avatar : "👤";
  const userPhoto = (state.profile && state.profile.photo) ? state.profile.photo : null;
  const userEmail = (state.profile && state.profile.email) ? state.profile.email.toLowerCase().trim() : null;
  const nowTs = Date.now();
  const timeStr = new Date().toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  const storeId = getStoreId();
  const activeChan = getActiveChatChannel();

  const isSuperAdminUser = isCurrentSuperAdmin();
  const userRole = isSuperAdminUser ? 'super_admin' : ((state.profile && state.profile.isDistributor) ? 'coach' : 'sfidante');

  const newMsg = {
    id: nowTs,
    userId: currentUserId,
    sender: userName,
    avatar: userAvatar,
    photo: userPhoto,
    sender_email: userEmail,
    sender_role: userRole,
    channel_type: activeChan.type,
    channel_id: activeChan.id,
    recipient_email: activeChan.recipient_email || null,
    recipient_coach_id: activeChan.recipient_coach_id || null,
    sender_coach_id: state.profile?.myHerbalifeId || null,
    text: query || (attachmentToSend ? "📸 [Foto]" : ""),
    attachment: attachmentToSend,
    bot: false,
    isUser: true,
    time: timeStr,
    timestamp: nowTs
  };

  // 2. Direct DOM append for 100% Guaranteed Instant Visual Feedback
  try {
    if (!Array.isArray(state.communityMessages)) {
      state.communityMessages = [];
    }
    state.communityMessages.push(newMsg);

    const box = document.getElementById("community-messages-box");
    if (box) {
      const row = document.createElement("div");
      row.className = "wa-message-row sent";
      let attachmentHtml = "";
      if (newMsg.attachment) {
        attachmentHtml = `<img src="${newMsg.attachment}" class="wa-message-image" alt="Foto condivisa" onclick="window.open(this.src)">`;
      }
      row.innerHTML = `
        <div class="wa-message-bubble">
          ${attachmentHtml}
          <p class="wa-message-text">${newMsg.text || ""}</p>
          <div class="wa-message-meta">
            <span class="wa-message-time">${timeStr}</span>
            <span class="wa-ticks">✓✓</span>
          </div>
        </div>
      `;
      box.appendChild(row);
      scrollToChatBottom();
    } else {
      renderCommunityChat();
    }
  } catch (renderErr) {
    console.warn("[CommunityChat] Direct render error:", renderErr);
  }

  // Safe local storage update
  try {
    saveStateToStorage();
  } catch (storeErr) {
    console.warn("[CommunityChat] Local storage notice:", storeErr);
  }

  // Audio feedback
  try { playMessageSentSound(); } catch (e) {}

  // 3. Instant Broadcast via Supabase Realtime to other peers
  try {
    if (realtimeChatChannel) {
      realtimeChatChannel.send({
        type: 'broadcast',
        event: 'new_chat_message',
        payload: {
          ...newMsg,
          isUser: false
        }
      });
    }
  } catch (wsErr) {
    console.warn("[Supabase Realtime] Broadcast notice:", wsErr);
  }

  // 4. Single Serverless Proxy Save to Supabase DB (/api/program10/community)
  try {
    const postPayload = {
      store_id: storeId,
      userId: currentUserId,
      sender: userName,
      avatar: userAvatar,
      photo: userPhoto,
      sender_email: userEmail,
      sender_role: userRole,
      channel_type: activeChan.type,
      channel_id: activeChan.id,
      recipient_email: activeChan.recipient_email || null,
      recipient_coach_id: activeChan.recipient_coach_id || null,
      sender_coach_id: state.profile?.myHerbalifeId || null,
      text: newMsg.text,
      attachment: attachmentToSend,
      bot: false,
      time: timeStr,
      timestamp: nowTs
    };
    const apiUrl = `${API_BASE_URL}/community`;
    fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(postPayload)
    }).then(r => r.json()).then(res => {
      if (res && res.success && res.message) {
        newMsg.id = res.message.id;
        try { saveStateToStorage(); } catch (_) {}
      }
    }).catch(e => console.warn("[CommunityChat] Backend save catch:", e));
  } catch (err) {
    console.warn("[CommunityChat] Proxy Save notice:", err);
  }
};

const initCommunityChat = () => {
  const input = document.getElementById("community-chat-input-field");
  const photoBtn = document.getElementById("community-chat-photo-btn");
  const photoInput = document.getElementById("community-chat-photo-input");
  const previewBar = document.getElementById("wa-attachment-preview-bar");
  const previewThumb = document.getElementById("wa-preview-thumb");
  const cancelAttachmentBtn = document.getElementById("wa-cancel-attachment");
  const refreshBtn = document.getElementById("wa-refresh-btn");
  const sendBtn = document.getElementById("wa-send-btn");
  
  const toggleChannelsBtn = document.getElementById("wa-toggle-channels-btn");
  const closeChannelsBtn = document.getElementById("close-channels-sidebar-btn");
  const channelsSidebar = document.getElementById("community-channels-sidebar");
  let originalSidebarParent = channelsSidebar ? channelsSidebar.parentNode : null;
  let originalSidebarSibling = channelsSidebar ? channelsSidebar.nextSibling : null;

  const openChannelsDrawer = () => {
    if (!channelsSidebar) return;
    if (!originalSidebarParent && channelsSidebar.parentNode) {
      originalSidebarParent = channelsSidebar.parentNode;
      originalSidebarSibling = channelsSidebar.nextSibling;
    }
    
    // Move channelsSidebar directly under body so it is completely above any backdrop and not dimmed
    if (channelsSidebar.parentNode !== document.body) {
      document.body.appendChild(channelsSidebar);
    }

    let backdrop = document.getElementById("channels-backdrop");
    if (!backdrop) {
      backdrop = document.createElement("div");
      backdrop.id = "channels-backdrop";
      backdrop.className = "channels-backdrop";
      backdrop.onclick = closeChannelsDrawer;
      document.body.insertBefore(backdrop, channelsSidebar);
    }

    channelsSidebar.classList.add("mobile-open");
  };

  const closeChannelsDrawer = () => {
    if (channelsSidebar) channelsSidebar.classList.remove("mobile-open");
    const backdrop = document.getElementById("channels-backdrop");
    if (backdrop) backdrop.remove();
  };

  window.addEventListener("resize", () => {
    if (window.innerWidth > 992) {
      closeChannelsDrawer();
      if (channelsSidebar && originalSidebarParent && channelsSidebar.parentNode === document.body) {
        if (originalSidebarSibling) {
          originalSidebarParent.insertBefore(channelsSidebar, originalSidebarSibling);
        } else {
          originalSidebarParent.appendChild(channelsSidebar);
        }
      }
    }
  });

  if (toggleChannelsBtn) {
    toggleChannelsBtn.onclick = (e) => {
      e.preventDefault();
      if (channelsSidebar && channelsSidebar.classList.contains("mobile-open")) {
        closeChannelsDrawer();
      } else {
        openChannelsDrawer();
      }
    };
  }

  if (closeChannelsBtn) {
    closeChannelsBtn.onclick = (e) => {
      e.preventDefault();
      closeChannelsDrawer();
    };
  }

  if (refreshBtn) {
    refreshBtn.onclick = () => {
      fetchCommunityMessages();
      try { playMessageSentSound(); } catch (e) {}
    };
  }

  const triggerSubmit = (e) => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
      e.stopPropagation();
    }
    window.submitCommunityChatMessage();
  };

  if (sendBtn) {
    sendBtn.onclick = triggerSubmit;
  }

  if (input) {
    input.onkeydown = (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        triggerSubmit(e);
      }
    };
  }
  
  if (photoBtn && photoInput) {
    photoBtn.addEventListener("click", () => {
      photoInput.click();
    });
    
    photoInput.addEventListener("change", (e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const maxDim = 800;
            let width = img.width;
            let height = img.height;
            if (width > height && width > maxDim) {
              height = Math.round((height * maxDim) / width);
              width = maxDim;
            } else if (height > maxDim) {
              width = Math.round((width * maxDim) / height);
              height = maxDim;
            }
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            tempAttachment = canvas.toDataURL("image/jpeg", 0.80);
            
            if (previewBar && previewThumb) {
              previewThumb.src = tempAttachment;
              previewBar.style.display = "flex";
            }
            if (input) input.focus();
          };
          img.src = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    });
  }

  if (cancelAttachmentBtn) {
    cancelAttachmentBtn.addEventListener("click", () => {
      tempAttachment = null;
      if (previewBar) previewBar.style.display = "none";
      if (photoInput) photoInput.value = "";
    });
  }

  // Render initial channel list & fetch contacts
  fetchCoachDownlineContacts().then(() => {
    if (typeof renderChatChannelsList === "function") renderChatChannelsList();
  });

  // Start Realtime WebSocket & Polling
  subscribeToCommunityChatRealtime();
};

// ==========================================
// SVG PROGRESS CHARTS & BIO-METRICS RENDERING
// ==========================================

const updateProgressProfileCardUI = () => {
  const p = state.profile || {};
  const dict = TRANSLATIONS[state.lang] || TRANSLATIONS.it;
  const activeLog = state.dailyLogs ? state.dailyLogs[state.activeDay - 1] : null;

  // 1. Avatar
  const avatarEl = document.getElementById("progress-client-avatar");
  if (avatarEl) {
    if (p.photo) {
      avatarEl.innerHTML = `<img src="${p.photo}" style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover;">`;
    } else {
      avatarEl.textContent = p.avatar || "👤";
    }
  }

  // 2. Client Name
  const nameEl = document.getElementById("progress-client-name");
  if (nameEl) {
    nameEl.textContent = p.name || (state.lang === "it" ? "Sfidante" : "Challenger");
  }

  // 3. Subtitle (Gender / Age / Height)
  const subEl = document.getElementById("progress-client-subtitle");
  if (subEl) {
    const genderKey = (p.gender || p.bodyShape || '').toLowerCase();
    let genderStr = "";
    if (genderKey === "donna" || genderKey === "female") genderStr = state.lang === "it" ? "Donna" : "Female";
    else if (genderKey === "uomo" || genderKey === "male") genderStr = state.lang === "it" ? "Uomo" : "Male";
    
    const ageStr = p.age ? `${p.age} ${dict.lbl_years || (state.lang === 'it' ? 'anni' : 'years')}` : "";
    const heightStr = `${dict.lbl_height || (state.lang === 'it' ? 'Altezza' : 'Height')}: ${p.height || 170} cm`;
    const parts = [genderStr, ageStr, heightStr].filter(Boolean);
    subEl.textContent = parts.length > 0 ? parts.join(" | ") : `${dict.lbl_height || 'Height'}: ${p.height || 170} cm`;
  }

  // 4. Days Completed Badge
  const daysBadge = document.getElementById("progress-client-days-badge");
  if (daysBadge) {
    const completedCount = Array.isArray(state.dailyLogs) 
      ? state.dailyLogs.filter(l => (typeof calculateDailyScore === 'function' ? calculateDailyScore(l) : 0) >= 60).length 
      : 0;
    daysBadge.textContent = `${completedCount}/10 ${dict.lbl_days || (state.lang === 'it' ? 'Giorni' : 'Days')}`;
  }

  // 5. BMI Calculation & Badge
  const startW = parseFloat(p.startWeight || 70);
  const currentW = (activeLog && activeLog.weight !== null && !isNaN(parseFloat(activeLog.weight)))
    ? parseFloat(activeLog.weight)
    : startW;
  const heightM = (parseFloat(p.height || 170)) / 100;
  const bmi = currentW / (heightM * heightM);

  const bmiBadge = document.getElementById("progress-client-bmi-badge");
  if (bmiBadge) {
    bmiBadge.textContent = `BMI ${bmi.toFixed(1)}`;
  }

  // 6. Metric: Weights (Starting -> Current)
  const weightsMetric = document.getElementById("progress-metric-weights");
  if (weightsMetric) {
    const diff = startW - currentW;
    const diffStr = diff > 0 ? ` (-${diff.toFixed(1)} kg)` : (diff < 0 ? ` (+${Math.abs(diff).toFixed(1)} kg)` : '');
    weightsMetric.textContent = `${startW.toFixed(1)} ➔ ${currentW.toFixed(1)} kg${diffStr}`;
  }

  // 7. Metric: Target Weight
  const targetMetric = document.getElementById("progress-metric-target");
  if (targetMetric) {
    const targetW = parseFloat(p.targetWeight || startW);
    targetMetric.textContent = `${targetW.toFixed(1)} kg`;
  }

  // 8. Metric: BMR / TDEE
  const metabolismMetric = document.getElementById("progress-metric-metabolism");
  if (metabolismMetric) {
    const bmr = Math.round((10 * currentW) + (6.25 * (p.height || 170)) - (5 * 30));
    let mult = 1.2;
    if (p.lifestyleType === "moderato") mult = 1.4;
    else if (p.lifestyleType === "attivo") mult = 1.6;
    let gymBonus = 0;
    if (p.gymFrequency === "1-2_volte") gymBonus = 100;
    else if (p.gymFrequency === "3-4_volte") gymBonus = 200;
    else if (p.gymFrequency === "quotidiana") gymBonus = 350;
    const tdee = Math.round((bmr * mult) + gymBonus);
    metabolismMetric.textContent = `${bmr} / ${tdee} kcal`;
  }

  // 9. Metric: Daily Calorie Target
  const deficitMetric = document.getElementById("progress-metric-deficit");
  if (deficitMetric) {
    const bmr = Math.round((10 * currentW) + (6.25 * (p.height || 170)) - (5 * 30));
    let mult = 1.2;
    if (p.lifestyleType === "moderato") mult = 1.4;
    else if (p.lifestyleType === "attivo") mult = 1.6;
    let gymBonus = 0;
    if (p.gymFrequency === "1-2_volte") gymBonus = 100;
    else if (p.gymFrequency === "3-4_volte") gymBonus = 200;
    else if (p.gymFrequency === "quotidiana") gymBonus = 350;
    const tdee = Math.round((bmr * mult) + gymBonus);
    let adj = 0;
    const targetW = parseFloat(p.targetWeight || startW);
    if (targetW < startW) adj = -400;
    else if (targetW > startW) adj = 200;
    const targetCal = Math.max(1200, Math.round(tdee + adj));
    deficitMetric.textContent = `${targetCal} kcal/${state.lang === 'it' ? 'die' : 'day'}`;
  }

  // 10. Metric: Measures (Chest / Waist / Hips)
  const measuresMetric = document.getElementById("progress-metric-measures");
  if (measuresMetric) {
    const c = p.chest ? `${p.chest}` : '--';
    const w = p.waist ? `${p.waist}` : '--';
    const h = p.hips ? `${p.hips}` : '--';
    measuresMetric.textContent = `${c} / ${w} / ${h} cm`;
  }

  // 11. Metric: Lifestyle & Sport
  const lifestyleMetric = document.getElementById("progress-metric-lifestyle");
  if (lifestyleMetric) {
    const lifeLabels = {
      "sedentario": state.lang === 'it' ? 'Sedentario' : 'Sedentary',
      "moderato": state.lang === 'it' ? 'Moderato' : 'Moderate',
      "attivo": state.lang === 'it' ? 'Attivo' : 'Active'
    };
    const gymLabels = {
      "nessuna": state.lang === 'it' ? 'Nessuna' : 'None',
      "1-2_volte": "1-2x/week",
      "3-4_volte": "3-4x/week",
      "quotidiana": state.lang === 'it' ? 'Quotidiana' : 'Daily'
    };
    const life = lifeLabels[p.lifestyleType] || (p.lifestyleType ? (p.lifestyleType.charAt(0).toUpperCase() + p.lifestyleType.slice(1)) : (state.lang === 'it' ? 'Sedentario' : 'Sedentary'));
    const gym = gymLabels[p.gymFrequency] || (p.gymFrequency ? p.gymFrequency.replace('_', ' ') : (state.lang === 'it' ? 'Nessuna' : 'None'));
    lifestyleMetric.textContent = `${life} | ${gym}`;
  }
};

const renderCharts = () => {
  updateProgressProfileCardUI();
  renderWeightChart();
  renderWaterChart();
};

const renderWeightChart = () => {
  const svg = document.getElementById("weight-svg-chart");
  const emptyState = document.getElementById("weight-chart-empty");
  if (!svg || !emptyState) return;
  svg.innerHTML = "";
  
  const startWeight = parseFloat(state.profile.startWeight || 70);
  const weights = [];
  state.dailyLogs.forEach((log, idx) => {
    if (log.weight !== null && !isNaN(parseFloat(log.weight))) {
      weights.push({ day: idx + 1, val: parseFloat(log.weight) });
    }
  });

  if (weights.length === 0) {
    emptyState.style.display = "flex";
    return;
  }
  
  emptyState.style.display = "none";
  
  // Construct points starting from baseline/day 1
  const points = [];
  const hasDay1 = weights.some(w => w.day === 1);
  if (!hasDay1) {
    points.push({ day: 1, val: startWeight, isStart: true });
  }
  weights.forEach(w => points.push(w));
  points.sort((a, b) => a.day - b.day);

  const weightValues = points.map(w => w.val);
  weightValues.push(startWeight);
  
  const minW = Math.min(...weightValues) - 0.5;
  const maxW = Math.max(...weightValues) + 0.5;
  const weightRange = Math.max(1, maxW - minW);

  const width = 500;
  const height = 200;
  const paddingX = 45;
  const paddingY = 25;
  
  const getX = (day) => paddingX + ((day - 1) / 9) * (width - paddingX * 2);
  const getY = (w) => height - paddingY - ((w - minW) / weightRange) * (height - paddingY * 2);

  // y-axis ticks
  const steps = 4;
  for (let i = 0; i <= steps; i++) {
    const wVal = minW + (weightRange / steps) * i;
    const y = getY(wVal);
    
    const gridLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
    gridLine.setAttribute("x1", paddingX);
    gridLine.setAttribute("y1", y);
    gridLine.setAttribute("x2", width - paddingX);
    gridLine.setAttribute("y2", y);
    gridLine.setAttribute("class", "chart-grid-line");
    svg.appendChild(gridLine);

    const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
    text.setAttribute("x", paddingX - 10);
    text.setAttribute("y", y + 3);
    text.setAttribute("text-anchor", "end");
    text.setAttribute("class", "chart-axis-text");
    text.textContent = `${wVal.toFixed(1)} kg`;
    svg.appendChild(text);
  }

  // x-axis
  const dayPrefix = state.lang === 'ro' ? 'Z' : (state.lang === 'it' ? 'G' : 'D');
  const dayWord = state.lang === 'it' ? 'Giorno' : (state.lang === 'ro' ? 'Ziua' : (state.lang === 'es' ? 'Día' : 'Day'));

  for (let d = 1; d <= 10; d++) {
    const x = getX(d);
    
    const gridLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
    gridLine.setAttribute("x1", x);
    gridLine.setAttribute("y1", paddingY);
    gridLine.setAttribute("x2", x);
    gridLine.setAttribute("y2", height - paddingY);
    gridLine.setAttribute("class", "chart-grid-line");
    svg.appendChild(gridLine);

    const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
    text.setAttribute("x", x);
    text.setAttribute("y", height - paddingY + 14);
    text.setAttribute("text-anchor", "middle");
    text.setAttribute("class", "chart-axis-text");
    text.textContent = `${dayPrefix}${d}`;
    svg.appendChild(text);
  }

  let pathStr = "";
  let areaStr = `M ${getX(points[0].day)} ${height - paddingY}`;
  
  points.forEach((p, idx) => {
    const x = getX(p.day);
    const y = getY(p.val);
    
    if (idx === 0) {
      pathStr += `M ${x} ${y}`;
    } else {
      pathStr += ` L ${x} ${y}`;
    }
    areaStr += ` L ${x} ${y}`;
  });

  areaStr += ` L ${getX(points[points.length - 1].day)} ${height - paddingY} Z`;

  const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
  defs.innerHTML = `
    <linearGradient id="weight-gradient" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="var(--primary)" stop-opacity="0.3"/>
      <stop offset="100%" stop-color="var(--primary)" stop-opacity="0.0"/>
    </linearGradient>
  `;
  svg.appendChild(defs);

  const areaPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
  areaPath.setAttribute("d", areaStr);
  areaPath.setAttribute("class", "chart-area-weight");
  svg.appendChild(areaPath);

  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute("d", pathStr);
  path.setAttribute("class", "chart-path-weight");
  svg.appendChild(path);

  points.forEach(p => {
    const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    circle.setAttribute("cx", getX(p.day));
    circle.setAttribute("cy", getY(p.val));
    circle.setAttribute("r", 5);
    circle.setAttribute("class", "chart-dot-weight");
    
    const title = document.createElementNS("http://www.w3.org/2000/svg", "title");
    title.textContent = `${dayWord} ${p.day}: ${p.val.toFixed(1)} kg`;
    circle.appendChild(title);
    
    svg.appendChild(circle);
  });
};

const renderWaterChart = () => {
  const svg = document.getElementById("water-svg-chart");
  const emptyState = document.getElementById("water-chart-empty");
  if (!svg || !emptyState) return;
  svg.innerHTML = "";

  const dayPrefix = state.lang === 'ro' ? 'Z' : (state.lang === 'it' ? 'G' : 'D');
  const dayWord = state.lang === 'it' ? 'Giorno' : (state.lang === 'ro' ? 'Ziua' : (state.lang === 'es' ? 'Día' : 'Day'));

  // Update target subtitle dynamically
  const waterSubEl = document.querySelector('[data-i18n="chart_water_sub"]');
  if (waterSubEl) {
    const prefix = state.lang === 'it' ? 'Target' : (state.lang === 'es' ? 'Objetivo' : (state.lang === 'ro' ? 'Țintă' : 'Target'));
    const unit = state.lang === 'it' ? 'Litri' : (state.lang === 'es' ? 'Litros' : (state.lang === 'ro' ? 'Litri' : 'Liters'));
    waterSubEl.textContent = `${prefix}: ${(state.profile.waterGoal || 2.5).toFixed(1)} ${unit}`;
  }
  
  const hasWater = state.dailyLogs.some(log => log.water > 0);
  if (!hasWater) {
    emptyState.style.display = "flex";
    return;
  }
  
  emptyState.style.display = "none";

  const width = 500;
  const height = 200;
  const paddingX = 40;
  const paddingY = 20;

  const targetWater = (state.profile.waterGoal || 2.5) * 1000;
  const maxVal = Math.max(targetWater, ...state.dailyLogs.map(log => log.water)) + 250;

  const getX = (day) => paddingX + ((day - 1) / 10) * (width - paddingX * 2);
  const getBarHeight = (ml) => (ml / maxVal) * (height - paddingY * 2);
  
  const targetY = height - paddingY - getBarHeight(targetWater);
  const targetLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
  targetLine.setAttribute("x1", paddingX);
  targetLine.setAttribute("y1", targetY);
  targetLine.setAttribute("x2", width - paddingX);
  targetLine.setAttribute("y2", targetY);
  targetLine.setAttribute("stroke", "var(--primary)");
  targetLine.setAttribute("stroke-width", "1.5");
  targetLine.setAttribute("stroke-dasharray", "4,3");
  svg.appendChild(targetLine);

  const targetText = document.createElementNS("http://www.w3.org/2000/svg", "text");
  targetText.setAttribute("x", width - paddingX + 5);
  targetText.setAttribute("y", targetY + 3);
  targetText.setAttribute("fill", "var(--primary)");
  targetText.setAttribute("font-size", "7px");
  targetText.setAttribute("font-weight", "bold");
  targetText.textContent = `${(state.profile.waterGoal || 2.5).toFixed(1)}L`;
  svg.appendChild(targetText);

  const steps = 4;
  for (let i = 0; i <= steps; i++) {
    const ml = (maxVal / steps) * i;
    const y = height - paddingY - getBarHeight(ml);
    
    const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
    text.setAttribute("x", paddingX - 8);
    text.setAttribute("y", y + 3);
    text.setAttribute("text-anchor", "end");
    text.setAttribute("class", "chart-axis-text");
    text.textContent = `${(ml/1000).toFixed(1)}L`;
    svg.appendChild(text);
  }

  const totalDays = 10;
  const barWidth = 24;
  
  for (let d = 1; d <= totalDays; d++) {
    const log = state.dailyLogs[d - 1];
    const x = getX(d) + (width - paddingX * 2) / 20 - barWidth / 2;
    
    const barBg = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    barBg.setAttribute("x", x);
    barBg.setAttribute("y", paddingY);
    barBg.setAttribute("width", barWidth);
    barBg.setAttribute("height", height - paddingY * 2);
    barBg.setAttribute("class", "chart-bar-water-bg");
    svg.appendChild(barBg);

    const ml = log.water;
    if (ml > 0) {
      const barH = getBarHeight(ml);
      const barY = height - paddingY - barH;
      
      const bar = document.createElementNS("http://www.w3.org/2000/svg", "rect");
      bar.setAttribute("x", x);
      bar.setAttribute("y", barY);
      bar.setAttribute("width", barWidth);
      bar.setAttribute("height", barH);
      bar.setAttribute("class", "chart-bar-water");
      if (ml >= targetWater) {
        bar.setAttribute("fill", "var(--primary)");
      } else {
        bar.setAttribute("fill", "var(--primary-glow)");
      }
      
      const title = document.createElementNS("http://www.w3.org/2000/svg", "title");
      title.textContent = `${dayWord} ${d}: ${(ml/1000).toFixed(2)}L`;
      bar.appendChild(title);
      
      svg.appendChild(bar);
    }

    const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
    text.setAttribute("x", x + barWidth / 2);
    text.setAttribute("y", height - paddingY + 12);
    text.setAttribute("text-anchor", "middle");
    text.setAttribute("class", "chart-axis-text");
    text.textContent = `${dayPrefix}${d}`;
    svg.appendChild(text);
  }
};

const updateNutritionalStrategyUI = () => {
  const p = state.profile || {};
  const activeLog = (state.dailyLogs && state.dailyLogs[state.activeDay - 1]) || null;
  const currentWeight = (activeLog && activeLog.weight !== null) ? parseFloat(activeLog.weight) : parseFloat(p.startWeight || 70);
  const caloricProfile = getUserCaloricProfile(p, currentWeight);
  const bmi = caloricProfile.bmi;

  let bmiStatus = "Normale";
  let bmiClass = "success";
  let bmiColor = "#2ecc71";

  if (bmi < 18.5) {
    bmiStatus = state.lang === "it" ? "Sottopeso" : (state.lang === "ro" ? "Subponderal" : "Underweight");
    bmiClass = "info";
    bmiColor = "#3498db";
  } else if (bmi < 25) {
    bmiStatus = state.lang === "it" ? "Normale" : (state.lang === "ro" ? "Normal" : "Normal");
    bmiClass = "success";
    bmiColor = "#2ecc71";
  } else if (bmi < 30) {
    bmiStatus = state.lang === "it" ? "Sovrappeso" : (state.lang === "ro" ? "Supraponderal" : "Overweight");
    bmiClass = "warning";
    bmiColor = "#f1c40f";
  } else {
    bmiStatus = state.lang === "it" ? "Obesità" : (state.lang === "ro" ? "Obezitate" : "Obese");
    bmiClass = "danger";
    bmiColor = "#e74c3c";
  }

  const imcValEl = document.getElementById("strategy-imc-value");
  if (imcValEl) imcValEl.textContent = bmi.toFixed(1);
  const statusBadge = document.getElementById("strategy-imc-status");
  if (statusBadge) {
    statusBadge.textContent = bmiStatus;
    statusBadge.className = `badge ${bmiClass}`;
  }

  const indicator = document.getElementById("strategy-imc-indicator");
  if (indicator) {
    let pct = ((bmi - 15) / (35 - 15)) * 100;
    pct = Math.max(3, Math.min(97, pct));
    indicator.style.left = `${pct}%`;
    indicator.style.borderColor = bmiColor;
  }

  const targetCalories = caloricProfile.targetCalories;
  const calValEl = document.getElementById("strategy-calories-value");
  if (calValEl) calValEl.textContent = `${targetCalories} kcal`;

  const { pPct, cPct, fPct, proteinG, carbsG, fatsG } = caloricProfile.macros;

  const protValEl = document.getElementById("strategy-protein-value");
  if (protValEl) protValEl.textContent = `${proteinG}g (${pPct}%)`;
  const protBarEl = document.getElementById("strategy-protein-bar");
  if (protBarEl) protBarEl.style.width = `${pPct}%`;

  const carbValEl = document.getElementById("strategy-carbs-value");
  if (carbValEl) carbValEl.textContent = `${carbsG}g (${cPct}%)`;
  const carbBarEl = document.getElementById("strategy-carbs-bar");
  if (carbBarEl) carbBarEl.style.width = `${cPct}%`;

  const fatValEl = document.getElementById("strategy-fats-value");
  if (fatValEl) fatValEl.textContent = `${fatsG}g (${fPct}%)`;
  const fatBarEl = document.getElementById("strategy-fats-bar");
  if (fatBarEl) fatBarEl.style.width = `${fPct}%`;

  const goal = caloricProfile.goal;
  const recommendations = {
    it: {
      weight_loss: {
        strategy: "La tua strategia è il **Deficit Calorico Mirato (-" + caloricProfile.deficit + " kcal)** per stimolare la lipolisi e sgonfiare l'addome preservando la massa magra. Integra con 2 Shake Formula 1 + PDM, Infuso Termogenico e Phyto Complete.",
        recFoods: [
          "Verdure a foglia verde e ortaggi a basso indice glicemico (50% del piatto) 🥗",
          "Proteine nobili: petto di pollo, tacchino, salmone, uova, tofu e PDM 🥩",
          "Carboidrati complessi controllati: quinoa, riso basmati, avena integrale 🍚",
          "Grassi sani: olio EVO a crudo, avocado e semi di lino in dosi misurate 🥑"
        ],
        avoidFoods: [
          "Zuccheri raffinati, dolci industriali e bevande gassate zuccherate 🚫",
          "Farine bianche ultra-processate e cibi fritti 🍟",
          "Alcolici e superalcolici (bloccano la lipolisi epatica) 🍷",
          "Snack iper-salati che favoriscono la ritenzione idrica 🥨"
        ]
      },
      energy_vitality: {
        strategy: "La tua strategia è la **Ricarica Mitocondriale & Idratazione Cellulare**. Formula 1 a colazione per stabilizzare la glicemia, AloeMax per la depurazione digestiva, Infuso per focus costante e Mineral Complex per l'equilibrio elettrolitico.",
        recFoods: [
          "Alimenti freschi ad alta densità vitaminica e clorofilla 🥦",
          "Frutti di bosco e agrumi ricchi di antiossidanti naturali 🫐",
          "Cereali integrali a lento rilascio energetico (farro, avena) 🌾",
          "Idratazione profonda: 2.5L d'acqua con AloeMax e Mineral Complex 💧"
        ],
        avoidFoods: [
          "Eccesso di caffeina da caffè torrefatto (causa crash pomeridiano) ☕",
          "Pasti pesanti a pranzo ricchi di grassi saturi che inducono sonnolenza 🍔",
          "Zuccheri semplici e dolcificanti sintetici infiammatori 🍬",
          "Saltare i pasti o spuntini (crea cali di concentrazione) ⏳"
        ]
      },
      muscle_tone: {
        strategy: "La tua strategia è il **Supporto Anabolico Pulito & Sintesi Proteica (1.8-2.2g/kg)**. Colazione Formula 1 + 2 misurini PDM, peri-workout con CR7 Drive, recupero immediato con H24 Rebuild Strength e Omega-3 Herbalifeline Max.",
        recFoods: [
          "Proteine nobili ad alto valore biologico (uova, salmone, pollo, shake H24) 🍳",
          "Carboidrati puliti per il ripristino del glicogeno (riso, patate dolci, avena) 🥔",
          "Acidi grassi essenziali Omega-3 per il recupero muscolare (Herbalifeline Max) 🐟",
          "Spuntini ad alta densità proteica (Protein Bar, Protein Chips) 🍫"
        ],
        avoidFoods: [
          "Alcolici (compromettono fino al 70% della sintesi proteica notturna) 🍺",
          "Digiuni prolungati non pianificati che innescano il catabolismo muscolare 📉",
          "Cibi spazzatura ad alto contenuto di grassi idrogenati 🍩",
          "Disidratazione durante le sessioni di allenamento 🏜️"
        ]
      }
    },
    en: {
      weight_loss: {
        strategy: "Your core strategy is **Targeted Caloric Deficit (-" + caloricProfile.deficit + " kcal)** to accelerate fat burning and debloat while preserving muscle. Power up with 2 Formula 1 Shakes + PDM, Herbal Tea, and Phyto Complete.",
        recFoods: [
          "Leafy greens and low-GI seasonal vegetables (50% of your plate) 🥗",
          "Clean lean proteins: chicken breast, salmon, eggs, tofu, PDM 🥩",
          "Portion-controlled complex carbs: quinoa, basmati rice, rolled oats 🍚",
          "Healthy fats: extra virgin olive oil, avocado, flaxseeds 🥑"
        ],
        avoidFoods: [
          "Refined sugars, pastries, and sugary sodas 🚫",
          "Deep-fried foods and ultra-processed white flour products 🍟",
          "Alcoholic drinks (halting liver fat oxidation) 🍷",
          "Excess sodium snacks triggering fluid retention 🥨"
        ]
      },
      energy_vitality: {
        strategy: "Your core strategy is **Cellular Mitochondrial Vitality & Deep Hydration**. Formula 1 Shake for morning blood-sugar stability, AloeMax for gut vitality, Herbal Tea for smooth focus, and Mineral Complex for electrolytes.",
        recFoods: [
          "Nutrient-dense fresh produce and antioxidant-rich berries 🫐",
          "Slow-burning whole grains (oats, spelt, brown rice) 🌾",
          "Digestible lean proteins without post-lunch food coma 🐟",
          "Electrolyte hydration: 2.5L water with AloeMax and Mineral Complex 💧"
        ],
        avoidFoods: [
          "Excessive espresso causing afternoon energy crashes ☕",
          "Heavy greasy meals that divert blood flow to heavy digestion 🍔",
          "Refined sweets causing rapid insulin spikes 🍬",
          "Skipping hydration throughout the working day ⏳"
        ]
      },
      muscle_tone: {
        strategy: "Your core strategy is **Lean Muscle Anabolism & Protein Optimization (1.8-2.2g/kg)**. Formula 1 + 2 scoops PDM breakfast, intra-workout CR7 Drive, H24 Rebuild Strength post-workout, and Herbalifeline Max.",
        recFoods: [
          "High biological value proteins (poultry, wild salmon, eggs, H24 Rebuild) 🍳",
          "Complex clean carbs for rapid glycogen replenishment (sweet potato, oats) 🥔",
          "Anti-inflammatory Omega-3 fats for joint and tissue recovery 🐟",
          "High-protein pocket snacks (Herbalife Protein Bars & Chips) 🍫"
        ],
        avoidFoods: [
          "Alcohol (impairing up to 70% of overnight muscle recovery) 🍺",
          "Unplanned fasting triggering muscle catabolism 📉",
          "Trans fats and ultra-processed junk snacks 🍩",
          "Dehydration during intense workout sets 🏜️"
        ]
      }
    },
    ro: {
      weight_loss: {
        strategy: "Strategia ta principală este **Deficitul Caloric Controlat (-" + caloricProfile.deficit + " kcal)** pentru arderea grăsimilor și eliminarea balonării. Folosește 2 Shake-uri Formula 1 + PDM, Ceai Instant pe bază de Plante și Phyto Complete.",
        recFoods: [
          "Legume verzi și salate proaspete (jumătate din farfurie) 🥗",
          "Proteine slabe de calitate: pui, curcan, somon, ouă, tofu și PDM 🥩",
          "Carbohidrați complecși moderați: quinoa, orez basmati, ovăz 🍚",
          "Grăsimi sănătoase: ulei de măsline extravirgin, avocado, semințe de in 🥑"
        ],
        avoidFoods: [
          "Zahăr rafinat, produse de patiserie și sucuri carbogazoase 🚫",
          "Alimente prăjite și produse din făină albă ultra-procesată 🍟",
          "Băuturi alcoolice (blochează arderea grăsimilor) 🍷",
          "Gustări foarte sărate care favorizează retenția de apă 🥨"
        ]
      },
      energy_vitality: {
        strategy: "Strategia ta este **Energia Celulară & Hidratarea Profundă**. Shake Formula 1 la micul dejun pentru glicemie stabilă, AloeMax pentru digestie ușoară, Ceai Instant pentru claritate și Mineral Complex.",
        recFoods: [
          "Legume proaspete bogate în clorofilă și fructe de pădure 🫐",
          "Cereale integrale cu eliberare prelungită de energie (ovăz, orz) 🌾",
          "Proteine ușoare pentru prevenirea stării de somnolență după masă 🐟",
          "Hidratare cu 2.5L apă, AloeMax și Mineral Complex 💧"
        ],
        avoidFoods: [
          "Exces de cafea ce provoacă scăderi bruște de energie ☕",
          "Mese grele și bogate în grăsimi saturate la prânz 🍔",
          "Dulciuri concentrate ce provoacă hiperglicemie 🍬",
          "Săritul peste mese sau hidratare insuficientă ⏳"
        ]
      },
      muscle_tone: {
        strategy: "Strategia ta este **Tonifierea Musculară & Aport Proteic Ridicat (1.8-2.2g/kg)**. Shake Formula 1 + 2 măsuri PDM, CR7 Drive în antrenament, H24 Rebuild Strength după efort și Herbalifeline Max.",
        recFoods: [
          "Proteine nobile cu valoare biologică ridicată (ouă, somon, pui, shake H24) 🍳",
          "Carbohidrați curați pentru refacerea depozitelor de glicogen (orez, cartofi dulci) 🥔",
          "Acizi grași Omega-3 pentru articulații și refacere musculară 🐟",
          "Gustări proteice practice (Batoane Proteice, Protein Chips) 🍫"
        ],
        avoidFoods: [
          "Alcool (afectează grav sinteza proteică nocturnă) 🍺",
          "Înfometarea necontrolată ce distruge masa musculară 📉",
          "Alimente fast-food și grăsimi hidrogenate 🍩",
          "Deshidratarea în timpul efortului fizic 🏜️"
        ]
      }
    },
    es: {
      weight_loss: {
        strategy: "Tu estrategia es el **Déficit Calórico Controlado (-" + caloricProfile.deficit + " kcal)** para quemar grasa y deshinchar el abdomen. Apóyate en 2 Batidos Formula 1 + PDM, Bebida Instantánea de Hierbas y Phyto Complete.",
        recFoods: [
          "Verduras de hoja verde y hortalizas de bajo índice glucémico 🥗",
          "Proteína limpia: pollo, pavo, salmón, huevos, tofu y PDM 🥩",
          "Carbohidratos complejos medidos: quinoa, arroz basmati, avena 🍚",
          "Grasas saludables: aceite de oliva virgen extra, aguacate, semillas 🥑"
        ],
        avoidFoods: [
          "Azúcares refinados, bollería y bebidas azucaradas 🚫",
          "Frituras y harinas ultraprocesadas 🍟",
          "Bebidas alcohólicas (bloquean la quema de grasa) 🍷",
          "Snacks muy salados que retienen líquidos 🥨"
        ]
      },
      energy_vitality: {
        strategy: "Tu estrategia es la **Vitalidad Celular e Hidratación Profunda**. Batido Formula 1 para energía estable, AloeMax para bienestar digestivo, Té de Hierbas para enfoque continuo y Mineral Complex.",
        recFoods: [
          "Vegetales frescos ricos en clorofila y frutos rojos 🫐",
          "Cereales integrales de liberación prolongada (avena, espelta) 🌾",
          "Proteínas ligeras que evitan la pesadez post-almuerzo 🐟",
          "Hidratación con 2.5L de agua con AloeMax y Mineral Complex 💧"
        ],
        avoidFoods: [
          "Exceso de café que provoca bajones de energía por la tarde ☕",
          "Comidas copiosas que dificultan la digestión 🍔",
          "Dulces refinados con picos de insulina 🍬",
          "Saltarse comidas o descuidar el agua ⏳"
        ]
      },
      muscle_tone: {
        strategy: "Tu estrategia es la **Tonificación Muscular y Síntesis Proteica (1.8-2.2g/kg)**. Batido Formula 1 + 2 cucharadas PDM, CR7 Drive en entreno, H24 Rebuild Strength post-ejercicio y Herbalifeline Max.",
        recFoods: [
          "Proteínas de alto valor biológico (huevos, salmón, pollo, batido H24) 🍳",
          "Carbohidratos limpios para recuperar glucógeno (arroz, batata, avena) 🥔",
          "Ácidos grasos Omega-3 para recuperación muscular (Herbalifeline Max) 🐟",
          "Snacks proteicos portátiles (Barritas Proteicas, Protein Chips) 🍫"
        ],
        avoidFoods: [
          "Alcohol (compromete la síntesis proteica nocturna) 🍺",
          "Ayunos descontrolados que degradan masa magra 📉",
          "Comida chatarra con grasas trans 🍩",
          "Deshidratación durante los entrenamientos 🏜️"
        ]
      }
    }
  };

  const recByLang = recommendations[state.lang] || recommendations.it;
  const goalRec = recByLang[goal] || recByLang.weight_loss;

  const textEl = document.getElementById("strategy-text-desc");
  if (textEl) {
    textEl.innerHTML = goalRec.strategy;
  }

  const recListEl = document.getElementById("strategy-rec-foods-list");
  if (recListEl) {
    recListEl.innerHTML = goalRec.recFoods.map(item => `<li style="margin-bottom: 6px;">${item}</li>`).join('');
  }

  const avoidListEl = document.getElementById("strategy-avoid-foods-list");
  if (avoidListEl) {
    avoidListEl.innerHTML = goalRec.avoidFoods.map(item => `<li style="margin-bottom: 6px;">${item}</li>`).join('');
  }
};

const initProfileForm = () => {
  const f = document.getElementById("profile-form");
  initProfileSubTabs();
  updateProfileHeroBar();
  if (!f) return;
  
  // Populate form fields from state
  populateProfileFormFields();
  
  const emailEl = document.getElementById("set-user-email");

  // Toggle distributor fields
  const chkDist = document.getElementById("chk-is-distributor");
  const distWrapper = document.getElementById("distributor-fields-wrapper");
  if (chkDist && distWrapper) {
    chkDist.addEventListener("change", () => {
      distWrapper.style.display = chkDist.checked ? "block" : "none";
      state.profile.isDistributor = chkDist.checked;
      updatePersonalReferralUI();
    });
  }

  // Real-time lookup on Coach ID input
  const sponsorIdInput = document.getElementById("set-sponsor-id");
  if (sponsorIdInput) {
    sponsorIdInput.addEventListener("input", (e) => {
      clearTimeout(lookupCoachTimeout);
      const val = e.target.value.trim();
      lookupCoachTimeout = setTimeout(() => {
        lookupCoachAndUpdatePreview(val);
      }, 400);
    });
  }

  // Update referral link on My Distributor ID input
  const myDistIdInput = document.getElementById("set-my-distributor-id");
  if (myDistIdInput) {
    myDistIdInput.addEventListener("input", (e) => {
      state.profile.myHerbalifeId = e.target.value.trim();
      updatePersonalReferralUI();
    });
  }
  
  const handleSaveProfileForm = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    // Save to state
    const nameInput = document.getElementById("set-user-name");
    if (nameInput && nameInput.value) state.profile.name = nameInput.value.trim();

    if (emailEl && emailEl.value) state.profile.email = emailEl.value.trim();
    const avatarEl = document.getElementById("select-profile-avatar");
    if (avatarEl) state.profile.avatar = avatarEl.value;

    const startW = document.getElementById("set-start-weight");
    if (startW && !isNaN(parseFloat(startW.value))) state.profile.startWeight = parseFloat(startW.value);

    const targetW = document.getElementById("set-target-weight");
    if (targetW && !isNaN(parseFloat(targetW.value))) state.profile.targetWeight = parseFloat(targetW.value);

    const heightEl = document.getElementById("set-height");
    if (heightEl && !isNaN(parseFloat(heightEl.value))) state.profile.height = parseFloat(heightEl.value);

    const waterEl = document.getElementById("set-water-goal");
    if (waterEl && !isNaN(parseFloat(waterEl.value))) state.profile.waterGoal = parseFloat(waterEl.value);

    const kitEl = document.getElementById("set-kit-type");
    if (kitEl) state.profile.kitType = kitEl.value;

    const spNameVal = document.getElementById("set-sponsor-name");
    if (spNameVal) state.profile.sponsorName = spNameVal.value.trim();
    const spIdVal = document.getElementById("set-sponsor-id");
    if (spIdVal) state.profile.sponsorId = spIdVal.value.trim();
    const spPhoneVal = document.getElementById("set-sponsor-phone");
    if (spPhoneVal) state.profile.sponsorPhone = spPhoneVal.value.trim();
    const spEmailVal = document.getElementById("set-sponsor-email");
    if (spEmailVal) state.profile.sponsorEmail = spEmailVal.value.trim();

    // Distributor fields save
    const isDistChecked = document.getElementById("chk-is-distributor") ? document.getElementById("chk-is-distributor").checked : false;
    state.profile.isDistributor = isDistChecked;
    const myDistId = document.getElementById("set-my-distributor-id") ? document.getElementById("set-my-distributor-id").value.trim() : "";
    
    if (isDistChecked && myDistId) {
      if (state.profile.myHerbalifeId !== myDistId || !state.profile.herbalifeIdStatus) {
        state.profile.herbalifeIdStatus = (state.profile.herbalifeIdStatus === 'verified' && state.profile.myHerbalifeId === myDistId) ? 'verified' : 'pending';
      }
      state.profile.myHerbalifeId = myDistId;
    } else {
      state.profile.isDistributor = false;
      state.profile.herbalifeIdStatus = "unverified";
    }

    updateDistributorStatusUI();
    updatePersonalReferralUI();
    checkAdminStatus();
    updateSponsorUI();

    const chestEl = document.getElementById("set-measure-chest");
    if (chestEl) state.profile.chest = parseFloat(chestEl.value) || null;
    const waistEl = document.getElementById("set-measure-waist");
    if (waistEl) state.profile.waist = parseFloat(waistEl.value) || null;
    const hipsEl = document.getElementById("set-measure-hips");
    if (hipsEl) state.profile.hips = parseFloat(hipsEl.value) || null;
    
    // Advanced fields save
    const shapeEl = document.getElementById("set-body-shape");
    if (shapeEl) state.profile.bodyShape = shapeEl.value;
    const lifeEl = document.getElementById("set-lifestyle");
    if (lifeEl) state.profile.lifestyleType = lifeEl.value;
    const gymEl = document.getElementById("set-gym-frequency");
    if (gymEl) state.profile.gymFrequency = gymEl.value;
    const coffeeEl = document.getElementById("set-coffee-count");
    if (coffeeEl) state.profile.coffeeCount = parseInt(coffeeEl.value) || 0;
    const alcEl = document.getElementById("set-alcohol");
    if (alcEl) state.profile.alcoholUsage = alcEl.value;
    const sleepEl = document.getElementById("set-sleep-quality");
    if (sleepEl) state.profile.sleepQuality = sleepEl.value;
    const stressEl = document.getElementById("set-stress-level");
    if (stressEl) state.profile.stressLevel = stressEl.value;
    
    const walksEl = document.getElementById("chk-walks");
    if (walksEl) state.profile.hasWalks = walksEl.checked;
    const saunaEl = document.getElementById("chk-sauna");
    if (saunaEl) state.profile.hasSauna = saunaEl.checked;
    const coldEl = document.getElementById("chk-cold-shower");
    if (coldEl) state.profile.hasColdShower = coldEl.checked;
    const medEl = document.getElementById("chk-meditation");
    if (medEl) state.profile.hasMeditation = medEl.checked;
    const fastEl = document.getElementById("chk-fasting");
    if (fastEl) state.profile.hasFasting = fastEl.checked;
    
    const dietTypeEl = document.getElementById("set-diet-type");
    if (dietTypeEl) state.profile.dietType = dietTypeEl.value;
    const curDietEl = document.getElementById("set-current-diet");
    if (curDietEl) state.profile.currentDiet = curDietEl.value;
    const suppEl = document.getElementById("set-supplements");
    if (suppEl) state.profile.supplements = suppEl.value;
    const illEl = document.getElementById("set-illnesses");
    if (illEl) state.profile.illnesses = illEl.value;
    const medListEl = document.getElementById("set-medications");
    if (medListEl) state.profile.medications = medListEl.value;
    const probEl = document.getElementById("set-health-problems");
    if (probEl) state.profile.healthProblems = probEl.value;
    
    // Save locally to storage
    saveStateToStorage();

    // Cloud force upload to persist exactly what user filled
    if (state.profile.email && state.profile.email.includes("@")) {
      await syncUserProfileWithCloud(state.profile.email, { forceUpload: true });
    }

    loadActiveDayLogs();
    updateNutritionalStrategyUI();
    updateProfileHeroBar();
    
    // Trigger Day 1 Welcome Email Sequence via Resend API
    if (state.profile.email && state.profile.email.includes("@")) {
      sendProgram10EmailTrigger("welcome_day1");
    }

    // Update sidebar brand letter
    const sidebarAvatar = document.querySelector(".row-avatar");
    if (sidebarAvatar) {
      sidebarAvatar.textContent = state.profile.avatar;
    }

    // Interactive button visual feedback
    const saveBtn = document.getElementById("btn-save-profile-settings") || f.querySelector("button[type='submit']");
    if (saveBtn) {
      const origHtml = saveBtn.innerHTML;
      saveBtn.innerHTML = "Salvato con successo! ✅";
      saveBtn.style.background = "#10B981";
      saveBtn.style.color = "#061A14";
      setTimeout(() => {
        saveBtn.innerHTML = origHtml;
        saveBtn.style.background = "";
        saveBtn.style.color = "";
      }, 2500);
    }

    // Sleek floating toast notification
    showAppToast(
      state.lang === "it" 
        ? "Profilo salvato e sincronizzato con successo! 💾" 
        : "Profile saved and synced successfully! 💾",
      "success"
    );
  };

  f.addEventListener("submit", handleSaveProfileForm);

  const directSaveBtn = document.getElementById("btn-save-profile-settings");
  if (directSaveBtn && directSaveBtn.form !== f) {
    directSaveBtn.addEventListener("click", handleSaveProfileForm);
  }

  // Initial Strategy calculations load
  updateNutritionalStrategyUI();

  // Handle PDF Report Export
  const exportPdfBtn = document.getElementById("btn-export-pdf-report");
  if (exportPdfBtn) {
    exportPdfBtn.addEventListener("click", () => {
      exportProgram10ReportPDF();
    });
  }
};

const exportProgram10ReportPDF = (targetClient = null) => {
  const p = (targetClient && targetClient.profile) ? targetClient.profile : (state.profile || {});
  const rawLogs = (targetClient && targetClient.dailyLogs) ? targetClient.dailyLogs : (state.dailyLogs || []);
  
  // Normalize logs to 10 days
  const dailyLogs = Array.from({ length: 10 }, (_, i) => {
    return rawLogs[i] || {
      shakesCount: 0,
      water: 0,
      snack: false,
      meal: false,
      steps: 0,
      km: 0,
      exType: "nessuno",
      exDuration: 0,
      weight: null,
      scannedMeal: null
    };
  });

  const startWeight = parseFloat(p.startWeight || 70);
  const targetWeight = parseFloat(p.targetWeight || startWeight);

  let latestWeight = startWeight;
  let totalScore = 0;
  let totalWaterMl = 0;
  let totalShakes = 0;
  let daysCompleted = 0;

  dailyLogs.forEach((log) => {
    if (log.weight !== null && !isNaN(parseFloat(log.weight))) {
      latestWeight = parseFloat(log.weight);
    }
    totalWaterMl += Number(log.water) || 0;
    totalShakes += Number(log.shakesCount) || 0;
    const s = typeof calculateDailyScore === 'function' ? calculateDailyScore(log) : 0;
    if (s > 0 || (log.shakesCount > 0) || (log.water > 0) || (log.weight !== null)) {
      totalScore += s;
      daysCompleted++;
    }
  });

  const currentWeight = latestWeight;
  const lostKg = (startWeight - currentWeight).toFixed(1);
  const height = parseFloat(p.height || 170);
  const caloricProfile = getUserCaloricProfile(p, currentWeight);
  const bmi = caloricProfile.bmi.toFixed(1);
  const targetCalories = caloricProfile.targetCalories;
  const { pPct, cPct, fPct, proteinG: pG, carbsG: cG, fatsG: fG } = caloricProfile.macros;
  const goalDef = caloricProfile.goalDefinition;
  const lang = state.lang || 'it';
  const goalLabel = (goalDef.badgeLabel && goalDef.badgeLabel[lang]) || goalDef.badgeLabel.it || caloricProfile.goal;

  // Progress & Trend Calculations (Andamento 1:1)
  const weights = [];
  dailyLogs.forEach((log, idx) => {
    if (log.weight !== null && !isNaN(parseFloat(log.weight))) {
      weights.push({ day: idx + 1, val: parseFloat(log.weight) });
    }
  });
  const loggedWeightsList = weights.map(w => w.val);
  const minWeight = loggedWeightsList.length ? Math.min(...loggedWeightsList).toFixed(1) : startWeight.toFixed(1);
  const maxWeight = loggedWeightsList.length ? Math.max(...loggedWeightsList).toFixed(1) : startWeight.toFixed(1);
  const daysWaterTarget = dailyLogs.filter(l => (l.water || 0) >= 2500).length;
  const totalWaterL = parseFloat((totalWaterMl / 1000).toFixed(1));
  const avgWaterDay = (totalWaterL / Math.max(1, daysCompleted || 1)).toFixed(1);
  const avgScore = daysCompleted > 0 ? Math.round(totalScore / daysCompleted) : 0;

  const stats = {
    startWeight,
    currentWeight,
    weightLoss: parseFloat((startWeight - currentWeight).toFixed(1)),
    avgScore,
    daysCompleted,
    totalWaterL,
    totalShakes
  };

  let progressPct = 0;
  let remWeight = "0.0";
  if (targetWeight < startWeight) {
    const totalToLose = startWeight - targetWeight;
    const lostSoFar = startWeight - currentWeight;
    progressPct = totalToLose > 0 ? Math.min(100, Math.max(0, Math.round((lostSoFar / totalToLose) * 100))) : 100;
    remWeight = Math.max(0, currentWeight - targetWeight).toFixed(1);
  } else if (targetWeight > startWeight) {
    const totalToGain = targetWeight - startWeight;
    const gainedSoFar = currentWeight - startWeight;
    progressPct = totalToGain > 0 ? Math.min(100, Math.max(0, Math.round((gainedSoFar / totalToGain) * 100))) : 100;
    remWeight = Math.max(0, targetWeight - currentWeight).toFixed(1);
  } else {
    progressPct = 100;
    remWeight = "0.0";
  }

  const lifeLabelsMap = {
    it: {
      sedentario: "Sedentario", moderato: "Moderatamente attivo", attivo: "Molto attivo / Dinamico",
      nessuna: "Nessuna", "1-2_volte": "1-2 volte a sett.", "3-4_volte": "3-4 volte a sett.", quotidiana: "Quotidiana"
    },
    en: {
      sedentario: "Sedentary", moderato: "Moderately active", attivo: "Very active / Dynamic",
      nessuna: "None", "1-2_volte": "1-2x/week", "3-4_volte": "3-4x/week", quotidiana: "Daily"
    },
    ro: {
      sedentario: "Sedentar", moderato: "Moderat activ", attivo: "Foarte activ / Dinamic",
      nessuna: "Niciuna", "1-2_volte": "1-2x/săpt.", "3-4_volte": "3-4x/săpt.", quotidiana: "Zilnic"
    },
    es: {
      sedentario: "Sedentario", moderato: "Moderadamente activo", attivo: "Muy activo / Dinámico",
      nessuna: "Ninguna", "1-2_volte": "1-2x/sem.", "3-4_volte": "3-4x/sem.", quotidiana: "Diario"
    }
  };
  const curLifeMap = lifeLabelsMap[state.lang] || lifeLabelsMap.it;
  const lifeLabel = curLifeMap[p.lifestyleType] || p.lifestyleType || curLifeMap.moderato;
  const gymLabel = curLifeMap[p.gymFrequency] || p.gymFrequency || curLifeMap.nessuna;

  const recommendations = {
    it: {
      strategyLoss: "La tua strategia primaria è il Deficit Calorico Controllato per stimolare il dimagrimento senza intaccare la massa muscolare. Integra con la colazione equilibrata Herbalife e 2 Frullati Formula 1 al giorno.",
      strategyGain: "La tua strategia primaria è il Surplus Calorico Pulito per favorire la crescita e la tonificazione muscolare. Usa Formula 1 come nutriente post-allenamento e abbina pasti ricchi di proteine.",
      strategyMaint: "La tua strategia è il Mantenimento Attivo & Tonificazione. Usa 1 Frullato Formula 1 a colazione per nutrire le cellule con 25 vitamine, minerali e fibre essenziali.",
      recFoods: [
        "Verdure fresche di stagione a foglia verde e ortaggi colorati (almeno metà del piatto)",
        "Proteine nobili e magre: petto di pollo, tacchino, pesce azzurro/salmone, uova, tofu e legumi",
        "Carboidrati complessi a basso indice glicemico: riso integrale, quinoa, farro, avena e patate dolci",
        "Grassi buoni in porzioni controllate: olio extravergine d'oliva a crudo, avocado, noci e mandorle"
      ],
      avoidFoods: [
        "Zuccheri raffinati, merendine industriali, dolci da forno e bevande zuccherate gassate",
        "Cibi fritti, oli idrogenati, grassi trans e salse industriali ricche di zuccheri e grassi saturi",
        "Alcolici e superalcolici (rallentano il metabolismo ed affaticano il fegato)",
        "Insaccati, salumi grassi e cibi ultra-processati ad alto contenuto di sodio e conservanti"
      ],
      bmiUnder: "Sottopeso", bmiNorm: "Normale", bmiOver: "Sovrappeso", bmiObese: "Obesità",
      kitBase: "Kit Base (Colazione & Snack)", kitAdv: "Kit Avanzato Completo", kitCustom: "Personalizzato",
      shapeNormal: "Normale", shapeUnder: "Sottopeso", shapeOver: "Sovrappeso", shapeAthletic: "Atletica / Tonica",
      lifeSed: "Sedentario", lifeMod: "Moderatamente attivo", lifeAct: "Molto attivo / Dinamico",
      gymNone: "Nessuna", gym12: "1-2 volte a settimana", gym34: "3-4 volte a settimana", gymDaily: "Quasi quotidiana",
      alcNo: "No / Astemio", alcOcc: "Occasionale (Weekend)", alcFreq: "Frequente",
      sleepGood: "Buona / Riposante", sleepGreat: "Ottima / Profonda", sleepPoor: "Insufficiente", sleepInsomnia: "Insonnia",
      stressLow: "Basso / Rilassato", stressMed: "Medio", stressHigh: "Alto / Molto stressato",
      dietOmni: "Onnivora", dietVeg: "Vegetariana", dietVegan: "Vegana", dietKeto: "Keto / Low-Carb", dietOther: "Altro",
      unlocked: "✅ Sbloccato", inProgress: "⏳ In Corso",
      yes: "✅ Sì", no: "❌ No",
      title: "REPORT COMPLETO PROGRAMMA 10 GIORNI",
      distributor: "Distributore Indipendente Herbalife",
      sec_bio: "👤 Dati Personali & Parametri Biometrici",
      sec_sponsor: "🌟 Sponsor & Coach di Riferimento",
      sec_lifestyle: "🏃 Stile di Vita, Abitudini & Salute",
      sec_andamento: "📈 Andamento, Metabolismo & Progressione",
      sec_strategy: "🍽️ Scheda & Strategia Nutrizionale Personalizzata",
      sec_perf: "📊 Riepilogo Performance 10 Giorni",
      sec_daily_log: "📋 Registro Giornaliero Dettagliato (10 Giorni)",
      sec_achievements: "🏆 Traguardi & Medaglie Sbloccate",
      lbl_name: "Nome / Nickname", lbl_email: "Email", lbl_start_w: "Peso Iniziale", lbl_curr_w: "Peso Attuale",
      lbl_target_w: "Peso Obiettivo", lbl_delta_w: "Variazione Peso", lbl_height: "Altezza", lbl_water_goal: "Target Acqua",
      lbl_chest: "Petto", lbl_waist: "Vita", lbl_hips: "Fianchi", lbl_kit: "Kit Herbalife",
      lbl_sponsor_name: "Nome Coach", lbl_sponsor_id: "ID Distributore", lbl_sponsor_phone: "WhatsApp / Tel", lbl_sponsor_email: "Email Coach",
      lbl_shape: "Forma Fisica", lbl_lifestyle: "Stile di Vita", lbl_gym: "Allenamenti", lbl_coffee: "Caffè/Giorno",
      lbl_alc: "Alcol", lbl_sleep: "Sonno", lbl_stress: "Livello Stress", lbl_habits: "Abitudini Attive",
      lbl_diet_type: "Tipo Dieta", lbl_current_diet: "Piano Attuale", lbl_supplements: "Integratori Assunti",
      lbl_illnesses: "Condizioni Note", lbl_meds: "Farmaci Assunti", lbl_health_notes: "Note di Salute",
      lbl_bmi: "Indice di Massa Corporea (IMC)", lbl_calories: "Fabbisogno Calorico Target (TDEE)",
      lbl_macros: "Ripartizione Macronutrienti", lbl_rec_foods: "Alimenti Consigliati ✅", lbl_avoid_foods: "Alimenti da Evitare / Limitare ❌",
      lbl_days_comp: "Giorni Completati", lbl_avg_score: "Punteggio Medio", lbl_total_water: "Idratazione Totale",
      lbl_total_shakes: "Frullati F1 Totali", lbl_compliance: "Tasso di Costanza",
      lbl_weight_start_curr: "Iniziale ➔ Attuale", lbl_weight_target_and: "Obiettivo Finale",
      lbl_metabolism_tdee: "BMR / TDEE Stimato", lbl_target_deficit: "Target Giornaliero",
      lbl_measures_summary: "Misure (Petto/Vita/Fianchi)", lbl_lifestyle_habits: "Attività & Sport",
      stat_lost_eff: "Perdita Peso Effettiva", stat_compliance: "Tasso Adempimento", stat_water_tot: "Acqua Totale Bevuta",
      lbl_goal_progress: "Progresso verso Obiettivo", lbl_rem_weight: "rimanenti al target",
      lbl_weight_min_max: "Range Pesi Rilevati (Min / Max)",
      th_day: "Giorno", th_shakes: "Shake F1", th_water: "Acqua (L)", th_snack: "Spuntino", th_meal: "Pasto", th_steps: "Passi / Km", th_exercise: "Attività Fisica", th_weight: "Peso (kg)", th_score: "Punti",
      badge_water: "Idratazione Perfetta (≥2.5L per 3 gg consec.)",
      badge_shakes: "Nutrizione Costante (≥2 Shake F1 per 5 gg)",
      badge_perfect: "Giorno Perfetto (100 punti in 1 giorno)",
      badge_finish: "Campione 10 Giorni (Tutti i 10 log completati)",
      footer_disclaimer: "Gli integratori alimentari non vanno intesi come sostituti di una dieta varia ed equilibrata e di uno stile di vita sano. Report generato dall'Applicazione Programma 10 Giorni — Distributore Indipendente Herbalife."
    },
    en: {
      strategyLoss: "Your primary strategy is Controlled Calorie Deficit to stimulate fat loss while preserving lean muscle mass. Support this with Herbalife balanced breakfast and 2 Formula 1 Shakes per day.",
      strategyGain: "Your primary strategy is Clean Calorie Surplus to support muscle growth and toning. Use Formula 1 as a post-workout recovery shake paired with high-protein meals.",
      strategyMaint: "Your primary strategy is Active Maintenance & Toning. Use 1 Formula 1 Shake at breakfast to nourish cells with 25 essential vitamins, minerals, and dietary fibers.",
      recFoods: [
        "Fresh green leafy seasonal vegetables and colorful veggies (half of your main plate)",
        "Lean protein: chicken breast, turkey, wild fish/salmon, eggs, tofu, and legumes",
        "Low-GI complex carbohydrates: brown rice, quinoa, spelt, oats, and sweet potatoes",
        "Healthy fats in moderate portions: extra virgin olive oil, avocado, walnuts, and almonds"
      ],
      avoidFoods: [
        "Refined sugars, industrial snacks, baked sweets, and sugary carbonated soft drinks",
        "Fried foods, hydrogenated oils, trans fats, and sugar-heavy industrial sauces",
        "Alcohol and excessive liquors (slows down metabolism and strains liver function)",
        "Fatty processed meats, sausages, and ultra-processed high-sodium foods"
      ],
      bmiUnder: "Underweight", bmiNorm: "Normal", bmiOver: "Overweight", bmiObese: "Obesity",
      kitBase: "Basic Kit (Breakfast & Snack)", kitAdv: "Complete Advanced Kit", kitCustom: "Custom",
      shapeNormal: "Normal", shapeUnder: "Underweight", shapeOver: "Overweight", shapeAthletic: "Athletic / Toned",
      lifeSed: "Sedentary", lifeMod: "Moderately active", lifeAct: "Very active / Dynamic",
      gymNone: "None", gym12: "1-2 times/week", gym34: "3-4 times/week", gymDaily: "Daily",
      alcNo: "No / Non-drinker", alcOcc: "Occasional", alcFreq: "Frequent",
      sleepGood: "Good / Restful", sleepGreat: "Great / Deep", sleepPoor: "Poor", sleepInsomnia: "Insomnia",
      stressLow: "Low / Relaxed", stressMed: "Medium", stressHigh: "High / Stressed",
      dietOmni: "Omnivore", dietVeg: "Vegetarian", dietVegan: "Vegan", dietKeto: "Keto / Low-Carb", dietOther: "Other",
      unlocked: "✅ Unlocked", inProgress: "⏳ In Progress",
      yes: "✅ Yes", no: "❌ No",
      title: "10-DAY PROGRAM COMPLETE WELLNESS REPORT",
      distributor: "Independent Herbalife Distributor",
      sec_bio: "👤 Personal Profile & Biometric Data",
      sec_sponsor: "🌟 Reference Sponsor & Coach",
      sec_lifestyle: "🏃 Lifestyle, Habits & Health",
      sec_andamento: "📈 Progress Trend, Metabolism & Analytics",
      sec_strategy: "🍽️ Personalized Nutritional Plan & Strategy",
      sec_perf: "📊 10-Day Performance Summary",
      sec_daily_log: "📋 Detailed 10-Day Daily Log",
      sec_achievements: "🏆 Achievements & Badges Unlocked",
      lbl_name: "Name / Nickname", lbl_email: "Email", lbl_start_w: "Starting Weight", lbl_curr_w: "Current Weight",
      lbl_target_w: "Target Weight", lbl_delta_w: "Weight Change", lbl_height: "Height", lbl_water_goal: "Water Goal",
      lbl_chest: "Chest", lbl_waist: "Waist", lbl_hips: "Hips", lbl_kit: "Herbalife Kit",
      lbl_sponsor_name: "Coach Name", lbl_sponsor_id: "Distributor ID", lbl_sponsor_phone: "WhatsApp / Tel", lbl_sponsor_email: "Coach Email",
      lbl_shape: "Body Shape", lbl_lifestyle: "Lifestyle", lbl_gym: "Workouts", lbl_coffee: "Coffee/Day",
      lbl_alc: "Alcohol", lbl_sleep: "Sleep Quality", lbl_stress: "Stress Level", lbl_habits: "Active Habits",
      lbl_diet_type: "Diet Type", lbl_current_diet: "Current Diet", lbl_supplements: "Supplements",
      lbl_illnesses: "Known Conditions", lbl_meds: "Medications", lbl_health_notes: "Health Notes",
      lbl_bmi: "Body Mass Index (BMI)", lbl_calories: "Target Calorie Need (TDEE)",
      lbl_macros: "Macronutrient Breakdown", lbl_rec_foods: "Recommended Foods ✅", lbl_avoid_foods: "Foods to Avoid / Limit ❌",
      lbl_days_comp: "Days Completed", lbl_avg_score: "Average Score", lbl_total_water: "Total Hydration",
      lbl_total_shakes: "Total F1 Shakes", lbl_compliance: "Consistency Rate",
      lbl_weight_start_curr: "Starting ➔ Current", lbl_weight_target_and: "Final Goal",
      lbl_metabolism_tdee: "Estimated BMR / TDEE", lbl_target_deficit: "Daily Target",
      lbl_measures_summary: "Measurements (Chest/Waist/Hips)", lbl_lifestyle_habits: "Activity & Sport",
      stat_lost_eff: "Actual Weight Loss", stat_compliance: "Compliance Rate", stat_water_tot: "Total Water Logged",
      lbl_goal_progress: "Goal Progress", lbl_rem_weight: "remaining to target",
      lbl_weight_min_max: "Logged Weight Range (Min / Max)",
      th_day: "Day", th_shakes: "F1 Shakes", th_water: "Water (L)", th_snack: "Snack", th_meal: "Meal", th_steps: "Steps / Km", th_exercise: "Physical Activity", th_weight: "Weight (kg)", th_score: "Points",
      badge_water: "Perfect Hydration (≥2.5L for 3 consecutive days)",
      badge_shakes: "Consistent Nutrition (≥2 F1 Shakes for 5 days)",
      badge_perfect: "Perfect Day (100 points in 1 day)",
      badge_finish: "10-Day Champion (All 10 daily logs completed)",
      footer_disclaimer: "Dietary supplements are not intended as a substitute for a varied and balanced diet and a healthy lifestyle. Report generated by 10-Day Program App — Independent Herbalife Distributor."
    },
    ro: {
      strategyLoss: "Strategia ta principală este Deficitul Caloric Controlat pentru a stimula slăbirea fără pierderea masei musculare. Integrează micul dejun Herbalife și 2 Shake-uri Formula 1 pe zi.",
      strategyGain: "Strategia ta principală este Surplusul Caloric Curat pentru a susține creșterea musculară și tonifierea. Folosește Formula 1 post-antrenament împreună cu mese bogate în proteine.",
      strategyMaint: "Strategia ta este Menținerea Activă & Tonifierea. Folosește 1 Shake Formula 1 la micul dejun pentru a hrăni celulele cu 25 de vitamine și minerale esențiale.",
      recFoods: [
        "Legume proaspete cu frunze verzi și legume de sezon (jumătate din farfuria principală)",
        "Proteine slabe: piept de pui, curcan, pește alb/somon, ouă, tofu și leguminoase",
        "Carbohidrați complecși cu indice glicemic scăzut: orez brun, quinoa, cartofi dulci și ovăz",
        "Grăsimi sănătoase în porții moderate: ulei de măsline extravirgin, avocado, nuci și migdale"
      ],
      avoidFoods: [
        "Zaharuri rafinate, dulciuri industriale și băuturi carbogazoase îndulcite",
        "Alimente prăjite, uleiuri vegetale hidrogenate și grăsimi trans industriale",
        "Alcoolul (încetinește metabolismul și suprasolicită ficatul)",
        "Mezeluri grase, cârnați și alimente ultra-procesate bogate în sodiu și conservanți"
      ],
      bmiUnder: "Subponderal", bmiNorm: "Normal", bmiOver: "Supraponderal", bmiObese: "Obezitate",
      kitBase: "Kit de Bază (Mic Dejun & Gustare)", kitAdv: "Kit Avansat Complet", kitCustom: "Personalizat",
      shapeNormal: "Normal", shapeUnder: "Subponderal", shapeOver: "Supraponderal", shapeAthletic: "Atletică / Tonifiată",
      lifeSed: "Sedentar", lifeMod: "Moderat activ", lifeAct: "Foarte activ / Dinamic",
      gymNone: "Niciuna", gym12: "1-2 ori/săptămână", gym34: "3-4 ori/săptămână", gymDaily: "Zilnic",
      alcNo: "Nu / Abstinent", alcOcc: "Ocazional", alcFreq: "Frecvent",
      sleepGood: "Bun / Odihnitor", sleepGreat: "Excelent / Profund", sleepPoor: "Insuficient", sleepInsomnia: "Insomnie",
      stressLow: "Scăzut / Relaxat", stressMed: "Mediu", stressHigh: "Ridicat / Stresat",
      dietOmni: "Omnivoră", dietVeg: "Vegetariană", dietVegan: "Vegană", dietKeto: "Keto / Low-Carb", dietOther: "Altul",
      unlocked: "✅ Deblocat", inProgress: "⏳ În Curs",
      yes: "✅ Da", no: "❌ Nu",
      title: "RAPORT COMPLET WELLNESS PROGRAM 10 ZILE",
      distributor: "Distribuitor Independent Herbalife",
      sec_bio: "👤 Date Personale & Parametri Biometrici",
      sec_sponsor: "🌟 Sponsor & Coach de Referință",
      sec_lifestyle: "🏃 Stil de Viață, Obiceiuri & Sănătate",
      sec_andamento: "📈 Evoluție, Metabolism & Monitorizare Obiectiv",
      sec_strategy: "🍽️ Plan & Strategie Nutrițională Personalizată",
      sec_perf: "📊 Sumar Performanță 10 Zile",
      sec_daily_log: "📋 Jurnal Zilnic Detaliat (10 Zile)",
      sec_achievements: "🏆 Realizări & Medalii Deblocate",
      lbl_name: "Nume / Nickname", lbl_email: "Email", lbl_start_w: "Greutate Inițială", lbl_curr_w: "Greutate Actuală",
      lbl_target_w: "Greutate Țintă", lbl_delta_w: "Evoluție Greutate", lbl_height: "Înălțime", lbl_water_goal: "Țintă Apă",
      lbl_chest: "Piept", lbl_waist: "Talie", lbl_hips: "Șolduri", lbl_kit: "Kit Herbalife",
      lbl_sponsor_name: "Nume Coach", lbl_sponsor_id: "ID Distribuitor", lbl_sponsor_phone: "WhatsApp / Tel", lbl_sponsor_email: "Email Coach",
      lbl_shape: "Formă Fizică", lbl_lifestyle: "Stil de Viață", lbl_gym: "Antrenamente", lbl_coffee: "Cafea/Zi",
      lbl_alc: "Alcool", lbl_sleep: "Calitate Somn", lbl_stress: "Nivel Stres", lbl_habits: "Obiceiuri Active",
      lbl_diet_type: "Tip Dietă", lbl_current_diet: "Plan Actual", lbl_supplements: "Suplimente",
      lbl_illnesses: "Boli / Condiții", lbl_meds: "Medicamente", lbl_health_notes: "Note Medicale",
      lbl_bmi: "Indice Masă Corporală (IMC)", lbl_calories: "Necesar Caloric Țintă (TDEE)",
      lbl_macros: "Distribuție Macronutrienți", lbl_rec_foods: "Alimente Recomandate ✅", lbl_avoid_foods: "Alimente de Evitat / Limitat ❌",
      lbl_days_comp: "Zile Completate", lbl_avg_score: "Scor Mediu", lbl_total_water: "Hidratare Totală",
      lbl_total_shakes: "Shake-uri F1 Totale", lbl_compliance: "Rată de Consecvență",
      lbl_weight_start_curr: "Inițială ➔ Actuală", lbl_weight_target_and: "Obiectiv Final",
      lbl_metabolism_tdee: "BMR / TDEE Estimat", lbl_target_deficit: "Țintă Zilnică",
      lbl_measures_summary: "Măsurători (Piept/Talie/Șolduri)", lbl_lifestyle_habits: "Activitate & Sport",
      stat_lost_eff: "Scădere în Greutate Efectivă", stat_compliance: "Rată de Conformitate", stat_water_tot: "Apă Totală Băută",
      lbl_goal_progress: "Progres Obiectiv", lbl_rem_weight: "rămas până la țintă",
      lbl_weight_min_max: "Interval Greutate Înregistrată (Min / Max)",
      th_day: "Ziua", th_shakes: "Shake F1", th_water: "Apă (L)", th_snack: "Gustare", th_meal: "Masă", th_steps: "Pași / Km", th_exercise: "Activitate Fizică", th_weight: "Greutate (kg)", th_score: "Puncte",
      badge_water: "Hidratare Perfectă (≥2.5L timp de 3 zile consec.)",
      badge_shakes: "Nutriție Constantă (≥2 Shake F1 timp de 5 zile)",
      badge_perfect: "Zi Perfectă (100 puncte într-o zi)",
      badge_finish: "Campion 10 Zile (Toate cele 10 loguri completate)",
      footer_disclaimer: "Suplimentele alimentare nu trebuie să înlocuiască o dietă variată și echilibrată și un stil de viață sănătos. Raport generat de Aplicația Program 10 Zile — Distribuitor Independent Herbalife."
    },
    es: {
      strategyLoss: "Tu estrategia principal es el Déficit Calórico Controlado para estimular la quema de grasa protegiendo la masa muscular. Apóyate con el desayuno equilibrado Herbalife y 2 Batidos Formula 1 al día.",
      strategyGain: "Tu estrategia principal es el Superávit Calórico Limpio para favorecer el aumento de masa muscular y tonificación. Consume Formula 1 post-entreno con comidas ricas en proteínas.",
      strategyMaint: "Tu estrategia es el Mantenimiento Activo & Tonificación. Consume 1 Batido Formula 1 en el desayuno para nutrir las células con 25 vitaminas, minerales y fibras esenciales.",
      recFoods: [
        "Verduras frescas de hoja verde y hortalizas de temporada (la mitad de tu plato principal)",
        "Proteínas limpias y magras: pechuga de pollo, pavo, pescado azul/salmón, huevos, tofu y legumbres",
        "Carbohidratos complejos de bajo índice glucémico: arroz integral, quinoa, espelta, avena y batatas",
        "Grasas saludables en porciones moderadas: aceite de oliva virgen extra, aguacate, nueces y almendras"
      ],
      avoidFoods: [
        "Azúcares refinados, bollería industrial, dulces y refrescos azucarados con gas",
        "Comidas fritas, aceites vegetales hidrogenados, grasas trans y salsas industriales calóricas",
        "Alcohol y exceso de licores (ralentizan el metabolismo y sobrecargan el hígado)",
        "Embutidos grasos, salchichas y productos ultraprocesados con alto contenido de sodio y conservantes"
      ],
      bmiUnder: "Bajo Peso", bmiNorm: "Normal", bmiOver: "Sobrepeso", bmiObese: "Obesidad",
      kitBase: "Kit Base (Desayuno y Snack)", kitAdv: "Kit Avanzado Completo", kitCustom: "Personalizado",
      shapeNormal: "Normal", shapeUnder: "Bajo Peso", shapeOver: "Sobrepeso", shapeAthletic: "Atlética / Tonificada",
      lifeSed: "Sedentario", lifeMod: "Moderadamente activo", lifeAct: "Muy activo / Dinámico",
      gymNone: "Ninguna", gym12: "1-2 veces/semana", gym34: "3-4 veces/semana", gymDaily: "Diario",
      alcNo: "No / Abstemio", alcOcc: "Ocasional", alcFreq: "Frecuente",
      sleepGood: "Bueno / Reparador", sleepGreat: "Excelente / Profundo", sleepPoor: "Insuficiente", sleepInsomnia: "Insomnio",
      stressLow: "Bajo / Relajado", stressMed: "Medio", stressHigh: "Alto / Estresado",
      dietOmni: "Omnívora", dietVeg: "Vegetariana", dietVegan: "Vegana", dietKeto: "Keto / Low-Carb", dietOther: "Otro",
      unlocked: "✅ Desbloqueado", inProgress: "⏳ En Curso",
      yes: "✅ Sí", no: "❌ No",
      title: "REPORTE COMPLETO DE BIENESTAR PROGRAMA 10 DÍAS",
      distributor: "Distribuidor Independiente Herbalife",
      sec_bio: "👤 Datos Personales & Parámetros Biométricos",
      sec_sponsor: "🌟 Sponsor & Coach de Referencia",
      sec_lifestyle: "🏃 Estilo de Vida, Hábitos & Salud",
      sec_andamento: "📈 Evolución, Metabolismo & Seguimiento de Objetivo",
      sec_strategy: "🍽️ Plan y Estrategia Nutricional Personalizada",
      sec_perf: "📊 Resumen de Rendimiento 10 Días",
      sec_daily_log: "📋 Registro Diario Detallado (10 Días)",
      sec_achievements: "🏆 Logros & Medallas Desbloqueadas",
      lbl_name: "Nombre / Nickname", lbl_email: "Email", lbl_start_w: "Peso Inicial", lbl_curr_w: "Peso Actual",
      lbl_target_w: "Peso Objetivo", lbl_delta_w: "Variación de Peso", lbl_height: "Altura", lbl_water_goal: "Meta de Agua",
      lbl_chest: "Pecho", lbl_waist: "Cintura", lbl_hips: "Caderas", lbl_kit: "Kit Herbalife",
      lbl_sponsor_name: "Nombre Coach", lbl_sponsor_id: "ID Distribuidor", lbl_sponsor_phone: "WhatsApp / Tel", lbl_sponsor_email: "Email Coach",
      lbl_shape: "Forma Física", lbl_lifestyle: "Estilo de Vida", lbl_gym: "Entrenamientos", lbl_coffee: "Café/Día",
      lbl_alc: "Alcohol", lbl_sleep: "Calidad de Sueño", lbl_stress: "Nivel de Estrés", lbl_habits: "Hábitos Activos",
      lbl_diet_type: "Tipo de Dieta", lbl_current_diet: "Plan Actual", lbl_supplements: "Suplementos",
      lbl_illnesses: "Condiciones Conocidas", lbl_meds: "Medicamentos", lbl_health_notes: "Notas Médicas",
      lbl_bmi: "Índice de Masa Corporal (IMC)", lbl_calories: "Requerimiento Calórico Objetivo (TDEE)",
      lbl_macros: "Distribución de Macronutrientes", lbl_rec_foods: "Alimentos Recomendados ✅", lbl_avoid_foods: "Alimentos a Evitar / Limitar ❌",
      lbl_days_comp: "Días Completados", lbl_avg_score: "Puntuación Media", lbl_total_water: "Hidratación Total",
      lbl_total_shakes: "Batidos F1 Totales", lbl_compliance: "Tasa de Constancia",
      lbl_weight_start_curr: "Inicial ➔ Actual", lbl_weight_target_and: "Objetivo Final",
      lbl_metabolism_tdee: "BMR / TDEE Estimado", lbl_target_deficit: "Meta Diaria",
      lbl_measures_summary: "Medidas (Pecho/Cintura/Caderas)", lbl_lifestyle_habits: "Actividad y Deporte",
      stat_lost_eff: "Pérdida de Peso Efectiva", stat_compliance: "Tasa de Cumplimiento", stat_water_tot: "Agua Total Registrada",
      lbl_goal_progress: "Progreso hacia Objetivo", lbl_rem_weight: "restante al objetivo",
      lbl_weight_min_max: "Rango de Peso Registrado (Mín / Máx)",
      th_day: "Día", th_shakes: "Batidos F1", th_water: "Agua (L)", th_snack: "Snack", th_meal: "Comida", th_steps: "Pasos / Km", th_exercise: "Actividad Física", th_weight: "Peso (kg)", th_score: "Puntos",
      badge_water: "Hidratación Perfecta (≥2.5L por 3 días consec.)",
      badge_shakes: "Nutrición Constante (≥2 Batidos F1 por 5 días)",
      badge_perfect: "Día Perfecto (100 puntos en 1 día)",
      badge_finish: "Campeón 10 Días (Todos los 10 registros completados)",
      footer_disclaimer: "Los complementos alimenticios no deben utilizarse como sustitutos de una dieta variada y equilibrada y un estilo de vida saludable. Reporte generado por la App Programa 10 Días — Distribuidor Independiente Herbalife."
    }
  };

  const t = recommendations[state.lang] || recommendations.it;

  let bmiLabel = t.bmiNorm;
  let bmiBadgeClass = "badge-success";
  if (bmi < 18.5) { bmiLabel = t.bmiUnder; bmiBadgeClass = "badge-info"; }
  else if (bmi < 25) { bmiLabel = t.bmiNorm; bmiBadgeClass = "badge-success"; }
  else if (bmi < 30) { bmiLabel = t.bmiOver; bmiBadgeClass = "badge-warning"; }
  else { bmiLabel = t.bmiObese; bmiBadgeClass = "badge-danger"; }

  let strategyText = t.strategyMaint;
  if (isLoss) strategyText = t.strategyLoss;
  else if (isGain) strategyText = t.strategyGain;

  // Active Habits formatting
  const activeHabitsList = [];
  if (p.hasWalks) activeHabitsList.push("🚶 Passeggiate regolari");
  if (p.hasSauna) activeHabitsList.push("🧖 Sauna / Bagno turco");
  if (p.hasColdShower) activeHabitsList.push("🥶 Docce fredde");
  if (p.hasMeditation) activeHabitsList.push("🧘 Meditazione / Yoga");
  if (p.hasFasting) activeHabitsList.push("⏳ Digiuno intermittente");
  const activeHabitsStr = activeHabitsList.length > 0 ? activeHabitsList.join(" • ") : "Nessuna specifica";

  // Package & Kit label
  const pkgKey = p.package || (p.kitType === "base" ? "bronze" : (p.kitType === "personalizzato" ? "gold" : (p.kitType || "silver")));
  const pkgDef = PACKAGES_DEFINITIONS[pkgKey] || PACKAGES_DEFINITIONS.silver;
  const kitLabel = `${pkgDef.name} (${pkgDef.price})`;

  // Badges status
  const bState = (targetClient && targetClient.badgesUnlocked) || state.badgesUnlocked || {
    waterChamp: daysWaterTarget >= 3,
    shakeLover: totalShakes >= 10,
    perfectDay: dailyLogs.some(l => (typeof calculateDailyScore === 'function' ? calculateDailyScore(l) : 0) === 100),
    finisher: daysCompleted === 10
  };
  const waterBadgeText = bState.waterChamp ? t.unlocked : t.inProgress;
  const shakeBadgeText = bState.shakeLover ? t.unlocked : t.inProgress;
  const perfectBadgeText = bState.perfectDay ? t.unlocked : t.inProgress;
  const finishBadgeText = bState.finisher ? t.unlocked : t.inProgress;

  const now = new Date();
  const dateFormatted = now.toLocaleDateString(state.lang === 'it' ? 'it-IT' : (state.lang === 'ro' ? 'ro-RO' : (state.lang === 'es' ? 'es-ES' : 'en-US')), {
    year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'
  });

  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    alert(state.lang === 'it' ? 'Consenti i pop-up per scaricare il report PDF!' : 'Please allow pop-ups to download the PDF report!');
    return;
  }

  const htmlContent = `
<!DOCTYPE html>
<html lang="${state.lang}">
<head>
  <meta charset="utf-8">
  <title>Programma 10 Giorni - Report Completo - ${p.name || 'Partecipante'}</title>
  <style>
    @page { margin: 12mm 14mm; size: A4 portrait; }
    * { box-sizing: border-box; }
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
      color: #0f172a;
      background: #ffffff;
      margin: 0;
      padding: 24px;
      font-size: 12px;
      line-height: 1.45;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 3px solid #10B981;
      padding-bottom: 14px;
      margin-bottom: 18px;
    }
    .brand-title {
      font-size: 20px;
      font-weight: 800;
      color: #0f172a;
      letter-spacing: -0.5px;
      margin: 0;
    }
    .brand-subtitle {
      font-size: 12px;
      font-weight: 700;
      color: #10B981;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-top: 3px;
    }
    .meta-box {
      text-align: right;
      font-size: 11px;
      color: #64748b;
    }
    .meta-badge {
      display: inline-block;
      background: rgba(16, 185, 129, 0.12);
      color: #059669;
      font-weight: 700;
      padding: 3px 8px;
      border-radius: 6px;
      margin-bottom: 4px;
    }
    
    .section-title {
      font-size: 13.5px;
      font-weight: 800;
      color: #0f172a;
      background: #f1f5f9;
      border-left: 4px solid #10B981;
      padding: 6px 12px;
      border-radius: 0 6px 6px 0;
      margin: 18px 0 10px 0;
      page-break-after: avoid;
    }
    
    .grid-2 {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      page-break-inside: avoid;
    }
    .grid-3 {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 10px;
      page-break-inside: avoid;
    }
    .grid-4 {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 10px;
      page-break-inside: avoid;
    }
    
    .card {
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      padding: 11px 13px;
      page-break-inside: avoid;
    }
    
    .stat-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 3.5px 0;
      border-bottom: 1px dashed #e2e8f0;
      font-size: 11.5px;
    }
    .stat-row:last-child { border-bottom: none; }
    .stat-label { color: #64748b; font-weight: 500; }
    .stat-val { color: #0f172a; font-weight: 700; }
    
    .badge {
      display: inline-block;
      padding: 2px 7px;
      border-radius: 4px;
      font-size: 10.5px;
      font-weight: 700;
    }
    .badge-success { background: #dcfce7; color: #166534; }
    .badge-info { background: #e0f2fe; color: #075985; }
    .badge-warning { background: #fef3c7; color: #92400e; }
    .badge-danger { background: #fee2e2; color: #991b1b; }
    .badge-neutral { background: #f1f5f9; color: #475569; }

    .kpi-card {
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      padding: 9px;
      text-align: center;
    }
    .kpi-num {
      font-size: 17px;
      font-weight: 800;
      color: #0f172a;
      margin-top: 2px;
    }
    .kpi-label {
      font-size: 10px;
      text-transform: uppercase;
      font-weight: 700;
      color: #64748b;
      letter-spacing: 0.3px;
    }

    /* Progress bar visualizer */
    .progress-bar-track {
      height: 8px;
      background: #e2e8f0;
      border-radius: 4px;
      overflow: hidden;
      margin: 6px 0 4px 0;
    }
    .progress-bar-fill {
      height: 100%;
      background: linear-gradient(90deg, #10B981, #059669);
      border-radius: 4px;
    }

    /* Macro Bar visualizer */
    .macro-bar-wrap {
      display: flex;
      height: 10px;
      border-radius: 5px;
      overflow: hidden;
      margin: 6px 0 8px 0;
      background: #e2e8f0;
    }
    .macro-bar-p { background: #10B981; }
    .macro-bar-c { background: #3b82f6; }
    .macro-bar-f { background: #f59e0b; }

    /* Tables */
    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 6px;
      font-size: 10.5px;
      page-break-inside: avoid;
    }
    th, td {
      border: 1px solid #cbd5e1;
      padding: 5px 7px;
      text-align: center;
    }
    th {
      background: #0f172a;
      color: #ffffff;
      font-weight: 700;
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }
    tr:nth-child(even) { background: #f8fafc; }

    ul.bullet-list {
      margin: 3px 0 0 0;
      padding-left: 16px;
      font-size: 11px;
      color: #334155;
    }
    ul.bullet-list li { margin-bottom: 2px; }

    .footer {
      text-align: center;
      margin-top: 24px;
      padding-top: 12px;
      border-top: 1px solid #e2e8f0;
      font-size: 10px;
      color: #64748b;
      line-height: 1.4;
      page-break-inside: avoid;
    }
    
    @media print {
      body { padding: 0; }
      .no-print { display: none !important; }
      .card, table, .grid-2, .grid-3, .grid-4 { page-break-inside: avoid; }
    }
  </style>
</head>
<body>

  <!-- Header Banner -->
  <div class="header">
    <div>
      <h1 class="brand-title">${t.title}</h1>
      <div class="brand-subtitle">🌿 ${t.distributor}</div>
    </div>
    <div class="meta-box">
      <div class="meta-badge">${p.name || 'Partecipante'}</div>
      <div><strong>${t.lbl_email}:</strong> ${p.email || 'N/D'}</div>
      <div>${dateFormatted}</div>
    </div>
  </div>

  <!-- 1. Dati Personali & Parametri Biometrici -->
  <div class="section-title">${t.sec_bio}</div>
  <div class="grid-2">
    <div class="card">
      <div class="stat-row"><span class="stat-label">${t.lbl_name}:</span><span class="stat-val">${p.name || 'Sfidante'} ${p.avatar || '👤'}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_email}:</span><span class="stat-val">${p.email || 'N/D'}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_height}:</span><span class="stat-val">${height} cm</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_kit}:</span><span class="stat-val">${kitLabel}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_water_goal}:</span><span class="stat-val">${p.waterGoal || 2.5} L / die</span></div>
    </div>
    <div class="card">
      <div class="stat-row"><span class="stat-label">${t.lbl_start_w}:</span><span class="stat-val">${startWeight} kg</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_curr_w}:</span><span class="stat-val">${currentWeight} kg</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_target_w}:</span><span class="stat-val">${targetWeight} kg</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_delta_w}:</span><span class="stat-val" style="color: ${parseFloat(lostKg) > 0 ? '#10B981' : '#0f172a'};">${parseFloat(lostKg) > 0 ? '-' : '+'}${Math.abs(lostKg)} kg</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_chest} / ${t.lbl_waist} / ${t.lbl_hips}:</span><span class="stat-val">${p.chest || '-'} / ${p.waist || '-'} / ${p.hips || '-'} cm</span></div>
    </div>
  </div>

  <!-- 2. Sponsor & Coach Herbalife -->
  <div class="section-title">${t.sec_sponsor}</div>
  <div class="grid-2">
    <div class="card">
      <div class="stat-row"><span class="stat-label">${t.lbl_sponsor_name}:</span><span class="stat-val">${p.sponsorName || 'N/D'}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_sponsor_id}:</span><span class="stat-val">${p.sponsorId || 'N/D'}</span></div>
    </div>
    <div class="card">
      <div class="stat-row"><span class="stat-label">${t.lbl_sponsor_phone}:</span><span class="stat-val">${p.sponsorPhone || 'N/D'}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_sponsor_email}:</span><span class="stat-val">${p.sponsorEmail || 'N/D'}</span></div>
    </div>
  </div>

  <!-- 3. Stile di Vita, Abitudini & Salute -->
  <div class="section-title">${t.sec_lifestyle}</div>
  <div class="grid-2">
    <div class="card">
      <div class="stat-row"><span class="stat-label">${t.lbl_shape}:</span><span class="stat-val">${p.bodyShape || 'Normale'}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_lifestyle}:</span><span class="stat-val">${p.lifestyleType || 'Moderato'}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_gym}:</span><span class="stat-val">${p.gymFrequency || 'Nessuna'}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_coffee} / ${t.lbl_alc}:</span><span class="stat-val">${p.coffeeCount || 0} caffè | ${p.alcoholUsage || 'No'}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_sleep} / ${t.lbl_stress}:</span><span class="stat-val">${p.sleepQuality || 'Buona'} | Stress ${p.stressLevel || 'Medio'}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_habits}:</span><span class="stat-val" style="font-size: 10.5px;">${activeHabitsStr}</span></div>
    </div>
    <div class="card">
      <div class="stat-row"><span class="stat-label">${t.lbl_diet_type}:</span><span class="stat-val">${p.dietType || 'Onnivora'}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_current_diet}:</span><span class="stat-val">${p.currentDiet || 'Nessuna specifica'}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_supplements}:</span><span class="stat-val">${p.supplements || 'Nessuno specificato'}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_illnesses}:</span><span class="stat-val">${p.illnesses || 'Nessuna segnalata'}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_meds}:</span><span class="stat-val">${p.medications || 'Nessuno'}</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_health_notes}:</span><span class="stat-val" style="font-size: 10.5px;">${p.healthProblems || 'Nessuna'}</span></div>
    </div>
  </div>

  <!-- 4. Andamento, Metabolismo & Progressione (Sezione Andamento 1:1) -->
  <div class="section-title">${t.sec_andamento}</div>
  <div class="grid-3" style="margin-bottom: 10px;">
    <div class="kpi-card">
      <div class="kpi-label">${t.stat_lost_eff}</div>
      <div class="kpi-num" style="color: ${parseFloat(lostKg) > 0 ? '#10B981' : '#0f172a'};">${parseFloat(lostKg) > 0 ? '-' : '+'}${Math.abs(lostKg)} kg</div>
      <div style="font-size: 10.5px; color: #64748b; margin-top: 2px;">${startWeight.toFixed(1)} ➔ ${currentWeight.toFixed(1)} kg</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">${t.lbl_goal_progress}</div>
      <div class="kpi-num" style="color: #10B981;">${progressPct}%</div>
      <div class="progress-bar-track">
        <div class="progress-bar-fill" style="width: ${progressPct}%;"></div>
      </div>
      <div style="font-size: 10px; color: #64748b;">${remWeight} kg ${t.lbl_rem_weight}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">${t.lbl_metabolism_tdee}</div>
      <div class="kpi-num" style="color: #0f172a;">${bmr} / ${tdee} <span style="font-size: 10px; font-weight: 500;">kcal</span></div>
      <div style="font-size: 10.5px; color: #64748b; margin-top: 2px;">BMR / TDEE Stimato</div>
    </div>
  </div>

  <div class="grid-2" style="margin-bottom: 10px;">
    <div class="card">
      <div class="stat-row"><span class="stat-label">${t.lbl_weight_start_curr}:</span><span class="stat-val">${startWeight.toFixed(1)} ➔ ${currentWeight.toFixed(1)} kg</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_weight_target_and}:</span><span class="stat-val" style="color: #10B981;">${targetWeight.toFixed(1)} kg</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_weight_min_max}:</span><span class="stat-val">${minWeight} / ${maxWeight} kg</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_measures_summary}:</span><span class="stat-val">${p.chest || '-'} / ${p.waist || '-'} / ${p.hips || '-'} cm</span></div>
    </div>
    <div class="card">
      <div class="stat-row"><span class="stat-label">${t.lbl_target_deficit}:</span><span class="stat-val" style="color: #10B981;">${targetCalories} kcal / die</span></div>
      <div class="stat-row"><span class="stat-label">${t.lbl_lifestyle_habits}:</span><span class="stat-val">${lifeLabel} | ${gymLabel}</span></div>
      <div class="stat-row"><span class="stat-label">${t.stat_water_tot}:</span><span class="stat-val" style="color: #3b82f6;">${stats.totalWaterL} L (${daysWaterTarget}/10 gg a target)</span></div>
      <div class="stat-row"><span class="stat-label">${t.stat_compliance}:</span><span class="stat-val" style="color: #10B981;">${Math.round((stats.avgScore / 100) * 100)}%</span></div>
    </div>
  </div>

  <!-- 5. Scheda & Strategia Nutrizionale Personalizzata -->
  <div class="section-title">${t.sec_strategy}</div>
  <div class="grid-3" style="margin-bottom: 10px;">
    <div class="kpi-card">
      <div class="kpi-label">${t.lbl_bmi}</div>
      <div class="kpi-num">${bmi} <span class="badge ${bmiBadgeClass}">${bmiLabel}</span></div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">${t.lbl_calories}</div>
      <div class="kpi-num" style="color: #10B981;">${targetCalories} kcal</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">${t.lbl_macros}</div>
      <div style="font-size: 11px; font-weight: 700; margin-top: 3px;">
        <span style="color: #10B981;">P: ${pG}g (${pPct}%)</span> • 
        <span style="color: #3b82f6;">C: ${cG}g (${cPct}%)</span> • 
        <span style="color: #f59e0b;">F: ${fG}g (${fPct}%)</span>
      </div>
      <div class="macro-bar-wrap">
        <div class="macro-bar-p" style="width: ${pPct}%;"></div>
        <div class="macro-bar-c" style="width: ${cPct}%;"></div>
        <div class="macro-bar-f" style="width: ${fPct}%;"></div>
      </div>
    </div>
  </div>

  <div class="card" style="margin-bottom: 10px;">
    <div style="font-weight: 700; color: #0f172a; margin-bottom: 4px;">🎯 Linea Guida & Strategia Personalizzata:</div>
    <p style="margin: 0 0 6px 0; color: #475569; font-size: 11.5px;">${strategyText}</p>
    <div class="grid-2">
      <div>
        <strong style="color: #166534; font-size: 11px;">${t.lbl_rec_foods}:</strong>
        <ul class="bullet-list">
          ${t.recFoods.map(f => `<li>${f}</li>`).join('')}
        </ul>
      </div>
      <div>
        <strong style="color: #991b1b; font-size: 11px;">${t.lbl_avoid_foods}:</strong>
        <ul class="bullet-list">
          ${t.avoidFoods.map(f => `<li>${f}</li>`).join('')}
        </ul>
      </div>
    </div>
  </div>

  <!-- 6. Riepilogo Performance 10 Giorni -->
  <div class="section-title">${t.sec_perf}</div>
  <div class="grid-4" style="margin-bottom: 10px;">
    <div class="kpi-card">
      <div class="kpi-label">${t.lbl_days_comp}</div>
      <div class="kpi-num">${stats.daysCompleted}/10</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">${t.lbl_avg_score}</div>
      <div class="kpi-num" style="color: #10B981;">${stats.avgScore} pt</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">${t.lbl_total_water}</div>
      <div class="kpi-num" style="color: #3b82f6;">${stats.totalWaterL} L</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">${t.lbl_total_shakes}</div>
      <div class="kpi-num">${stats.totalShakes} 🥤</div>
    </div>
  </div>

  <!-- 7. Registro Giornaliero Dettagliato -->
  <div class="section-title">${t.sec_daily_log}</div>
  <table>
    <thead>
      <tr>
        <th>${t.th_day}</th>
        <th>${t.th_shakes}</th>
        <th>${t.th_water}</th>
        <th>${t.th_snack}</th>
        <th>${t.th_meal}</th>
        <th>${t.th_steps}</th>
        <th>${t.th_exercise}</th>
        <th>${t.th_weight}</th>
        <th>${t.th_score}</th>
      </tr>
    </thead>
    <tbody>
      ${dailyLogs.map((log, idx) => {
        const dayScore = typeof calculateDailyScore === 'function' ? calculateDailyScore(log) : 0;
        const exText = (log.exType && log.exType !== 'nessuno' && log.exDuration > 0)
          ? `${log.exType} (${log.exDuration}m)`
          : '—';
        const stepsText = log.steps ? `${log.steps}` : '—';
        return `
        <tr>
          <td><strong>${t.th_day} ${idx + 1}</strong></td>
          <td>${log.shakesCount || 0} 🥤</td>
          <td>${((log.water || 0) / 1000).toFixed(1)} L</td>
          <td>${log.snack ? t.yes : t.no}</td>
          <td>${log.meal ? t.yes : t.no}</td>
          <td>${stepsText}</td>
          <td>${exText}</td>
          <td>${(log.weight !== null && !isNaN(parseFloat(log.weight))) ? log.weight + ' kg' : '—'}</td>
          <td><span class="badge ${dayScore >= 80 ? 'badge-success' : (dayScore >= 50 ? 'badge-warning' : 'badge-neutral')}">${dayScore} pt</span></td>
        </tr>
      `;
      }).join('')}
    </tbody>
  </table>

  <!-- 8. Traguardi & Medaglie -->
  <div class="section-title">${t.sec_achievements}</div>
  <div class="grid-2">
    <div class="card">
      <div class="stat-row"><span class="stat-label">🚰 ${t.badge_water}:</span><span class="stat-val">${waterBadgeText}</span></div>
      <div class="stat-row"><span class="stat-label">🥤 ${t.badge_shakes}:</span><span class="stat-val">${shakeBadgeText}</span></div>
    </div>
    <div class="card">
      <div class="stat-row"><span class="stat-label">🌟 ${t.badge_perfect}:</span><span class="stat-val">${perfectBadgeText}</span></div>
      <div class="stat-row"><span class="stat-label">🏆 ${t.badge_finish}:</span><span class="stat-val">${finishBadgeText}</span></div>
    </div>
  </div>

  <!-- Footer Disclaimer -->
  <div class="footer">
    <p>${t.footer_disclaimer}</p>
  </div>

  <script>
    window.onload = function() {
      setTimeout(function() { window.print(); }, 350);
    };
  </script>
</body>
</html>
  `;

  printWindow.document.write(htmlContent);
  printWindow.document.close();
};

// ==========================================
// MEAL SCANNER INTERACTIVE SUBMIT
// ==========================================

const renderScannerResults = (stats, mealDesc = "") => {
  if (!stats) return;

  const calEl = document.getElementById("scan-calories-num");
  const pEl = document.getElementById("scan-protein-pct");
  const cEl = document.getElementById("scan-carbs-pct");
  const fEl = document.getElementById("scan-fats-pct");
  const pBar = document.getElementById("scan-protein-bar");
  const cBar = document.getElementById("scan-carbs-bar");
  const fBar = document.getElementById("scan-fats-bar");
  const adviceEl = document.getElementById("scan-coach-opinion");
  const ingListEl = document.getElementById("scan-detected-ingredients-list");

  const calories = stats.calories || 350;
  const protein = stats.protein || 20;
  const carbs = stats.carbs || 30;
  const fats = stats.fats || 10;

  if (calEl) calEl.textContent = calories;
  if (pEl) pEl.textContent = `${protein}g`;
  if (cEl) cEl.textContent = `${carbs}g`;
  if (fEl) fEl.textContent = `${fats}g`;

  const total = (protein + carbs + fats) || 1;
  if (pBar) pBar.style.width = `${(protein / total) * 100}%`;
  if (cBar) cBar.style.width = `${(carbs / total) * 100}%`;
  if (fBar) fBar.style.width = `${(fats / total) * 100}%`;

  // Render Coach Advice
  let adviceStr = "";
  if (typeof stats.advice === "object" && stats.advice !== null) {
    adviceStr = stats.advice[state.lang] || stats.advice.it || stats.advice.en || "";
  } else if (typeof stats.advice === "string") {
    adviceStr = stats.advice;
  }
  if (!adviceStr) {
    adviceStr = state.lang === "it"
      ? "Il tuo piatto è bilanciato! Ricorda di accompagnarlo con un bicchiere di Aloe Concentrato prima o dopo i pasti per stimolare la digestione."
      : "Your meal is balanced! Remember to pair it with a glass of Herbal Aloe Concentrate to support digestion.";
  }
  if (adviceEl) adviceEl.innerHTML = adviceStr;

  // Auto-detect and render country/store specific product cards for scanner advice
  const productContainer = document.getElementById("scan-coach-product-container");
  if (productContainer) {
    const storeId = typeof getStoreId === "function" ? getStoreId() : "herbaally";
    const detected = detectSuggestedProducts(adviceStr, storeId);
    if (detected && detected.length > 0) {
      productContainer.innerHTML = renderCoachProductCards(detected, state.lang);
      productContainer.style.display = "block";
    } else {
      productContainer.innerHTML = "";
      productContainer.style.display = "none";
    }
  }

  // Render Detected Ingredients List (ALWAYS populated)
  if (ingListEl) {
    ingListEl.innerHTML = "";
    let itemsList = [];

    if (Array.isArray(stats.detected_ingredients) && stats.detected_ingredients.length > 0) {
      itemsList = stats.detected_ingredients;
    } else if (typeof stats.detected_ingredients === "string" && stats.detected_ingredients.trim() !== "") {
      itemsList = stats.detected_ingredients.split(/,|\n|;/).map(s => s.trim()).filter(Boolean);
    } else if (Array.isArray(stats.ingredients) && stats.ingredients.length > 0) {
      itemsList = stats.ingredients;
    } else if (stats.dish_name) {
      itemsList = [stats.dish_name];
    } else if (mealDesc && mealDesc.trim() !== "") {
      itemsList = mealDesc.split(/,|\n|;/).map(s => s.trim()).filter(Boolean);
    } else {
      itemsList = [
        state.lang === "it" ? "Proteine magre (es. pollo/pesce/uova)" : "Lean protein (chicken/fish/eggs)",
        state.lang === "it" ? "Carboidrati complessi (es. riso/quinoa)" : "Complex carbs (rice/quinoa)",
        state.lang === "it" ? "Verdure fresche o cotte" : "Fresh or cooked vegetables"
      ];
    }

    itemsList.forEach(item => {
      const li = document.createElement("li");
      li.textContent = item;
      ingListEl.appendChild(li);
    });
  }
};

const compressImageForAI = (base64Str, maxDim = 800) => {
  return new Promise((resolve) => {
    if (!base64Str || !base64Str.startsWith("data:image")) return resolve(null);
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      let w = img.width;
      let h = img.height;
      if (w > maxDim || h > maxDim) {
        if (w > h) {
          h = Math.round((h * maxDim) / w);
          w = maxDim;
        } else {
          w = Math.round((w * maxDim) / h);
          h = maxDim;
        }
      }
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL("image/jpeg", 0.8));
    };
    img.onerror = () => resolve(base64Str);
    img.src = base64Str;
  });
};

const initMealScanner = () => {
  const form = document.getElementById("scanner-form");
  const upload = document.getElementById("scanner-image-input");
  const cameraUpload = document.getElementById("scanner-camera-input");
  const placeholder = document.getElementById("scanner-upload-placeholder");
  const preview = document.getElementById("scanner-preview-img");
  const btnCamera = document.getElementById("btn-trigger-camera");
  const btnGallery = document.getElementById("btn-trigger-gallery");
  
  if (!form || !placeholder) return;

  // Check and render initial product recommendations for placeholder scanner advice if present
  const initialAdviceEl = document.getElementById("scan-coach-opinion");
  const initialProdContainer = document.getElementById("scan-coach-product-container");
  if (initialAdviceEl && initialProdContainer && !initialProdContainer.innerHTML.trim()) {
    const storeId = typeof getStoreId === "function" ? getStoreId() : "herbaally";
    const detected = detectSuggestedProducts(initialAdviceEl.textContent, storeId);
    if (detected && detected.length > 0) {
      initialProdContainer.innerHTML = renderCoachProductCards(detected, state.lang);
      initialProdContainer.style.display = "block";
    }
  }
  
  const handleFileChange = (inputEl) => {
    if (inputEl && inputEl.files && inputEl.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (preview) {
          preview.src = e.target.result;
          preview.classList.remove("preview-hidden");
        }
        placeholder.classList.add("has-preview");
        if (placeholder.querySelector(".upload-icon")) placeholder.querySelector(".upload-icon").style.display = "none";
        if (placeholder.querySelector(".upload-text")) placeholder.querySelector(".upload-text").style.display = "none";
      };
      reader.readAsDataURL(inputEl.files[0]);
    }
  };

  if (upload) upload.addEventListener("change", () => handleFileChange(upload));
  if (cameraUpload) cameraUpload.addEventListener("change", () => handleFileChange(cameraUpload));

  if (btnCamera) {
    btnCamera.addEventListener("click", (e) => {
      e.preventDefault();
      if (cameraUpload) cameraUpload.click();
      else if (upload) upload.click();
    });
  }

  if (btnGallery) {
    btnGallery.addEventListener("click", (e) => {
      e.preventDefault();
      if (upload) upload.click();
    });
  }

  placeholder.addEventListener("click", () => {
    if (cameraUpload) cameraUpload.click();
    else if (upload) upload.click();
  });

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const hasImage = preview.src && preview.src.startsWith("data:image");
    if (!hasImage) {
      if (typeof showAppToast === "function") {
        showAppToast("Carica una foto 📸", "Scatta o seleziona la foto del tuo piatto per avviare la scansione AI.", "⚠️");
      }
      return;
    }
    
    const loader = document.getElementById("scanner-loader");
    const emptyBox = document.getElementById("scanner-empty-box");
    const dataBox = document.getElementById("scanner-data-box");
    const laserOverlay = document.getElementById("scanner-image-laser");
    const progressFill = document.getElementById("scanner-progress-fill");
    const progressPct = document.getElementById("scanner-progress-pct");
    
    emptyBox.style.display = "none";
    dataBox.style.display = "none";
    loader.style.display = "flex";
    if (laserOverlay) laserOverlay.style.display = "block";
    if (progressFill) progressFill.style.width = "0%";
    if (progressPct) progressPct.textContent = "0%";

    // Smooth progressive fill animation during AI scan
    let curPct = 0;
    const progressInterval = setInterval(() => {
      if (curPct < 88) {
        curPct += Math.floor(Math.random() * 8) + 4;
        if (curPct > 88) curPct = 88;
        if (progressFill) progressFill.style.width = `${curPct}%`;
        if (progressPct) progressPct.textContent = `${curPct}%`;
      }
    }, 120);

    const finishProgress = async () => {
      clearInterval(progressInterval);
      if (progressFill) progressFill.style.width = "100%";
      if (progressPct) progressPct.textContent = "100%";
      await new Promise(r => setTimeout(r, 250));
      if (laserOverlay) laserOverlay.style.display = "none";
      loader.style.display = "none";
      dataBox.style.display = "block";
    };

    const compressedImage = await compressImageForAI(preview.src, 800);

    const storeId = getStoreId();
    try {
      const res = await fetch(`${API_BASE_URL}/scanner`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          store_id: storeId,
          lang: state.lang,
          image_base64: compressedImage,
          meal_description: ""
        })
      });
      const data = await res.json();
      await finishProgress();

      const saveScanResult = (resultStats) => {
        const scannedMealData = {
          image: compressedImage || preview.src,
          stats: resultStats,
          day: state.activeDay,
          timestamp: new Date().toISOString()
        };

        // Store in current active day log
        const currentLog = state.dailyLogs[state.activeDay - 1];
        currentLog.scannedMeal = scannedMealData;
        currentLog.meal = true; // Auto-check balanced meal log!

        // Save state to storage
        saveStateToStorage();

        // Refresh UI elements
        updateDailyScoreUI();
        updateChallengeSummaryUI();
        renderDaySelector();
        loadActiveDayLogs();
        checkAndAwardBadges();

        if (typeof showAppToast === "function") {
          showAppToast(
            state.lang === "it" ? "Pasto Scansionato e Salvato! 🥗" : "Meal Scanned & Saved! 🥗",
            state.lang === "it" ? `Registrato nel Diario del Giorno ${state.activeDay} (+15 pt).` : `Saved to Day ${state.activeDay} logbook (+15 pt).`,
            "✅"
          );
        }
      };

      if (data.success && data.result) {
        renderScannerResults(data.result, "");
        saveScanResult(data.result);
      } else {
        const stats = analyzeMealWithAISimulator("");
        renderScannerResults(stats, "");
        saveScanResult(stats);
      }
    } catch (err) {
      console.warn("[ScannerAPI] Fallback to simulator:", err);
      await finishProgress();
      const stats = analyzeMealWithAISimulator("");
      renderScannerResults(stats, "");
      saveScanResult(stats);
    }
  });
};

const restoreScannerState = () => {
  const currentLog = state.dailyLogs[state.activeDay - 1];
  const scannedMeal = currentLog ? currentLog.scannedMeal : null;

  const preview = document.getElementById("scanner-preview-img");
  const placeholder = document.getElementById("scanner-upload-placeholder");
  const emptyBox = document.getElementById("scanner-empty-box");
  const dataBox = document.getElementById("scanner-data-box");
  const loader = document.getElementById("scanner-loader");
  const laserOverlay = document.getElementById("scanner-image-laser");

  if (laserOverlay) laserOverlay.style.display = "none";

  if (!scannedMeal || !scannedMeal.stats) {
    if (emptyBox) emptyBox.style.display = "flex";
    if (dataBox) dataBox.style.display = "none";
    if (loader) loader.style.display = "none";
    if (preview) preview.classList.add("preview-hidden");
    if (placeholder) {
      placeholder.classList.remove("has-preview");
      const icon = typeof placeholder.querySelector === 'function' ? placeholder.querySelector(".upload-icon") : null;
      if (icon) icon.style.display = "block";
      const txt = typeof placeholder.querySelector === 'function' ? placeholder.querySelector(".upload-text") : null;
      if (txt) txt.style.display = "block";
    }
    return;
  }

  if (preview && scannedMeal.image) {
    preview.src = scannedMeal.image;
    preview.classList.remove("preview-hidden");
  }
  if (placeholder) {
    placeholder.classList.add("has-preview");
    const icon = typeof placeholder.querySelector === 'function' ? placeholder.querySelector(".upload-icon") : null;
    if (icon) icon.style.display = "none";
    const txt = typeof placeholder.querySelector === 'function' ? placeholder.querySelector(".upload-text") : null;
    if (txt) txt.style.display = "none";
  }
  if (emptyBox) emptyBox.style.display = "none";
  if (loader) loader.style.display = "none";
  if (dataBox) dataBox.style.display = "block";

  renderScannerResults(scannedMeal.stats, "");
};

const askCoachAI = async (query) => {
  const storeId = getStoreId();
  appendChatMessage(query, "user");
  const loadingMsgId = "bot-loading-" + Date.now();
  
  const loadingCard = document.createElement("div");
  loadingCard.className = "chat-message bot";
  loadingCard.id = loadingMsgId;
  loadingCard.innerHTML = `<div class="chat-bubble">🤖 <em>${state.lang === 'it' ? 'Il Coach sta consultando la Knowledge Base...' : 'Coach is reading knowledge base...'}</em></div>`;
  const box = document.getElementById("chat-messages-box");
  if (box) { box.appendChild(loadingCard); box.scrollTop = box.scrollHeight; }

  try {
    const res = await fetch(`${API_BASE_URL}/coach`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        store_id: storeId,
        lang: state.lang,
        query: query,
        active_day: state.activeDay,
        user_context: {
          startWeight: state.profile.startWeight,
          targetWeight: state.profile.targetWeight,
          waterGoal: state.profile.waterGoal
        }
      })
    });
    const data = await res.json();
    const loadingEl = document.getElementById(loadingMsgId);
    if (loadingEl) loadingEl.remove();

    if (data.success && data.reply) {
      appendChatMessage(data.reply, "bot");
    } else {
      const fallbackReply = handleBotReply(query);
      appendChatMessage(fallbackReply, "bot");
    }
  } catch (err) {
    console.warn("[CoachAPI] Fallback to local reply:", err);
    const loadingEl = document.getElementById(loadingMsgId);
    if (loadingEl) loadingEl.remove();
    const fallbackReply = handleBotReply(query);
    appendChatMessage(fallbackReply, "bot");
  }
};

const initChatbot = () => {
  const form = document.getElementById("chat-form");
  const input = document.getElementById("chat-input-field");
  if (!form || !input) return;
  
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const query = input.value;
    if (query.trim() === "") return;
    
    input.value = "";
    askCoachAI(query);
  });
  
  document.querySelectorAll(".suggestion-chips .chip").forEach(chip => {
    chip.addEventListener("click", () => {
      const query = chip.getAttribute("data-question");
      askCoachAI(query);
    });
  });
};

// ==========================================
// OTHER INTERACTION BINDINGS
// ==========================================

const initChecklistListeners = () => {
  const shakeSelect = document.getElementById("select-shakes-count");
  const chkSnack = document.getElementById("chk-snack");
  const chkMeal = document.getElementById("chk-meal");
  const stepsInput = document.getElementById("input-daily-steps");
  const kmInput = document.getElementById("input-daily-km");
  const exTypeSelect = document.getElementById("select-exercise-type");
  const exDurationInput = document.getElementById("input-exercise-duration");
  const weightInput = document.getElementById("input-daily-weight");
  
  // Real-time auto-saver for all habit, nutrition, movement & weight inputs
  const autoSaveHabits = () => {
    const log = state.dailyLogs[state.activeDay - 1];
    if (!log) return;

    if (shakeSelect) log.shakesCount = parseInt(shakeSelect.value, 10) || 0;
    if (chkSnack) log.snack = chkSnack.checked;
    if (chkMeal) log.meal = chkMeal.checked;
    if (stepsInput) log.steps = parseInt(stepsInput.value, 10) || 0;
    if (kmInput) log.km = parseFloat(kmInput.value) || 0;
    if (exTypeSelect) log.exType = exTypeSelect.value;
    if (exDurationInput) log.exDuration = parseInt(exDurationInput.value, 10) || 0;

    if (weightInput) {
      const val = parseFloat(weightInput.value);
      if (!isNaN(val) && val >= 30 && val <= 250) {
        log.weight = val;
      } else if (weightInput.value.trim() === "") {
        log.weight = null;
      }
    }
    
    saveStateToStorage();
    updateDailyScoreUI();
    updateChallengeSummaryUI();
    renderDaySelector();
    checkAndAwardBadges();
    
    if (shakeSelect) {
      const shakePoints = log.shakesCount >= 2 ? 20 : (log.shakesCount === 1 ? 10 : 0);
      const pointsDisplay = document.getElementById("points-shakes-display");
      if (pointsDisplay) pointsDisplay.textContent = `+${shakePoints} pt`;
    }
  };

  if (shakeSelect) {
    shakeSelect.addEventListener("change", autoSaveHabits);
    shakeSelect.addEventListener("input", autoSaveHabits);
  }
  if (chkSnack) chkSnack.addEventListener("change", autoSaveHabits);
  if (chkMeal) chkMeal.addEventListener("change", autoSaveHabits);

  // Two-way synchronization between Steps and Distance (km) + Real-time auto save
  if (stepsInput && kmInput) {
    const getStrideM = () => {
      const height = (state.profile && state.profile.height && !isNaN(parseFloat(state.profile.height))) 
        ? parseFloat(state.profile.height) 
        : 170;
      return (height * 0.415) / 100;
    };

    stepsInput.addEventListener("input", () => {
      if (document.activeElement === stepsInput) {
        const rawSteps = stepsInput.value.trim();
        if (rawSteps === "" || isNaN(parseInt(rawSteps, 10))) {
          kmInput.value = "";
        } else {
          const steps = parseInt(rawSteps, 10);
          if (steps <= 0) {
            kmInput.value = "";
          } else {
            const strideM = getStrideM();
            const km = (steps * strideM) / 1000;
            kmInput.value = km < 10 ? km.toFixed(2) : km.toFixed(1);
          }
        }
      }
      autoSaveHabits();
    });

    kmInput.addEventListener("input", () => {
      if (document.activeElement === kmInput) {
        const rawKm = kmInput.value.trim();
        if (rawKm === "" || isNaN(parseFloat(rawKm))) {
          stepsInput.value = "";
        } else {
          const km = parseFloat(rawKm);
          if (km <= 0) {
            stepsInput.value = "";
          } else {
            const strideM = getStrideM();
            const steps = Math.round((km * 1000) / strideM);
            stepsInput.value = steps;
          }
        }
      }
      autoSaveHabits();
    });
  }

  if (exTypeSelect) {
    exTypeSelect.addEventListener("change", autoSaveHabits);
  }
  if (exDurationInput) {
    exDurationInput.addEventListener("input", autoSaveHabits);
    exDurationInput.addEventListener("change", autoSaveHabits);
  }
  if (weightInput) {
    weightInput.addEventListener("input", autoSaveHabits);
    weightInput.addEventListener("change", autoSaveHabits);
  }

  // Save Movement button (kept for user comfort but shows sleek feedback, no blocking alert)
  const saveMoveBtn = document.getElementById("btn-save-movement");
  if (saveMoveBtn) {
    saveMoveBtn.addEventListener("click", (e) => {
      e.preventDefault();
      autoSaveHabits();
      const origText = saveMoveBtn.textContent;
      saveMoveBtn.textContent = state.lang === "it" ? "Salvato! ✓" : "Saved! ✓";
      saveMoveBtn.style.background = "#10B981";
      saveMoveBtn.style.color = "#FFFFFF";
      setTimeout(() => {
        saveMoveBtn.textContent = origText;
        saveMoveBtn.style.background = "";
        saveMoveBtn.style.color = "";
      }, 1500);
    });
  }

  // Save Weight button (kept for user comfort but shows sleek feedback, no blocking alert)
  const saveWeightBtn = document.getElementById("btn-save-weight");
  if (saveWeightBtn) {
    saveWeightBtn.addEventListener("click", (e) => {
      e.preventDefault();
      autoSaveHabits();
      const origText = saveWeightBtn.textContent;
      saveWeightBtn.textContent = state.lang === "it" ? "Salvato! ✓" : "Saved! ✓";
      saveWeightBtn.style.background = "#10B981";
      saveWeightBtn.style.color = "#FFFFFF";
      setTimeout(() => {
        saveWeightBtn.textContent = origText;
        saveWeightBtn.style.background = "";
        saveWeightBtn.style.color = "";
      }, 1500);
    });
  }
};

const initNavigation = () => {
  let lastNavTime = 0;
  let touchStartX = 0;
  let touchStartY = 0;
  let touchMoved = false;

  const bottomNav = document.getElementById("app-bottom-nav");
  if (bottomNav) {
    bottomNav.addEventListener("touchstart", (e) => {
      if (e.touches && e.touches.length > 0) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchMoved = false;
      }
    }, { passive: true });

    bottomNav.addEventListener("touchmove", (e) => {
      if (e.touches && e.touches.length > 0) {
        const dx = Math.abs(e.touches[0].clientX - touchStartX);
        const dy = Math.abs(e.touches[0].clientY - touchStartY);
        if (dx > 6 || dy > 6) {
          touchMoved = true;
        }
      }
    }, { passive: true });
  }

  const handleNav = (e) => {
    if (touchMoved) {
      touchMoved = false;
      if (e && typeof e.preventDefault === "function" && e.cancelable) e.preventDefault();
      return;
    }

    const now = Date.now();
    if (now - lastNavTime < 180) return;
    lastNavTime = now;

    const btn = e.currentTarget || e.target.closest(".nav-item");
    if (!btn) return;
    const targetId = btn.getAttribute("data-target");
    if (!targetId) return;

    document.querySelectorAll(".app-page").forEach(page => {
      page.classList.remove("active");
    });

    const targetPage = document.getElementById(targetId);
    if (targetPage) {
      targetPage.classList.add("active");
      syncNavigationUI(targetId);
      updateHeaderMetadata();

      if (targetId === "page-classifica") {
        renderLeaderboard();
      } else if (targetId === "page-grafici" || targetId === "page-piano") {
        renderCharts();
        updateNutritionalStrategyUI();
        checkAndAwardBadges();
      } else if (targetId === "page-ricette") {
        renderRecipes();
      } else if (targetId === "page-community") {
        if (typeof fetchCoachDownlineContacts === "function") {
          fetchCoachDownlineContacts().then(() => {
            if (typeof renderChatChannelsList === "function") renderChatChannelsList();
          });
        }
        if (typeof renderChatChannelsList === "function") renderChatChannelsList();
        renderCommunityChat();
        fetchCommunityMessages();
      } else if (targetId === "page-coach") {
        renderChatHistory();
      } else if (targetId === "page-scanner") {
        restoreScannerState();
      } else if (targetId === "page-coach-dashboard") {
        loadCoachDashboardData();
      } else if (targetId === "page-super-admin") {
        loadSuperAdminDashboardData();
      } else if (targetId === "page-pacchetti") {
        if (typeof updatePackagesUI === "function") updatePackagesUI();
      } else if (targetId === "page-profilo") {
        if (typeof populateProfileFormFields === "function") populateProfileFormFields();
        if (typeof updateAccountUI === "function") updateAccountUI();
        if (typeof updateProfileHeroBar === "function") updateProfileHeroBar();
        if (typeof updatePackagesUI === "function") updatePackagesUI();
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const navItems = document.querySelectorAll(".nav-item");
  navItems.forEach(item => {
    item.addEventListener("click", handleNav);
  });
};

const initResetHandler = () => {
  const btn = document.getElementById("btn-reset-challenge");
  if (!btn) return;
  btn.addEventListener("click", () => {
    const confirm = window.confirm("ATTENZIONE! Vuoi davvero resettare tutti i dati del Programma 10 Giorni?");
    if (confirm) {
      state.dailyLogs = Array.from({ length: 10 }, () => ({
        shakesCount: 0,
        water: 0,
        snack: false,
        meal: false,
        steps: 0,
        km: 0,
        exType: "nessuno",
        exDuration: 0,
        weight: null
      }));
      state.activeDay = 1;
      saveStateToStorage();
      
      renderDaySelector();
      loadActiveDayLogs();
      alert("Azzurato! Ricomincia!");
      document.querySelector('[data-target="page-diario"]').click();
    }
  });
};

// ==========================================
// WORKOUT VIDEO MODAL & INTERACTION HANDLERS
// ==========================================

let activeWorkoutModalId = null;

const openWorkoutVideoModal = (workoutId) => {
  const modal = document.getElementById("workout-video-modal");
  if (!modal) return;

  const w = WORKOUT_VIDEOS.find(item => item.id === workoutId);
  if (!w) return;

  activeWorkoutModalId = workoutId;
  const currentLang = state.lang || 'it';

  const t = (item, prop) => {
    if (currentLang === 'it') return item[prop];
    const localized = item[`${prop}_${currentLang}`];
    return localized ? localized : item[prop];
  };

  // Tags / Badges
  const tagsContainer = document.getElementById("workout-modal-tags");
  if (tagsContainer) {
    let catName = "🟢 Fase 1: Start (G. 1–7)";
    if (w.isRest) catName = "🧘 Rest & Rigenerazione";
    else if (w.phase === 'fase2') catName = "🔵 Fase 2: Ritmo (G. 8–14)";
    else if (w.phase === 'fase3') catName = "🟣 Fase 3: Peak (G. 15–21)";

    let goalName = "Giorno " + String(w.dayNumber || 1).padStart(2, '0');
    const eqText = t(w, 'equipment') || 'Corpo Libero & Tappetino';

    tagsContainer.innerHTML = `
      <span class="badge badge-primary" style="font-size: 11px; padding: 4px 10px; border-radius: 8px;">${catName}</span>
      <span class="badge badge-outline" style="font-size: 11px; padding: 4px 10px; border-radius: 8px; border-color: rgba(59, 130, 246, 0.4); color: #60a5fa;">📅 ${goalName}</span>
      <span class="badge" style="font-size: 11px; padding: 4px 10px; border-radius: 8px; background: rgba(255,255,255,0.08); color: #E2E8F0;">🏋️ ${escapeHtml(eqText)}</span>
    `;
  }

  // Title & Desc
  const titleEl = document.getElementById("workout-modal-title");
  const descEl = document.getElementById("workout-modal-desc");
  if (titleEl) titleEl.textContent = t(w, 'title');
  if (descEl) descEl.textContent = t(w, 'desc');

  // Video Embed (Vimeo Player with Privacy Hash Support + Fallback YouTube)
  const embedContainer = document.getElementById("workout-video-embed-container");
  if (embedContainer) {
    if (w.vimeoId) {
      const vimeoSrc = `https://player.vimeo.com/video/${w.vimeoId}${w.vimeoHash ? `?h=${w.vimeoHash}&` : '?'}autoplay=1&badge=0&autopause=0&player_id=0&app_id=58479`;
      embedContainer.innerHTML = `
        <iframe src="${vimeoSrc}" 
          title="${escapeHtml(t(w, 'title'))}" 
          frameborder="0" 
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" 
          allowfullscreen 
          style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; border: none; border-radius: 12px;">
        </iframe>
      `;
    } else if (w.youtubeId) {
      embedContainer.innerHTML = `
        <iframe src="https://www.youtube-nocookie.com/embed/${w.youtubeId}?autoplay=1&rel=0&modestbranding=1" 
          title="${escapeHtml(t(w, 'title'))}" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen 
          style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; border: none; border-radius: 12px;">
        </iframe>
      `;
    }
  }

  // Stats
  const durEl = document.getElementById("workout-stat-duration");
  const intEl = document.getElementById("workout-stat-intensity");
  const calEl = document.getElementById("workout-stat-calories");
  if (durEl) durEl.textContent = w.duration;
  if (intEl) intEl.textContent = t(w, 'intensity');
  if (calEl) calEl.textContent = w.calories;

  // Exercises List
  const exercisesContainer = document.getElementById("workout-exercises-list");
  if (exercisesContainer && w.exercises) {
    exercisesContainer.innerHTML = w.exercises.map(ex => `<li>${escapeHtml(ex)}</li>`).join('');
  }

  // Peri-Workout Nutrition Guidance Box
  const nutritionContainer = document.getElementById("workout-nutrition-box");
  if (nutritionContainer) {
    const storeId = typeof getStoreId === 'function' ? getStoreId() : 'herbaally';
    const storeCat = STORE_PRODUCTS_CATALOG[storeId] || STORE_PRODUCTS_CATALOG.herbaally;
    
    let prodsHtml = '';
    if (w.productKeys && storeCat && storeCat.products) {
      w.productKeys.forEach(pk => {
        const prod = storeCat.products[pk];
        if (prod) {
          prodsHtml += `
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 10px; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 10px; padding: 8px 12px; margin-top: 8px;">
              <div style="display: flex; align-items: center; gap: 10px; min-width: 0;">
                <img src="${prod.image}" alt="${prod.title}" style="width: 36px; height: 36px; object-fit: cover; border-radius: 6px;">
                <div style="min-width: 0;">
                  <div style="font-size: 12.5px; font-weight: 700; color: #FFFFFF; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${prod.title}</div>
                  <div style="font-size: 11px; color: #94A3B8;">${prod.category || 'Nutrizione Sportiva'}</div>
                </div>
              </div>
              <a href="${prod.url}" target="_blank" rel="noopener noreferrer" class="btn-product-buy" style="font-size: 11px; padding: 5px 10px; white-space: nowrap; text-decoration: none; border-radius: 6px; background: #10B981; color: #FFFFFF; font-weight: 700;">
                Vedi Prodotto ↗
              </a>
            </div>
          `;
        }
      });
    }

    nutritionContainer.innerHTML = `
      <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px;">
        <span style="font-size: 16px;">🥤</span>
        <span style="font-size: 13px; font-weight: 800; color: #34D399;">Consiglio del Coach Peri-Workout:</span>
      </div>
      <p style="font-size: 12.5px; color: var(--text-muted); margin: 0 0 8px; line-height: 1.45;">
        ${t(w, 'nutritionTip')}
      </p>
      ${prodsHtml}
    `;
  }

  modal.style.display = "flex";
  document.body.style.overflow = "hidden";
};

const closeWorkoutVideoModal = () => {
  const modal = document.getElementById("workout-video-modal");
  if (!modal) return;

  // Clear iframe to stop video sound playback immediately
  const embedContainer = document.getElementById("workout-video-embed-container");
  if (embedContainer) embedContainer.innerHTML = "";

  modal.style.display = "none";
  document.body.style.overflow = "";
  activeWorkoutModalId = null;
};

// ==========================================
// RECIPES & WORKOUT HUB RENDER ENGINE
// ==========================================

const openCoachGuideModal = (guideId) => {
  const modal = document.getElementById("coach-guide-modal");
  if (!modal) return;

  const g = COACH_GUIDES.find(item => item.id === guideId);
  if (!g) return;

  activeCoachGuideId = guideId;
  const currentLang = state.lang || 'it';
  const langDict = TRANSLATIONS[currentLang] || TRANSLATIONS.it;

  const t = (item, prop) => {
    if (currentLang === 'it') return item[prop];
    const localized = item[`${prop}_${currentLang}`];
    return localized ? localized : item[prop];
  };

  // Header
  const headerEl = document.getElementById("guide-modal-header");
  if (headerEl) {
    const badgeTxt = langDict.badge_why_important || "PERCHÉ È IMPORTANTE";
    headerEl.innerHTML = `
      <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 8px;">
        <div style="width: 48px; height: 48px; border-radius: 14px; background: ${g.gradient}; display: flex; align-items: center; justify-content: center; font-size: 24px; box-shadow: 0 4px 14px rgba(0,0,0,0.25);">
          ${g.icon}
        </div>
        <div>
          <span class="badge badge-primary" style="font-size: 11px; text-transform: uppercase;">${badgeTxt}</span>
        </div>
      </div>
      <h3 class="guide-modal-title">${t(g, 'title')}</h3>
      <p class="guide-modal-subtitle">${t(g, 'desc')}</p>
    `;
  }

  // Body
  const bodyEl = document.getElementById("guide-modal-body");
  if (bodyEl) {
    bodyEl.innerHTML = t(g, 'htmlContent');
  }

  // Products Box
  const prodsContainer = document.getElementById("guide-modal-products");
  if (prodsContainer) {
    const storeId = typeof getStoreId === 'function' ? getStoreId() : 'herbaally';
    const storeCat = STORE_PRODUCTS_CATALOG[storeId] || STORE_PRODUCTS_CATALOG.herbaally;
    
    let prodsHtml = '';
    if (g.productKeys && storeCat && storeCat.products) {
      g.productKeys.forEach(pk => {
        const prod = storeCat.products[pk];
        if (prod) {
          const viewBtnTxt = langDict.guide_modal_view_prod || "Vedi Prodotto ↗";
          prodsHtml += `
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 10px; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 10px; padding: 8px 12px; margin-top: 8px;">
              <div style="display: flex; align-items: center; gap: 10px; min-width: 0;">
                <img src="${prod.image}" alt="${prod.title}" style="width: 36px; height: 36px; object-fit: cover; border-radius: 6px;">
                <div style="min-width: 0;">
                  <div style="font-size: 12.5px; font-weight: 700; color: #FFFFFF; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${prod.title}</div>
                  <div style="font-size: 11px; color: #94A3B8;">${prod.category || 'Nutrizione Mirata'}</div>
                </div>
              </div>
              <a href="${prod.url}" target="_blank" rel="noopener noreferrer" class="btn-product-buy" style="font-size: 11px; padding: 5px 10px; white-space: nowrap; text-decoration: none; border-radius: 6px; background: #10B981; color: #FFFFFF; font-weight: 700;">
                ${viewBtnTxt}
              </a>
            </div>
          `;
        }
      });
    }

    if (prodsHtml) {
      const headingTxt = langDict.guide_modal_rec_prods || "🌿 Integrazione Herbalife Consigliata in Questa Guida:";
      prodsContainer.innerHTML = `
        <div style="margin-top: 16px; padding: 14px 16px; background: rgba(16, 185, 129, 0.08); border: 1px solid rgba(16, 185, 129, 0.25); border-radius: 14px;">
          <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px;">
            <span style="font-size: 16px;">🌿</span>
            <span style="font-size: 13px; font-weight: 800; color: #34D399;">${headingTxt}</span>
          </div>
          ${prodsHtml}
        </div>
      `;
    } else {
      prodsContainer.innerHTML = '';
    }
  }

  // Understood Button
  const understoodBtn = document.getElementById("btn-understood-guide");
  if (understoodBtn) {
    understoodBtn.textContent = langDict.guide_modal_understood || "👍 Ho Capito! Applica al Mio Benessere";
  }

  modal.style.display = "flex";
  document.body.style.overflow = "hidden";
};

const closeCoachGuideModal = () => {
  const modal = document.getElementById("coach-guide-modal");
  if (!modal) return;
  modal.style.display = "none";
  document.body.style.overflow = "";
  activeCoachGuideId = null;
};

if (typeof window !== 'undefined') {
  window.openCoachGuideModal = openCoachGuideModal;
  window.closeCoachGuideModal = closeCoachGuideModal;
}

const renderDailyCoachFocusBanner = () => {
  const banner = document.getElementById("daily-coach-focus-card");
  if (!banner) return;

  const currentDay = state.activeDay || 1;
  const currentLang = state.lang || 'it';
  const langDict = TRANSLATIONS[currentLang] || TRANSLATIONS.it;

  const guideMap = {
    1: "guide_water",
    2: "guide_sleep",
    3: "guide_hunger",
    4: "guide_walking",
    5: "guide_skip_meals",
    6: "guide_balanced_plate",
    7: "guide_bloat",
    8: "guide_water",
    9: "guide_hunger",
    10: "guide_walking"
  };

  const guideId = guideMap[currentDay] || "guide_water";
  const g = COACH_GUIDES.find(item => item.id === guideId) || COACH_GUIDES[0];

  const t = (item, prop) => {
    if (currentLang === 'it') return item[prop];
    const localized = item[`${prop}_${currentLang}`];
    return localized ? localized : item[prop];
  };

  const badgeEl = document.getElementById("focus-card-day-badge");
  const titleEl = document.getElementById("focus-card-title");
  const descEl = document.getElementById("focus-card-desc");
  const btnEl = document.getElementById("btn-read-daily-guide");

  const prefix = langDict.focus_banner_prefix || "💡 Perché è Importante — Giorno";
  const btnTxt = langDict.focus_banner_btn || "Leggi Guida";

  if (badgeEl) badgeEl.textContent = `${prefix} ${currentDay}`;
  if (titleEl) titleEl.textContent = t(g, 'title');
  if (descEl) descEl.textContent = t(g, 'desc');

  if (btnEl) {
    btnEl.innerHTML = `<span>${btnTxt}</span> →`;
    btnEl.onclick = (e) => {
      e.preventDefault();
      openCoachGuideModal(g.id);
    };
  }
};

let activeWorkoutSubCategory = "all";
let activeMealSubCategory = "all";

const FOOD_PHOTOGRAPHY_MAP = {
  chicken: 'assets/balanced_lunch_chicken.png',
  cod: 'assets/lunch_cod_sweetpotato.png',
  shrimp: 'assets/lunch_shrimp_blackrice.png',
  salmon: 'assets/dinner_salmon_steamed.png',
  omelet: 'assets/dinner_spinach_omelet.png',
  fish: 'assets/balanced_dinner_fish.png',
  hummus: 'assets/snack_hummus_veggies.png',
  protein_bar: 'assets/snack_protein_bar.png',
  yogurt: 'assets/healthy_afternoon_snack.png',
  shake_green: 'assets/breakfast_shake_aloe.png',
  shake_berries: 'assets/breakfast_vanilla_berries.png',

  beef: 'https://images.unsplash.com/photo-1544025162-d76694265947?w=600&auto=format&fit=crop&q=80',
  turkey: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=600&auto=format&fit=crop&q=80',
  quinoa: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=600&auto=format&fit=crop&q=80',
  tofu: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=600&auto=format&fit=crop&q=80',
  lentil: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=600&auto=format&fit=crop&q=80',
  pumpkin: 'https://images.unsplash.com/photo-1476718406336-bb5a9690ee2a?w=600&auto=format&fit=crop&q=80',
  pasta: 'https://images.unsplash.com/photo-1621996346565-e3d5d6281696?w=600&auto=format&fit=crop&q=80',
  tuna: 'https://images.unsplash.com/photo-1546793665-c74683f339c1?w=600&auto=format&fit=crop&q=80',
  wrap: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=600&auto=format&fit=crop&q=80',
  swordfish: 'https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=600&auto=format&fit=crop&q=80',
  pancake: 'https://images.unsplash.com/photo-1528207776546-365bb710ee93?w=600&auto=format&fit=crop&q=80',
  iced_coffee: 'https://images.unsplash.com/photo-1517701550927-30cf4ba1dba5?w=600&auto=format&fit=crop&q=80',
  apple_pb: 'https://images.unsplash.com/photo-1568702846914-96b305d2aaeb?w=600&auto=format&fit=crop&q=80',
  smoothie: 'https://images.unsplash.com/photo-1553530666-ba11a7da3888?w=600&auto=format&fit=crop&q=80',
  mango: 'https://images.unsplash.com/photo-1546173159-315724a31696?w=600&auto=format&fit=crop&q=80',
  chocolate: 'https://images.unsplash.com/photo-1572490122747-3968b75cc699?w=600&auto=format&fit=crop&q=80'
};

const getRecipeImageUrl = (recipe) => {
  if (recipe && recipe.img) {
    return recipe.img.startsWith('http') ? recipe.img : getAssetUrl(recipe.img);
  }
  return getAssetUrl('assets/breakfast_shake_aloe.png');
};

const renderRecipes = (categoryFilter = "all", searchQuery = "", workoutSubFilter = activeWorkoutSubCategory, mealSubFilter = activeMealSubCategory) => {
  const grid = document.getElementById("recipes-list-grid");
  if (!grid) return;

  activeWorkoutSubCategory = workoutSubFilter;
  activeMealSubCategory = mealSubFilter;
  const currentLang = state.lang || 'it';
  const langDict = TRANSLATIONS[currentLang] || TRANSLATIONS.it;

  const t = (item, prop) => {
    if (currentLang === 'it') return item[prop];
    const localized = item[`${prop}_${currentLang}`];
    return localized ? localized : item[prop];
  };

  const storeId = typeof getStoreId === 'function' ? getStoreId() : 'herbaally';
  const storeCat = STORE_PRODUCTS_CATALOG[storeId] || STORE_PRODUCTS_CATALOG.herbaally;

  // Update tabs text dynamically from translations
  const tabAll = document.querySelector('.tab-btn[data-category="all"]');
  const tabMeals = document.querySelector('.tab-btn[data-category="pasti"]');
  const tabShakes = document.querySelector('.tab-btn[data-category="frullati"]');
  const tabSnacks = document.querySelector('.tab-btn[data-category="snack"]');
  const tabWorkouts = document.querySelector('.tab-btn[data-category="allenamento"]');
  const tabTips = document.querySelector('.tab-btn[data-category="consigli"]');
  const searchInput = document.getElementById('recipes-search-input') || document.getElementById('recipe-search');

  if (tabAll) tabAll.textContent = langDict.tab_all || "Tutte";
  if (tabMeals) tabMeals.textContent = langDict.tab_meals || "🥗 Pasti Sani";
  if (tabShakes) tabShakes.textContent = langDict.tab_shakes || "Frullati F1";
  if (tabSnacks) tabSnacks.textContent = langDict.tab_snacks || "Spuntini Sani";
  if (tabWorkouts) tabWorkouts.textContent = langDict.tab_workouts || "🏋️ Video Allenamenti";
  if (tabTips) tabTips.textContent = langDict.tab_why_important || langDict.tab_tips || "💡 Perché è Importante";
  if (searchInput) searchInput.placeholder = langDict.search_recipes_placeholder || "Cerca ingredienti o ricette...";

  grid.innerHTML = "";

  // 1. IF CATEGORY IS "allenamento" -> RENDER WORKOUT VIDEOS
  if (categoryFilter === "allenamento") {
    const filteredWorkouts = WORKOUT_VIDEOS.filter(w => {
      let matchSub = true;
      if (workoutSubFilter && workoutSubFilter !== "all") {
        if (workoutSubFilter === "fase1") {
          matchSub = w.phase === "fase1" || (w.dayNumber >= 1 && w.dayNumber <= 7);
        } else if (workoutSubFilter === "fase2") {
          matchSub = w.phase === "fase2" || (w.dayNumber >= 8 && w.dayNumber <= 14);
        } else if (workoutSubFilter === "fase3") {
          matchSub = w.phase === "fase3" || (w.dayNumber >= 15 && w.dayNumber <= 21);
        } else if (workoutSubFilter === "rest") {
          matchSub = !!w.isRest || w.category === "rest";
        } else {
          matchSub = w.category === workoutSubFilter || w.phase === workoutSubFilter;
        }
      }

      const titleLower = t(w, 'title').toLowerCase();
      const descLower = t(w, 'desc').toLowerCase();
      const searchLower = searchQuery.toLowerCase();
      const matchSearch = !searchQuery || titleLower.includes(searchLower) || descLower.includes(searchLower);
      return matchSub && matchSearch;
    });

    if (filteredWorkouts.length === 0) {
      grid.innerHTML = `<p style="text-align:center; width:100%; color:#94A3B8; grid-column: 1 / -1; padding: 40px 0;">Nessun video allenamento trovato per i filtri selezionati.</p>`;
      return;
    }

    filteredWorkouts.forEach(workout => {
      const card = document.createElement("div");
      card.className = "workout-card";
      card.setAttribute("data-id", workout.id);

      const title = t(workout, 'title');
      const desc = t(workout, 'desc');
      const intensity = t(workout, 'intensity');
      const equipment = t(workout, 'equipment') || 'Corpo Libero & Tappetino';
      const thumbUrl = workout.coverImg || 'https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=600&auto=format&fit=crop&q=80';

      let catPillLabel = '🟢 FASE 1: START';
      if (workout.isRest) catPillLabel = '🧘 REST & RIGENERAZIONE';
      else if (workout.phase === 'fase2') catPillLabel = '🔵 FASE 2: RITMO';
      else if (workout.phase === 'fase3') catPillLabel = '🟣 FASE 3: PEAK';

      card.innerHTML = `
        <div class="workout-thumbnail-wrap">
          <img src="${thumbUrl}" alt="${title}" class="workout-thumbnail-img" loading="lazy">
          <div class="workout-play-btn-overlay">▶</div>
          <span class="workout-duration-pill">⏱️ ${workout.duration}</span>
          <span class="workout-category-pill">${catPillLabel}</span>
        </div>
        <div class="workout-card-body">
          <div class="workout-card-title">${title}</div>
          <div class="workout-card-desc">${desc}</div>
          <div style="font-size: 11.5px; color: #94A3B8; margin-bottom: 10px; display: flex; align-items: center; gap: 6px;">
            <span>🏋️</span> <span>Attrezzatura: <strong style="color: #E2E8F0;">${escapeHtml(equipment)}</strong></span>
          </div>
          <div class="workout-card-footer">
            <span style="color: #F59E0B;">⚡ ${intensity}</span>
            <span style="color: #10B981; font-weight: 700;">🔥 ${workout.calories}</span>
          </div>
        </div>
      `;

      card.addEventListener("click", () => {
        openWorkoutVideoModal(workout.id);
      });

      grid.appendChild(card);
    });

    return;
  }

  // 2. IF CATEGORY IS "consigli" -> RENDER WHY IT MATTERS GUIDES
  if (categoryFilter === "consigli") {
    const filteredGuides = COACH_GUIDES.filter(g => {
      const titleLower = t(g, 'title').toLowerCase();
      const descLower = t(g, 'desc').toLowerCase();
      const searchLower = searchQuery.toLowerCase();
      return !searchQuery || titleLower.includes(searchLower) || descLower.includes(searchLower);
    });

    if (filteredGuides.length === 0) {
      grid.innerHTML = `<p style="text-align:center; width:100%; color:#94A3B8; grid-column: 1 / -1; padding: 40px 0;">No guides found.</p>`;
      return;
    }

    const badgeTxt = langDict.badge_why_important || "PERCHÉ È IMPORTANTE";
    const readBtnTxt = langDict.btn_read_full_guide || "📖 Leggi Guida Completa →";

    filteredGuides.forEach(guide => {
      const card = document.createElement("div");
      card.className = "coach-guide-card";
      card.setAttribute("data-id", guide.id);

      const title = t(guide, 'title');
      const desc = t(guide, 'desc');
      const pts = t(guide, 'keyPoints') || guide.keyPoints;

      let pointsHtml = '';
      if (Array.isArray(pts) && pts.length > 0) {
        pointsHtml = '<ul class="coach-guide-key-points">' + 
          pts.slice(0, 3).map(pt => `<li>${escapeHtml(pt)}</li>`).join('') +
          '</ul>';
      }

      // Products pills
      let productsHtml = '';
      if (guide.productKeys && storeCat && storeCat.products) {
        productsHtml = '<div class="recipe-products-box" style="margin-bottom: 12px;">';
        guide.productKeys.forEach(pk => {
          const prod = storeCat.products[pk];
          if (prod) {
            productsHtml += `
              <div class="recipe-prod-pill">
                <span class="prod-tag">🌿 ${prod.title}</span>
              </div>
            `;
          }
        });
        productsHtml += '</div>';
      }

      card.innerHTML = `
        <div class="coach-guide-card-header" style="background: ${guide.gradient};">
          <div class="coach-guide-icon-wrap">${guide.icon}</div>
          <span class="coach-guide-tag-badge">${badgeTxt}</span>
        </div>
        <div class="coach-guide-card-body">
          <div class="coach-guide-card-title">${title}</div>
          <div class="coach-guide-card-desc">${desc}</div>
          ${pointsHtml}
          ${productsHtml}
          <div class="coach-guide-card-footer">
            <button class="btn-open-guide-card">
              <span>${readBtnTxt}</span>
            </button>
          </div>
        </div>
      `;

      card.addEventListener("click", () => {
        openCoachGuideModal(guide.id);
      });

      grid.appendChild(card);
    });

    return;
  }

  // 3. IF CATEGORY IS "pasti" -> RENDER HEALTHY REAL-FOOD MEALS
  if (categoryFilter === "pasti") {
    const filteredMeals = RECIPES.filter(r => {
      if (r.category !== "pasti") return false;
      
      let matchSub = true;
      if (mealSubFilter && mealSubFilter !== "all") {
        if (mealSubFilter === "pranzo") {
          matchSub = r.mealType === "pranzo" || r.mealType === "both";
        } else if (mealSubFilter === "cena") {
          matchSub = r.mealType === "cena" || r.mealType === "both";
        } else if (mealSubFilter === "deficit") {
          matchSub = r.goalTag === "deficit";
        } else if (mealSubFilter === "massa") {
          matchSub = r.goalTag === "massa";
        } else if (mealSubFilter === "energia") {
          matchSub = r.goalTag === "energia";
        }
      }

      const titleLower = t(r, 'title').toLowerCase();
      const descLower = t(r, 'description').toLowerCase();
      const ingrLower = (t(r, 'ingredients') || '').toLowerCase();
      const searchLower = searchQuery.toLowerCase();
      const matchSearch = !searchQuery || titleLower.includes(searchLower) || descLower.includes(searchLower) || ingrLower.includes(searchLower);

      return matchSub && matchSearch;
    });

    if (filteredMeals.length === 0) {
      grid.innerHTML = `<p style="text-align:center; width:100%; color:#94A3B8; grid-column: 1 / -1; padding: 40px 0;">${currentLang === 'en' ? 'No healthy meals found for the selected filters.' : (currentLang === 'ro' ? 'Nu s-au găsit mese sănătoase pentru filtrele selectate.' : (currentLang === 'es' ? 'No se encontraron comidas saludables para los filtros seleccionados.' : 'Nessun piatto sano trovato per i filtri selezionati.'))}</p>`;
      return;
    }

    filteredMeals.forEach(recipe => {
      let goalBadge = '🥗 PASTO SANO';
      if (recipe.goalTag === 'deficit') {
        goalBadge = currentLang === 'en' ? '🎯 CALORIC DEFICIT' : (currentLang === 'ro' ? '🎯 DEFICIT CALORIC' : (currentLang === 'es' ? '🎯 DÉFICIT CALÓRICO' : '🎯 DEFICIT CALORICO'));
      } else if (recipe.goalTag === 'massa') {
        goalBadge = currentLang === 'en' ? '💪 LEAN MUSCLE' : (currentLang === 'ro' ? '💪 MASĂ & TONIFIERE' : (currentLang === 'es' ? '💪 MASA & TONO' : '💪 MASSA & TONO'));
      } else if (recipe.goalTag === 'energia') {
        goalBadge = currentLang === 'en' ? '⚡ ENERGY & VITALITY' : (currentLang === 'ro' ? '⚡ ENERGIE & VITALITATE' : (currentLang === 'es' ? '⚡ ENERGÍA & VITALIDAD' : '⚡ ENERGIA & VITALITÀ'));
      }

      let mealSlotBadge = '';
      if (recipe.mealType === 'pranzo') mealSlotBadge = currentLang === 'en' ? '🍗 Lunch' : (currentLang === 'ro' ? '🍗 Prânz' : (currentLang === 'es' ? '🍗 Almuerzo' : '🍗 Pranzo'));
      else if (recipe.mealType === 'cena') mealSlotBadge = currentLang === 'en' ? '🐟 Dinner' : (currentLang === 'ro' ? '🐟 Cină' : (currentLang === 'es' ? '🐟 Cena' : '🐟 Cena'));
      else if (recipe.mealType === 'both') mealSlotBadge = currentLang === 'en' ? '🍽️ Lunch & Dinner' : (currentLang === 'ro' ? '🍽️ Prânz & Cină' : (currentLang === 'es' ? '🍽️ Almuerzo & Cena' : '🍽️ Pranzo & Cena'));

      const title = t(recipe, 'title');
      const description = t(recipe, 'description');
      const ingredients = t(recipe, 'ingredients');
      const tip = t(recipe, 'tip');
      const imgUrl = getRecipeImageUrl(recipe);

      let goalClass = '';
      if (recipe.goalTag === 'massa') goalClass = 'goal-massa';
      else if (recipe.goalTag === 'energia') goalClass = 'goal-energia';

      const card = document.createElement("div");
      card.className = "recipe-card";

      card.innerHTML = `
        <div class="recipe-thumbnail-wrap">
          <img src="${imgUrl}" alt="${title}" class="recipe-thumbnail-img" loading="lazy" onerror="this.onerror=null; this.src='assets/balanced_lunch_chicken.png';">
          <div class="recipe-thumbnail-overlay"></div>
          <div class="recipe-top-badges">
            ${mealSlotBadge ? `<span class="recipe-pill-slot">${mealSlotBadge}</span>` : `<span class="recipe-pill-slot">${recipe.emoji} ${recipe.mealType || 'PASTO'}</span>`}
            <span class="recipe-pill-goal ${goalClass}">${goalBadge}</span>
          </div>
          <div class="recipe-bottom-meta-overlay">
            <span class="recipe-pill-meta">⏱️ ${recipe.prepTime}</span>
            <span class="recipe-pill-meta">🔥 ${recipe.calories}</span>
          </div>
        </div>
        <div class="recipe-body">
          <div class="recipe-title">${title}</div>
          <div class="recipe-desc">${description}</div>
          
          <div class="recipe-ingredients-box">
            <div class="ingr-label">📋 ${currentLang === 'en' ? 'Ingredients & Grams:' : (currentLang === 'ro' ? 'Ingrediente & Gramaj:' : (currentLang === 'es' ? 'Ingredientes y Cantidades:' : 'Ingredienti & Grammature:'))}</div>
            <div class="ingr-text">${ingredients}</div>
          </div>

          <div class="recipe-tip">
            <span class="tip-icon">💡</span>
            <span class="tip-text">${tip}</span>
          </div>

          <div class="recipe-footer" style="display: flex; flex-wrap: wrap; gap: 6px;">
            <span class="macro-badge">⏱️ ${recipe.prepTime}</span>
            <span class="macro-badge">🔥 ${recipe.calories}</span>
            ${recipe.protein && recipe.protein !== '-' ? `<span class="macro-badge" style="color:#10B981; font-weight:700;">💪 ${recipe.protein}</span>` : ''}
            ${recipe.carbs && recipe.carbs !== '-' ? `<span class="macro-badge" style="color:#60A5FA; font-weight:600;">🌾 ${recipe.carbs}</span>` : ''}
            ${recipe.fats && recipe.fats !== '-' ? `<span class="macro-badge" style="color:#F59E0B; font-weight:600;">🥑 ${recipe.fats}</span>` : ''}
          </div>
        </div>
      `;

      grid.appendChild(card);
    });

    return;
  }

  // 4. RECIPES FILTERING (FRULLATI / SNACK / ALL)
  const filteredRecipes = RECIPES.filter(r => {
    const matchCat = categoryFilter === "all" || r.category === categoryFilter;
    const titleLower = t(r, 'title').toLowerCase();
    const descLower = (t(r, 'description') || '').toLowerCase();
    const ingrLower = (t(r, 'ingredients') || '').toLowerCase();
    const searchLower = searchQuery.toLowerCase();
    const matchSearch = !searchQuery || titleLower.includes(searchLower) || descLower.includes(searchLower) || ingrLower.includes(searchLower);
    return matchCat && matchSearch;
  });

  if (filteredRecipes.length === 0 && categoryFilter !== "all") {
    grid.innerHTML = `<p style="text-align:center; width:100%; color:#94A3B8; grid-column: 1 / -1; padding: 40px 0;">No results found.</p>`;
    return;
  }

  filteredRecipes.forEach(recipe => {
    let catLabel = recipe.category;
    if (recipe.category === 'pasti') {
      if (recipe.goalTag === 'deficit') catLabel = currentLang === 'en' ? '🎯 DEFICIT' : (currentLang === 'ro' ? '🎯 DEFICIT' : (currentLang === 'es' ? '🎯 DÉFICIT' : '🎯 DEFICIT'));
      else if (recipe.goalTag === 'massa') catLabel = currentLang === 'en' ? '💪 MUSCLE' : (currentLang === 'ro' ? '💪 MASĂ' : (currentLang === 'es' ? '💪 MASA' : '💪 MASSA'));
      else if (recipe.goalTag === 'energia') catLabel = currentLang === 'en' ? '⚡ ENERGY' : (currentLang === 'ro' ? '⚡ ENERGIE' : (currentLang === 'es' ? '⚡ ENERGÍA' : '⚡ ENERGIA'));
      else catLabel = currentLang === 'en' ? '🥗 Meals' : (currentLang === 'ro' ? '🥗 Mese' : (currentLang === 'es' ? '🥗 Comidas' : '🥗 Pasti'));
    } else if (currentLang === 'en') {
      if (recipe.category === 'frullati') catLabel = 'Shakes';
      else if (recipe.category === 'snack') catLabel = 'Snacks';
    } else if (currentLang === 'ro') {
      if (recipe.category === 'frullati') catLabel = 'Shake-uri';
      else if (recipe.category === 'snack') catLabel = 'Gustări';
    } else if (currentLang === 'es') {
      if (recipe.category === 'frullati') catLabel = 'Batidos';
      else if (recipe.category === 'snack') catLabel = 'Snacks';
    }

    const title = t(recipe, 'title');
    const description = t(recipe, 'description');
    const ingredients = t(recipe, 'ingredients');
    const tip = t(recipe, 'tip');
    const imgUrl = getRecipeImageUrl(recipe);

    let goalClass = '';
    if (recipe.goalTag === 'massa') goalClass = 'goal-massa';
    else if (recipe.goalTag === 'energia') goalClass = 'goal-energia';

    // Build Product badges & links
    let productsHtml = "";
    if (recipe.productKeys && recipe.productKeys.length > 0 && storeCat && storeCat.products) {
      productsHtml = '<div class="recipe-products-box">';
      recipe.productKeys.forEach(pk => {
        const prod = storeCat.products[pk];
        if (prod) {
          const buyTxt = currentLang === 'en' ? 'Shop ↗' : (currentLang === 'ro' ? 'Cumpără ↗' : (currentLang === 'es' ? 'Comprar ↗' : 'Acquista ↗'));
          productsHtml += `
            <div class="recipe-prod-pill">
              <span class="prod-tag">🌿 ${prod.title}</span>
              <a href="${prod.url}" target="_blank" rel="noopener noreferrer" class="prod-buy-btn" title="View Product">${buyTxt}</a>
            </div>
          `;
        }
      });
      productsHtml += '</div>';
    }

    const ingrTitle = recipe.isRealFood 
      ? (currentLang === 'en' ? 'Ingredients & Grams:' : (currentLang === 'ro' ? 'Ingrediente & Gramaj:' : (currentLang === 'es' ? 'Ingredientes y Cantidades:' : 'Ingredienti & Grammature:')))
      : (currentLang === 'en' ? 'Ingredients & Doses:' : (currentLang === 'ro' ? 'Ingrediente:' : (currentLang === 'es' ? 'Ingredientes:' : 'Ingredienti & Dosi:')));

    const card = document.createElement("div");
    card.className = "recipe-card";

    card.innerHTML = `
      <div class="recipe-thumbnail-wrap">
        <img src="${imgUrl}" alt="${title}" class="recipe-thumbnail-img" loading="lazy" onerror="this.onerror=null; this.src='assets/breakfast_shake_aloe.png';">
        <div class="recipe-thumbnail-overlay"></div>
        <div class="recipe-top-badges">
          <span class="recipe-pill-slot">${recipe.emoji} ${catLabel.toUpperCase()}</span>
          ${recipe.goalTag ? `<span class="recipe-pill-goal ${goalClass}">${recipe.goalTag.toUpperCase()}</span>` : ''}
        </div>
        <div class="recipe-bottom-meta-overlay">
          <span class="recipe-pill-meta">⏱️ ${recipe.prepTime}</span>
          <span class="recipe-pill-meta">🔥 ${recipe.calories}</span>
        </div>
      </div>
      <div class="recipe-body">
        <div class="recipe-title">${title}</div>
        <div class="recipe-desc">${description}</div>
        
        <div class="recipe-ingredients-box">
          <div class="ingr-label">📋 ${ingrTitle}</div>
          <div class="ingr-text">${ingredients}</div>
        </div>

        ${productsHtml}

        <div class="recipe-tip">
          <span class="tip-icon">💡</span>
          <span class="tip-text">${tip}</span>
        </div>

        <div class="recipe-footer" style="display: flex; flex-wrap: wrap; gap: 6px;">
          <span class="macro-badge">⏱️ ${recipe.prepTime}</span>
          <span class="macro-badge">🔥 ${recipe.calories}</span>
          ${recipe.protein && recipe.protein !== '-' ? `<span class="macro-badge" style="color:#10B981; font-weight:700;">💪 ${recipe.protein}</span>` : ''}
          ${recipe.carbs && recipe.carbs !== '-' ? `<span class="macro-badge" style="color:#60A5FA; font-weight:600;">🌾 ${recipe.carbs}</span>` : ''}
          ${recipe.fats && recipe.fats !== '-' ? `<span class="macro-badge" style="color:#F59E0B; font-weight:600;">🥑 ${recipe.fats}</span>` : ''}
        </div>
      </div>
    `;

    grid.appendChild(card);
  });

  // 5. IF CATEGORY IS "all", ALSO APPEND HIGHLIGHTS
  if (categoryFilter === "all" && (!searchQuery || searchQuery.toLowerCase().includes('allen') || searchQuery.toLowerCase().includes('sport') || searchQuery.toLowerCase().includes('work'))) {
    WORKOUT_VIDEOS.slice(0, 4).forEach(workout => {
      const card = document.createElement("div");
      card.className = "workout-card";
      card.setAttribute("data-id", workout.id);

      const title = t(workout, 'title');
      const desc = t(workout, 'desc');
      const intensity = t(workout, 'intensity');
      const equipment = t(workout, 'equipment') || 'Corpo Libero & Tappetino';
      const thumbUrl = workout.coverImg || 'https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=600&auto=format&fit=crop&q=80';

      let catPillLabel = '🟢 FASE 1: START';
      if (workout.isRest) catPillLabel = '🧘 REST & RIGENERAZIONE';
      else if (workout.phase === 'fase2') catPillLabel = '🔵 FASE 2: RITMO';
      else if (workout.phase === 'fase3') catPillLabel = '🟣 FASE 3: PEAK';

      card.innerHTML = `
        <div class="workout-thumbnail-wrap">
          <img src="${thumbUrl}" alt="${title}" class="workout-thumbnail-img" loading="lazy">
          <div class="workout-play-btn-overlay">▶</div>
          <span class="workout-duration-pill">⏱️ ${workout.duration}</span>
          <span class="workout-category-pill">${catPillLabel}</span>
        </div>
        <div class="workout-card-body">
          <div class="workout-card-title">${title}</div>
          <div class="workout-card-desc">${desc}</div>
          <div style="font-size: 11.5px; color: #94A3B8; margin-bottom: 8px; display: flex; align-items: center; gap: 6px;">
            <span>🏋️</span> <span>Attrezzatura: <strong style="color: #E2E8F0;">${escapeHtml(equipment)}</strong></span>
          </div>
          <div class="workout-card-footer">
            <span style="color: #F59E0B;">⚡ ${intensity}</span>
            <span style="color: #10B981; font-weight: 700;">🔥 ${workout.calories}</span>
          </div>
        </div>
      `;

      card.addEventListener("click", () => {
        openWorkoutVideoModal(workout.id);
      });

      grid.appendChild(card);
    });
  }

      if (categoryFilter === "all" && (!searchQuery || searchQuery.toLowerCase().includes('consigli') || searchQuery.toLowerCase().includes('why') || searchQuery.toLowerCase().includes('matters') || searchQuery.toLowerCase().includes('acqua') || searchQuery.toLowerCase().includes('water') || searchQuery.toLowerCase().includes('sleep') || searchQuery.toLowerCase().includes('coach'))) {
    const badgeTxt = langDict.badge_why_important || "PERCHÉ È IMPORTANTE";
    const readBtnTxt = langDict.btn_read_full_guide || "📖 Leggi Guida Completa →";

    COACH_GUIDES.slice(0, 2).forEach(guide => {
      const card = document.createElement("div");
      card.className = "coach-guide-card";
      card.setAttribute("data-id", guide.id);

      const title = t(guide, 'title');
      const desc = t(guide, 'desc');

      card.innerHTML = `
        <div class="coach-guide-card-header" style="background: ${guide.gradient};">
          <div class="coach-guide-icon-wrap">${guide.icon}</div>
          <span class="coach-guide-tag-badge">${badgeTxt}</span>
        </div>
        <div class="coach-guide-card-body">
          <div class="coach-guide-card-title">${title}</div>
          <div class="coach-guide-card-desc">${desc}</div>
          <div class="coach-guide-card-footer">
            <button class="btn-open-guide-card">
              <span>${readBtnTxt}</span>
            </button>
          </div>
        </div>
      `;

      card.addEventListener("click", () => {
        openCoachGuideModal(guide.id);
      });

      grid.appendChild(card);
    });
  }
};

const initRecipesFilters = () => {
  let currentMainCategory = "all";
  let currentWorkoutSub = "all";
  let currentMealSub = "all";

  const workoutSubBar = document.getElementById("workout-subfilters-bar");
  const mealsSubBar = document.getElementById("meals-subfilters-bar");
  const searchInput = document.getElementById("recipe-search");
  const tabContainer = document.getElementById("recipes-categories-tabs");

  const updateSubBarVisibility = () => {
    if (workoutSubBar) {
      workoutSubBar.style.display = currentMainCategory === "allenamento" ? "flex" : "none";
    }
    if (mealsSubBar) {
      mealsSubBar.style.display = currentMainCategory === "pasti" ? "flex" : "none";
    }
  };

  try { renderRecipes("all"); } catch(e) { console.error(e); }
  try { renderDailyCoachFocusBanner(); } catch(e) { console.error(e); }

  // Wire up Coach Guide Modal Close & Action Handlers
  const closeGuideBtn = document.getElementById("close-guide-modal-btn");
  if (closeGuideBtn) closeGuideBtn.addEventListener("click", closeCoachGuideModal);

  const guideModal = document.getElementById("coach-guide-modal");
  if (guideModal) {
    guideModal.addEventListener("click", (e) => {
      if (e.target === guideModal) closeCoachGuideModal();
    });
  }

  const understoodGuideBtn = document.getElementById("btn-understood-guide");
  if (understoodGuideBtn) understoodGuideBtn.addEventListener("click", closeCoachGuideModal);
  
  if (searchInput) {
    searchInput.addEventListener("input", (e) => {
      const activeBtn = document.querySelector("#recipes-categories-tabs .tab-btn.active");
      currentMainCategory = activeBtn ? activeBtn.getAttribute("data-category") : "all";
      renderRecipes(currentMainCategory, e.target.value, currentWorkoutSub, currentMealSub);
    });
  }
  
  if (tabContainer) {
    tabContainer.querySelectorAll(".tab-btn").forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        tabContainer.querySelectorAll(".tab-btn").forEach(b => b.classList.remove("active"));
        btn.classList.add("active");
        currentMainCategory = btn.getAttribute("data-category") || "all";
        updateSubBarVisibility();
        const query = searchInput ? searchInput.value : "";
        renderRecipes(currentMainCategory, query, currentWorkoutSub, currentMealSub);
      });
    });
  }

  if (workoutSubBar) {
    workoutSubBar.querySelectorAll(".workout-subtab-btn").forEach(sbtn => {
      sbtn.addEventListener("click", (e) => {
        e.preventDefault();
        workoutSubBar.querySelectorAll(".workout-subtab-btn").forEach(b => b.classList.remove("active"));
        sbtn.classList.add("active");
        currentWorkoutSub = sbtn.getAttribute("data-workout-sub") || "all";
        const query = searchInput ? searchInput.value : "";
        renderRecipes("allenamento", query, currentWorkoutSub, currentMealSub);
      });
    });
  }

  if (mealsSubBar) {
    mealsSubBar.querySelectorAll(".meal-subtab-btn").forEach(sbtn => {
      sbtn.addEventListener("click", (e) => {
        e.preventDefault();
        mealsSubBar.querySelectorAll(".meal-subtab-btn").forEach(b => b.classList.remove("active"));
        sbtn.classList.add("active");
        currentMealSub = sbtn.getAttribute("data-meal-sub") || "all";
        const query = searchInput ? searchInput.value : "";
        renderRecipes("pasti", query, currentWorkoutSub, currentMealSub);
      });
    });
  }

  // Wire up Workout Modal Close & Action Handlers
  const closeBtn = document.getElementById("close-workout-modal-btn");
  if (closeBtn) {
    closeBtn.addEventListener("click", closeWorkoutVideoModal);
  }

  const workoutModal = document.getElementById("workout-video-modal");
  if (workoutModal) {
    workoutModal.addEventListener("click", (e) => {
      if (e.target === workoutModal) closeWorkoutVideoModal();
    });
  }

  // Complete workout button
  const completeBtn = document.getElementById("btn-complete-workout");
  if (completeBtn) {
    completeBtn.addEventListener("click", () => {
      closeWorkoutVideoModal();
      
      // Add Habit movement check or points if available
      const chkMovement = document.getElementById("chk-movement");
      if (chkMovement && !chkMovement.checked) {
        chkMovement.checked = true;
        if (typeof updateHabitsScore === 'function') updateHabitsScore();
      }

      // Add movement points directly
      if (typeof addPoints === 'function') {
        addPoints(15, "Allenamento Video Guidato");
      }

      if (typeof showToast === 'function') {
        showToast("🎉 Ottimo lavoro! Allenamento completato con successo (+15 pt)");
      } else {
        alert("🎉 Ottimo lavoro! Allenamento completato con successo (+15 pt)");
      }
    });
  }

  // Wire up Habit 5 shortcut button in Diario to switch to Workout tab in recipes
  const gotoWorkoutsBtn = document.getElementById("btn-goto-workouts");
  if (gotoWorkoutsBtn) {
    gotoWorkoutsBtn.addEventListener("click", (e) => {
      e.preventDefault();
      
      // 1. Switch active page to page-ricette
      const ricetteNavBtn = document.querySelector('.nav-item[data-target="page-ricette"]');
      if (ricetteNavBtn) {
        ricetteNavBtn.click();
      } else {
        document.querySelectorAll(".app-page").forEach(p => p.classList.remove("active"));
        const targetPage = document.getElementById("page-ricette");
        if (targetPage) targetPage.classList.add("active");
        if (typeof syncNavigationUI === 'function') syncNavigationUI("page-ricette");
      }

      // 2. Switch tab to "allenamento"
      currentMainCategory = "allenamento";
      if (tabContainer) {
        tabContainer.querySelectorAll(".tab-btn").forEach(b => b.classList.remove("active"));
        const workoutTabBtn = tabContainer.querySelector('.tab-btn[data-category="allenamento"]');
        if (workoutTabBtn) workoutTabBtn.classList.add("active");
      }
      updateSubBarVisibility();

      // 3. Render workouts
      renderRecipes("allenamento", "", currentWorkoutSub, currentMealSub);

      // Scroll smoothly to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // Wire up btn-goto-meals-academy shortcut button in Diario to switch to Pasti Sani tab in recipes
  const gotoMealsBtn = document.getElementById("btn-goto-meals-academy");
  if (gotoMealsBtn) {
    gotoMealsBtn.addEventListener("click", (e) => {
      e.preventDefault();
      
      // 1. Switch active page to page-ricette
      const ricetteNavBtn = document.querySelector('.nav-item[data-target="page-ricette"]');
      if (ricetteNavBtn) {
        ricetteNavBtn.click();
      } else {
        document.querySelectorAll(".app-page").forEach(p => p.classList.remove("active"));
        const targetPage = document.getElementById("page-ricette");
        if (targetPage) targetPage.classList.add("active");
        if (typeof syncNavigationUI === 'function') syncNavigationUI("page-ricette");
      }

      // 2. Switch tab to "pasti"
      currentMainCategory = "pasti";
      if (tabContainer) {
        tabContainer.querySelectorAll(".tab-btn").forEach(b => b.classList.remove("active"));
        const mealsTabBtn = tabContainer.querySelector('.tab-btn[data-category="pasti"]');
        if (mealsTabBtn) mealsTabBtn.classList.add("active");
      }
      updateSubBarVisibility();

      // 3. Render pasti
      renderRecipes("pasti", "", currentWorkoutSub, currentMealSub);

      // Scroll smoothly to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
};

const initRecipesPage = initRecipesFilters;

const initThemeToggle = () => {
  const btn = document.getElementById("theme-btn");
  if (!btn) return;
  btn.addEventListener("click", () => {
    state.theme = state.theme === "dark" ? "light" : "dark";
    saveStateToStorage();
    applyTheme();
  });
};

const initLanguageSelector = () => {
  const select = document.getElementById("lang-select");
  if (!select) return;
  
  select.value = state.lang || "it";
  
  select.addEventListener("change", (e) => {
    state.lang = e.target.value;
    state.lang_manually_selected = true;
    
    // Overwrite community initial seed chat with translated version
    state.communityMessages = [...COMMUNITY_CHATS[state.lang]];
    
    saveStateToStorage();
    updateAppLanguage();
  });
};

// Initialize navigation sync
const syncNavigationUI = (activeTarget) => {
  document.querySelectorAll(".nav-item").forEach((btn) => {
    if (btn.getAttribute("data-target") === activeTarget) {
      btn.classList.add("active");
      if (btn.closest("#app-bottom-nav")) {
        try {
          btn.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
        } catch (e) {}
      }
    } else {
      btn.classList.remove("active");
    }
  });
};


// ==========================================
// PREMIUM FEATURES: GAMIFICATION, REMINDERS & PDF
// ==========================================

// Web Audio API Synthesizer Chimes
const playAlertSound = (type) => {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    const ctx = new AudioContext();
    
    if (type === "badge") {
      // Triumphant arpeggio chime (C4 -> E4 -> G4 -> C5)
      const now = ctx.currentTime;
      const notes = [261.63, 329.63, 392.00, 523.25]; // C4, E4, G4, C5
      notes.forEach((freq, idx) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        
        osc.type = "sine";
        osc.frequency.setValueAtTime(freq, now + idx * 0.12);
        
        gain.gain.setValueAtTime(0, now + idx * 0.12);
        gain.gain.linearRampToValueAtTime(0.3, now + idx * 0.12 + 0.05);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + idx * 0.12 + 0.4);
        
        osc.start(now + idx * 0.12);
        osc.stop(now + idx * 0.12 + 0.5);
      });
    } else {
      // Gentle double-bell reminder chime (440Hz -> 554.37Hz)
      const now = ctx.currentTime;
      const notes = [440.00, 554.37];
      notes.forEach((freq, idx) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        
        osc.type = "triangle";
        osc.frequency.setValueAtTime(freq, now + idx * 0.15);
        
        gain.gain.setValueAtTime(0, now + idx * 0.15);
        gain.gain.linearRampToValueAtTime(0.2, now + idx * 0.15 + 0.05);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + idx * 0.15 + 0.3);
        
        osc.start(now + idx * 0.15);
        osc.stop(now + idx * 0.15 + 0.4);
      });
    }
  } catch (e) {
    console.error("AudioContext synthesis failed:", e);
  }
};

// Show in-app slide-out Toast Alerts
const showAppToast = (title, desc = "", icon = "💾", isBadge = false) => {
  let container = document.getElementById("app-toast-container");
  if (!container) {
    container = document.createElement("div");
    container.id = "app-toast-container";
    document.body.appendChild(container);
  }
  
  const toast = document.createElement("div");
  toast.className = `toast-alert ${isBadge ? 'badge-toast' : ''}`;
  const finalDesc = (typeof desc === 'string' && desc !== 'success' && desc !== 'error') ? desc : '';
  const finalIcon = (typeof icon === 'string' && icon.length <= 4) ? icon : (desc === 'error' ? '⚠️' : '💾');
  
  toast.innerHTML = `
    <span class="toast-icon">${finalIcon}</span>
    <div class="toast-body">
      <span class="toast-title">${title}</span>
      ${finalDesc ? `<span class="toast-desc">${finalDesc}</span>` : ''}
    </div>
  `;
  
  container.appendChild(toast);
  
  // Play chime
  if (typeof playAlertSound === 'function') {
    try {
      playAlertSound(isBadge ? "badge" : "reminder");
    } catch (soundErr) {
      // AudioContext might be user-gesture gated
    }
  }
  
  // Trigger slide-in
  setTimeout(() => toast.classList.add("show"), 50);
  
  // Auto-remove after 4s
  setTimeout(() => {
    toast.classList.remove("show");
    setTimeout(() => toast.remove(), 450);
  }, 4000);
};

// Gamification Check Engine
const checkAndAwardBadges = () => {
  if (!state.badgesUnlocked) {
    state.badgesUnlocked = { waterChamp: false, shakeLover: false, perfectDay: false, finisher: false };
  }
  
  const b = state.badgesUnlocked;
  
  // 1. Water Champ: Target met (>=2.5L / 2500ml) for 3 consecutive days
  if (!b.waterChamp) {
    let consecutiveDays = 0;
    let maxConsecutive = 0;
    state.dailyLogs.forEach(log => {
      if (log.water >= 2500) {
        consecutiveDays++;
        if (consecutiveDays > maxConsecutive) maxConsecutive = consecutiveDays;
      } else {
        consecutiveDays = 0;
      }
    });
    
    if (maxConsecutive >= 3) {
      b.waterChamp = true;
      saveStateToStorage();
      const title = state.lang === "it" ? "Traguardo Sbloccato! 🚰" : "Achievement Unlocked! 🚰";
      const desc = state.lang === "it" ? "Hai sbloccato 'Idratazione Perfetta' (>=2.5L per 3 giorni consecutivi)." : "You unlocked 'Water Champ' (>=2.5L for 3 consecutive days).";
      showAppToast(title, desc, "🚰", true);
    }
  }
  
  // 2. Shake Lover: At least 2 shakes per day logged for 5 days total
  if (!b.shakeLover) {
    const daysCount = state.dailyLogs.filter(log => log.shakesCount >= 2).length;
    if (daysCount >= 5) {
      b.shakeLover = true;
      saveStateToStorage();
      const title = state.lang === "it" ? "Traguardo Sbloccato! 🥤" : "Achievement Unlocked! 🥤";
      const desc = state.lang === "it" ? "Hai sbloccato 'Nutrizione Costante' (2 frullati per 5 giorni)." : "You unlocked 'Shake Lover' (2 shakes logged for 5 days).";
      showAppToast(title, desc, "🥤", true);
    }
  }
  
  // 3. Perfect Day: Got 100 points on any day
  if (!b.perfectDay) {
    const hasPerfect = state.dailyLogs.some(log => calculateDailyScore(log) === 100);
    if (hasPerfect) {
      b.perfectDay = true;
      saveStateToStorage();
      const title = state.lang === "it" ? "Traguardo Sbloccato! 🌟" : "Achievement Unlocked! 🌟";
      const desc = state.lang === "it" ? "Hai sbloccato 'Giorno Perfetto' (100 punti in un giorno!)." : "You unlocked 'Perfect Day' (Reached 100 points in a day).";
      showAppToast(title, desc, "🌟", true);
    }
  }
  
  // 4. Finisher: Completed all 10 days logs
  if (!b.finisher) {
    const allLogged = state.dailyLogs.every(log => log.shakesCount > 0 || log.water > 0 || log.weight !== null);
    if (allLogged) {
      b.finisher = true;
      saveStateToStorage();
      const title = state.lang === "it" ? "Traguardo Sbloccato! 🏆" : "Achievement Unlocked! 🏆";
      const desc = state.lang === "it" ? "Hai sbloccato 'Campione 10 Giorni' (Completato il percorso!)." : "You unlocked '10-Day Finisher' (Completed the entire program!).";
      showAppToast(title, desc, "🏆", true);
    }
  }
  
  renderBadgesUI();
};

// Render Badges visual states (Grayscale vs Color)
const renderBadgesUI = () => {
  const b = state.badgesUnlocked || { waterChamp: false, shakeLover: false, perfectDay: false, finisher: false };
  
  const badgesMap = {
    "badge-water-champ": b.waterChamp,
    "badge-shake-lover": b.shakeLover,
    "badge-perfect-day": b.perfectDay,
    "badge-finisher": b.finisher
  };
  
  Object.keys(badgesMap).forEach(id => {
    const el = document.getElementById(id);
    if (el) {
      if (badgesMap[id]) {
        el.classList.remove("locked");
        el.classList.add("unlocked");
      } else {
        el.classList.add("locked");
        el.classList.remove("unlocked");
      }
    }
  });
};

// Initialize Reminders Configuration Inputs in Profile
const initRemindersPanel = () => {
  const globalChk = document.getElementById("chk-reminder-global");
  const timeBreakfast = document.getElementById("time-rem-colazione");
  const timeWater = document.getElementById("time-rem-idratazione");
  const timeSnack = document.getElementById("time-rem-spuntino");
  const timeDinner = document.getElementById("time-rem-cena");
  
  if (!globalChk || !timeBreakfast) return;
  
  // Populate from state
  const r = state.reminders || { enabled: true, colazione: "08:00", idratazione: "11:00", spuntino: "16:00", cena: "20:00" };
  globalChk.checked = !!r.enabled;
  timeBreakfast.value = r.colazione || "08:00";
  timeWater.value = r.idratazione || "11:00";
  timeSnack.value = r.spuntino || "16:00";
  timeDinner.value = r.cena || "20:00";
  
  const saveReminders = () => {
    state.reminders = {
      enabled: globalChk.checked,
      colazione: timeBreakfast.value,
      idratazione: timeWater.value,
      spuntino: timeSnack.value,
      cena: timeDinner.value
    };
    saveStateToStorage();
  };
  
  globalChk.addEventListener("change", saveReminders);
  timeBreakfast.addEventListener("change", saveReminders);
  timeWater.addEventListener("change", saveReminders);
  timeSnack.addEventListener("change", saveReminders);
  timeDinner.addEventListener("change", saveReminders);
};

// Schedule Reminders check loop (Reminders Daemon)
let lastCheckedMinute = "";
const startRemindersDaemon = () => {
  if ('Notification' in window && Notification.permission === 'default') {
    const globalChk = document.getElementById("chk-reminder-global");
    if (globalChk) {
      globalChk.addEventListener("click", () => {
        Notification.requestPermission();
      }, { once: true });
    }
  }

  setInterval(() => {
    const r = state.reminders;
    if (!r || !r.enabled) return;
    
    const d = new Date();
    const currentMin = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    
    if (currentMin === lastCheckedMinute) return;
    
    const alertsMap = {
      [r.colazione]: {
        it: { title: "🥤 Colazione Herbalife", desc: "È il momento di preparare il tuo Frullato Formula 1 e Aloe!" },
        en: { title: "🥤 Herbalife Breakfast", desc: "Time to shake up your Formula 1 and sip your Aloe!" }
      },
      [r.idratazione]: {
        it: { title: "🚰 Idratazione", desc: "Non dimenticare di bere un bicchiere d'acqua fresca o Infuso alle erbe." },
        en: { title: "🚰 Hydration Time", desc: "Remember to drink a refreshing glass of water or herbal tea." }
      },
      [r.spuntino]: {
        it: { title: "🍎 Spuntino Proteico", desc: "Ora di ricaricare le energie con uno snack Herbalife o yogurt." },
        en: { title: "🍎 Protein Snack", desc: "Time to boost your energy with a healthy protein snack." }
      },
      [r.cena]: {
        it: { title: "🌙 Resoconto della Giornata", desc: "Ricordati di loggare i tuoi progressi di oggi nel Diario!" },
        en: { title: "🌙 Log your Day", desc: "Don't forget to record today's wellness progress in your logbook!" }
      }
    };
    
    if (alertsMap[currentMin]) {
      lastCheckedMinute = currentMin;
      const content = alertsMap[currentMin][state.lang] || alertsMap[currentMin].it;
      
      showAppToast(content.title, content.desc, "⏰");
      
      if ('Notification' in window && Notification.permission === 'granted') {
        try {
          new Notification(content.title, {
            body: content.desc,
            icon: 'https://cdn.shopify.com/s/files/1/0871/6291/9193/files/green-logo.png?v=123'
          });
        } catch (e) {
          console.error("Native push trigger failed:", e);
        }
      }
    }
  }, 60000);
};

// Initialize PDF Report and Sub-navigation
const initProgressSubnav = () => {
  const subnavBtns = document.querySelectorAll(".progress-subnav-btn");
  const subtabPanes = {
    charts: document.getElementById("subtab-pane-charts"),
    nutrition: document.getElementById("subtab-pane-nutrition"),
    achievements: document.getElementById("subtab-pane-achievements")
  };

  subnavBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      const targetSubtab = btn.dataset.subtab;
      
      // Update buttons
      subnavBtns.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      // Update panes
      Object.keys(subtabPanes).forEach(k => {
        if (subtabPanes[k]) {
          if (k === targetSubtab) {
            subtabPanes[k].classList.add("active");
          } else {
            subtabPanes[k].classList.remove("active");
          }
        }
      });

      // Trigger respective redraws
      if (targetSubtab === "charts") {
        renderCharts();
      } else if (targetSubtab === "nutrition") {
        updateNutritionalStrategyUI();
      } else if (targetSubtab === "achievements") {
        checkAndAwardBadges();
      }
    });
  });

  // Quick PDF Button in Top Bio-Dossier Header
  const quickPdfBtn = document.getElementById("btn-quick-export-pdf");
  if (quickPdfBtn) {
    quickPdfBtn.addEventListener("click", () => {
      exportProgram10ReportPDF();
    });
  }

  // Full PDF Button in achievements card
  const exportPdfBtn = document.getElementById("btn-export-pdf-report");
  if (exportPdfBtn) {
    exportPdfBtn.addEventListener("click", () => {
      exportProgram10ReportPDF();
    });
  }

  const legacyPdfBtn = document.getElementById("btn-export-pdf");
  if (legacyPdfBtn) {
    legacyPdfBtn.addEventListener("click", () => {
      exportProgram10ReportPDF();
    });
  }
};

const initPDFExport = () => {
  initProgressSubnav();
};

// ==========================================
// CLOUD SYNC & COACH DASHBOARD ENGINE
// ==========================================

let db = null;

const initFirebase = () => {
  if (typeof firebase !== "undefined") {
    try {
      const firebaseConfig = {
        apiKey: "AIzaSyAs-sandbox-key-programma-10",
        authDomain: "programma-10-giorni.firebaseapp.com",
        projectId: "programma-10-giorni",
        storageBucket: "programma-10-giorni.appspot.com",
        messagingSenderId: "1234567890",
        appId: "1:1234567890:web:abcdef123456"
      };
      
      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      }
      db = firebase.firestore();
      console.log("[Firebase] Firestore connected!");
      
      syncStateToCloud();
    } catch (e) {
      console.warn("[Firebase] Failed to init Firestore. Using local storage only.", e);
    }
  } else {
    console.log("[Firebase] SDK not loaded, using local storage fallback.");
  }
};

const syncStateToCloud = async () => {
  if (!db) return;
  const userKey = window.ShopifyCustomerEmail || state.profile.name || "sfidante_anonimo";
  if (userKey === "sfidante_anonimo") return;
  
  try {
    const docRef = db.collection("users").doc(userKey);
    const doc = await docRef.get();
    
    if (doc.exists) {
      const cloudData = doc.data();
      state = {
        ...state,
        ...cloudData,
        profile: { ...state.profile, ...(cloudData.profile || {}) },
        dailyLogs: cloudData.dailyLogs || state.dailyLogs
      };
      
      localStorage.setItem("herbalife_programma10_advanced_state", JSON.stringify(state));
      
      loadActiveDayLogs();
      renderDaySelector();
      if (document.getElementById("page-coach-dashboard").classList.contains("active")) {
        loadCoachDashboardData();
      }
      console.log("[Firebase] State synced successfully from Cloud.");
    } else {
      await docRef.set(state);
      console.log("[Firebase] Local state uploaded as initial Cloud state.");
    }
  } catch (e) {
    console.error("[Firebase] Error syncing cloud state:", e);
  }
};

const SUPER_ADMIN_EMAILS = [
  "alinaciobotaru.roma@gmail.com"
];

function isCurrentSuperAdmin() {
  const email = (window.ShopifyCustomerEmail || (state.profile && state.profile.email) || "").toLowerCase().trim();
  const p = (state && state.profile) || {};
  if (SUPER_ADMIN_EMAILS.includes(email)) return true;
  if ((p.myHerbalifeId || "").trim() === "1111" && email === "alinaciobotaru.roma@gmail.com") return true;
  return false;
}

const checkAdminStatus = () => {
  const isAdminBypass = localStorage.getItem("admin_bypass") === "true";
  const shopifyAdmin = typeof window.ShopifyCustomerIsAdmin !== "undefined" && window.ShopifyCustomerIsAdmin;
  const p = state.profile || {};
  
  const isCoach = isAdminBypass || shopifyAdmin || 
                  (p.isDistributor && p.herbalifeIdStatus === "verified") ||
                  (p.myHerbalifeId && p.herbalifeIdStatus === "verified") ||
                  isCurrentSuperAdmin();
                  
  if (isCoach) {
    document.querySelectorAll(".coach-only").forEach(el => {
      el.style.display = "block";
    });
  } else {
    document.querySelectorAll(".coach-only").forEach(el => {
      el.style.display = "none";
    });
  }

  const isSuperAdminUser = isCurrentSuperAdmin();
  if (isSuperAdminUser) {
    document.querySelectorAll(".super-admin-only").forEach(el => {
      el.style.display = "block";
    });
  } else {
    document.querySelectorAll(".super-admin-only").forEach(el => {
      el.style.display = "none";
    });
  }
};

let superAdminCachedUsers = [];

async function loadSuperAdminDashboardData() {
  const container = document.getElementById("admin-users-list-container");
  if (!container) return;

  const adminEmail = (window.ShopifyCustomerEmail || (state.profile && state.profile.email) || "alinaciobotaru.roma@gmail.com").toLowerCase().trim();

  container.innerHTML = `<p class="text-muted text-center" style="padding: 30px; font-size: 14px;">Caricamento utenti dal database Supabase in corso... ⏳</p>`;

  try {
    const res = await fetch(`${API_BASE_URL}/admin/users?admin_email=${encodeURIComponent(adminEmail)}`);
    const data = await res.json();

    if (!data.success || !Array.isArray(data.users)) {
      container.innerHTML = `<div style="padding: 20px; text-align: center; color: #EF4444;">⚠️ Errore caricamento utenti: ${data.error || 'Errore di autorizzazione.'}</div>`;
      return;
    }

    superAdminCachedUsers = data.users;
    renderSuperAdminUI(superAdminCachedUsers);
  } catch (err) {
    console.error("[SuperAdmin] Load error:", err);
    container.innerHTML = `<div style="padding: 20px; text-align: center; color: #EF4444;">⚠️ Errore di connessione durante il recupero dei dati.</div>`;
  }
}

function renderSuperAdminUI(users) {
  const totalUsersEl = document.getElementById("admin-stat-total-users");
  const distEl = document.getElementById("admin-stat-distributors");
  const pendingEl = document.getElementById("admin-stat-pending");
  const compEl = document.getElementById("admin-stat-compliance");

  const total = users.length;
  const distributors = users.filter(u => u.isDistributor && u.herbalifeIdStatus === 'verified').length;
  const pending = users.filter(u => u.herbalifeIdStatus === 'pending').length;
  const avgComp = total > 0 ? Math.round(users.reduce((acc, u) => acc + (u.compliance || 0), 0) / total) : 0;

  if (totalUsersEl) totalUsersEl.textContent = total;
  if (distEl) distEl.textContent = distributors;
  if (pendingEl) pendingEl.textContent = pending;
  if (compEl) compEl.textContent = `${avgComp}%`;

  // 1. Pending Approvals Box
  const pendingBox = document.getElementById("admin-pending-approvals-box");
  const pendingCountBadge = document.getElementById("admin-pending-count-badge");
  const pendingList = document.getElementById("admin-pending-list");

  const pendingUsers = users.filter(u => u.herbalifeIdStatus === 'pending');
  if (pendingUsers.length > 0) {
    if (pendingBox) pendingBox.style.display = "block";
    if (pendingCountBadge) pendingCountBadge.textContent = `${pendingUsers.length} in attesa`;
    if (pendingList) {
      pendingList.innerHTML = pendingUsers.map(u => `
        <div class="admin-pending-item" style="display: flex; align-items: center; justify-content: space-between; padding: 12px 14px; border-radius: 10px; background: rgba(255,255,255,0.03); border: 1px solid rgba(245,158,11,0.3); gap: 12px; flex-wrap: wrap;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <div style="width: 40px; height: 40px; border-radius: 50%; background: rgba(245,158,11,0.2); color: #F59E0B; display: flex; align-items: center; justify-content: center; font-size: 18px; overflow: hidden;">
              ${u.photo ? `<img src="${u.photo}" style="width:100%;height:100%;object-fit:cover;">` : (u.avatar || '👤')}
            </div>
            <div>
              <strong style="font-size: 14px; color: #FFFFFF;">${u.name}</strong>
              <span style="display: block; font-size: 12px; color: #94A3B8;">${u.email} • ID Herbalife: <strong style="color: #F59E0B;">${u.myHerbalifeId}</strong> (Upline: <strong style="color: #38BDF8;">${u.uplineHerbalifeId || 'Nessuna'}</strong>)</span>
            </div>
          </div>
          <div style="display: flex; gap: 8px;">
            <button type="button" class="btn-primary-glow btn-admin-action" data-email="${u.email}" data-action="approve" style="padding: 7px 14px; font-size: 12px; background: #10B981; color: #061A14; font-weight: 700; border-radius: 6px;">Approva Globale ✅</button>
            <button type="button" class="btn-secondary btn-admin-action" data-email="${u.email}" data-action="reject" style="padding: 7px 12px; font-size: 12px; border-radius: 6px;">Rifiuta ❌</button>
            <button type="button" class="btn-secondary btn-admin-action" data-email="${u.email}" data-action="delete" style="padding: 7px 12px; font-size: 12px; border-radius: 6px; background: rgba(239, 68, 68, 0.15); border-color: rgba(239, 68, 68, 0.4); color: #EF4444;">Elimina 🗑️</button>
          </div>
        </div>
      `).join('');
    }
  } else {
    if (pendingBox) pendingBox.style.display = "none";
  }

  // 2. Filter & Render Users List
  applySuperAdminFilters();
}

function applySuperAdminFilters() {
  const container = document.getElementById("admin-users-list-container");
  if (!container) return;

  const searchInput = document.getElementById("admin-search-input");
  const filterRole = document.getElementById("admin-filter-role");

  const query = (searchInput ? searchInput.value : "").toLowerCase().trim();
  const role = filterRole ? filterRole.value : "all";

  let filtered = superAdminCachedUsers.filter(u => {
    // Role filter
    if (role === "distributors" && (!u.isDistributor || u.herbalifeIdStatus !== 'verified')) return false;
    if (role === "pending" && u.herbalifeIdStatus !== 'pending') return false;
    if (role === "clients" && u.isDistributor) return false;

    // Search query filter
    if (query) {
      const matchName = (u.name || "").toLowerCase().includes(query);
      const matchEmail = (u.email || "").toLowerCase().includes(query);
      const matchMyId = (u.myHerbalifeId || "").toLowerCase().includes(query);
      const matchUpline = (u.uplineHerbalifeId || "").toLowerCase().includes(query);
      const matchPhone = (u.phone || "").toLowerCase().includes(query);
      if (!matchName && !matchEmail && !matchMyId && !matchUpline && !matchPhone) return false;
    }

    return true;
  });

  if (filtered.length === 0) {
    container.innerHTML = `<div style="padding: 30px; text-align: center; color: #94A3B8;">Nessun utente trovato con i filtri selezionati.</div>`;
    return;
  }

  container.innerHTML = filtered.map(u => {
    let statusBadge = `<span class="badge" style="background: rgba(148, 163, 184, 0.15); color: #94A3B8;">🏃 Sfidante</span>`;
    if (u.herbalifeIdStatus === 'verified') {
      statusBadge = `<span class="badge" style="background: rgba(16, 185, 129, 0.2); color: #10B981;">🟢 Distributore Verificato</span>`;
    } else if (u.herbalifeIdStatus === 'pending') {
      statusBadge = `<span class="badge" style="background: rgba(245, 158, 11, 0.2); color: #F59E0B;">🟡 In Attesa Approvazione</span>`;
    } else if (u.herbalifeIdStatus === 'rejected') {
      statusBadge = `<span class="badge" style="background: rgba(239, 68, 68, 0.2); color: #EF4444;">🔴 Distributore Rifiutato</span>`;
    }

    return `
      <div class="admin-user-card" style="display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-radius: 12px; background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.08); gap: 14px; flex-wrap: wrap;">
        <!-- Left: User Identity -->
        <div style="display: flex; align-items: center; gap: 12px; min-width: 240px; flex: 1;">
          <div style="width: 44px; height: 44px; border-radius: 50%; background: rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: center; font-size: 20px; overflow: hidden; border: 1px solid rgba(255,255,255,0.1);">
            ${u.photo ? `<img src="${u.photo}" style="width:100%;height:100%;object-fit:cover;">` : (u.avatar || '👤')}
          </div>
          <div>
            <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
              <strong style="font-size: 15px; color: #FFFFFF;">${u.name}</strong>
              ${statusBadge}
            </div>
            <span style="display: block; font-size: 12px; color: #94A3B8; margin-top: 2px;">
              ${u.email} ${u.phone ? `• 📞 ${u.phone}` : ''} • Store: <strong style="color: #38BDF8;">${u.store_id || 'herbaally'}</strong>
            </span>
          </div>
        </div>

        <!-- Center: Herbalife ID & Upline & Compliance -->
        <div style="display: flex; align-items: center; gap: 20px; flex-wrap: wrap;">
          <div>
            <span style="display: block; font-size: 11px; color: #64748B; text-transform: uppercase;">ID Herbalife</span>
            <strong style="font-size: 13px; color: ${u.myHerbalifeId ? '#10B981' : '#64748B'};">${u.myHerbalifeId || 'Nessuno'}</strong>
          </div>
          <div>
            <span style="display: block; font-size: 11px; color: #64748B; text-transform: uppercase;">Upline Coach</span>
            <strong style="font-size: 13px; color: ${u.uplineHerbalifeId ? '#38BDF8' : '#64748B'};">${u.uplineHerbalifeId || 'Nessuno'}</strong>
          </div>
          <div>
            <span style="display: block; font-size: 11px; color: #64748B; text-transform: uppercase;">Compliance</span>
            <strong style="font-size: 13px; color: #A78BFA;">${u.compliance || 0}%</strong>
          </div>
        </div>

        <!-- Right: Actions (Approve / Reject / Delete) -->
        <div style="display: flex; gap: 8px; align-items: center;">
          ${u.herbalifeIdStatus !== 'verified' ? `
            <button type="button" class="btn-primary-glow btn-admin-action" data-email="${u.email}" data-action="approve" style="padding: 7px 14px; font-size: 12px; background: #10B981; color: #061A14; font-weight: 700; border-radius: 6px;">Approva ✅</button>
          ` : ''}
          ${u.herbalifeIdStatus === 'verified' || u.herbalifeIdStatus === 'pending' ? `
            <button type="button" class="btn-secondary btn-admin-action" data-email="${u.email}" data-action="reject" style="padding: 7px 12px; font-size: 12px; border-radius: 6px;">Rifiuta ❌</button>
          ` : ''}
          <button type="button" class="btn-secondary btn-admin-action" data-email="${u.email}" data-action="delete" style="padding: 7px 12px; font-size: 12px; border-radius: 6px; background: rgba(239, 68, 68, 0.15); border-color: rgba(239, 68, 68, 0.4); color: #EF4444;">Elimina 🗑️</button>
        </div>
      </div>
    `;
  }).join('');

  // Attach action handlers
  container.querySelectorAll(".btn-admin-action").forEach(btn => {
    btn.addEventListener("click", async () => {
      const targetEmail = btn.getAttribute("data-email");
      const action = btn.getAttribute("data-action");
      const adminEmail = (window.ShopifyCustomerEmail || (state.profile && state.profile.email) || "alinaciobotaru.roma@gmail.com").toLowerCase().trim();

      if (action === "delete") {
        if (!confirm(`⚠️ SEI SICURA di voler eliminare DEFINITIVAMENTE l'utente ${targetEmail}?\n\nTutti i dati del profilo e le misurazioni verranno rimossi per sempre da Supabase.`)) {
          return;
        }
      }

      btn.disabled = true;
      const origText = btn.textContent;
      btn.textContent = "...";

      try {
        const postRes = await fetch(`${API_BASE_URL}/admin/users`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ admin_email: adminEmail, target_email: targetEmail, action })
        });
        const postData = await postRes.json();

        if (postData.success) {
          if (typeof showAppToast === 'function') {
            showAppToast("Operazione Super Admin Completata! 👑", postData.message || `Utente ${targetEmail} aggiornato.`, "👑");
          } else {
            alert(postData.message || "Operazione completata con successo!");
          }
          loadSuperAdminDashboardData();
        } else {
          alert(`Errore: ${postData.error || 'Impossibile completare l\'operazione.'}`);
          btn.disabled = false;
          btn.textContent = origText;
        }
      } catch (err) {
        alert("Errore di connessione durante l'operazione.");
        btn.disabled = false;
        btn.textContent = origText;
      }
    });
  });
}

function initSuperAdminFilters() {
  const searchInput = document.getElementById("admin-search-input");
  const filterRole = document.getElementById("admin-filter-role");
  const refreshBtn = document.getElementById("admin-btn-refresh");

  if (searchInput) {
    searchInput.addEventListener("input", applySuperAdminFilters);
  }
  if (filterRole) {
    filterRole.addEventListener("change", applySuperAdminFilters);
  }
  if (refreshBtn) {
    refreshBtn.addEventListener("click", loadSuperAdminDashboardData);
  }
}

async function fetchAndRenderDownlineApprovals(coachId) {
  const cleanCoachId = (coachId || "").trim();
  if (!cleanCoachId) return;

  const dashSection = document.getElementById("coach-approvals-section");
  const dashBadge = document.getElementById("coach-approvals-count-badge");
  const dashList = document.getElementById("coach-approvals-list");

  const profSection = document.getElementById("profile-distributor-approvals-section");
  const profBadge = document.getElementById("profile-approvals-count-badge");
  const profList = document.getElementById("profile-approvals-list");

  try {
    const downlineRes = await fetch(`${API_BASE_URL}/coach/downline?coach_id=${encodeURIComponent(cleanCoachId)}`);
    const downlineData = await downlineRes.json();

    if (downlineData.success && Array.isArray(downlineData.pending) && downlineData.pending.length > 0) {
      const pendingCount = downlineData.pending.length;

      if (dashSection) dashSection.style.display = "block";
      if (dashBadge) dashBadge.textContent = `${pendingCount} in attesa`;

      if (profSection) profSection.style.display = "block";
      if (profBadge) profBadge.textContent = `${pendingCount} in attesa`;

      const renderCard = (applicant) => `
        <div class="pending-downline-card" style="display: flex; align-items: center; justify-content: space-between; padding: 12px 14px; border-radius: 10px; background: rgba(255,255,255,0.03); border: 1px solid rgba(245,158,11,0.25); gap: 10px; flex-wrap: wrap;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <div style="width: 38px; height: 38px; border-radius: 50%; background: rgba(245,158,11,0.2); color: #F59E0B; display: flex; align-items: center; justify-content: center; font-size: 18px; overflow: hidden;">
              ${applicant.photo ? `<img src="${applicant.photo}" style="width:100%;height:100%;object-fit:cover;">` : (applicant.avatar || '👤')}
            </div>
            <div>
              <strong style="font-size: 14px; color: #FFFFFF;">${applicant.name}</strong>
              <span style="display: block; font-size: 12px; color: #94A3B8;">${applicant.email} • ID Herbalife: <strong style="color: #F59E0B;">${applicant.my_herbalife_id}</strong></span>
            </div>
          </div>
          <div style="display: flex; gap: 8px;">
            <button type="button" class="btn-primary-glow btn-approve-downline" data-email="${applicant.email}" style="padding: 6px 14px; font-size: 12px; white-space: nowrap; background: #10B981; color: #061A14; font-weight: 700; border-radius: 6px;">Approva ✅</button>
            <button type="button" class="btn-secondary btn-reject-downline" data-email="${applicant.email}" style="padding: 6px 12px; font-size: 12px; white-space: nowrap; border-radius: 6px;">Rifiuta ❌</button>
          </div>
        </div>
      `;

      const html = downlineData.pending.map(renderCard).join('');
      if (dashList) dashList.innerHTML = html;
      if (profList) profList.innerHTML = html;

      // Attach action handlers for approve/reject
      document.querySelectorAll(".btn-approve-downline").forEach(btn => {
        btn.onclick = async () => {
          const targetEmail = btn.getAttribute("data-email");
          btn.disabled = true;
          btn.textContent = "Approvazione...";
          try {
            const postRes = await fetch(`${API_BASE_URL}/coach/downline`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ coach_id: cleanCoachId, target_email: targetEmail, action: "approve" })
            });
            const postData = await postRes.json();
            if (postData.success) {
              if (typeof showAppToast === 'function') {
                showAppToast("Distributore Approvato! 🎉", `Downline ${targetEmail} attivata con successo.`, "✅");
              } else {
                alert("Distributore approvato con successo! 🎉");
              }
              fetchAndRenderDownlineApprovals(cleanCoachId);
              loadCoachDashboardData();
            } else {
              alert(postData.error || "Errore durante l'approvazione.");
              btn.disabled = false;
              btn.textContent = "Approva ✅";
            }
          } catch (err) {
            alert("Errore di rete durante l'operazione.");
            btn.disabled = false;
            btn.textContent = "Approva ✅";
          }
        };
      });

      document.querySelectorAll(".btn-reject-downline").forEach(btn => {
        btn.onclick = async () => {
          const targetEmail = btn.getAttribute("data-email");
          if (!confirm(state.lang === "it" ? `Vuoi rifiutare la richiesta di ${targetEmail}?` : `Reject ${targetEmail}?`)) return;
          btn.disabled = true;
          try {
            const postRes = await fetch(`${API_BASE_URL}/coach/downline`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ coach_id: cleanCoachId, target_email: targetEmail, action: "reject" })
            });
            const postData = await postRes.json();
            if (postData.success) {
              fetchAndRenderDownlineApprovals(cleanCoachId);
              loadCoachDashboardData();
            }
          } catch (err) {
            console.warn(err);
          }
        };
      });
    } else {
      if (dashSection) dashSection.style.display = "none";
      if (profSection) profSection.style.display = "none";
    }
  } catch (downlineErr) {
    console.warn("[Downline Load] Notice:", downlineErr.message);
    if (dashSection) dashSection.style.display = "none";
    if (profSection) profSection.style.display = "none";
  }
}

const loadCoachDashboardData = async () => {
  const listContainer = document.getElementById("coach-clients-list-container");
  if (!listContainer) return;
  
  const p = state.profile || {};
  const activeCoachId = (p.myHerbalifeId || "").trim();
  const host = (typeof window !== "undefined" && window.location.hostname) ? window.location.hostname : "herbaally.com";
  const protocol = (typeof window !== "undefined" && window.location.protocol.startsWith("http")) ? window.location.protocol : "https:";
  const pathname = (typeof window !== "undefined" && window.location.pathname) ? window.location.pathname : "/pages/10-day-program";

  // 1. Update Coach Quick Referral Box
  const badgeId = document.getElementById("dashboard-coach-badge-id");
  const referralInput = document.getElementById("dashboard-coach-referral-input");
  const copyBtn = document.getElementById("dashboard-btn-copy-link");
  const shareWaBtn = document.getElementById("dashboard-btn-share-wa");

  if (!activeCoachId) {
    if (badgeId) badgeId.textContent = "ID: Non impostato";
    if (referralInput) {
      referralInput.value = "";
      referralInput.placeholder = state.lang === "it"
        ? "⚠️ Inserisci il tuo ID Distributore nel profilo per attivare il tuo link d'invito..."
        : "⚠️ Enter your Distributor ID in profile to activate your referral link...";
    }
    if (copyBtn) copyBtn.disabled = true;
    if (shareWaBtn) {
      shareWaBtn.style.pointerEvents = "none";
      shareWaBtn.style.opacity = "0.5";
      shareWaBtn.href = "#";
    }
    renderEmptyCoachClientsState();
    return;
  }

  const referralUrl = `${protocol}//${host}${pathname}?coach=${encodeURIComponent(activeCoachId)}`;

  if (badgeId) badgeId.textContent = `ID: ${activeCoachId}`;
  if (referralInput) referralInput.value = referralUrl;

  if (copyBtn) {
    copyBtn.disabled = false;
    copyBtn.onclick = () => {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(referralUrl).then(() => {
          const orig = copyBtn.textContent;
          copyBtn.textContent = "Link Copiato! ✅";
          setTimeout(() => { copyBtn.textContent = orig; }, 2000);
        });
      }
    };
  }

  if (shareWaBtn) {
    shareWaBtn.style.pointerEvents = "auto";
    shareWaBtn.style.opacity = "1";
    const shareText = encodeURIComponent(
      state.lang === "it"
        ? `Ciao! Ti invito a partecipare al Programma 10 Giorni Herbalife con me. Registrati e inizia la tua sfida qui: ${referralUrl}`
        : `Hi! Join the 10-Day Herbalife Program with me. Sign up and start your challenge here: ${referralUrl}`
    );
    shareWaBtn.href = `https://api.whatsapp.com/send?text=${shareText}`;
  }

  // 2. Fetch and Render Pending Downline Approvals (Dual Container Sync)
  await fetchAndRenderDownlineApprovals(activeCoachId);

  // 3. Fetch and Render Coach Direct Clients & Downlines
  try {
    const clientsRes = await fetch(`${API_BASE_URL}/coach/clients?coach_id=${encodeURIComponent(activeCoachId)}&store_id=${getStoreId()}`);
    const clientsData = await clientsRes.json();

    listContainer.innerHTML = "";
    let clientsCount = 0;

    if (clientsData.success && Array.isArray(clientsData.clients) && clientsData.clients.length > 0) {
      clientsData.clients.forEach(client => {
        clientsCount++;
        const email = client.email || "email@program10.local";
        const name = client.name || "Sfidante";
        const avatar = client.avatar || "🏃";
        const compliance = client.compliance || 0;

        const item = document.createElement("div");
        item.className = "client-card-item";
        item.setAttribute("data-email", email);

        const avatarHtml = client.photo ?
          `<img src="${client.photo}" class="client-avatar-mini" style="object-fit: cover;">` :
          `<div class="client-avatar-mini">${avatar}</div>`;

        const distTag = client.is_distributor ?
          `<span style="font-size: 10px; padding: 1px 6px; border-radius: 4px; background: rgba(56,189,248,0.2); color: #38BDF8; margin-left: 6px;">Distributore</span>` :
          '';

        item.innerHTML = `
          ${avatarHtml}
          <div class="client-info-mini">
            <span class="client-name-mini">${name} ${distTag}</span>
            <span class="client-email-mini">${email}</span>
          </div>
          <span class="client-compliance-mini">${compliance}%</span>
        `;

        item.addEventListener("click", () => {
          document.querySelectorAll(".client-card-item").forEach(c => c.classList.remove("active"));
          item.classList.add("active");
          displayCoachClientDetails(client, email);
        });

        listContainer.appendChild(item);
      });

      const countBadge = document.getElementById("coach-clients-count");
      if (countBadge) countBadge.textContent = clientsCount;
    } else {
      renderEmptyCoachClientsState();
    }
  } catch (e) {
    console.warn("[Coach Clients] Notice:", e.message);
    renderEmptyCoachClientsState();
  }
};

const renderEmptyCoachClientsState = () => {
  const listContainer = document.getElementById("coach-clients-list-container");
  if (!listContainer) return;
  
  listContainer.innerHTML = `
    <div style="text-align: center; padding: 36px 16px; color: var(--text-muted);">
      <div style="font-size: 32px; margin-bottom: 10px;">👥</div>
      <p style="font-size: 14px; font-weight: 700; color: var(--text); margin-bottom: 6px;">Nessun cliente o downline collegato</p>
      <p style="font-size: 12px; color: var(--text-muted); line-height: 1.5; max-width: 280px; margin: 0 auto;">Condividi il tuo Link d'Invito Coach per collegare nuovi sfidanti al tuo profilo e monitorare i loro progressi.</p>
    </div>
  `;
  
  const countBadge = document.getElementById("coach-clients-count");
  if (countBadge) countBadge.textContent = "0";

  const emptyCard = document.getElementById("coach-client-empty-card");
  if (emptyCard) emptyCard.style.display = "block";
  const detailCard = document.getElementById("coach-client-detail-card");
  if (detailCard) detailCard.style.display = "none";
};

const displayCoachClientDetails = (clientState, email) => {
  const emptyCard = document.getElementById("coach-client-empty-card");
  if (emptyCard) emptyCard.style.display = "none";
  const detailCard = document.getElementById("coach-client-detail-card");
  if (!detailCard) return;
  detailCard.style.display = "block";
  
  const p = clientState.profile || {};
  const logs = Array.isArray(clientState.dailyLogs) ? clientState.dailyLogs : [];
  
  // Normalize logs to 10 days
  const normalizedLogs = Array.from({ length: 10 }, (_, i) => {
    return logs[i] || {
      shakesCount: 0,
      water: 0,
      snack: false,
      meal: false,
      steps: 0,
      km: 0,
      exType: "nessuno",
      exDuration: 0,
      weight: null,
      scannedMeal: null
    };
  });

  // 1. Identity & Header
  const nameEl = document.getElementById("coach-detail-name");
  if (nameEl) nameEl.textContent = p.name || clientState.name || "Sfidante";
  
  const emailEl = document.getElementById("coach-detail-email");
  if (emailEl) emailEl.textContent = email || clientState.email || "";

  const avatarEl = document.getElementById("coach-detail-avatar");
  if (avatarEl) {
    if (p.photo || clientState.photo) {
      avatarEl.innerHTML = `<img src="${p.photo || clientState.photo}" style="width: 100%; height: 100%; object-fit: cover;">`;
    } else {
      avatarEl.textContent = p.avatar || clientState.avatar || "🏃";
    }
  }

  const roleBadge = document.getElementById("coach-detail-role-badge");
  if (roleBadge) {
    if (clientState.is_distributor) {
      const statusText = clientState.herbalife_id_status === "verified" ? "Verificato" : "In attesa";
      roleBadge.style.background = clientState.herbalife_id_status === "verified" ? "rgba(16, 185, 129, 0.2)" : "rgba(245, 158, 11, 0.2)";
      roleBadge.style.color = clientState.herbalife_id_status === "verified" ? "#10B981" : "#F59E0B";
      roleBadge.textContent = `🟢 Distributore ${statusText} (ID: ${clientState.my_herbalife_id || p.myHerbalifeId || 'N/D'})`;
    } else {
      roleBadge.style.background = "rgba(56, 189, 248, 0.15)";
      roleBadge.style.color = "#38BDF8";
      roleBadge.textContent = "🏃 Sfidante Cliente";
    }
  }

  const phoneTag = document.getElementById("coach-detail-phone-tag");
  const clientPhone = p.phone || clientState.phone || "";
  if (phoneTag) {
    if (clientPhone) {
      phoneTag.style.display = "inline";
      phoneTag.textContent = `📞 ${clientPhone}`;
    } else {
      phoneTag.style.display = "none";
    }
  }

  const metaTags = document.getElementById("coach-detail-meta-tags");
  if (metaTags) {
    const storeLabel = {
      herbaally: "Herbaally",
      mylifestylemotion: "My Lifestyle Motion",
      herballeato: "Herballeato",
      yourwellnesspath: "Your Wellness Path"
    }[clientState.store_id || "herbaally"] || clientState.store_id || "Store";
    const pkgKey = p.package || (p.kitType === "base" ? "bronze" : (p.kitType === "personalizzato" ? "gold" : (p.kitType || "silver")));
    const pkgDef = PACKAGES_DEFINITIONS[pkgKey] || PACKAGES_DEFINITIONS.silver;
    const kitLabel = `${pkgDef.name} (${pkgDef.price})`;
    metaTags.textContent = `• 🏪 ${storeLabel} • 📦 ${kitLabel}`;
  }

  // 2. Quantitative Calculations
  const startWeight = parseFloat(p.startWeight) || 80.0;
  let latestWeight = startWeight;
  let totalScore = 0;
  let totalWaterMl = 0;
  let totalShakes = 0;
  let totalSteps = 0;
  let totalKm = 0;
  let daysCompleted = 0;

  normalizedLogs.forEach((log, idx) => {
    if (log.weight !== null && !isNaN(parseFloat(log.weight))) {
      latestWeight = parseFloat(log.weight);
    }
    const s = calculateDailyScore(log);
    if (s > 0 || (log.shakesCount > 0) || (log.water > 0) || (log.weight !== null)) {
      daysCompleted++;
      totalScore += s;
    }
    totalWaterMl += Number(log.water) || 0;
    totalShakes += Number(log.shakesCount) || 0;
    totalSteps += Number(log.steps) || 0;
    totalKm += Number(log.km) || 0;
  });

  const compliance = Math.min(100, Math.round((daysCompleted / 10) * 100));
  const avgScore = daysCompleted > 0 ? Math.round(totalScore / daysCompleted) : 0;
  const weightDelta = (latestWeight - startWeight).toFixed(1);
  const totalWaterL = (totalWaterMl / 1000).toFixed(1);
  const avgWaterL = daysCompleted > 0 ? (totalWaterL / daysCompleted).toFixed(1) : (totalWaterL / 1).toFixed(1);

  // Set Quantitative KPI Values
  const statCompliance = document.getElementById("coach-detail-stat-compliance");
  if (statCompliance) statCompliance.textContent = `${compliance}%`;
  
  const statDays = document.getElementById("coach-detail-stat-days");
  if (statDays) statDays.textContent = `${daysCompleted}/10 Giorni`;

  const statScore = document.getElementById("coach-detail-stat-score");
  if (statScore) statScore.textContent = `${avgScore} pt`;

  const statWeightLoss = document.getElementById("coach-detail-stat-weight-loss");
  if (statWeightLoss) {
    const numDelta = parseFloat(weightDelta);
    if (numDelta < 0) {
      statWeightLoss.textContent = `${numDelta} kg`;
      statWeightLoss.style.color = "#10B981";
    } else if (numDelta > 0) {
      statWeightLoss.textContent = `+${numDelta} kg`;
      statWeightLoss.style.color = "#F59E0B";
    } else {
      statWeightLoss.textContent = `0.0 kg`;
      statWeightLoss.style.color = "#94A3B8";
    }
  }

  const statWater = document.getElementById("coach-detail-stat-water");
  if (statWater) statWater.textContent = `${totalWaterL} L`;

  const statWaterAvg = document.getElementById("coach-detail-stat-water-avg");
  if (statWaterAvg) statWaterAvg.textContent = `Media: ${avgWaterL} L/die`;

  const statShakes = document.getElementById("coach-detail-stat-shakes");
  if (statShakes) statShakes.textContent = `${totalShakes} 🥤`;

  const statSteps = document.getElementById("coach-detail-stat-steps");
  if (statSteps) statSteps.textContent = totalSteps.toLocaleString('it-IT');

  const statKm = document.getElementById("coach-detail-stat-km");
  if (statKm) statKm.textContent = `${totalKm.toFixed(1)} km percorsi`;

  // 3. Touchpoint Buttons (WhatsApp, Call, PDF)
  const waBtn = document.getElementById("coach-btn-client-wa");
  if (waBtn) {
    const cleanPhone = clientPhone.replace(/[^0-9+]/g, '');
    const clientName = p.name || clientState.name || "Sfidante";
    const deltaTxt = parseFloat(weightDelta) < 0 ? `hai già perso ${Math.abs(weightDelta)} kg 🔥` : `sei a ${latestWeight} kg`;
    const waText = encodeURIComponent(
      `Ciao ${clientName}! 🌟 Sono il tuo Coach del Programma 10 Giorni Herbalife.\n\n` +
      `Ho verificato il tuo andamento:\n` +
      `• Compliance: ${compliance}% (${daysCompleted}/10 giorni completati)\n` +
      `• Punteggio Medio: ${avgScore}/100 pt\n` +
      `• Peso Attuale: ${latestWeight} kg (${deltaTxt})\n` +
      `• Acqua Totale Bevuta: ${totalWaterL} Litri\n\n` +
      `Complimenti per il tuo impegno! Come ti senti oggi? C'è qualcosa in cui posso aiutarti per migliorare ancora i tuoi risultati? 💪💚`
    );
    waBtn.href = cleanPhone ? `https://wa.me/${cleanPhone.replace(/^\+/, '')}?text=${waText}` : `https://api.whatsapp.com/send?text=${waText}`;
  }

  const callBtn = document.getElementById("coach-btn-client-call");
  if (callBtn) {
    const cleanPhone = clientPhone.replace(/[^0-9+]/g, '');
    if (cleanPhone) {
      callBtn.style.display = "inline-flex";
      callBtn.href = `tel:${cleanPhone}`;
    } else {
      callBtn.style.display = "none";
    }
  }

  const pdfBtn = document.getElementById("coach-btn-client-pdf");
  if (pdfBtn) {
    pdfBtn.onclick = () => {
      exportProgram10ReportPDF(clientState);
    };
  }

  // 4. Render Day-by-Day 10-Days Logbook
  const logbookContainer = document.getElementById("coach-detail-days-logbook");
  if (logbookContainer) {
    logbookContainer.innerHTML = "";
    normalizedLogs.forEach((log, i) => {
      const dayNum = i + 1;
      const dayScore = calculateDailyScore(log);
      const isLogged = (log.shakesCount > 0) || (log.water > 0) || (log.weight !== null) || log.snack || log.meal || (log.steps > 0);
      
      let statusBadge = `<span class="badge" style="background: rgba(148,163,184,0.15); color: #94A3B8; font-size: 10.5px;">⚪ Non registrato</span>`;
      if (dayScore === 100) {
        statusBadge = `<span class="badge" style="background: rgba(16,185,129,0.25); color: #10B981; font-weight: 800; font-size: 10.5px;">🌟 Giorno Perfetto (${dayScore} pt)</span>`;
      } else if (isLogged) {
        statusBadge = `<span class="badge" style="background: rgba(16,185,129,0.15); color: #34D399; font-size: 10.5px;">✅ Completato (${dayScore} pt)</span>`;
      }

      const waterL = ((log.water || 0) / 1000).toFixed(1);
      const shakesText = `${log.shakesCount || 0}/2`;
      const weightText = log.weight !== null ? `${log.weight} kg` : `--`;
      const stepsText = (log.steps || 0).toLocaleString('it-IT');

      let aiScanHtml = "";
      if (log.scannedMeal && log.scannedMeal.stats) {
        const dish = log.scannedMeal.stats.dish_name || "Pasto Scansionato";
        const cal = log.scannedMeal.stats.calories ? `• ${log.scannedMeal.stats.calories}` : "";
        const prot = log.scannedMeal.stats.protein ? `• Prot: ${log.scannedMeal.stats.protein}` : "";
        aiScanHtml = `
          <div style="margin-top: 6px; font-size: 11px; color: #34D399; background: rgba(16,185,129,0.08); padding: 4px 8px; border-radius: 6px;">
            📸 <strong>AI Scan:</strong> ${dish} ${cal} ${prot}
          </div>
        `;
      }

      const dayCard = document.createElement("div");
      dayCard.style.cssText = `
        background: ${isLogged ? 'rgba(255,255,255,0.03)' : 'rgba(255,255,255,0.01)'};
        border: 1px solid ${isLogged ? 'rgba(16,185,129,0.2)' : 'rgba(255,255,255,0.06)'};
        border-radius: 8px;
        padding: 10px 12px;
      `;

      dayCard.innerHTML = `
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
          <strong style="font-size: 13px; color: #FFFFFF;">Giorno ${dayNum}</strong>
          ${statusBadge}
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 8px 14px; font-size: 11.5px; color: #CBD5E1;">
          <span>🥤 Frullati: <strong style="color: ${log.shakesCount >= 2 ? '#10B981' : '#F59E0B'};">${shakesText}</strong></span>
          <span>💧 Acqua: <strong style="color: #60A5FA;">${waterL} L</strong></span>
          <span>🍎 Spuntino: <strong>${log.snack ? '✅' : '❌'}</strong></span>
          <span>🥗 Pasto: <strong>${log.meal ? '✅' : '❌'}</strong></span>
          <span>🚶 Passi: <strong style="color: #A78BFA;">${stepsText}</strong></span>
          <span>⚖️ Peso: <strong style="color: #38BDF8;">${weightText}</strong></span>
        </div>
        ${aiScanHtml}
      `;

      logbookContainer.appendChild(dayCard);
    });
  }

  // 5. Biometrics & Measurements
  const startWEl = document.getElementById("coach-detail-start-weight");
  if (startWEl) startWEl.textContent = `${startWeight} kg`;

  const currWEl = document.getElementById("coach-detail-current-weight");
  if (currWEl) currWEl.textContent = `${latestWeight} kg`;

  const targetWEl = document.getElementById("coach-detail-target-weight");
  const targetWeight = parseFloat(p.targetWeight) || (startWeight - 3);
  if (targetWEl) targetWEl.textContent = `${targetWeight} kg`;

  const heightVal = parseFloat(p.height) || 170;
  const bmiVal = (heightVal && latestWeight) ? (latestWeight / Math.pow(heightVal / 100, 2)).toFixed(1) : "--";
  const bmiEl = document.getElementById("coach-detail-bmi");
  if (bmiEl) bmiEl.textContent = `${bmiVal}`;

  const bmiBadge = document.getElementById("coach-detail-bmi-badge");
  if (bmiBadge && bmiVal !== "--") {
    const numBmi = parseFloat(bmiVal);
    if (numBmi < 18.5) {
      bmiBadge.textContent = "Sottopeso";
      bmiBadge.style.color = "#F59E0B";
    } else if (numBmi <= 24.9) {
      bmiBadge.textContent = "Normopeso";
      bmiBadge.style.color = "#10B981";
    } else if (numBmi <= 29.9) {
      bmiBadge.textContent = "Sovrappeso";
      bmiBadge.style.color = "#F59E0B";
    } else {
      bmiBadge.textContent = "Obesità";
      bmiBadge.style.color = "#EF4444";
    }
  }

  const chestEl = document.getElementById("coach-detail-chest");
  if (chestEl) chestEl.textContent = p.chest || "--";

  const waistEl = document.getElementById("coach-detail-waist");
  if (waistEl) waistEl.textContent = p.waist || "--";

  const hipsEl = document.getElementById("coach-detail-hips");
  if (hipsEl) hipsEl.textContent = p.hips || "--";

  const waterGoalEl = document.getElementById("coach-detail-water-goal");
  if (waterGoalEl) waterGoalEl.textContent = p.waterGoal || "2.5";

  // 6. Strategy & Nutritional Advice
  const strategyTxtEl = document.getElementById("coach-detail-strategy-txt");
  if (strategyTxtEl) {
    if (startWeight > targetWeight) {
      strategyTxtEl.textContent = `Deficit Calorico Controllato (-450 kcal) per perdita di massa grassa. Sostituzione di 2 pasti con Formula 1 + PDM.`;
    } else if (startWeight < targetWeight) {
      strategyTxtEl.textContent = `Superavit Pulito per aumento massa muscolare. 1 Frullato Formula 1 post-workout + pasti ad alto valore proteico.`;
    } else {
      strategyTxtEl.textContent = `Mantenimento Attivo & Tonificazione. 1 Frullato Formula 1 a colazione per apporto completo di micronutrienti.`;
    }
  }

  const dietEl = document.getElementById("coach-detail-diet");
  if (dietEl) dietEl.textContent = `${p.dietType || "Onnivora"} ${p.currentDiet ? '(' + p.currentDiet + ')' : ''}`;

  const suppEl = document.getElementById("coach-detail-supplements");
  if (suppEl) suppEl.textContent = p.supplements || "Nessuno specificato";

  // 7. Lifestyle & Habits
  const shapeEl = document.getElementById("coach-detail-shape");
  if (shapeEl) shapeEl.textContent = p.bodyShape || "Media";

  const moveEl = document.getElementById("coach-detail-movement");
  if (moveEl) moveEl.textContent = p.lifestyleType || "Sedentario / Lavoro d'ufficio";

  const gymEl = document.getElementById("coach-detail-gym");
  if (gymEl) gymEl.textContent = p.gymFrequency || "1-2 volte a settimana";

  const substEl = document.getElementById("coach-detail-substances");
  if (substEl) substEl.textContent = `${p.coffeeCount || 0} caffè/die | Alcol: ${p.alcoholUsage || "Occasionale"}`;

  const sleepEl = document.getElementById("coach-detail-sleep");
  if (sleepEl) sleepEl.textContent = p.sleepQuality || "Buono (7-8 ore)";

  const stressEl = document.getElementById("coach-detail-stress");
  if (stressEl) stressEl.textContent = p.stressLevel || "Medio";

  const habitsEl = document.getElementById("coach-detail-habits");
  if (habitsEl) {
    const habitsList = [];
    if (p.hasWalks) habitsList.push("Passeggiate 🚶");
    if (p.hasSauna) habitsList.push("Sauna 🧖");
    if (p.hasColdShower) habitsList.push("Doccia fredda ❄️");
    if (p.hasMeditation) habitsList.push("Meditazione 🧘");
    if (p.hasFasting) habitsList.push("Digiuno Intermittente ⏳");
    habitsEl.textContent = habitsList.length > 0 ? habitsList.join(", ") : "Nessuna abitudine attiva impostata";
  }

  // 8. Clinical Notes & Warnings
  const illEl = document.getElementById("coach-detail-illnesses");
  if (illEl) illEl.textContent = p.illnesses || "Nessuna patologia o condizione segnalata";

  const medEl = document.getElementById("coach-detail-medications");
  if (medEl) medEl.textContent = p.medications || "Nessun farmaco assunto regolarmente";

  const probEl = document.getElementById("coach-detail-health-problems");
  if (probEl) probEl.textContent = p.healthProblems || "Nessun disturbo o problematica riferita";

  // 9. Render Weight Progression Chart
  renderCoachChart(clientState, normalizedLogs, startWeight, targetWeight);
};

const renderCoachChart = (clientState, normalizedLogs, startWeight, targetWeight) => {
  const svg = document.getElementById("coach-weight-svg");
  if (!svg) return;
  svg.innerHTML = "";

  const chartBadge = document.getElementById("coach-chart-summary-badge");
  if (chartBadge) {
    chartBadge.textContent = `Target: ${targetWeight || '--'} kg`;
  }

  const logs = normalizedLogs || clientState.dailyLogs || [];
  const validPoints = [];

  // Baseline Day 1
  validPoints.push({ day: 1, val: startWeight });

  logs.forEach((log, idx) => {
    if (log && log.weight !== null && !isNaN(parseFloat(log.weight))) {
      const d = idx + 1;
      if (d === 1) {
        validPoints[0].val = parseFloat(log.weight);
      } else {
        validPoints.push({ day: d, val: parseFloat(log.weight) });
      }
    }
  });

  const weightValues = validPoints.map(p => p.val);
  if (targetWeight) weightValues.push(targetWeight);
  weightValues.push(startWeight);

  const minW = Math.min(...weightValues) - 1.0;
  const maxW = Math.max(...weightValues) + 1.0;
  const weightRange = Math.max(1, maxW - minW);

  const width = 500;
  const height = 160;
  const paddingX = 45;
  const paddingY = 20;

  const getX = (day) => paddingX + ((day - 1) / 9) * (width - paddingX * 2);
  const getY = (w) => height - paddingY - ((w - minW) / weightRange) * (height - paddingY * 2);

  // Horizontal Grid Lines
  for (let i = 0; i <= 3; i++) {
    const wVal = minW + (weightRange / 3) * i;
    const y = getY(wVal);

    const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
    line.setAttribute("x1", paddingX);
    line.setAttribute("y1", y);
    line.setAttribute("x2", width - paddingX);
    line.setAttribute("y2", y);
    line.setAttribute("stroke", "rgba(255,255,255,0.06)");
    line.setAttribute("stroke-dasharray", "4");
    svg.appendChild(line);

    const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
    text.setAttribute("x", paddingX - 6);
    text.setAttribute("y", y + 4);
    text.setAttribute("text-anchor", "end");
    text.setAttribute("fill", "#64748B");
    text.setAttribute("font-size", "10");
    text.textContent = `${wVal.toFixed(1)}`;
    svg.appendChild(text);
  }

  // Day Vertical Axis
  for (let d = 1; d <= 10; d++) {
    const x = getX(d);
    const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
    text.setAttribute("x", x);
    text.setAttribute("y", height - 4);
    text.setAttribute("text-anchor", "middle");
    text.setAttribute("fill", "#64748B");
    text.setAttribute("font-size", "10");
    text.textContent = `G${d}`;
    svg.appendChild(text);
  }

  // Target Reference Line (if targetWeight)
  if (targetWeight) {
    const targetY = getY(targetWeight);
    const targetLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
    targetLine.setAttribute("x1", paddingX);
    targetLine.setAttribute("y1", targetY);
    targetLine.setAttribute("x2", width - paddingX);
    targetLine.setAttribute("y2", targetY);
    targetLine.setAttribute("stroke", "rgba(56, 189, 248, 0.4)");
    targetLine.setAttribute("stroke-dasharray", "3 3");
    targetLine.setAttribute("stroke-width", "1.5");
    svg.appendChild(targetLine);
  }

  // Polyline for weight points
  if (validPoints.length > 1) {
    let pathD = "";
    validPoints.forEach((p, idx) => {
      const x = getX(p.day);
      const y = getY(p.val);
      pathD += (idx === 0 ? `M ${x} ${y}` : ` L ${x} ${y}`);
    });

    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", pathD);
    path.setAttribute("fill", "none");
    path.setAttribute("stroke", "#10B981");
    path.setAttribute("stroke-width", "2.5");
    svg.appendChild(path);
  }

  // Draw Circles with tooltips for points
  validPoints.forEach(p => {
    const x = getX(p.day);
    const y = getY(p.val);

    const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    circle.setAttribute("cx", x);
    circle.setAttribute("cy", y);
    circle.setAttribute("r", 4.5);
    circle.setAttribute("fill", "#10B981");
    circle.setAttribute("stroke", "#0B0F19");
    circle.setAttribute("stroke-width", "2");
    svg.appendChild(circle);

    const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
    text.setAttribute("x", x);
    text.setAttribute("y", y - 8);
    text.setAttribute("text-anchor", "middle");
    text.setAttribute("fill", "#FFFFFF");
    text.setAttribute("font-size", "9.5");
    text.setAttribute("font-weight", "700");
    text.textContent = `${p.val.toFixed(1)}`;
    svg.appendChild(text);
  });
};



const initProfilePhotoUpload = () => {
  const photoInput = document.getElementById("input-profile-photo");
  const previewImg = document.getElementById("profile-photo-preview");
  
  if (!photoInput) return;
  
  if (state.profile.photo) {
    previewImg.src = state.profile.photo;
    previewImg.style.display = "block";
  }
  
  photoInput.addEventListener("change", (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const rawData = event.target.result;
        const img = new Image();
        img.onload = () => {
          const maxDim = 140;
          let w = img.width;
          let h = img.height;
          if (w > h) {
            if (w > maxDim) {
              h = Math.round((h * maxDim) / w);
              w = maxDim;
            }
          } else {
            if (h > maxDim) {
              w = Math.round((w * maxDim) / h);
              h = maxDim;
            }
          }
          const canvas = document.createElement("canvas");
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, w, h);
          const compressedData = canvas.toDataURL("image/jpeg", 0.8);
          
          state.profile.photo = compressedData;
          previewImg.src = compressedData;
          previewImg.style.display = "block";
          
          saveStateToStorage();
          
          const sidebarAvatar = document.querySelector(".row-avatar");
          if (sidebarAvatar) {
            sidebarAvatar.innerHTML = `<img src="${compressedData}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">`;
          }
          
          renderLeaderboard();
          renderCommunityChat();
          if (typeof updateProfileHeroBar === "function") updateProfileHeroBar();
          if (typeof showAppToast === "function") {
            showAppToast("Foto profilo aggiornata! 📷", "La tua immagine è ora visibile nel tuo profilo e nella classifica.", "📷");
          }
        };
        img.onerror = () => {
          state.profile.photo = rawData;
          saveStateToStorage();
        };
        img.src = rawData;
      };
      reader.readAsDataURL(file);
    }
  });
};

// ==========================================
// NEW UX ENHANCEMENTS & HELPER FUNCTIONS
// ==========================================

const updateProgressRing = () => {
  const circle = document.getElementById("progress-ring-circle");
  const pctText = document.getElementById("progress-ring-pct");
  const summaryText = document.getElementById("habits-summary-text");
  const streakVal = document.getElementById("streak-count-val");
  const quoteText = document.getElementById("daily-motivation-quote");
  
  if (!state.dailyLogs || !state.dailyLogs[state.activeDay - 1]) return;
  const currentLog = state.dailyLogs[state.activeDay - 1];
  let completedCount = 0;

  const h1 = (currentLog.shakesCount || 0) >= 1;
  const h2 = (currentLog.water || 0) >= 1500;
  const h3 = !!currentLog.snack;
  const h4 = !!currentLog.meal;
  const h5 = ((currentLog.steps || 0) >= 3000 || (currentLog.exDuration || 0) >= 15 || (currentLog.exType && currentLog.exType !== 'nessuno'));

  if (h1) completedCount++;
  if (h2) completedCount++;
  if (h3) completedCount++;
  if (h4) completedCount++;
  if (h5) completedCount++;

  const updateElementState = (el, isCompleted) => {
    if (!el) return;
    if (isCompleted) {
      el.classList.add("completed", "active-card", "slot-completed");
    } else {
      el.classList.remove("completed", "active-card", "slot-completed");
    }
  };

  // 1. Update 5 Habit Matrix Pills in Header Hub
  const p1 = document.getElementById("habit-pill-1");
  const p2 = document.getElementById("habit-pill-2");
  const p3 = document.getElementById("habit-pill-3");
  const p4 = document.getElementById("habit-pill-4");
  const p5 = document.getElementById("habit-pill-5");

  updateElementState(p1, h1);
  updateElementState(p2, h2);
  updateElementState(p3, h3);
  updateElementState(p4, h4);
  updateElementState(p5, h5);

  // 2. Update 5 Standalone Habit Cards in Habits Grid
  const c1 = document.getElementById("habit-card-shakes");
  const c2 = document.getElementById("habit-card-water");
  const c3 = document.getElementById("habit-card-snack");
  const c4 = document.getElementById("habit-card-meal");
  const c5 = document.getElementById("habit-card-movement");

  updateElementState(c1, h1);
  updateElementState(c2, h2);
  updateElementState(c3, h3);
  updateElementState(c4, h4);
  updateElementState(c5, h5);

  // 3. Update Suggested Meal Timeline Slots
  const slotMorning = document.querySelector('.suggested-meal-box[data-slot="morning"], .suggested-meal-box[data-meal-slot="morning"]');
  const slotLunch = document.querySelector('.suggested-meal-box[data-slot="lunch"], .suggested-meal-box[data-meal-slot="lunch"]');
  const slotSnack = document.querySelector('.suggested-meal-box[data-slot="afternoon"], .suggested-meal-box[data-meal-slot="snack"]');
  const slotDinner = document.querySelector('.suggested-meal-box[data-slot="dinner"], .suggested-meal-box[data-meal-slot="evening"]');

  updateElementState(slotMorning, h1);
  updateElementState(slotLunch, h4 || (currentLog.shakesCount >= 2));
  updateElementState(slotSnack, h3);
  updateElementState(slotDinner, h4 || (currentLog.shakesCount >= 2));

  // 4. Update Ring & Percent Text
  const percentage = Math.round((completedCount / 5) * 100);
  if (circle) {
    const strokeDasharray = 289;
    const offset = strokeDasharray - (percentage / 100) * strokeDasharray;
    circle.style.strokeDashoffset = offset;
  }
  if (pctText) {
    pctText.textContent = `${percentage}%`;
  }

  if (summaryText) {
    if (state.lang === "it") summaryText.textContent = `${completedCount} di 5 abitudini completate`;
    else if (state.lang === "en") summaryText.textContent = `${completedCount} of 5 habits completed`;
    else if (state.lang === "ro") summaryText.textContent = `${completedCount} din 5 obiceiuri finalizate`;
    else summaryText.textContent = `${completedCount} de 5 hábitos completados`;
  }

  // 5. Calculate Streak
  let streakDays = 0;
  for (let i = 0; i < state.dailyLogs.length; i++) {
    const log = state.dailyLogs[i];
    if (log.shakesCount >= 1 || log.water >= 1000 || log.snack || log.meal || log.steps > 0) {
      streakDays++;
    } else {
      break;
    }
  }
  if (streakVal) {
    const dayWord = streakDays === 1 ? (state.lang === 'it' ? 'Giorno' : 'Day') : (state.lang === 'it' ? 'Giorni' : 'Days');
    streakVal.textContent = `${streakDays} ${dayWord}`;
  }

  // 6. Daily Quote
  if (quoteText && MOTIVATIONAL_QUOTES.length > 0) {
    quoteText.textContent = `"${MOTIVATIONAL_QUOTES[(state.activeDay - 1) % MOTIVATIONAL_QUOTES.length]}"`;
  }

  // Trigger Confetti if 100% completed
  if (percentage === 100 && !currentLog._confettiFired) {
    currentLog._confettiFired = true;
    if (typeof triggerConfetti === "function") triggerConfetti();
  }

  // Initialize click-to-toggle listeners on habit pills & timeline slots if not done
  if (typeof initInteractiveHabitPills === "function") {
    initInteractiveHabitPills();
  }
};

const initInteractiveHabitPills = () => {
  const p1 = document.getElementById("habit-pill-1");
  const p2 = document.getElementById("habit-pill-2");
  const p3 = document.getElementById("habit-pill-3");
  const p4 = document.getElementById("habit-pill-4");
  const p5 = document.getElementById("habit-pill-5");

  const toggleShake = () => {
    const log = state.dailyLogs[state.activeDay - 1];
    if (!log) return;
    const shakeSelect = document.getElementById("select-shakes-count");
    log.shakesCount = (log.shakesCount || 0) >= 2 ? 0 : ((log.shakesCount || 0) + 1);
    if (shakeSelect) shakeSelect.value = log.shakesCount;
    saveStateToStorage();
    updateDailyScoreUI();
    updateChallengeSummaryUI();
    renderDaySelector();
  };

  const toggleWater = () => {
    const log = state.dailyLogs[state.activeDay - 1];
    if (!log) return;
    log.water = (log.water || 0) >= 2500 ? 0 : ((log.water || 0) + 500);
    renderWaterGlasses();
    saveStateToStorage();
    updateDailyScoreUI();
    updateChallengeSummaryUI();
    renderDaySelector();
  };

  const toggleSnack = () => {
    const log = state.dailyLogs[state.activeDay - 1];
    if (!log) return;
    const chkSnack = document.getElementById("chk-snack");
    log.snack = !log.snack;
    if (chkSnack) chkSnack.checked = log.snack;
    saveStateToStorage();
    updateDailyScoreUI();
    updateChallengeSummaryUI();
    renderDaySelector();
  };

  const toggleMeal = () => {
    const log = state.dailyLogs[state.activeDay - 1];
    if (!log) return;
    const chkMeal = document.getElementById("chk-meal");
    log.meal = !log.meal;
    if (chkMeal) chkMeal.checked = log.meal;
    saveStateToStorage();
    updateDailyScoreUI();
    updateChallengeSummaryUI();
    renderDaySelector();
  };

  const toggleMovement = () => {
    const log = state.dailyLogs[state.activeDay - 1];
    if (!log) return;
    const stepsInput = document.getElementById("input-daily-steps");
    const kmInput = document.getElementById("input-daily-km");
    if ((log.steps || 0) > 0 || (log.exDuration || 0) > 0) {
      log.steps = 0;
      log.km = 0;
      log.exDuration = 0;
    } else {
      log.steps = 6000;
      log.km = 4.2;
    }
    if (stepsInput) stepsInput.value = log.steps || "";
    if (kmInput) kmInput.value = log.km || "";
    saveStateToStorage();
    updateDailyScoreUI();
    updateChallengeSummaryUI();
    renderDaySelector();
  };

  if (p1 && !p1._hasToggleListener) { p1._hasToggleListener = true; p1.style.cursor = "pointer"; p1.addEventListener("click", toggleShake); }
  if (p2 && !p2._hasToggleListener) { p2._hasToggleListener = true; p2.style.cursor = "pointer"; p2.addEventListener("click", toggleWater); }
  if (p3 && !p3._hasToggleListener) { p3._hasToggleListener = true; p3.style.cursor = "pointer"; p3.addEventListener("click", toggleSnack); }
  if (p4 && !p4._hasToggleListener) { p4._hasToggleListener = true; p4.style.cursor = "pointer"; p4.addEventListener("click", toggleMeal); }
  if (p5 && !p5._hasToggleListener) { p5._hasToggleListener = true; p5.style.cursor = "pointer"; p5.addEventListener("click", toggleMovement); }

  const slotMorning = document.querySelector('.suggested-meal-box[data-slot="morning"], .suggested-meal-box[data-meal-slot="morning"]');
  const slotLunch = document.querySelector('.suggested-meal-box[data-slot="lunch"], .suggested-meal-box[data-meal-slot="lunch"]');
  const slotSnack = document.querySelector('.suggested-meal-box[data-slot="afternoon"], .suggested-meal-box[data-meal-slot="snack"]');
  const slotDinner = document.querySelector('.suggested-meal-box[data-slot="dinner"], .suggested-meal-box[data-meal-slot="evening"]');

  if (slotMorning && !slotMorning._hasToggleListener) { slotMorning._hasToggleListener = true; slotMorning.style.cursor = "pointer"; slotMorning.addEventListener("click", toggleShake); }
  if (slotLunch && !slotLunch._hasToggleListener) { slotLunch._hasToggleListener = true; slotLunch.style.cursor = "pointer"; slotLunch.addEventListener("click", toggleMeal); }
  if (slotSnack && !slotSnack._hasToggleListener) { slotSnack._hasToggleListener = true; slotSnack.style.cursor = "pointer"; slotSnack.addEventListener("click", toggleSnack); }
  if (slotDinner && !slotDinner._hasToggleListener) { slotDinner._hasToggleListener = true; slotDinner.style.cursor = "pointer"; slotDinner.addEventListener("click", toggleMeal); }
};

const renderWaterCups = () => {
  const container = document.getElementById("water-cups-grid");
  if (!container) return;

  const currentLog = state.dailyLogs[state.activeDay - 1];
  const waterMl = currentLog.water || 0;
  const cupsTotal = 5; // 5 cups of 500ml = 2.5L
  const filledCups = Math.min(cupsTotal, Math.floor(waterMl / 500));

  container.innerHTML = "";
  container.className = "water-cups-interactive-grid";

  for (let i = 0; i < cupsTotal; i++) {
    const isFilled = i < filledCups;
    const cupEl = document.createElement("div");
    cupEl.className = `water-cup-item ${isFilled ? 'filled' : ''}`;
    cupEl.innerHTML = `
      <span class="cup-icon">🥛</span>
      <span class="cup-volume">500ml</span>
    `;
    cupEl.addEventListener("click", () => {
      toggleWaterCup(i);
    });
    container.appendChild(cupEl);
  }
};

const toggleWaterCup = (index) => {
  const currentLog = state.dailyLogs[state.activeDay - 1];
  const targetMl = (index + 1) * 500;
  
  if (currentLog.water >= targetMl) {
    currentLog.water = Math.max(0, index * 500);
  } else {
    currentLog.water = targetMl;
  }

  saveStateToStorage();
  loadActiveDayLogs();
  updateProgressRing();
};

const updateHourlyTimeline = () => {
  const clockEl = document.getElementById("live-clock");
  const slots = document.querySelectorAll(".timeline-slot");
  if (!slots.length) return;

  const now = new Date();
  const hours = now.getHours();
  const mins = String(now.getMinutes()).padStart(2, '0');

  if (clockEl) {
    clockEl.textContent = `${String(hours).padStart(2, '0')}:${mins}`;
  }

  let activeSlotKey = "morning";
  if (hours >= 7 && hours < 10) activeSlotKey = "morning";
  else if (hours >= 10 && hours < 13) activeSlotKey = "midmorning";
  else if (hours >= 13 && hours < 16) activeSlotKey = "lunch";
  else if (hours >= 16 && hours < 19) activeSlotKey = "afternoon";
  else activeSlotKey = "dinner";

  slots.forEach(slot => {
    if (slot.getAttribute("data-slot") === activeSlotKey) {
      slot.classList.add("active-now");
    } else {
      slot.classList.remove("active-now");
    }
  });
};

const triggerConfetti = () => {
  const canvas = document.getElementById("confetti-canvas");
  if (!canvas) return;
  const ctx = canvas.getContext("2d");
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;

  const particles = Array.from({ length: 80 }, () => ({
    x: Math.random() * canvas.width,
    y: Math.random() * canvas.height - canvas.height,
    size: Math.random() * 8 + 4,
    color: ["#10B981", "#38BDF8", "#F59E0B", "#EC4899", "#8B5CF6"][Math.floor(Math.random() * 5)],
    speedY: Math.random() * 4 + 2,
    speedX: Math.random() * 2 - 1,
    rotation: Math.random() * 360
  }));

  let frame = 0;
  const animate = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    particles.forEach(p => {
      p.y += p.speedY;
      p.x += p.speedX;
      p.rotation += 2;
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate((p.rotation * Math.PI) / 180);
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size);
      ctx.restore();
    });

    frame++;
    if (frame < 120) {
      requestAnimationFrame(animate);
    } else {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  };
  animate();
};

let deferredPwaPrompt = null;
const initPwaBanner = () => {
  const banner = document.getElementById("pwa-install-banner");
  const installBtn = document.getElementById("pwa-install-btn");
  const dismissBtn = document.getElementById("pwa-dismiss-btn");

  if (!banner || !installBtn) return;

  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPwaPrompt = e;
    banner.style.display = "flex";
  });

  installBtn.addEventListener("click", () => {
    if (deferredPwaPrompt) {
      deferredPwaPrompt.prompt();
      deferredPwaPrompt.userChoice.then(() => {
        deferredPwaPrompt = null;
        banner.style.display = "none";
      });
    }
  });

  if (dismissBtn) {
    dismissBtn.addEventListener("click", () => {
      banner.style.display = "none";
    });
  }
};

// ==========================================
// INTERACTIVE MEAL DETAILS MODAL & PDF EXPORT
// ==========================================

let currentActiveMealData = null;

function getSuggestedProductsForMeal(meal, storeId) {
  if (!meal) return [];
  const targetStore = storeId || (typeof getStoreId === 'function' ? getStoreId() : 'herbaally');
  const storeCat = STORE_PRODUCTS_CATALOG[targetStore] || STORE_PRODUCTS_CATALOG.herbaally;
  if (!storeCat || !storeCat.products) return [];

  const textToScan = `${meal.title || ''} ${meal.desc || ''} ${meal.ingredients || ''} ${meal.tip || ''}`.toLowerCase();
  let detected = detectSuggestedProducts(textToScan, targetStore);

  // If none or only 1 detected, complement with natural products for that meal slot
  if (!detected || detected.length < 2) {
    const isSolidDish = !textToScan.includes('shake') && !textToScan.includes('frullato') && !textToScan.includes('formula 1');
    const slotKeys = {
      morning: ['formula1', 'pdm', 'aloe'],
      lunch: isSolidDish ? ['tea', 'mineralcomplex', 'phytocomplete'] : ['formula1', 'pdm', 'tea'],
      snack: ['proteinbar', 'proteinchips', 'icedcoffee', 'pdm', 'triblend'],
      evening: isSolidDish ? ['nightmode', 'restore', 'mineralcomplex'] : ['formula1', 'pdm', 'nightmode']
    };
    const defaultKeys = slotKeys[meal.slot] || ['formula1', 'aloe', 'tea'];
    const seen = new Set((detected || []).map(p => p.id));
    if (!detected) detected = [];
    defaultKeys.forEach(k => {
      const prod = storeCat.products[k];
      if (prod && !seen.has(prod.id)) {
        detected.push(prod);
        seen.add(prod.id);
      }
    });
  }

  return (detected || []).slice(0, 3);
}

function printMealRecipePDF(meal) {
  if (!meal) return;
  const p = state.profile || {};
  const slotNames = {
    morning: state.lang === 'it' ? '☀️ Colazione' : (state.lang === 'ro' ? '☀️ Micul Dejun' : (state.lang === 'es' ? '☀️ Desayuno' : '☀️ Breakfast')),
    lunch: state.lang === 'it' ? '🌤️ Pranzo' : (state.lang === 'ro' ? '🌤️ Prânz' : (state.lang === 'es' ? '🌤️ Almuerzo' : '🌤️ Lunch')),
    snack: state.lang === 'it' ? '🍎 Merenda' : (state.lang === 'ro' ? '🍎 Gustare' : (state.lang === 'es' ? '🍎 Merienda' : '🍎 Snack')),
    evening: state.lang === 'it' ? '🌙 Cena' : (state.lang === 'ro' ? '🌙 Cină' : (state.lang === 'es' ? '🌙 Cena' : '🌙 Dinner'))
  };
  const slotLabel = slotNames[meal.slot] || (state.lang === 'it' ? 'Pasto Consigliato' : 'Recommended Meal');
  const dayWord = state.lang === 'it' ? 'Giorno' : (state.lang === 'ro' ? 'Ziua' : (state.lang === 'es' ? 'Día' : 'Day'));
  const dayText = `${dayWord} ${meal.day || state.activeDay}`;
  const storeId = typeof getStoreId === 'function' ? getStoreId() : 'herbaally';
  const brandName = {
    herbaally: 'Herbaally',
    mylifestylemotion: 'My Lifestyle Motion',
    herballeato: 'Herballeato',
    yourwellnesspath: 'Your Wellness Path'
  }[storeId] || 'Programma 10 Giorni';

  const imgUrl = getAssetUrl(meal.img || 'assets/breakfast_shake_aloe.png');
  const mealProducts = getSuggestedProductsForMeal(meal, storeId);

  const prodHeaderTxt = {
    it: "🛍️ Prodotti Herbalife Consigliati per Questa Ricetta",
    en: "🛍️ Recommended Herbalife Products for This Recipe",
    ro: "🛍️ Produse Herbalife Recomandate pentru Această Rețetă",
    es: "🛍️ Productos Herbalife Recomendados para Esta Receta"
  }[state.lang] || "🛍️ Recommended Herbalife Products for This Recipe";

  const productsSectionHtml = (mealProducts && mealProducts.length > 0) ? `
    <div class="pdf-section-box">
      <div class="pdf-sec-title" style="color: #10B981;">${prodHeaderTxt}</div>
      <div class="pdf-products-grid" style="display: grid; grid-template-columns: repeat(${Math.min(mealProducts.length, 3)}, 1fr); gap: 12px; margin-top: 10px;">
        ${mealProducts.map(prod => `
          <div style="background: rgba(255, 255, 255, 0.03); border: 1px solid rgba(16, 185, 129, 0.25); border-radius: 12px; padding: 10px; text-align: center; display: flex; flex-direction: column; align-items: center; justify-content: space-between;">
            <div style="width: 54px; height: 54px; margin-bottom: 6px; background: #FFFFFF; border-radius: 8px; overflow: hidden; display: flex; align-items: center; justify-content: center; padding: 2px;">
              <img src="${prod.image}" alt="${prod.title}" style="max-width: 100%; max-height: 100%; object-fit: contain;">
            </div>
            <div style="font-size: 11px; font-weight: 800; color: #FFFFFF; line-height: 1.2; margin-bottom: 3px;">${prod.title}</div>
            <div style="font-size: 10px; color: #94A3B8; line-height: 1.2; margin-bottom: 6px;">${prod.benefit || ''}</div>
            <a href="${prod.url}" target="_blank" style="font-size: 10px; font-weight: 800; color: #061A14; background: #10B981; padding: 4px 10px; border-radius: 6px; text-decoration: none; display: inline-flex; align-items: center; justify-content: center; text-align: center; width: 100%; box-sizing: border-box; margin-top: 4px;">Vedi sullo Store</a>
          </div>
        `).join('')}
      </div>
    </div>
  ` : '';

  const printHtml = `
<!DOCTYPE html>
<html lang="${state.lang}">
<head>
  <meta charset="utf-8">
  <title>${meal.title || 'Ricetta Pasto'} - ${dayText} - ${brandName}</title>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800;900&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body {
      font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
      background: #0B0F19;
      color: #F8FAFC;
      padding: 24px;
      line-height: 1.5;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    .recipe-card-pdf {
      max-width: 680px;
      margin: 0 auto;
      background: #111827;
      border: 1px solid rgba(16, 185, 129, 0.35);
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 10px 40px rgba(0,0,0,0.5);
    }
    .pdf-header-banner {
      background: linear-gradient(135deg, #059669 0%, #10B981 50%, #047857 100%);
      padding: 16px 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: white;
    }
    .pdf-header-title {
      font-family: 'Outfit', sans-serif;
      font-size: 18px;
      font-weight: 800;
      letter-spacing: -0.5px;
    }
    .pdf-header-sub {
      font-size: 11px;
      opacity: 0.9;
      font-weight: 600;
    }
    .pdf-hero-img-wrap {
      position: relative;
      height: 240px;
      background: #000;
      overflow: hidden;
    }
    .pdf-hero-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .pdf-badges-overlay {
      position: absolute;
      top: 14px;
      left: 14px;
      display: flex;
      gap: 8px;
    }
    .pdf-badge {
      background: rgba(15, 23, 42, 0.85);
      backdrop-filter: blur(8px);
      border: 1px solid rgba(255, 255, 255, 0.15);
      color: #FFFFFF;
      padding: 6px 12px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 800;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    }
    .pdf-badge.accent {
      background: rgba(16, 185, 129, 0.9);
      border-color: #10B981;
    }
    .pdf-body {
      padding: 24px;
    }
    .pdf-recipe-title {
      font-family: 'Outfit', sans-serif;
      font-size: 24px;
      font-weight: 800;
      color: #FFFFFF;
      margin-bottom: 8px;
      line-height: 1.25;
    }
    .pdf-recipe-desc {
      font-size: 13.5px;
      color: #94A3B8;
      margin-bottom: 20px;
      line-height: 1.5;
    }
    .pdf-stats-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 12px;
      margin-bottom: 16px;
    }
    .pdf-stat-pill {
      background: rgba(255, 255, 255, 0.03);
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 14px;
      padding: 12px 14px;
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .pdf-stat-icon {
      font-size: 22px;
    }
    .pdf-stat-lbl {
      font-size: 10.5px;
      font-weight: 700;
      text-transform: uppercase;
      color: #94A3B8;
      display: block;
    }
    .pdf-stat-val {
      font-size: 16px;
      font-weight: 800;
      color: #10B981;
    }
    .pdf-macros-row {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      margin-bottom: 20px;
    }
    .pdf-macro-box {
      border-radius: 12px;
      padding: 10px;
      text-align: center;
      font-size: 12px;
    }
    .pdf-macro-prot { background: rgba(16, 185, 129, 0.1); border: 1px solid rgba(16, 185, 129, 0.3); color: #34D399; }
    .pdf-macro-carb { background: rgba(245, 158, 11, 0.1); border: 1px solid rgba(245, 158, 11, 0.3); color: #FBBF24; }
    .pdf-macro-fat { background: rgba(56, 189, 248, 0.1); border: 1px solid rgba(56, 189, 248, 0.3); color: #38BDF8; }
    .pdf-macro-val {
      display: block;
      font-size: 17px;
      font-weight: 800;
      margin-top: 3px;
      color: #FFFFFF;
    }
    .pdf-section-box {
      background: rgba(255, 255, 255, 0.02);
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 14px;
      padding: 16px 18px;
      margin-bottom: 16px;
    }
    .pdf-section-box.tip-box {
      background: linear-gradient(135deg, rgba(16, 185, 129, 0.08) 0%, rgba(15, 23, 42, 0.6) 100%);
      border-color: rgba(16, 185, 129, 0.35);
    }
    .pdf-sec-title {
      font-size: 13.5px;
      font-weight: 800;
      color: #F1F5F9;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      gap: 6px;
    }
    .pdf-sec-text {
      font-size: 12.5px;
      color: #CBD5E1;
      line-height: 1.55;
    }
    .pdf-footer {
      border-top: 1px solid rgba(255, 255, 255, 0.08);
      padding: 14px 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 11px;
      color: #64748B;
    }
    @media print {
      body { background: #FFFFFF !important; color: #0F172A !important; padding: 0 !important; }
      .recipe-card-pdf { border: 1px solid #CBD5E1 !important; box-shadow: none !important; max-width: 100% !important; background: #FFFFFF !important; }
      .pdf-recipe-title { color: #0F172A !important; }
      .pdf-recipe-desc { color: #475569 !important; }
      .pdf-stat-pill { background: #F8FAFC !important; border-color: #E2E8F0 !important; }
      .pdf-stat-lbl { color: #64748B !important; }
      .pdf-stat-val { color: #059669 !important; }
      .pdf-macro-prot { background: #ECFDF5 !important; border-color: #A7F3D0 !important; color: #047857 !important; }
      .pdf-macro-carb { background: #FFFBEB !important; border-color: #FDE68A !important; color: #B45309 !important; }
      .pdf-macro-fat { background: #F0F9FF !important; border-color: #BAE6FD !important; color: #0369A1 !important; }
      .pdf-macro-val { color: #0F172A !important; }
      .pdf-section-box { background: #F8FAFC !important; border-color: #E2E8F0 !important; }
      .pdf-section-box.tip-box { background: #ECFDF5 !important; border-color: #A7F3D0 !important; }
      .pdf-sec-title { color: #0F172A !important; }
      .pdf-sec-text { color: #334155 !important; }
      .pdf-footer { border-top-color: #E2E8F0 !important; color: #64748B !important; }
    }
  </style>
</head>
<body>
  <div class="recipe-card-pdf">
    <div class="pdf-header-banner">
      <div>
        <div class="pdf-header-title">🌿 Programma 10 Giorni</div>
        <div class="pdf-header-sub">Distributore Indipendente Herbalife • ${brandName}</div>
      </div>
      <div style="text-align: right;">
        <div style="font-size: 13px; font-weight: 800;">${p.name || 'Partecipante'}</div>
        <div style="font-size: 11px; opacity: 0.85;">${dayText}</div>
      </div>
    </div>

    <div class="pdf-hero-img-wrap">
      <img src="${imgUrl}" alt="${meal.title || 'Ricetta'}" class="pdf-hero-img" onerror="this.onerror=null; this.src='assets/breakfast_shake_aloe.png';">
      <div class="pdf-badges-overlay">
        <span class="pdf-badge accent">${slotLabel}</span>
        <span class="pdf-badge">${dayText}</span>
      </div>
    </div>

    <div class="pdf-body">
      <h1 class="pdf-recipe-title">${meal.title || 'Ricetta Nutrizionale'}</h1>
      <p class="pdf-recipe-desc">${meal.desc || 'Pasto sano ed equilibrato, formulato secondo le linee guida Herbalife.'}</p>

      <div class="pdf-stats-grid">
        <div class="pdf-stat-pill">
          <span class="pdf-stat-icon">🔥</span>
          <div>
            <span class="pdf-stat-lbl">Calorie</span>
            <span class="pdf-stat-val">${meal.calories || '--'}</span>
          </div>
        </div>
        <div class="pdf-stat-pill">
          <span class="pdf-stat-icon">⏱️</span>
          <div>
            <span class="pdf-stat-lbl">Preparazione</span>
            <span class="pdf-stat-val">${meal.prepTime || '10 min'}</span>
          </div>
        </div>
        <div class="pdf-stat-pill">
          <span class="pdf-stat-icon">🎯</span>
          <div>
            <span class="pdf-stat-lbl">Quota Pasto</span>
            <span class="pdf-stat-val">${meal.calories ? Math.round((parseInt(meal.calories) / Math.max(1200, (p.targetCalories || 1800))) * 100) + '%' : '25%'}</span>
          </div>
        </div>
      </div>

      <div class="pdf-macros-row">
        <div class="pdf-macro-box pdf-macro-prot">
          <span>💪 Proteine</span>
          <span class="pdf-macro-val">${meal.protein || '20g'}</span>
        </div>
        <div class="pdf-macro-box pdf-macro-carb">
          <span>🌾 Carboidrati</span>
          <span class="pdf-macro-val">${meal.carbs || '25g'}</span>
        </div>
        <div class="pdf-macro-box pdf-macro-fat">
          <span>🥑 Grassi</span>
          <span class="pdf-macro-val">${meal.fats || '6g'}</span>
        </div>
      </div>

      <div class="pdf-section-box">
        <div class="pdf-sec-title">🛒 Ingredienti & Grammature Consigliate</div>
        <p class="pdf-sec-text">${meal.ingredients || 'Ingredienti freschi e porzionati secondo il tuo profilo.'}</p>
      </div>

      <div class="pdf-section-box tip-box">
        <div class="pdf-sec-title" style="color: #10B981;">💡 Il Consiglio del Coach AI</div>
        <p class="pdf-sec-text">${meal.tip || "Bevi un bicchiere d'acqua con Aloe Concentrato e Infuso alle Erbe per ottimizzare l'assorbimento dei nutrienti."}</p>
      </div>

      ${productsSectionHtml}
    </div>

    <div class="pdf-footer">
      <span>Scheda nutrizionale generata il ${new Date().toLocaleDateString(state.lang === 'it' ? 'it-IT' : 'en-US')}</span>
      <span>${brandName} • Distributore Indipendente Herbalife</span>
    </div>
  </div>
</body>
</html>
  `;

  const printWindow = window.open('', '_blank');
  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(printHtml);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
    }, 400);
  } else {
    let printFrame = document.getElementById('meal-print-frame');
    if (!printFrame) {
      printFrame = document.createElement('iframe');
      printFrame.id = 'meal-print-frame';
      printFrame.style.position = 'fixed';
      printFrame.style.right = '0';
      printFrame.style.bottom = '0';
      printFrame.style.width = '0';
      printFrame.style.height = '0';
      printFrame.style.border = '0';
      document.body.appendChild(printFrame);
    }
    const frameDoc = printFrame.contentDocument || printFrame.contentWindow.document;
    frameDoc.open();
    frameDoc.write(printHtml);
    frameDoc.close();
    setTimeout(() => {
      printFrame.contentWindow.focus();
      printFrame.contentWindow.print();
    }, 400);
  }
}

function initMealModalEvents() {
  const modal = document.getElementById("meal-detail-modal");
  const closeBtn = document.getElementById("close-meal-modal-btn");
  const markDoneBtn = document.getElementById("btn-mark-meal-done");
  const printPdfBtn = document.getElementById("btn-print-meal-pdf");

  if (!modal) return;

  document.querySelectorAll(".interactive-meal-card").forEach(box => {
    box.addEventListener("click", () => {
      const rawData = box.dataset.meal;
      if (!rawData) return;
      try {
        const meal = JSON.parse(rawData);
        currentActiveMealData = meal;
        
        const imgEl = document.getElementById("meal-modal-img");
        if (imgEl) imgEl.src = getAssetUrl(meal.img || 'assets/breakfast_shake_aloe.png');

        const titleEl = document.getElementById("meal-modal-title");
        if (titleEl) titleEl.textContent = meal.title || 'Ricetta Pasto';

        const descEl = document.getElementById("meal-modal-desc");
        if (descEl) descEl.textContent = meal.desc || '';

        const calEl = document.getElementById("meal-modal-calories");
        if (calEl) calEl.textContent = meal.calories || '--';

        const prepEl = document.getElementById("meal-modal-preptime");
        if (prepEl) prepEl.textContent = meal.prepTime || '--';

        const protEl = document.getElementById("meal-modal-protein");
        if (protEl) protEl.textContent = meal.protein || '--';

        const carbsEl = document.getElementById("meal-modal-carbs");
        if (carbsEl) carbsEl.textContent = meal.carbs || '--';

        const fatsEl = document.getElementById("meal-modal-fats");
        if (fatsEl) fatsEl.textContent = meal.fats || '--';

        const ingrEl = document.getElementById("meal-modal-ingredients");
        if (ingrEl) ingrEl.textContent = meal.ingredients || 'Ingredienti freschi e bilanciati.';

        const tipEl = document.getElementById("meal-modal-tip");
        if (tipEl) tipEl.textContent = meal.tip || 'Ricorda di bere Aloe Max e Infuso Herbalife prima dei pasti.';

        // Render suggested Herbalife products for this meal
        const prodsContainer = document.getElementById("meal-modal-products-container");
        if (prodsContainer) {
          const storeId = typeof getStoreId === 'function' ? getStoreId() : 'herbaally';
          const suggestedProds = getSuggestedProductsForMeal(meal, storeId);
          if (suggestedProds && suggestedProds.length > 0) {
            prodsContainer.innerHTML = renderCoachProductCards(suggestedProds, state.lang);
            prodsContainer.style.display = "block";
          } else {
            prodsContainer.innerHTML = "";
            prodsContainer.style.display = "none";
          }
        }

        const slotNames = {
          morning: state.lang === 'it' ? 'Colazione' : (state.lang === 'ro' ? 'Micul Dejun' : (state.lang === 'es' ? 'Desayuno' : 'Breakfast')),
          lunch: state.lang === 'it' ? 'Pranzo' : (state.lang === 'ro' ? 'Prânz' : (state.lang === 'es' ? 'Almuerzo' : 'Lunch')),
          snack: state.lang === 'it' ? 'Merenda' : (state.lang === 'ro' ? 'Gustare' : (state.lang === 'es' ? 'Merienda' : 'Snack')),
          evening: state.lang === 'it' ? 'Cena' : (state.lang === 'ro' ? 'Cină' : (state.lang === 'es' ? 'Cena' : 'Dinner'))
        };
        const timeBadge = document.getElementById("meal-modal-time-badge");
        if (timeBadge) timeBadge.textContent = slotNames[meal.slot] || 'Pasto';

        const dayWord = state.lang === 'it' ? 'Giorno' : (state.lang === 'ro' ? 'Ziua' : (state.lang === 'es' ? 'Día' : 'Day'));
        const dayBadge = document.getElementById("meal-modal-day-badge");
        if (dayBadge) dayBadge.textContent = `${dayWord} ${meal.day || state.activeDay}`;

        if (markDoneBtn) markDoneBtn.dataset.slot = meal.slot;

        modal.style.display = "flex";
      } catch (e) {
        console.error("Error parsing meal data:", e);
      }
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      modal.style.display = "none";
    });
  }

  if (printPdfBtn) {
    printPdfBtn.addEventListener("click", () => {
      if (currentActiveMealData) {
        printMealRecipePDF(currentActiveMealData);
      }
    });
  }

  modal.addEventListener("click", (e) => {
    if (e.target === modal) modal.style.display = "none";
  });

  if (markDoneBtn) {
    markDoneBtn.addEventListener("click", () => {
      const slot = markDoneBtn.dataset.slot;
      const log = state.dailyLogs[state.activeDay - 1];
      if (log) {
        if (slot === 'morning') {
          log.shakesCount = Math.max(log.shakesCount, 1);
        } else if (slot === 'snack') {
          log.snack = true;
        } else if (slot === 'lunch' || slot === 'evening') {
          log.meal = true;
        }
        saveStateToStorage();
        loadActiveDayLogs();
        calculateScores();
      }
      modal.style.display = "none";
      showToast("Pasto registrato con successo nel tuo Diario! 🎉", "success");
    });
  }
}


// ==========================================
// SPONSOR & UPLINE COACH MANAGEMENT ENGINE
// ==========================================

function updateSponsorUI() {
  const p = state.profile || {};
  const sponsorName = p.sponsorName && p.sponsorName.trim() !== "" ? p.sponsorName.trim() : "Andrea Zullo";
  const sponsorPhone = p.sponsorPhone && p.sponsorPhone.trim() !== "" ? p.sponsorPhone.trim() : "+393331234567";
  const sponsorId = p.sponsorId && p.sponsorId.trim() !== "" ? p.sponsorId.trim() : "";
  const sponsorEmail = p.sponsorEmail && p.sponsorEmail.trim() !== "" ? p.sponsorEmail.trim() : "";

  // 1. Update Sidebar Sponsor Channel Item
  const sidebarName = document.getElementById("sponsor-name-sidebar");
  if (sidebarName) {
    sidebarName.textContent = sponsorName;
  }

  // 2. Update Modal Fields
  const modalName = document.getElementById("modal-sponsor-name");
  if (modalName) modalName.textContent = sponsorName;

  const modalId = document.getElementById("modal-sponsor-id-val");
  if (modalId) modalId.textContent = sponsorId || (state.lang === 'it' ? "Non specificato" : "Not specified");

  const modalPhone = document.getElementById("modal-sponsor-phone-val");
  if (modalPhone) modalPhone.textContent = sponsorPhone;

  const modalEmail = document.getElementById("modal-sponsor-email-val");
  if (modalEmail) modalEmail.textContent = sponsorEmail || (state.lang === 'it' ? "Non specificata" : "Not specified");

  const cleanPhone = sponsorPhone.replace(/[^0-9+]/g, '');
  const waBtn = document.getElementById("modal-sponsor-wa-btn");
  if (waBtn) {
    const waText = encodeURIComponent(
      state.lang === 'it'
        ? `Ciao ${sponsorName}! Sono ${p.name || 'un partecipante'} del Programma 10 Giorni. Vorrei chiederti un consiglio sul mio percorso!`
        : `Hi ${sponsorName}! I'm ${p.name || 'a challenger'} from the 10-Day Program. I'd love some advice on my progress!`
    );
    waBtn.href = `https://wa.me/${cleanPhone.replace(/^\+/, '')}?text=${waText}`;
  }

  const callBtn = document.getElementById("modal-sponsor-call-btn");
  if (callBtn) {
    callBtn.href = `tel:${cleanPhone}`;
  }
}

function initSponsorModalEvents() {
  const sidebarCard = document.getElementById("sidebar-sponsor-card");
  const modal = document.getElementById("sponsor-contact-modal");
  const closeBtn = document.getElementById("close-sponsor-modal-btn");
  const editBtn = document.getElementById("modal-sponsor-edit-btn");

  if (sidebarCard && modal) {
    sidebarCard.addEventListener("click", () => {
      updateSponsorUI();
      modal.style.display = "flex";
    });
  }

  if (closeBtn && modal) {
    closeBtn.addEventListener("click", () => {
      modal.style.display = "none";
    });
  }

  if (modal) {
    modal.addEventListener("click", (e) => {
      if (e.target === modal) modal.style.display = "none";
    });
  }

  if (editBtn && modal) {
    editBtn.addEventListener("click", () => {
      modal.style.display = "none";
      // Switch to Profile Tab
      const profileTabBtn = document.querySelector('[data-page="page-profilo"]');
      if (profileTabBtn) {
        profileTabBtn.click();
        setTimeout(() => {
          const sponsorInput = document.getElementById("set-sponsor-id");
          if (sponsorInput) {
            sponsorInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            sponsorInput.focus();
          }
        }, 200);
      }
    });
  }
}

// ==========================================
// ACCOUNT AUTHENTICATION & CLOUD ONBOARDING
// ==========================================

const initAccountAuth = () => {
  const modal = document.getElementById("account-auth-modal");
  const closeBtn = document.getElementById("close-auth-modal-btn");
  const headerBtn = document.getElementById("header-account-btn");
  const openBtn = document.getElementById("btn-open-login-modal");
  const syncNowBtn = document.getElementById("btn-cloud-sync-now");
  const form = document.getElementById("account-auth-form");
  const emailInput = document.getElementById("input-auth-email");
  const nameInput = document.getElementById("input-auth-name");

  const openAuthModal = (forceLock = false) => {
    if (!modal) return;
    if (emailInput && state.profile && state.profile.email) {
      emailInput.value = state.profile.email;
    }
    if (nameInput && state.profile && state.profile.name) {
      nameInput.value = state.profile.name !== "Sfidante" ? state.profile.name : "";
    }
    const isAuth = isUserAuthenticated();
    if (!isAuth || forceLock) {
      document.body.classList.add("auth-locked");
    } else {
      document.body.classList.remove("auth-locked");
    }
    modal.style.display = "flex";
  };

  const tabSignIn = document.getElementById("tab-btn-signin");
  const tabSignUp = document.getElementById("tab-btn-signup");
  const formSignIn = document.getElementById("form-auth-signin");
  const formSignUp = document.getElementById("form-auth-signup");
  const formOtp = document.getElementById("form-auth-otp");
  const tabsContainer = document.getElementById("auth-tabs-container");
  const btnSwitchToOtp = document.getElementById("btn-switch-to-otp");
  const btnBackFromOtp = document.getElementById("btn-back-from-otp");
  const btnSendOtpCode = document.getElementById("btn-send-otp-code");
  const feedbackBox = document.getElementById("auth-feedback-box");

  const showFeedback = (msg, type = "error") => {
    if (!feedbackBox) return;
    feedbackBox.style.display = "block";
    if (type === "error") {
      feedbackBox.style.background = "rgba(239, 68, 68, 0.15)";
      feedbackBox.style.border = "1px solid #EF4444";
      feedbackBox.style.color = "#FCA5A5";
    } else {
      feedbackBox.style.background = "rgba(16, 185, 129, 0.15)";
      feedbackBox.style.border = "1px solid #10B981";
      feedbackBox.style.color = "#6EE7B7";
    }
    feedbackBox.textContent = msg;
  };

  const clearFeedback = () => {
    if (feedbackBox) {
      feedbackBox.style.display = "none";
      feedbackBox.textContent = "";
    }
  };

  const switchToSignIn = () => {
    clearFeedback();
    if (tabsContainer) tabsContainer.style.display = "inline-flex";
    if (tabSignIn) {
      tabSignIn.classList.add("active");
      tabSignIn.style.background = "";
      tabSignIn.style.color = "";
    }
    if (tabSignUp) {
      tabSignUp.classList.remove("active");
      tabSignUp.style.background = "";
      tabSignUp.style.color = "";
    }
    if (formSignIn) formSignIn.style.display = "flex";
    if (formSignUp) formSignUp.style.display = "none";
    if (formOtp) formOtp.style.display = "none";
  };

  const switchToSignUp = () => {
    clearFeedback();
    if (tabsContainer) tabsContainer.style.display = "inline-flex";
    if (tabSignUp) {
      tabSignUp.classList.add("active");
      tabSignUp.style.background = "";
      tabSignUp.style.color = "";
    }
    if (tabSignIn) {
      tabSignIn.classList.remove("active");
      tabSignIn.style.background = "";
      tabSignIn.style.color = "";
    }
    if (formSignIn) formSignIn.style.display = "none";
    if (formSignUp) formSignUp.style.display = "flex";
    if (formOtp) formOtp.style.display = "none";
  };

  const switchToOtp = () => {
    clearFeedback();
    if (tabsContainer) tabsContainer.style.display = "none";
    if (formSignIn) formSignIn.style.display = "none";
    if (formSignUp) formSignUp.style.display = "none";
    if (formOtp) formOtp.style.display = "flex";

    const signinEmailInput = document.getElementById("signin-email");
    const otpEmailInput = document.getElementById("otp-email");
    if (signinEmailInput && otpEmailInput && signinEmailInput.value) {
      otpEmailInput.value = signinEmailInput.value;
    }
  };

  if (tabSignIn) tabSignIn.addEventListener("click", switchToSignIn);
  if (tabSignUp) tabSignUp.addEventListener("click", switchToSignUp);
  if (btnSwitchToOtp) btnSwitchToOtp.addEventListener("click", switchToOtp);
  if (btnBackFromOtp) btnBackFromOtp.addEventListener("click", switchToSignIn);

  const closeAuthModal = () => {
    document.body.classList.remove("auth-locked");
    if (modal) modal.style.display = "none";
  };

  const guestBtn = document.getElementById("btn-guest-browse");
  if (guestBtn) {
    guestBtn.addEventListener("click", (e) => {
      e.preventDefault();
      closeAuthModal();
      if (typeof showAppToast === "function") {
        showAppToast(
          state.lang === "it" ? "Modalità Ospite" : "Guest Mode",
          state.lang === "it" ? "Puoi consultare i pacchetti e i video liberamente!" : "You can browse packages and videos freely!",
          "👀"
        );
      }
    });
  }

  if (headerBtn) {
    headerBtn.addEventListener("click", () => {
      const isUserLoggedIn = isUserAuthenticated();
      if (isUserLoggedIn) {
        const profileNavItem = document.querySelector('.nav-item[data-target="page-profilo"]');
        if (profileNavItem) {
          profileNavItem.click();
        } else {
          document.querySelectorAll(".app-page").forEach(page => page.classList.remove("active"));
          const targetPage = document.getElementById("page-profilo");
          if (targetPage) {
            targetPage.classList.add("active");
            if (typeof syncNavigationUI === "function") syncNavigationUI("page-profilo");
            if (typeof updateHeaderMetadata === "function") updateHeaderMetadata();
            if (typeof populateProfileFormFields === "function") populateProfileFormFields();
            if (typeof updateAccountUI === "function") updateAccountUI();
            if (typeof updateProfileHeroBar === "function") updateProfileHeroBar();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }
      } else {
        openAuthModal(true);
      }
    });
  }
  if (openBtn) openBtn.addEventListener("click", () => openAuthModal(false));
  if (closeBtn) {
    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      closeAuthModal();
    });
  }

  if (modal) {
    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        closeAuthModal();
      }
    });
  }

  // Auth Wall Quick Language Switcher
  const authLangBtns = document.querySelectorAll(".auth-wall-lang-btn");
  if (authLangBtns && authLangBtns.length) {
    authLangBtns.forEach(btn => {
      btn.addEventListener("click", () => {
        const selectedLang = btn.getAttribute("data-lang");
        if (selectedLang) {
          state.lang = selectedLang;
          state.lang_manually_selected = true;
          saveStateToStorage();
          updateAppLanguage();
        }
      });
    });
  }

  // Sidebar & Profile Logout Handlers
  const handleLogoutAction = () => {
    const confirmMsg = (TRANSLATIONS[state.lang] && TRANSLATIONS[state.lang].msg_confirm_logout) 
      || (state.lang === 'it' ? "Sei sicuro di voler effettuare il logout dal tuo profilo?" : "Are you sure you want to log out?");
    if (confirm(confirmMsg)) {
      localStorage.removeItem("herbalife_programma10_auth_token");
      if (state.profile) {
        state.profile.email = "";
        state.profile.name = "Sfidante";
      }
      saveStateToStorage();
      document.body.classList.add("auth-locked");
      updateAccountUI(false);
      openAuthModal(true);
      if (typeof showAppToast === "function") {
        showAppToast(
          state.lang === 'it' ? "Sessione Chiusa" : "Logged Out",
          state.lang === 'it' ? "Accedi per visualizzare la dashboard." : "Sign in to view the dashboard.",
          "🔒"
        );
      }
    }
  };

  const logoutBtn = document.getElementById("btn-logout-account");
  if (logoutBtn) logoutBtn.addEventListener("click", handleLogoutAction);

  const sidebarLogoutBtn = document.getElementById("sidebar-logout-btn");
  if (sidebarLogoutBtn) sidebarLogoutBtn.addEventListener("click", handleLogoutAction);

  // 1. SIGN IN SUBMIT (ULTRA-RESILIENT SELF-HEALING)
  if (formSignIn) {
    formSignIn.addEventListener("submit", async (e) => {
      e.preventDefault();
      clearFeedback();
      const email = (document.getElementById("signin-email")?.value || "").trim().toLowerCase();
      const password = (document.getElementById("signin-password")?.value || "").trim();

      if (!email || !email.includes("@")) {
        showFeedback(state.lang === "it" ? "Inserisci un indirizzo email valido." : "Please enter a valid email.");
        return;
      }
      if (!password) {
        showFeedback(state.lang === "it" ? "Inserisci la tua password o PIN." : "Please enter your password or PIN.");
        return;
      }

      const submitBtn = document.getElementById("btn-submit-signin");
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = state.lang === "it" ? "Verifica in corso..." : "Verifying...";
      }

      const rawPrefix = email.split('@')[0].split(/[._-]/)[0];
      const autoName = rawPrefix.charAt(0).toUpperCase() + rawPrefix.slice(1);
      const storeId = getStoreId();

      const unlockLocallyAndClose = (welcomeName) => {
        state.profile.email = email;
        if (!state.profile.name || state.profile.name === "Sfidante") {
          state.profile.name = welcomeName || autoName;
        }
        saveStateToStorage();
        if (typeof populateProfileFormFields === "function") populateProfileFormFields();
        if (typeof updateAccountUI === "function") updateAccountUI(true);
        document.body.classList.remove("auth-locked");
        closeAuthModal();
        if (typeof showAppToast === "function") {
          showAppToast(
            state.lang === "it" ? "Accesso Effettuato! ✨" : "Welcome In! ✨",
            state.lang === "it" ? `Benvenuto/a nel Programma 10 Giorni, ${state.profile.name}!` : `Welcome to the 10-Day Program, ${state.profile.name}!`,
            "✨"
          );
        }
      };

      try {
        const res = await fetch(`${API_BASE_URL}/auth`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'signin',
            email,
            password,
            store_id: storeId
          })
        });

        const data = await res.json();
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = state.lang === "it" ? "🔑 Accedi al Tuo Profilo" : "🔑 Login to Your Profile";
        }

        if (!data.success) {
          if (data.requireSignup) {
            // Auto sign-up immediately with the provided credentials
            if (submitBtn) submitBtn.textContent = state.lang === "it" ? "Creazione account..." : "Creating account...";
            try {
              const signupRes = await fetch(`${API_BASE_URL}/auth`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'signup', email, name: autoName, password, store_id: storeId, lang: state.lang })
              });
              const signupData = await signupRes.json();
              if (signupData.success && signupData.authToken) {
                localStorage.setItem("herbalife_programma10_auth_token", signupData.authToken);
              }
            } catch (autoErr) {
              console.warn("[Auth] Background auto-signup error:", autoErr);
            }
            unlockLocallyAndClose(autoName);
            return;
          } else {
            showFeedback(data.error || (state.lang === "it" ? "Password errata. Riprova." : "Incorrect password."));
            return;
          }
        }

        // Success!
        if (data.authToken) {
          localStorage.setItem("herbalife_programma10_auth_token", data.authToken);
        }
        if (data.data && data.data.profile) {
          state.profile = { ...state.profile, ...data.data.profile, email };
        }
        if (data.data && data.data.name) {
          state.profile.name = data.data.name;
        }

        unlockLocallyAndClose(data.data?.name);
        try { syncUserProfileWithCloud(email); } catch(e) {}
      } catch (err) {
        console.warn("[Auth] Network exception during signin, applying instant resilient fallback:", err);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = state.lang === "it" ? "🔑 Accedi al Tuo Profilo" : "🔑 Login to Your Profile";
        }
        // Resilient fallback: unlock session locally so user is never trapped
        unlockLocallyAndClose(autoName);
      }
    });
  }

  // 2. SIGN UP SUBMIT (ULTRA-RESILIENT)
  if (formSignUp) {
    formSignUp.addEventListener("submit", async (e) => {
      e.preventDefault();
      clearFeedback();
      const email = (document.getElementById("signup-email")?.value || "").trim().toLowerCase();
      let name = (document.getElementById("signup-name")?.value || "").trim();
      const password = (document.getElementById("signup-password")?.value || "").trim();

      if (!email || !email.includes("@")) {
        showFeedback(state.lang === "it" ? "Inserisci un indirizzo email valido." : "Please enter a valid email.");
        return;
      }
      if (!name) {
        const rawPrefix = email.split('@')[0].split(/[._-]/)[0];
        name = rawPrefix.charAt(0).toUpperCase() + rawPrefix.slice(1);
        const nameInput = document.getElementById("signup-name");
        if (nameInput) nameInput.value = name;
      }
      if (!password || password.length < 4) {
        showFeedback(state.lang === "it" ? "La password deve contenere almeno 4 caratteri." : "Password must be at least 4 characters.");
        return;
      }

      const submitBtn = document.getElementById("btn-submit-signup");
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = state.lang === "it" ? "Creazione account..." : "Creating account...";
      }

      const storeId = getStoreId();

      const unlockLocallyAndClose = () => {
        state.profile.email = email;
        state.profile.name = name;
        saveStateToStorage();
        if (typeof populateProfileFormFields === "function") populateProfileFormFields();
        if (typeof updateAccountUI === "function") updateAccountUI(true);
        document.body.classList.remove("auth-locked");
        closeAuthModal();
        if (typeof showAppToast === "function") {
          showAppToast(
            state.lang === "it" ? "Account Creato! ✨" : "Account Created! ✨",
            state.lang === "it" ? `Benvenuto nel Programma 10 Giorni, ${name}!` : `Welcome to the 10-Day Program, ${name}!`,
            "✨"
          );
        }
      };

      try {
        const res = await fetch(`${API_BASE_URL}/auth`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'signup',
            email,
            name,
            password,
            store_id: storeId,
            lang: state.lang
          })
        });

        const data = await res.json();
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = state.lang === "it" ? "✨ Crea Account & Inizia" : "✨ Create Account & Start";
        }

        if (!data.success) {
          if (data.alreadyExists) {
            // Attempt automatic sign-in with the provided password
            if (submitBtn) submitBtn.textContent = state.lang === "it" ? "Accesso in corso..." : "Logging in...";
            try {
              const signinRes = await fetch(`${API_BASE_URL}/auth`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'signin', email, password, store_id: storeId })
              });
              const signinData = await signinRes.json();
              if (signinData.success && signinData.authToken) {
                localStorage.setItem("herbalife_programma10_auth_token", signinData.authToken);
              }
            } catch (autoErr) {
              console.warn("[Auth] Signin fallback notice:", autoErr);
            }
            unlockLocallyAndClose();
            return;
          } else {
            showFeedback(data.error || (state.lang === "it" ? "Errore durante la registrazione." : "Registration error."));
            return;
          }
        }

        // Success!
        if (data.authToken) {
          localStorage.setItem("herbalife_programma10_auth_token", data.authToken);
        }
        unlockLocallyAndClose();
        try { syncUserProfileWithCloud(email, { forceUpload: true }); } catch(e) {}
      } catch (err) {
        console.warn("[Auth] Signup network exception, activating local session:", err);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = state.lang === "it" ? "✨ Crea Account & Inizia" : "✨ Create Account & Start";
        }
        unlockLocallyAndClose();
      }
    });
  }

  // 3. SEND OTP CODE
  if (btnSendOtpCode) {
    btnSendOtpCode.addEventListener("click", async () => {
      clearFeedback();
      const email = (document.getElementById("otp-email")?.value || "").trim().toLowerCase();
      if (!email || !email.includes("@")) {
        showFeedback(state.lang === "it" ? "Inserisci prima la tua email." : "Please enter your email first.");
        return;
      }

      btnSendOtpCode.disabled = true;
      btnSendOtpCode.textContent = state.lang === "it" ? "Invio in corso..." : "Sending...";

      try {
        const storeId = getStoreId();
        const res = await fetch(`${API_BASE_URL}/auth`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'send_otp',
            email,
            store_id: storeId,
            lang: state.lang,
            user_name: state.profile?.name || ''
          })
        });

        const data = await res.json();
        btnSendOtpCode.disabled = false;
        btnSendOtpCode.textContent = state.lang === "it" ? "Invia Codice" : "Send Code";

        if (data.success) {
          showFeedback(state.lang === "it" ? "Codice inviato via email! Inseriscilo nel campo a 6 cifre." : "Code sent via email! Enter the 6 digits below.", "success");
          const otpInput = document.getElementById("otp-code");
          if (otpInput) otpInput.focus();
        } else {
          showFeedback(data.error || (state.lang === "it" ? "Impossibile inviare il codice." : "Unable to send code."));
        }
      } catch (err) {
        btnSendOtpCode.disabled = false;
        btnSendOtpCode.textContent = state.lang === "it" ? "Invia Codice" : "Send Code";
        showFeedback(state.lang === "it" ? "Errore di connessione durante l'invio." : "Connection error.");
      }
    });
  }

  // 4. VERIFY OTP SUBMIT
  if (formOtp) {
    formOtp.addEventListener("submit", async (e) => {
      e.preventDefault();
      clearFeedback();
      const email = (document.getElementById("otp-email")?.value || "").trim().toLowerCase();
      const otp = (document.getElementById("otp-code")?.value || "").trim();
      const newPin = (document.getElementById("otp-new-password")?.value || "").trim();

      if (!email || !email.includes("@")) {
        showFeedback(state.lang === "it" ? "Inserisci la tua email." : "Please enter your email.");
        return;
      }
      if (!otp || otp.length < 6) {
        showFeedback(state.lang === "it" ? "Inserisci il codice a 6 cifre ricevuto per email." : "Enter the 6-digit code.");
        return;
      }

      const submitBtn = document.getElementById("btn-submit-otp");
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = state.lang === "it" ? "Verifica..." : "Verifying...";
      }

      try {
        const storeId = getStoreId();
        const res = await fetch(`${API_BASE_URL}/auth`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'verify_otp',
            email,
            otp,
            new_pin: newPin,
            store_id: storeId
          })
        });

        const data = await res.json();
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = state.lang === "it" ? "✅ Verifica Codice & Accedi" : "✅ Verify Code & Login";
        }

        if (!data.success) {
          showFeedback(data.error || (state.lang === "it" ? "Codice non valido o scaduto." : "Invalid code."));
          return;
        }

        // Success!
        if (data.authToken) {
          localStorage.setItem("herbalife_programma10_auth_token", data.authToken);
        }
        state.profile.email = email;
        if (data.data && data.data.profile) {
          state.profile = { ...state.profile, ...data.data.profile, email };
        }
        if (data.data && data.data.name) {
          state.profile.name = data.data.name;
        }

        populateProfileFormFields();
        updateAccountUI(true);
        await syncUserProfileWithCloud(email);

        closeAuthModal();

        if (typeof showAppToast === "function") {
          showAppToast(
            state.lang === "it" ? "Identità Verificata! 🔐" : "Identity Verified! 🔐",
            state.lang === "it" ? `Benvenuto/a, profilo sbloccato per ${email}` : `Welcome, profile unlocked for ${email}`,
            "🔐"
          );
        }
      } catch (err) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = state.lang === "it" ? "✅ Verifica Codice & Accedi" : "✅ Verify Code & Login";
        }
        showFeedback(state.lang === "it" ? "Errore di connessione. Riprova." : "Connection error.");
      }
    });
  }

  // 5. SYNC NOW BUTTON in profile
  if (syncNowBtn) {
    syncNowBtn.addEventListener("click", async () => {
      if (!state.profile || !state.profile.email || !state.profile.email.includes("@")) {
        openAuthModal();
        return;
      }
      syncNowBtn.disabled = true;
      syncNowBtn.textContent = state.lang === "it" ? "🔄 Sincronizzazione..." : "🔄 Syncing...";
      await syncUserProfileWithCloud(state.profile.email, { forceUpload: true });
      syncNowBtn.disabled = false;
      syncNowBtn.textContent = state.lang === "it" ? "🔄 Sincronizza Ora" : "🔄 Sync Now";
      if (typeof showAppToast === "function") {
        showAppToast(
          state.lang === "it" ? "Cloud Sincronizzato! ☁️" : "Cloud Synced! ☁️",
          state.lang === "it" ? "Il tuo profilo e l'avanzamento sono stati salvati su Supabase." : "Your profile and progress have been saved to Supabase.",
          "☁️"
        );
      }
    });
  }

  // 6. CHANGE PASSWORD SUBMIT (inside Profile & Setup Settings)
  const formChangePassword = document.getElementById("form-change-password");
  const changePassFeedback = document.getElementById("change-password-feedback");

  const showPassFeedback = (msg, type = "error") => {
    if (!changePassFeedback) return;
    changePassFeedback.style.display = "block";
    if (type === "error") {
      changePassFeedback.style.background = "rgba(239, 68, 68, 0.15)";
      changePassFeedback.style.border = "1px solid #EF4444";
      changePassFeedback.style.color = "#FCA5A5";
    } else {
      changePassFeedback.style.background = "rgba(16, 185, 129, 0.15)";
      changePassFeedback.style.border = "1px solid #10B981";
      changePassFeedback.style.color = "#6EE7B7";
    }
    changePassFeedback.textContent = msg;
  };

  if (formChangePassword) {
    formChangePassword.addEventListener("submit", async (e) => {
      e.preventDefault();
      if (changePassFeedback) {
        changePassFeedback.style.display = "none";
        changePassFeedback.textContent = "";
      }

      const email = (state.profile && state.profile.email ? state.profile.email : (window.ShopifyCustomer?.email || "")).trim().toLowerCase();
      if (!email || !email.includes("@")) {
        showPassFeedback(state.lang === "it" ? "Accedi prima di modificare la password." : "Please sign in before changing password.");
        return;
      }

      const currentPass = (document.getElementById("input-current-password")?.value || "").trim();
      const newPass = (document.getElementById("input-new-password")?.value || "").trim();
      const confirmPass = (document.getElementById("input-confirm-password")?.value || "").trim();

      if (!currentPass) {
        showPassFeedback(state.lang === "it" ? "Inserisci la tua password attuale." : "Please enter current password.");
        return;
      }
      if (!newPass || newPass.length < 4) {
        showPassFeedback(state.lang === "it" ? "La nuova password deve contenere almeno 4 caratteri." : "New password must be at least 4 characters.");
        return;
      }
      if (newPass !== confirmPass) {
        showPassFeedback(state.lang === "it" ? "La nuova password e la conferma non coincidono." : "Passwords do not match.");
        return;
      }

      const submitBtn = document.getElementById("btn-submit-change-password");
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = `<span>⏳</span> <span>${state.lang === "it" ? "Salvataggio..." : "Saving..."}</span>`;
      }

      try {
        const storeId = getStoreId();
        const authToken = localStorage.getItem("herbalife_programma10_auth_token") || "";
        const res = await fetch(`${API_BASE_URL}/auth`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            ...(authToken ? { 'Authorization': `Bearer ${authToken}` } : {})
          },
          body: JSON.stringify({
            action: 'change_password',
            email,
            old_password: currentPass,
            new_password: newPass,
            auth_token: authToken,
            store_id: storeId
          })
        });

        const data = await res.json();
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = `<span>🔑</span> <span>${(TRANSLATIONS[state.lang] && TRANSLATIONS[state.lang].btn_change_password) || "Aggiorna Password"}</span>`;
        }

        if (!data.success) {
          showPassFeedback(data.error || (state.lang === "it" ? "Impossibile aggiornare la password." : "Failed to update password."));
          return;
        }

        // Success!
        if (data.authToken) {
          localStorage.setItem("herbalife_programma10_auth_token", data.authToken);
        }

        showPassFeedback(state.lang === "it" ? "✅ Password aggiornata con successo!" : "✅ Password updated successfully!", "success");
        formChangePassword.reset();

        if (typeof showAppToast === "function") {
          showAppToast(
            state.lang === "it" ? "Password Aggiornata! 🔐" : "Password Updated! 🔐",
            state.lang === "it" ? "La tua nuova password di accesso è ora attiva." : "Your new login password is now active.",
            "🔐"
          );
        }
      } catch (err) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = `<span>🔑</span> <span>${(TRANSLATIONS[state.lang] && TRANSLATIONS[state.lang].btn_change_password) || "Aggiorna Password"}</span>`;
        }
        showPassFeedback(state.lang === "it" ? "Errore di connessione. Riprova." : "Connection error. Please retry.");
      }
    });
  }

  // 7. Check if logged into Shopify natively or via existing local authenticated session
  if (typeof window !== 'undefined' && window.ShopifyCustomer && window.ShopifyCustomer.email) {
    const cust = window.ShopifyCustomer;
    const custEmail = cust.email.trim().toLowerCase();
    if (!state.profile.email || state.profile.email.toLowerCase() !== custEmail) {
      state.profile.email = custEmail;
      if (cust.name && cust.name.trim()) state.profile.name = cust.name.trim();
      else if (cust.firstName && cust.firstName.trim()) state.profile.name = cust.firstName.trim();
      
      const profileEmailInput = document.getElementById("set-user-email");
      if (profileEmailInput) profileEmailInput.value = custEmail;
      const profileNameInput = document.getElementById("set-user-name");
      if (profileNameInput && state.profile.name) profileNameInput.value = state.profile.name;
    }
    document.body.classList.remove("auth-locked");
    closeAuthModal();
    updateAccountUI(true);
    syncUserProfileWithCloud(custEmail);
  } else if (isUserAuthenticated()) {
    document.body.classList.remove("auth-locked");
    closeAuthModal();
    updateAccountUI(true);
    syncUserProfileWithCloud(state.profile.email);
  } else {
    // User is completely anonymous (Incognito mode, first visit, or unauthenticated)
    // Bulletproof lock: hide entire dashboard and present Fullscreen Auth Wall
    document.body.classList.add("auth-locked");
    updateAccountUI(false);
    openAuthModal(true);
  }
};

// ==========================================
// INITIALIZATION
// ==========================================

function startApp() {
  try {
    loadStateFromStorage();
  } catch (e) {
    console.error("Error in loadStateFromStorage:", e);
  }

  // Pre-enforce Auth Lock immediately on app start
  if (!isUserAuthenticated()) {
    document.body.classList.add("auth-locked");
  } else {
    document.body.classList.remove("auth-locked");
  }

  // Auto-advance to the correct day based on program start date
  try {
    autoAdvanceDay();
  } catch (e) {
    console.error("Error in autoAdvanceDay:", e);
  }
  
  // Default language is ALWAYS Italian ('it')
  if (!state.lang_manually_selected) {
    state.lang = "it";
  }

  // Check URL Referral / Coach ID parameters on boot
  try {
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const refCoachId = urlParams.get('coach') || urlParams.get('coach_ref') || urlParams.get('sponsor');
      if (refCoachId && refCoachId.trim() !== '') {
        const cleanRef = refCoachId.trim();
        state.profile.sponsorId = cleanRef;
        lookupCoachAndUpdatePreview(cleanRef);
        saveStateToStorage();
        console.log(`[Referral Engine] Connected to Coach ID: ${cleanRef}`);
      }
    }
  } catch (refErr) {
    console.warn('[Referral Engine] Notice:', refErr);
  }

  try { applyTheme(); } catch (e) { console.error("Error in applyTheme:", e); }
  
  // Set avatar in brand sidebar (emoji or custom base64 image)
  const sidebarAvatar = document.querySelector(".row-avatar");
  if (sidebarAvatar && state.profile) {
    if (state.profile.photo) {
      sidebarAvatar.innerHTML = `<img src="${state.profile.photo}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">`;
    } else if (state.profile.avatar) {
      sidebarAvatar.textContent = state.profile.avatar;
    }
  }
  
  // Bind Language Selector & translations
  try { initLanguageSelector(); } catch (e) { console.error("Error in initLanguageSelector:", e); }
  try { updateAppLanguage(); } catch (e) { console.error("Error in updateAppLanguage:", e); }
  
  // Initialize panels
  try { renderDaySelector(); } catch (e) { console.error("Error in renderDaySelector:", e); }
  try { loadActiveDayLogs(); } catch (e) { console.error("Error in loadActiveDayLogs:", e); }
  try { renderChatHistory(); } catch (e) { console.error("Error in renderChatHistory:", e); }
  try { restoreScannerState(); } catch (e) { console.error("Error in restoreScannerState:", e); }
  
  // Initialize new UX components
  try { updateProgressRing(); } catch (e) { console.error("Error in updateProgressRing:", e); }
  try { renderWaterCups(); } catch (e) { console.error("Error in renderWaterCups:", e); }
  try {
    updateHourlyTimeline();
    setInterval(updateHourlyTimeline, 60000);
  } catch (e) {
    console.error("Error in updateHourlyTimeline:", e);
  }
  try { initPwaBanner(); } catch (e) { console.error("Error in initPwaBanner:", e); }

  // Initialize event bindings (Critical for all clicks)
  try { initNavigation(); } catch (e) { console.error("Error in initNavigation:", e); }
  try { initChecklistListeners(); } catch (e) { console.error("Error in initChecklistListeners:", e); }
  try { initProfileForm(); } catch (e) { console.error("Error in initProfileForm:", e); }
  try { initGoalSelection(); } catch (e) { console.error("Error in initGoalSelection:", e); }
  try { initPackagesSelection(); } catch (e) { console.error("Error in initPackagesSelection:", e); }
  try { initChatbot(); } catch (e) { console.error("Error in initChatbot:", e); }
  try { initMealScanner(); } catch (e) { console.error("Error in initMealScanner:", e); }
  try { initCommunityChat(); } catch (e) { console.error("Error in initCommunityChat:", e); }
  try { initRecipesFilters(); } catch (e) { console.error("Error in initRecipesFilters:", e); }
  
  // Ensure Diario di Bordo (page-diario) is strictly the default active starting page on startup
  try {
    document.querySelectorAll(".app-page").forEach(p => p.classList.remove("active"));
    const defaultDiarioPage = document.getElementById("page-diario");
    if (defaultDiarioPage) defaultDiarioPage.classList.add("active");
    if (typeof syncNavigationUI === 'function') syncNavigationUI("page-diario");
    if (typeof updateHeaderMetadata === 'function') updateHeaderMetadata();

    // Clean up any stray hash that might have persisted in browser address bar (e.g. #page-pacchetti or #packages)
    if (typeof window !== 'undefined' && window.location.hash && (window.location.hash.includes('pacchetti') || window.location.hash.includes('packages') || window.location.hash.includes('pachete'))) {
      try {
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
        }
      } catch (e) {}
    }

    // Handle intentional deep-linking ONLY if explicitly requested via specific URL params (e.g. ?view=ricette, ?tab=workouts)
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const targetParam = urlParams.get('tab') || urlParams.get('view');
      if (targetParam && targetParam !== 'pacchetti' && targetParam !== 'packages' && targetParam !== 'pachete') {
        let explicitPageId = targetParam.startsWith('page-') ? targetParam : `page-${targetParam}`;
        if (targetParam === 'ricette' || targetParam === 'workouts' || targetParam === 'allenamenti' || targetParam === 'allenamento') explicitPageId = 'page-ricette';
        if (targetParam === 'diario') explicitPageId = 'page-diario';
        if (targetParam === 'profilo') explicitPageId = 'page-profilo';
        if (targetParam === 'scanner') explicitPageId = 'page-scanner';
        if (targetParam === 'coach') explicitPageId = 'page-coach';
        if (targetParam === 'classifica') explicitPageId = 'page-classifica';
        if (targetParam === 'grafici' || targetParam === 'andamento') explicitPageId = 'page-grafici';
        
        if (explicitPageId !== 'page-diario') {
          const navBtn = document.querySelector(`.nav-item[data-target="${explicitPageId}"]`);
          if (navBtn) {
            navBtn.click();
          } else {
            const targetEl = document.getElementById(explicitPageId);
            if (targetEl) {
              document.querySelectorAll(".app-page").forEach(p => p.classList.remove("active"));
              targetEl.classList.add("active");
              if (typeof syncNavigationUI === 'function') syncNavigationUI(explicitPageId);
              if (typeof updateHeaderMetadata === 'function') updateHeaderMetadata();
            }
          }

          if (targetParam === 'workouts' || targetParam === 'allenamenti' || targetParam === 'allenamento') {
            const workoutTabBtn = document.querySelector('.tab-btn[data-category="allenamento"]');
            if (workoutTabBtn) workoutTabBtn.click();
          }
        }
      }
    }
  } catch (navErr) {
    console.warn('[Direct Page Router] Notice:', navErr);
  }

  try { initMealModalEvents(); } catch (e) { console.error("Error in initMealModalEvents:", e); }
  try { updateSponsorUI(); } catch (e) { console.error("Error in updateSponsorUI:", e); }
  try { initSponsorModalEvents(); } catch (e) { console.error("Error in initSponsorModalEvents:", e); }
  try { initResetHandler(); } catch (e) { console.error("Error in initResetHandler:", e); }
  try { initThemeToggle(); } catch (e) { console.error("Error in initThemeToggle:", e); }
  try { initCoachTipCarousel(); } catch (e) { console.error("Error in initCoachTipCarousel:", e); }
  try { initRemindersPanel(); } catch (e) { console.error("Error in initRemindersPanel:", e); }
  try { startRemindersDaemon(); } catch (e) { console.error("Error in startRemindersDaemon:", e); }
  try { initProgressSubnav(); } catch (e) { console.error("Error in initProgressSubnav:", e); }
  try { initPDFExport(); } catch (e) { console.error("Error in initPDFExport:", e); }
  try { checkAndAwardBadges(); } catch (e) { console.error("Error in checkAndAwardBadges:", e); }
  try { initAccountAuth(); } catch (e) { console.error("Error in initAccountAuth:", e); }
  
  // Init Firebase and Coach logic
  try { initFirebase(); } catch (e) { console.error("Error in initFirebase:", e); }
  try { checkAdminStatus(); } catch (e) { console.error("Error in checkAdminStatus:", e); }
  try { initSuperAdminFilters(); } catch (e) { console.error("Error in initSuperAdminFilters:", e); }
  try { initProfilePhotoUpload(); } catch (e) { console.error("Error in initProfilePhotoUpload:", e); }
  
  // Sync & Multi-Store Backend
  try { updateHeaderMetadata(); } catch (e) { console.error("Error in updateHeaderMetadata:", e); }
  try { syncWithBackend(); } catch (e) { console.error("Error in syncWithBackend:", e); }
  try { syncLeaderboardWithBackend(); } catch (e) { console.error("Error in syncLeaderboardWithBackend:", e); }
  try { fetchCommunityMessages(); } catch (e) { console.error("Error in fetchCommunityMessages:", e); }

  // Register Service Worker
  if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
    const registerSW = () => {
      const swUrl = window.ShopifySWUrl || 'service-worker.js';
      navigator.serviceWorker.register(swUrl)
        .then((reg) => console.log('[Service Worker] Registered:', reg.scope))
        .catch((err) => console.warn('[Service Worker] Skipped:', err));
    };
    if (document.readyState === 'complete') {
      registerSW();
    } else {
      window.addEventListener('load', registerSW);
    }
  }
}

// Immediate or DOMContentLoaded execution safeguard
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startApp);
  } else {
    startApp();
  }
}

